if (typeof window < "u") {
  let Ue = function(a, c) {
    var r = pn();
    return (Ue = function(e, t) {
      return r[e -= 477];
    })(a, c);
  }, pn = function() {
    var a = [
      "concat",
      "_selenium",
      "WEBGLVENDORANDRENDERER",
      "serial",
      "result",
      "HAS_TOUCH",
      "Modernizr.on Failed with feature ",
      "srcdoc",
      "DEVICE_CATEGORY",
      "UNMASKED_VENDOR_WEBGL",
      "code",
      " failed",
      "localStorage",
      "page intentionally left blank",
      "broJsFingerprint",
      "find",
      "TypeError",
      "    [native code]",
      "matchmedia",
      "IS_BOT",
      "serializedDeviceAttributes",
      "Geolocation retrieval failed: Location information is unavailable.",
      "floc",
      "LIES",
      "dateTimeLocale",
      "getWebglData",
      "isMobile",
      "DOCUMENT_ELEMENT_WEBDRIVER",
      "Metadata",
      "Other",
      "get",
      "Geolocation retrieval failed: Location permission denied by the user.",
      "HAS_SPEAKERS",
      "htmlGeoLocation_ErrorCode",
      "dataforseobot",
      "chrome_runtime_functions_invalid",
      "opera",
      "background-sync",
      "calculated workstation device attributes.",
      "permissions_api",
      "dataview",
      "__webdriver_evaluate",
      "configurable",
      "NAVIGATOR_PRODUCT",
      "JS_CHALLENGE",
      "target",
      "label",
      "connect",
      "selenium_in_navigator",
      "failed to get headless results",
      "atanh",
      "customprotocolhandler",
      "function",
      "maxVertexAttribs",
      "systemLanguage",
      "message_channel",
      "BroprintJS",
      "matchMedia",
      "unknown",
      "browserInfo",
      "sessionData",
      "navigator.languages_blank",
      "getOwnPropertyNames",
      "batteryDischargingTime",
      "WEBGL_MAXCOMBINEDTEXTUREIMAGEUNITS",
      "hardwareConcurrency",
      "webdriverCommand",
      "OS_CPU",
      "message",
      "createInvisibleElement",
      "function () {",
      "_WEBDRIVER_ELEM_CACHE",
      "geo_location",
      "NAVIGATOR_VIBRATE",
      "appendChild",
      "devicePixelRatio",
      "Ops : ",
      "heading",
      "Siemens",
      "localAgentJwt",
      "clipboard-read",
      "maxRenderbufferSize",
      "createDataChannel",
      "webGlStatus",
      "toLowerCase",
      "driver",
      "ie8compat",
      "cosh",
      "NAVIGATOR_POINTER_ENABLED",
      "Failed to add ",
      "DEVICE_MODEL",
      "isWebGl",
      "browserVersion",
      "getSerializedDeviceAttributes",
      "collectWebRtc",
      "Chrome",
      "permission",
      "webkitRTCPeerConnection",
      "__webdriver_script_func",
      "function query() { [native code] }",
      "performance",
      "info",
      "href",
      "origin",
      "videoInputDevices",
      "Rotor",
      "http://127.0.0.1",
      "NAVIGATOR_LANGUAGES",
      "RTCPeerConnection",
      "fonts",
      "_FAILED",
      "NuVision",
      "android",
      "metadataQueue",
      "shadingLanguageVersion",
      "Battery ",
      "keyboard",
      "MAX_VERTEX_UNIFORM_VECTORS",
      "productSub",
      "accessibility-events",
      "internationalization",
      "safeAddMetadata",
      "iphone",
      "detectIncognitoInternal",
      "isInvalidStackTraceSize",
      'video/mp4;; codecs = "avc1.42E01E"',
      "consistent_plugins_prototype",
      "propertyDescriptors",
      "opr",
      "reducedTransparency",
      "__lastWatirAlert",
      "seleniumSequentum",
      "resolve",
      "getDevicePayload",
      "canPlayType",
      "PREFERS_COLOR_SCHEME",
      "diffbot",
      "detectChromium",
      "NAVIGATOR_WEB_DRIVER",
      "getParameter",
      "onupgradeneeded",
      "page_visibility",
      "35866TVtBjV",
      "cookieStore",
      "hasEvent",
      "expm1",
      "custom_protocol_handler",
      "getAttribute",
      "ambient-light-sensor",
      "getAllLies",
      "email",
      "fingerPrintComponents",
      "onicecandidate",
      "pagevisibility",
      "NAVIGATOR_PLUGINS_LENGTH",
      "add",
      "lastCalculatedMetadata",
      "seleniumInNavigator",
      "NAVIGATOR_SERIAL_SUPPORTED",
      "duration",
      "ai2bot",
      "intl",
      "pow",
      "ACCELEROMETER_SUPPORTED",
      "matches",
      "rtt",
      "maxVertexTextureImageUnits",
      "HAS_CHROME_LOADTIMES",
      "signal",
      "kind",
      "NAVIGATOR_KEYBOARD_SUPPORTED",
      "selenium_in_window",
      "addStealthTest",
      "round",
      "Geolocation permission state is '",
      "_pingOneSignalsPingResult",
      "batteryInit",
      "iframeWindow",
      "height",
      "SCREEN_FRAME",
      "function toString() { [native code] }",
      "messagechannel",
      "closed",
      "WEBGL_MAXVARYINGVECTORS",
      "failed to add properties descriptor",
      "googleother-image",
      "seleniumInDocument",
      "videoCard",
      "HAS_MICROPHONE",
      "Essential",
      "experimental-webgl",
      "blob_constructor",
      "name",
      "OS_NAME",
      "SeleniumProperties",
      "hasMicrophone",
      "library",
      "proximity",
      "getFrequencyResponse",
      "createOffer",
      "Security error",
      "vendorFlavors",
      "AUDIO",
      "deviceId",
      "__driver_unwrapped",
      "pointerevents",
      "AGENT_BASE_URL",
      "anthropic-ai",
      "Dell",
      "gamepads",
      "getHasLiedBrowser",
      "string",
      "__lastWatirConfirm",
      "Battery not supported!",
      "NAVIGATOR_LANGUAGE",
      "scrapy",
      "promiseTimeout",
      "__nightmare",
      "forEach",
      "iframe_window",
      "addPropertyDescriptorInfo",
      "function ",
      "calledSelenium",
      "random",
      "BLUTOOTH_SUPPORTED",
      "49TVcSOF",
      "deviceMemory",
      "ipod",
      "clipboard-write",
      "BATTERY_LEVEL",
      "() {",
      "MQ_SCREEN",
      "agentIdentificationEnabled",
      "unknown transient reason",
      "spawn",
      "persistent-storage",
      "navigator.plugins_empty",
      "getExtension",
      "flatAndAddMetadata",
      "push",
      "maxFragmentUniformVectors",
      "calculateDeviceMetadata",
      "getCurrentBrowserFingerPrint",
      "trustTokenOperationError",
      "blank page",
      "universalTrustEnabled",
      "you",
      "metadataBlackList",
      "battery",
      "MAX_COMBINED_TEXTURE_IMAGE_UNITS",
      "domBlockers",
      "getUndefinedValueLie",
      "fingerPrintComponentKeys",
      "Geolocation API is not supported by this browser.",
      "electron",
      "ligatures",
      "game_pads",
      "hasWebcam",
      "invertedColors",
      "set",
      "canvas",
      "engine",
      "WEBGL_MAXTEXTURESIZE",
      "mozRTCPeerConnection",
      "NAVIGATOR_USER_AGENT",
      "perplexitybot",
      "assign",
      "' in browser '",
      "cookieEnabled",
      "quota detection failed: ",
      "interestCohort",
      "permissions_api_overriden",
      "webkitRequestFileSystem",
      "getLies",
      "openDatabase",
      "getFingerPrint",
      "memory",
      "browserMajor",
      "ZTE",
      "isBot",
      "debug",
      "WEBGL_VERSION",
      "fmget_targets",
      "stringify",
      "innerHeight",
      "20030107",
      "statusText",
      "apply",
      "custom_event",
      "mediaplayer",
      "MAX_VERTEX_TEXTURE_IMAGE_UNITS",
      "addIframeData",
      "sessionStorage.length",
      "filename",
      "allSettled",
      "NOTIFICATION_PERMISSION",
      "tablet",
      "onLine",
      "enumerateDevices",
      "rad.io",
      "HAS_CHROME_APP",
      "documentElement",
      "enumerateDevicesEnabled",
      "calculated browser device attributes.",
      "applePay",
      "failed to get fingerprint info",
      "Brave",
      "longitude",
      "charging",
      "__selenium_unwrapped",
      "hasOwnProperty",
      "document",
      "availHeight",
      "deleteDatabase",
      "coords",
      "lieTypes",
      "getWebglCanvas",
      "getOwnPropertyDescriptors",
      "indexeddbblob",
      "462291Onrrdu",
      "stack",
      "iframe",
      "function get ",
      "659461WYWsqS",
      "MEMORY_HEAP_SIZE_LIMIT",
      "chargingTime",
      "websockets",
      "DetectHeadless",
      "open",
      "speed",
      "Geolocation retrieval failed: Unknown geolocation error occurred.",
      "availWidth",
      "function () { [native code] }",
      "race",
      "NAVIGATOR_APP_VERSION",
      "cant",
      "all",
      "Windows",
      "PERMISSIONS",
      "data_view",
      "refreshDeviceAttributes",
      "DOCUMENT_ELEMENT_SELENIUM",
      "ondeviceproximity",
      "sin",
      "isBatterySupported",
      "indexeddb",
      "BLINK",
      "media",
      "query",
      "DOM_BLOCKERS",
      "CPU_ARCHITECTURE",
      "html",
      "getGeoSessionData",
      "numberOfAudioDevices",
      "Verizon",
      "NAVIGATOR_CONNECTION_RTT",
      "sent",
      "caller",
      "timpibot",
      "PromiseQueue",
      "INCOMPATIBLE_BROWSER",
      "audiooutput",
      "freeze",
      "NAVIGATOR_CLIENT_HINTS_PLATFORM",
      "referrer",
      "getRandomValues",
      "media_source",
      "Promise",
      "application/json",
      "type",
      "window_geb",
      "__driver_evaluate",
      "IS_TOUCH_DEVICE",
      "getPermissionsMetadata",
      "isWebGlSupported",
      "agentPort",
      "batteryChargingTime",
      "queryselector",
      "exif_orientation",
      "plugins",
      "webdriver",
      "BROWSER_TYPE",
      "architecture",
      "RunPerfTest",
      "failed to add iframe data",
      "audioinput",
      "__fxdriver_unwrapped",
      "youbot",
      "ccbot",
      "IS_AIBot",
      "failed to add client hints",
      "floc_version",
      "Volvo",
      "function get contentWindow() { [native code] }",
      "MAX_VERTEX_ATTRIBS",
      "htmlGeoLocation_timestamp",
      "WEB_RTC_SRFLX_IP",
      "latitude",
      "agentTimeout",
      "batteryCharging",
      "AiaSignals",
      "driver-evaluate",
      "history",
      "enumerateDevices() not supported.",
      "trim",
      "audio/aac",
      "getHeadlessResults",
      "Slack",
      "Yahoo! Japan",
      "DeviceOrientationEvent",
      "custom_elements",
      "() { [native code] }",
      "getMediaCodec",
      "getOps",
      "browser",
      "isPrivateMode",
      "ambient_light",
      "HAS_CAMERA",
      "ignore",
      "force_touch",
      "remove",
      "tan",
      "cors",
      "substr",
      "googleother-video",
      "contentWindow",
      "BROWSER_ENGINE_NAME",
      "WEBKIT_FORCE_AT_FORCE_MOUSE_DOWN",
      "getLineDash",
      "maxVaryingVectors",
      "omgilibot",
      "BROWSER_NAME",
      "createObjectStore",
      "browserName",
      "toUpperCase",
      "indexedDB",
      "NAVIGATOR_PLATFORM",
      "userLanguage",
      "FONT_PREFERENCES",
      "searchLies",
      "audioIntVideoInit",
      "webGlBasics",
      "disabledStorage",
      "externalIdentifiers",
      "webgl",
      "match",
      "__$webdriverAsyncExecutor",
      "outerHeight",
      "numberOfVideoDevices",
      "onerror",
      "Voice",
      "HAS_CHROME_RUNTIME",
      "setTrustToken",
      "isAIBot",
      "Sequentum",
      "external",
      "gptbot",
      "error_code",
      "userAgentData",
      "callPhantom",
      "TIMEOUT",
      "GYROSCOPE_SUPPORTED",
      "Invalid geoData JSON in session storage:",
      "inIframe",
      "LOG2E",
      "Util",
      "Failed to get FingerPrint ",
      "window.chrome_missing",
      "enumerateDevices failed",
      " headless test was failed",
      "AGENT_DEVICE_URL",
      "callSelenium",
      "constructor",
      "getSupportedExtensions",
      "deviceType",
      "Notification",
      "cos",
      "Xq7tSbjB517mhZwt",
      "includes",
      "VIDEO_INPUT_DEVICES",
      "force_touch.webkit_force_at_mouse_down",
      "hide",
      "Geolocation retrieval failed: Location request timed out.",
      "maxCombinedTextureImageUnits",
      "RCA",
      "htmlGeoLocation_accuracy",
      "addClientHints",
      "htmlGeoLocation",
      "getPrototypeInFunctionLie",
      "acos",
      "MEMORY_USED_HEAP_SIZE",
      "getSensorsMetadata",
      "getIdentificationMetadata",
      "documentLie",
      "WEBGL_MAXFRAGMENTUNIFORMVECTORS",
      "cros",
      "hasSpeakers",
      "ondevicemotion",
      "Incognito",
      "pdfViewerEnabled",
      "PingOne Signals deviceId: ",
      "engineName",
      "host",
      "IS_WEB_GLSTATUS",
      "toString",
      "__phantomas",
      "domAutomationController",
      "dataPoints",
      "put",
      "FingerPrint failed",
      "loadTimes",
      "batteryLevel",
      "accuracy",
      "HASLIEDLANGUAGES",
      "tanh",
      "Dragon Touch",
      "cbrt",
      "AUDIO_INPUT_DEVICES",
      "FINGER_PRINT",
      "detect",
      "vertical",
      "claude-web",
      "isElectronFamily",
      "crawler",
      "selenium-evaluate",
      "fingerprintTimeoutMillis",
      "GPS_SUPPORTED",
      "getDirectory",
      "aiaSignals",
      "languages",
      "request_animation_frame",
      "create",
      "components",
      "NextBook",
      "applebot",
      "getRTCPeerConnection",
      "failed to get lies results",
      "ARCHITECTURE",
      "Logger",
      "webglVersion",
      "length",
      "getAiaSignals",
      "horizontal",
      "_Selenium_IDE_Recorder",
      "prompt",
      "filter",
      "geb",
      "webgl2",
      "htmlGeoLocation_longitude",
      "LvTel",
      "contrast",
      "failed to get deviceId info",
      "WEBGL_MAXRENDERBUFFERSIZE",
      "audioOutputDevices",
      "additionalMediaCodecs",
      "accelerometer",
      "pointerlock",
      "gyroscope",
      "MEDIA_CODEC_X_M4A",
      "setLocalDescription",
      "NAVIGATOR_DEVICE_MEMORY",
      "platform",
      "left",
      "service_worker",
      "microphone",
      "timestamp",
      "AT&T",
      "app",
      "toSource",
      "NAVIGATOR_PRESENTATION_SUPPORTED",
      "IS_MOBILE",
      "msMaxTouchPoints",
      "geolocation",
      "semrushbot-ocob",
      "denied",
      "metadataParams",
      "ChromeDriverw",
      "audioInputDevices",
      "version",
      "fingerPrint",
      "permissions",
      "__assign",
      "isIAFDetectionEnabled",
      "lieTests",
      "msPointerEnabled",
      "deviceCreatedAt",
      "split",
      "iOS",
      "test",
      "...",
      "IS_ELECTRON_FAMILY",
      "4ciBhSC",
      "domAutomation",
      "createElement",
      "monochrome",
      "navigator",
      "context_menu",
      "[[IsRevoked]]",
      "getIoMetadata",
      "getStealthResult",
      "visitorId",
      "Flip Player",
      "continue",
      "payment-handler",
      "AUDIO_FINGERPRINT",
      "fetcher",
      "MEDIA_CODEC_AAC",
      "SHADING_LANGUAGE_VERSION",
      "level",
      "contextmenu",
      "video",
      "getContext",
      "camera",
      "mimeTypes",
      "call",
      "connection",
      "colorGamut",
      "text",
      "getLocalAgentJwt",
      "facebookbot",
      "Envizen",
      "Failed to fetch the Workstation data. Request timed out after ",
      "cpuClass",
      "aiSignalsResult",
      "SDKBP_FINGERPRINT",
      "innerWidth",
      "sinh",
      "isFunction",
      "HASLIEDOS",
      "error",
      "safeModernizrOn",
      "forcedColors",
      "omgili",
      "notifications",
      "localAgentJwtRequestCount",
      "eventlistener",
      "getHasLiedOs",
      "ambientlight",
      "ops",
      "exec",
      "localAgentAccessor",
      "Error during detection of aiasignals:",
      "__webdriver_script_fn",
      "next",
      "serviceworker",
      "appName",
      "__fxdriver_evaluate",
      "isIphoneOrIPad",
      "_POSignalsMetadata",
      "gpsSupported",
      "forcetouch",
      "osCpu",
      "mediaDevices",
      "trustToken",
      "77962nplGEe",
      "isWebGl2",
      "indexOf",
      "maxTouchPoints",
      "full_screen",
      "40tAfuey",
      "mac",
      "NAVIGATOR_APP_CODE_NAME",
      "WebGLMetadata",
      "htmlGeoLocation_ErrorMessage",
      "audioBaseLatency",
      "Neither WebGL 2.0 nor WebGL 1.0 is supported.",
      "undefined",
      "evaluateModernizr",
      "floc_id",
      "json",
      "MEMORY_TOTAL_HEAP_SIZE",
      "fingerprint",
      "DetectLies",
      "[[Handler]]",
      "Linux",
      "Opera",
      "trys",
      "WEBGL2VENDORANDRENDERER",
      "arguments",
      "speechSynthesis",
      "htmlGeoLocation_heading",
      "trident",
      "FingerprintJS",
      "extensions",
      "body",
      "setItem",
      "__proto__",
      "167168BPQvBl",
      "index_chrome_too_high",
      "calculatedDevToolsOpen",
      "__selenium_evaluate",
      "timezone",
      "1278549CGIQXB",
      "win",
      "propertyBlackList",
      "getDeviceAttributes",
      "webkitTemporaryStorage",
      "Firefox",
      "log10",
      "audio/x-m4a",
      "hid",
      "webRtcUrl",
      "dart",
      "Function",
      "headlessTests",
      "pop",
      "googleother",
      "toFixed",
      "copyFromChannel",
      "LN2",
      "ipad",
      "stealth test ",
      "window_html_webdriver",
      "WEBKIT_FORCE_AT_MOUSE_DOWN",
      "SQRT2",
      "iframe.contentWindow",
      "webzio-extended",
      "ontouchstart",
      "screenResolution",
      "midi",
      "chrome",
      "MAX_FRAGMENT_UNIFORM_VECTORS",
      "join",
      "fullscreen",
      "meta-externalagent",
      "headlessResults",
      "Unknown",
      "__webdriver_unwrapped",
      "oai-searchbot",
      "webdriver-evaluate-response",
      "pike",
      "delay",
      "jsHeapSizeLimit",
      "MEDIA_CODEC_",
      "getElementsByTagName",
      "downlinkMax",
      "failed ",
      "DetectStealth",
      "vendor",
      "RESOLUTION",
      "PERMISSION_DENIED",
      "candidate",
      "36fvgLzH",
      "Windows Phone",
      "done",
      "msSaveBlob",
      "NAVIGATOR_CLIENT_HINTS_BRAND_",
      "usedJSHeapSize",
      "value",
      "GET",
      "MAX_RENDERBUFFER_SIZE",
      "deviceVendor",
      "getGeoLocationData",
      "product",
      "_POSignalsUtils",
      "prototype",
      "HASLIEDBROWSER",
      "number",
      "cpuArchitecture",
      "UAParserHelperMetadata",
      "totalJSHeapSize",
      "linux",
      "window_RunPerfTest",
      "WEBGL_MAXVERTEXTEXTUREIMAGEUNITS",
      "isChromeFamily",
      "NAVIGATOR_VENDOR",
      "screen",
      "renderer",
      "getNewObjectToStringTypeErrorLie",
      "audio",
      "firefox",
      "RENDERER",
      "PingOne Signals deviceCreatedAt: ",
      "isCanvasSupported",
      "StackTraceTester",
      "dischargingTime",
      "vibrate",
      "POSITION_UNAVAILABLE",
      "Modernizr",
      "warn",
      "userAgent",
      "notification",
      "MediaSource",
      "getClientRects",
      "width",
      "NAVIGATOR_HARDWARE_CONCURRENCY",
      "browserType",
      "prefixed",
      "getOwnPropertyDescriptor",
      "BROWSER_VERSION",
      "brand",
      "return",
      "BROWSER_TAB_HISTORY_LENGTH",
      "cookiesEnabled",
      "HAS_CHROME_CSI",
      "IS_ACCEPT_COOKIES",
      "catch",
      "WEBGL_EXTENSIONS",
      "osVersion",
      "touchevents",
      "Safari",
      "navigator.webdriver_present",
      "colorDepth",
      "__awaiter",
      "state",
      "getHasLiedResolution",
      "sendMessage",
      "94375WvHsBB",
      "blobconstructor",
      "IS_WEBGL",
      "brands",
      "OPS",
      "Barnes & Noble",
      "emit",
      "getOwnPropertyLie",
      "window_fmget_targets",
      "WEBGL_MAXVERTEXATTRIBS",
      "dark",
      "mobile",
      "typedarrays",
      "MAX_VARYING_VECTORS",
      "keys",
      "storage",
      "typed_arrays",
      "BATTERY_DISCHARGING_TIME",
      "has",
      "NAVIGATOR_MAX_TOUCH_POINTS",
      "isPrivateModeV2",
      "getBattery",
      "engineVersion",
      "safari",
      "AbortError",
      "then",
      "osName",
      "Android",
      "PUSH_NOTIFICATIONS_SUPPORTED",
      "selenium_sequentum",
      "outerWidth",
      "slice",
      "getTime",
      "LIES.",
      "runtime",
      "abort",
      "cryptography",
      "throw",
      "cli",
      "quota_management",
      "WEB_RTC_ENABLED",
      "supported",
      "Internet Explorer",
      "NAVIGATOR_MIME_TYPES_LENGTH",
      "NETWORK_TYPE",
      "appVersion",
      "_phantom",
      "Mac",
      "__webdriver_script_function",
      "screenFrame",
      "hdr",
      "webRtcIps",
      "initDeviceIdentity",
      "sessionStorage"
    ];
    return (pn = function() {
      return a;
    })();
  };
  var No = Ue, Bo = pn, X;
  (function(a, c) {
    typeof a.CustomEvent != "function" && (a.CustomEvent = /* @__PURE__ */ function() {
      return function(r, e) {
        e = e || { bubbles: !1, cancelable: !1, detail: null };
        var t = document.createEvent("CustomEvent");
        return t.initCustomEvent(r, e.bubbles, e.cancelable, e.detail), t;
      };
    }());
  })(window), function() {
    var a = "st-ping-div";
    function c(i) {
      document.readyState !== "loading" ? i() : document.addEventListener("DOMContentLoaded", i);
    }
    function r(i) {
      c(function() {
        var s;
        i && ((s = document.getElementById(a)) || ((s = document.createElement("div")).style.border = "none", s.style.position = "absolute", s.style.top = "-999px", s.style.left = "-999px", s.style.width = "0", s.style.height = "0", s.style.visibility = "hidden", s.style.overflow = "hidden", s.id = a, document.body.appendChild(s)), s = s, window._pingOneSignalsToken = getComputedStyle(s, "::after").content.replace(
          /['"]+/g,
          ""
        ), document.dispatchEvent(new CustomEvent("PingOneSignalsTokenReadyEvent"))), s = "Finished - " + (i ? "success" : "failure"), window["enable-logs-pingOneSignals"] && console.log(s);
      });
    }
    var e, t, n = document.querySelector("script[data-pingOneSignalsSkipToken]");
    n && n.getAttribute("data-pingOneSignalsSkipToken") === "true" ? (window._pingOneSignalsToken = "skipped_token_" + (/* @__PURE__ */ new Date()).getTime(), c(function() {
      document.dispatchEvent(new CustomEvent("PingOneSignalsTokenSkippedEvent"));
    })) : (window._pingOneSignalsToken || (window._pingOneSignalsToken = "uninitialized_token_" + (/* @__PURE__ */ new Date()).getTime()), n = window._pingOneSignalsCustomHost || "apps.pingone.com", e = { sdkVersion: "5.6.4w", platform: navigator.platform || "" }, e = encodeURIComponent(
      function(i) {
        var s, u, h, l, d, p, y = "", k = 0, Q = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        for (i = function(m) {
          m = m.replace(/\r\n/g, `
`);
          for (var _ = "", w = 0; w < m.length; w++) {
            var A = m.charCodeAt(w);
            A < 128 ? _ += String.fromCharCode(A) : _ = 127 < A && A < 2048 ? (_ += String.fromCharCode(A >> 6 | 192)) + String.fromCharCode(63 & A | 128) : (_ = (_ += String.fromCharCode(A >> 12 | 224)) + String.fromCharCode(A >> 6 & 63 | 128)) + String.fromCharCode(63 & A | 128);
          }
          return _;
        }(i); k < i.length; )
          h = (s = i.charCodeAt(k++)) >> 2, l = (3 & s) << 4 | (s = i.charCodeAt(k++)) >> 4, d = (15 & s) << 2 | (u = i.charCodeAt(k++)) >> 6, p = 63 & u, isNaN(s) ? d = p = 64 : isNaN(u) && (p = 64), y = y + Q.charAt(h) + Q.charAt(l) + Q.charAt(d) + Q.charAt(p);
        return y;
      }(
        function(i, s) {
          for (var u = [], h = 0; h < i.length; h++) {
            var l = i.charCodeAt(h) ^ s.charCodeAt(h % s.length);
            u.push(String.fromCharCode(l));
          }
          return u.join("");
        }(JSON.stringify(e), "dkiBm42")
      )
    ), (t = document.createElement("link")).type = "text/css", t.rel = "stylesheet", t.href = "https://" + n + "/signals/sdk/pong.css?body=" + e + "&e=2", (document.head || document.getElementsByTagName("head")[0]).appendChild(t), t.onload = function() {
      r(!0);
    }, t.onerror = function() {
      r(!1);
    });
  }(), function(a) {
    a._POSignalsEntities || (a._POSignalsEntities = {}), a._pingOneSignals && console.warn("PingOne Signals script was imported multiple times");
  }(window), function(a) {
    function c(d) {
      var p = this.constructor;
      return this.then(
        function(y) {
          return p.resolve(d()).then(function() {
            return y;
          });
        },
        function(y) {
          return p.resolve(d()).then(function() {
            return p.reject(y);
          });
        }
      );
    }
    var r = setTimeout;
    function e(d) {
      return !!(d && d.length !== void 0);
    }
    function t() {
    }
    function n(d) {
      if (!(this instanceof n)) throw new TypeError("Promises must be constructed via new");
      if (typeof d != "function") throw new TypeError("not a function");
      this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], l(d, this);
    }
    function i(d, p) {
      for (; d._state === 3; ) d = d._value;
      d._state !== 0 ? (d._handled = !0, n._immediateFn(function() {
        var y = d._state === 1 ? p.onFulfilled : p.onRejected;
        if (y !== null) {
          var k;
          try {
            k = y(d._value);
          } catch (Q) {
            return void u(p.promise, Q);
          }
          s(p.promise, k);
        } else (d._state === 1 ? s : u)(p.promise, d._value);
      })) : d._deferreds.push(p);
    }
    function s(d, p) {
      try {
        if (p === d) throw new TypeError("A promise cannot be resolved with itself.");
        if (p && (typeof p == "object" || typeof p == "function")) {
          var y = p.then;
          if (p instanceof n) return d._state = 3, d._value = p, void h(d);
          if (typeof y == "function")
            return void l(
              (k = y, Q = p, function() {
                k.apply(Q, arguments);
              }),
              d
            );
        }
        d._state = 1, d._value = p, h(d);
      } catch (m) {
        u(d, m);
      }
      var k, Q;
    }
    function u(d, p) {
      d._state = 2, d._value = p, h(d);
    }
    function h(d) {
      d._state === 2 && d._deferreds.length === 0 && n._immediateFn(function() {
        d._handled || n._unhandledRejectionFn(d._value);
      });
      for (var p = 0, y = d._deferreds.length; p < y; p++) i(d, d._deferreds[p]);
      d._deferreds = null;
    }
    function l(d, p) {
      var y = !1;
      try {
        d(
          function(k) {
            y || (y = !0, s(p, k));
          },
          function(k) {
            y || (y = !0, u(p, k));
          }
        );
      } catch (k) {
        if (y) return;
        y = !0, u(p, k);
      }
    }
    n.prototype.catch = function(d) {
      return this.then(null, d);
    }, n.prototype.then = function(d, p) {
      var y = new this.constructor(t);
      return i(
        this,
        new function(k, Q, m) {
          this.onFulfilled = typeof k == "function" ? k : null, this.onRejected = typeof Q == "function" ? Q : null, this.promise = m;
        }(d, p, y)
      ), y;
    }, n.prototype.finally = c, n.all = function(d) {
      return new n(function(p, y) {
        if (!e(d)) return y(new TypeError("Promise.all accepts an array"));
        var k = Array.prototype.slice.call(d);
        if (k.length === 0) return p([]);
        var Q = k.length;
        function m(w, A) {
          try {
            if (A && (typeof A == "object" || typeof A == "function")) {
              var U = A.then;
              if (typeof U == "function")
                return void U.call(
                  A,
                  function(pe) {
                    m(w, pe);
                  },
                  y
                );
            }
            k[w] = A, --Q == 0 && p(k);
          } catch (pe) {
            y(pe);
          }
        }
        for (var _ = 0; _ < k.length; _++) m(_, k[_]);
      });
    }, n.resolve = function(d) {
      return d && typeof d == "object" && d.constructor === n ? d : new n(function(p) {
        p(d);
      });
    }, n.reject = function(d) {
      return new n(function(p, y) {
        y(d);
      });
    }, n.race = function(d) {
      return new n(function(p, y) {
        if (!e(d)) return y(new TypeError("Promise.race accepts an array"));
        for (var k = 0, Q = d.length; k < Q; k++) n.resolve(d[k]).then(p, y);
      });
    }, n._immediateFn = typeof setImmediate == "function" && function(d) {
      setImmediate(d);
    } || function(d) {
      r(d, 0);
    }, n._unhandledRejectionFn = function(d) {
      typeof console < "u" && console && console.warn("Possible Unhandled Promise Rejection:", d);
    }, typeof a.Promise != "function" ? a.Promise = n : a.Promise.prototype.finally || (a.Promise.prototype.finally = c);
  }(window), function(a, c) {
    (X || (X = {})).PromiseQueue = function() {
      var r = function() {
      };
      function e(t, n, i) {
        this.options = i = i || {}, this.pendingPromises = 0, this.maxPendingPromises = t !== void 0 ? t : 1 / 0, this.maxQueuedPromises = n !== void 0 ? n : 1 / 0, this.queue = [];
      }
      return e.prototype.add = function(t) {
        var n = this;
        return new Promise(function(i, s, u) {
          n.queue.length >= n.maxQueuedPromises ? s(new Error("Queue limit reached")) : (n.queue.push({ promiseGenerator: t, resolve: i, reject: s, notify: u || r }), n._dequeue());
        });
      }, e.prototype.getPendingLength = function() {
        return this.pendingPromises;
      }, e.prototype.getQueueLength = function() {
        return this.queue.length;
      }, e.prototype._dequeue = function() {
        var t = this;
        if (this.pendingPromises >= this.maxPendingPromises) return !1;
        var n, i = this.queue.shift();
        if (!i) return this.options.onEmpty && this.options.onEmpty(), !1;
        try {
          this.pendingPromises++, (n = i.promiseGenerator(), n && typeof n.then == "function" ? n : new Promise(function(s) {
            s(n);
          })).then(
            function(s) {
              t.pendingPromises--, i.resolve(s), t._dequeue();
            },
            function(s) {
              t.pendingPromises--, i.reject(s), t._dequeue();
            },
            function(s) {
              i.notify(s);
            }
          );
        } catch (s) {
          t.pendingPromises--, i.reject(s), t._dequeue();
        }
        return !0;
      }, e;
    }();
  }(), function(a) {
    var c = "input is invalid type", r = !a.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", e = "0123456789abcdef".split(""), t = [-2147483648, 8388608, 32768, 128], n = [24, 16, 8, 0], i = [
      1116352408,
      1899447441,
      3049323471,
      3921009573,
      961987163,
      1508970993,
      2453635748,
      2870763221,
      3624381080,
      310598401,
      607225278,
      1426881987,
      1925078388,
      2162078206,
      2614888103,
      3248222580,
      3835390401,
      4022224774,
      264347078,
      604807628,
      770255983,
      1249150122,
      1555081692,
      1996064986,
      2554220882,
      2821834349,
      2952996808,
      3210313671,
      3336571891,
      3584528711,
      113926993,
      338241895,
      666307205,
      773529912,
      1294757372,
      1396182291,
      1695183700,
      1986661051,
      2177026350,
      2456956037,
      2730485921,
      2820302411,
      3259730800,
      3345764771,
      3516065817,
      3600352804,
      4094571909,
      275423344,
      430227734,
      506948616,
      659060556,
      883997877,
      958139571,
      1322822218,
      1537002063,
      1747873779,
      1955562222,
      2024104815,
      2227730452,
      2361852424,
      2428436474,
      2756734187,
      3204031479,
      3329325298
    ], s = ["hex", "array", "digest", "arrayBuffer"], u = [];
    !a.JS_SHA256_NO_NODE_JS && Array.isArray || (Array.isArray = function(m) {
      return Object.prototype.toString.call(m) === "[object Array]";
    }), !r || !a.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function(m) {
      return typeof m == "object" && m.buffer && m.buffer.constructor === ArrayBuffer;
    });
    var h = function(m, _) {
      return function(w) {
        return new y(_, !0).update(w)[m]();
      };
    }, l = function(m) {
      var _ = h("hex", m);
      _.create = function() {
        return new y(m);
      }, _.update = function(U) {
        return _.create().update(U);
      };
      for (var w = 0; w < s.length; ++w) {
        var A = s[w];
        _[A] = h(A, m);
      }
      return _;
    }, d = function(m, _) {
      return function(w, A) {
        return new k(w, _, !0).update(A)[m]();
      };
    }, p = function(m) {
      var _ = d("hex", m);
      _.create = function(U) {
        return new k(U, m);
      }, _.update = function(U, pe) {
        return _.create(U).update(pe);
      };
      for (var w = 0; w < s.length; ++w) {
        var A = s[w];
        _[A] = d(A, m);
      }
      return _;
    };
    function y(m, _) {
      _ ? (u[0] = u[16] = u[1] = u[2] = u[3] = u[4] = u[5] = u[6] = u[7] = u[8] = u[9] = u[10] = u[11] = u[12] = u[13] = u[14] = u[15] = 0, this.blocks = u) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], m ? (this.h0 = 3238371032, this.h1 = 914150663, this.h2 = 812702999, this.h3 = 4144912697, this.h4 = 4290775857, this.h5 = 1750603025, this.h6 = 1694076839, this.h7 = 3204075428) : (this.h0 = 1779033703, this.h1 = 3144134277, this.h2 = 1013904242, this.h3 = 2773480762, this.h4 = 1359893119, this.h5 = 2600822924, this.h6 = 528734635, this.h7 = 1541459225), this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0, this.is224 = m;
    }
    function k(m, _, w) {
      var A, U = typeof m;
      if (U === "string") {
        var pe, D = [], W = m.length, P = 0;
        for (A = 0; A < W; ++A)
          (pe = m.charCodeAt(A)) < 128 ? D[P++] = pe : pe < 2048 ? (D[P++] = 192 | pe >> 6, D[P++] = 128 | 63 & pe) : pe < 55296 || pe >= 57344 ? (D[P++] = 224 | pe >> 12, D[P++] = 128 | pe >> 6 & 63, D[P++] = 128 | 63 & pe) : (pe = 65536 + ((1023 & pe) << 10 | 1023 & m.charCodeAt(++A)), D[P++] = 240 | pe >> 18, D[P++] = 128 | pe >> 12 & 63, D[P++] = 128 | pe >> 6 & 63, D[P++] = 128 | 63 & pe);
        m = D;
      } else {
        if (U !== "object") throw new Error(c);
        if (m === null) throw new Error(c);
        if (r && m.constructor === ArrayBuffer) m = new Uint8Array(m);
        else if (!(Array.isArray(m) || r && ArrayBuffer.isView(m))) throw new Error(c);
      }
      m.length > 64 && (m = new y(_, !0).update(m).array());
      var N = [], H = [];
      for (A = 0; A < 64; ++A) {
        var j = m[A] || 0;
        N[A] = 92 ^ j, H[A] = 54 ^ j;
      }
      y.call(this, _, w), this.update(H), this.oKeyPad = N, this.inner = !0, this.sharedMemory = w;
    }
    y.prototype.update = function(m) {
      if (!this.finalized) {
        var _, w = typeof m;
        if (w !== "string") {
          if (w !== "object") throw new Error(c);
          if (m === null) throw new Error(c);
          if (r && m.constructor === ArrayBuffer) m = new Uint8Array(m);
          else if (!(Array.isArray(m) || r && ArrayBuffer.isView(m))) throw new Error(c);
          _ = !0;
        }
        for (var A, U, pe = 0, D = m.length, W = this.blocks; pe < D; ) {
          if (this.hashed && (this.hashed = !1, W[0] = this.block, W[16] = W[1] = W[2] = W[3] = W[4] = W[5] = W[6] = W[7] = W[8] = W[9] = W[10] = W[11] = W[12] = W[13] = W[14] = W[15] = 0), _)
            for (U = this.start; pe < D && U < 64; ++pe) W[U >> 2] |= m[pe] << n[3 & U++];
          else
            for (U = this.start; pe < D && U < 64; ++pe)
              (A = m.charCodeAt(pe)) < 128 ? W[U >> 2] |= A << n[3 & U++] : A < 2048 ? (W[U >> 2] |= (192 | A >> 6) << n[3 & U++], W[U >> 2] |= (128 | 63 & A) << n[3 & U++]) : A < 55296 || A >= 57344 ? (W[U >> 2] |= (224 | A >> 12) << n[3 & U++], W[U >> 2] |= (128 | A >> 6 & 63) << n[3 & U++], W[U >> 2] |= (128 | 63 & A) << n[3 & U++]) : (A = 65536 + ((1023 & A) << 10 | 1023 & m.charCodeAt(++pe)), W[U >> 2] |= (240 | A >> 18) << n[3 & U++], W[U >> 2] |= (128 | A >> 12 & 63) << n[3 & U++], W[U >> 2] |= (128 | A >> 6 & 63) << n[3 & U++], W[U >> 2] |= (128 | 63 & A) << n[3 & U++]);
          this.lastByteIndex = U, this.bytes += U - this.start, U >= 64 ? (this.block = W[16], this.start = U - 64, this.hash(), this.hashed = !0) : this.start = U;
        }
        return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
      }
    }, y.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var m = this.blocks, _ = this.lastByteIndex;
        m[16] = this.block, m[_ >> 2] |= t[3 & _], this.block = m[16], _ >= 56 && (this.hashed || this.hash(), m[0] = this.block, m[16] = m[1] = m[2] = m[3] = m[4] = m[5] = m[6] = m[7] = m[8] = m[9] = m[10] = m[11] = m[12] = m[13] = m[14] = m[15] = 0), m[14] = this.hBytes << 3 | this.bytes >>> 29, m[15] = this.bytes << 3, this.hash();
      }
    }, y.prototype.hash = function() {
      var m, _, w, A, U, pe, D, W, P, N = this.h0, H = this.h1, j = this.h2, K = this.h3, ae = this.h4, ce = this.h5, ee = this.h6, re = this.h7, F = this.blocks;
      for (m = 16; m < 64; ++m)
        _ = ((U = F[m - 15]) >>> 7 | U << 25) ^ (U >>> 18 | U << 14) ^ U >>> 3, w = ((U = F[m - 2]) >>> 17 | U << 15) ^ (U >>> 19 | U << 13) ^ U >>> 10, F[m] = F[m - 16] + _ + F[m - 7] + w << 0;
      for (P = H & j, m = 0; m < 64; m += 4)
        this.first ? (this.is224 ? (pe = 300032, re = (U = F[0] - 1413257819) - 150054599 << 0, K = U + 24177077 << 0) : (pe = 704751109, re = (U = F[0] - 210244248) - 1521486534 << 0, K = U + 143694565 << 0), this.first = !1) : (_ = (N >>> 2 | N << 30) ^ (N >>> 13 | N << 19) ^ (N >>> 22 | N << 10), A = (pe = N & H) ^ N & j ^ P, re = K + (U = re + (w = (ae >>> 6 | ae << 26) ^ (ae >>> 11 | ae << 21) ^ (ae >>> 25 | ae << 7)) + (ae & ce ^ ~ae & ee) + i[m] + F[m]) << 0, K = U + (_ + A) << 0), _ = (K >>> 2 | K << 30) ^ (K >>> 13 | K << 19) ^ (K >>> 22 | K << 10), A = (D = K & N) ^ K & H ^ pe, ee = j + (U = ee + (w = (re >>> 6 | re << 26) ^ (re >>> 11 | re << 21) ^ (re >>> 25 | re << 7)) + (re & ae ^ ~re & ce) + i[m + 1] + F[m + 1]) << 0, _ = ((j = U + (_ + A) << 0) >>> 2 | j << 30) ^ (j >>> 13 | j << 19) ^ (j >>> 22 | j << 10), A = (W = j & K) ^ j & N ^ D, ce = H + (U = ce + (w = (ee >>> 6 | ee << 26) ^ (ee >>> 11 | ee << 21) ^ (ee >>> 25 | ee << 7)) + (ee & re ^ ~ee & ae) + i[m + 2] + F[m + 2]) << 0, _ = ((H = U + (_ + A) << 0) >>> 2 | H << 30) ^ (H >>> 13 | H << 19) ^ (H >>> 22 | H << 10), A = (P = H & j) ^ H & K ^ W, ae = N + (U = ae + (w = (ce >>> 6 | ce << 26) ^ (ce >>> 11 | ce << 21) ^ (ce >>> 25 | ce << 7)) + (ce & ee ^ ~ce & re) + i[m + 3] + F[m + 3]) << 0, N = U + (_ + A) << 0;
      this.h0 = this.h0 + N << 0, this.h1 = this.h1 + H << 0, this.h2 = this.h2 + j << 0, this.h3 = this.h3 + K << 0, this.h4 = this.h4 + ae << 0, this.h5 = this.h5 + ce << 0, this.h6 = this.h6 + ee << 0, this.h7 = this.h7 + re << 0;
    }, y.prototype.hex = function() {
      this.finalize();
      var m = this.h0, _ = this.h1, w = this.h2, A = this.h3, U = this.h4, pe = this.h5, D = this.h6, W = this.h7, P = e[m >> 28 & 15] + e[m >> 24 & 15] + e[m >> 20 & 15] + e[m >> 16 & 15] + e[m >> 12 & 15] + e[m >> 8 & 15] + e[m >> 4 & 15] + e[15 & m] + e[_ >> 28 & 15] + e[_ >> 24 & 15] + e[_ >> 20 & 15] + e[_ >> 16 & 15] + e[_ >> 12 & 15] + e[_ >> 8 & 15] + e[_ >> 4 & 15] + e[15 & _] + e[w >> 28 & 15] + e[w >> 24 & 15] + e[w >> 20 & 15] + e[w >> 16 & 15] + e[w >> 12 & 15] + e[w >> 8 & 15] + e[w >> 4 & 15] + e[15 & w] + e[A >> 28 & 15] + e[A >> 24 & 15] + e[A >> 20 & 15] + e[A >> 16 & 15] + e[A >> 12 & 15] + e[A >> 8 & 15] + e[A >> 4 & 15] + e[15 & A] + e[U >> 28 & 15] + e[U >> 24 & 15] + e[U >> 20 & 15] + e[U >> 16 & 15] + e[U >> 12 & 15] + e[U >> 8 & 15] + e[U >> 4 & 15] + e[15 & U] + e[pe >> 28 & 15] + e[pe >> 24 & 15] + e[pe >> 20 & 15] + e[pe >> 16 & 15] + e[pe >> 12 & 15] + e[pe >> 8 & 15] + e[pe >> 4 & 15] + e[15 & pe] + e[D >> 28 & 15] + e[D >> 24 & 15] + e[D >> 20 & 15] + e[D >> 16 & 15] + e[D >> 12 & 15] + e[D >> 8 & 15] + e[D >> 4 & 15] + e[15 & D];
      return this.is224 || (P += e[W >> 28 & 15] + e[W >> 24 & 15] + e[W >> 20 & 15] + e[W >> 16 & 15] + e[W >> 12 & 15] + e[W >> 8 & 15] + e[W >> 4 & 15] + e[15 & W]), P;
    }, y.prototype.toString = y.prototype.hex, y.prototype.digest = function() {
      this.finalize();
      var m = this.h0, _ = this.h1, w = this.h2, A = this.h3, U = this.h4, pe = this.h5, D = this.h6, W = this.h7, P = [
        m >> 24 & 255,
        m >> 16 & 255,
        m >> 8 & 255,
        255 & m,
        _ >> 24 & 255,
        _ >> 16 & 255,
        _ >> 8 & 255,
        255 & _,
        w >> 24 & 255,
        w >> 16 & 255,
        w >> 8 & 255,
        255 & w,
        A >> 24 & 255,
        A >> 16 & 255,
        A >> 8 & 255,
        255 & A,
        U >> 24 & 255,
        U >> 16 & 255,
        U >> 8 & 255,
        255 & U,
        pe >> 24 & 255,
        pe >> 16 & 255,
        pe >> 8 & 255,
        255 & pe,
        D >> 24 & 255,
        D >> 16 & 255,
        D >> 8 & 255,
        255 & D
      ];
      return this.is224 || P.push(W >> 24 & 255, W >> 16 & 255, W >> 8 & 255, 255 & W), P;
    }, y.prototype.array = y.prototype.digest, y.prototype.arrayBuffer = function() {
      this.finalize();
      var m = new ArrayBuffer(this.is224 ? 28 : 32), _ = new DataView(m);
      return _.setUint32(0, this.h0), _.setUint32(4, this.h1), _.setUint32(8, this.h2), _.setUint32(12, this.h3), _.setUint32(16, this.h4), _.setUint32(20, this.h5), _.setUint32(24, this.h6), this.is224 || _.setUint32(28, this.h7), m;
    }, k.prototype = new y(), k.prototype.finalize = function() {
      if (y.prototype.finalize.call(this), this.inner) {
        this.inner = !1;
        var m = this.array();
        y.call(this, this.is224, this.sharedMemory), this.update(this.oKeyPad), this.update(m), y.prototype.finalize.call(this);
      }
    };
    var Q = l();
    Q.sha256 = Q, Q.sha224 = l(!0), Q.sha256.hmac = p(), Q.sha224.hmac = p(!0), a.sha256 = Q.sha256, a.sha224 = Q.sha224;
  }(X || (X = {})), (X || (X = {})).FingerprintJS = function(a) {
    var c = function() {
      return (c = Object.assign || function(g) {
        for (var b, E = 1, T = arguments.length; E < T; E++)
          for (var R in b = arguments[E])
            Object.prototype.hasOwnProperty.call(b, R) && (g[R] = b[R]);
        return g;
      }).apply(this, arguments);
    };
    function r(g, b, E, T) {
      return new (E || (E = Promise))(function(R, $) {
        function ie(Y) {
          try {
            C(T.next(Y));
          } catch (q) {
            $(q);
          }
        }
        function z(Y) {
          try {
            C(T.throw(Y));
          } catch (q) {
            $(q);
          }
        }
        function C(Y) {
          var q;
          Y.done ? R(Y.value) : (q = Y.value, q instanceof E ? q : new E(function(ne) {
            ne(q);
          })).then(ie, z);
        }
        C((T = T.apply(g, [])).next());
      });
    }
    function e(g, b) {
      var E, T, R, $, ie = {
        label: 0,
        sent: function() {
          if (1 & R[0]) throw R[1];
          return R[1];
        },
        trys: [],
        ops: []
      };
      return $ = { next: z(0), throw: z(1), return: z(2) }, typeof Symbol == "function" && ($[Symbol.iterator] = function() {
        return this;
      }), $;
      function z(C) {
        return function(Y) {
          return function(q) {
            if (E) throw new TypeError("Generator is already executing.");
            for (; $ && ($ = 0, q[0] && (ie = 0)), ie; )
              try {
                if (E = 1, T && (R = 2 & q[0] ? T.return : q[0] ? T.throw || ((R = T.return) && R.call(T), 0) : T.next) && !(R = R.call(T, q[1])).done)
                  return R;
                switch (T = 0, R && (q = [2 & q[0], R.value]), q[0]) {
                  case 0:
                  case 1:
                    R = q;
                    break;
                  case 4:
                    return ie.label++, { value: q[1], done: !1 };
                  case 5:
                    ie.label++, T = q[1], q = [0];
                    continue;
                  case 7:
                    q = ie.ops.pop(), ie.trys.pop();
                    continue;
                  default:
                    if (!(R = (R = ie.trys).length > 0 && R[R.length - 1]) && (q[0] === 6 || q[0] === 2)) {
                      ie = 0;
                      continue;
                    }
                    if (q[0] === 3 && (!R || q[1] > R[0] && q[1] < R[3])) {
                      ie.label = q[1];
                      break;
                    }
                    if (q[0] === 6 && ie.label < R[1]) {
                      ie.label = R[1], R = q;
                      break;
                    }
                    if (R && ie.label < R[2]) {
                      ie.label = R[2], ie.ops.push(q);
                      break;
                    }
                    R[2] && ie.ops.pop(), ie.trys.pop();
                    continue;
                }
                q = b.call(g, ie);
              } catch (ne) {
                q = [6, ne], T = 0;
              } finally {
                E = R = 0;
              }
            if (5 & q[0]) throw q[1];
            return { value: q[0] ? q[1] : void 0, done: !0 };
          }([C, Y]);
        };
      }
    }
    function t(g, b, E) {
      for (var T, R = 0, $ = b.length; R < $; R++)
        !T && R in b || (T || (T = Array.prototype.slice.call(b, 0, R)), T[R] = b[R]);
      return g.concat(T || Array.prototype.slice.call(b));
    }
    var n = "4.6.1";
    function i(g, b) {
      return new Promise(function(E) {
        return setTimeout(E, g, b);
      });
    }
    function s(g) {
      return !!g && typeof g.then == "function";
    }
    function u(g, b) {
      try {
        var E = g();
        s(E) ? E.then(
          function(T) {
            return b(!0, T);
          },
          function(T) {
            return b(!1, T);
          }
        ) : b(!0, E);
      } catch (T) {
        b(!1, T);
      }
    }
    function h(g, b, E) {
      return E === void 0 && (E = 16), r(this, void 0, void 0, function() {
        var T, R, $, ie;
        return e(this, function(z) {
          switch (z.label) {
            case 0:
              T = Array(g.length), R = Date.now(), $ = 0, z.label = 1;
            case 1:
              return $ < g.length ? (T[$] = b(g[$], $), (ie = Date.now()) >= R + E ? (R = ie, [
                4,
                new Promise(function(C) {
                  var Y = new MessageChannel();
                  Y.port1.onmessage = function() {
                    return C();
                  }, Y.port2.postMessage(null);
                })
              ]) : [3, 3]) : [3, 4];
            case 2:
              z.sent(), z.label = 3;
            case 3:
              return ++$, [3, 1];
            case 4:
              return [2, T];
          }
        });
      });
    }
    function l(g) {
      return g.then(void 0, function() {
      }), g;
    }
    function d(g) {
      return parseInt(g);
    }
    function p(g) {
      return parseFloat(g);
    }
    function y(g, b) {
      return typeof g == "number" && isNaN(g) ? b : g;
    }
    function k(g) {
      return g.reduce(function(b, E) {
        return b + (E ? 1 : 0);
      }, 0);
    }
    function Q(g, b) {
      if (b === void 0 && (b = 1), Math.abs(b) >= 1) return Math.round(g / b) * b;
      var E = 1 / b;
      return Math.round(g * E) / E;
    }
    function m(g, b) {
      var E = g[0] >>> 16, T = 65535 & g[0], R = g[1] >>> 16, $ = 65535 & g[1], ie = b[0] >>> 16, z = 65535 & b[0], C = b[1] >>> 16, Y = 0, q = 0, ne = 0, ue = 0;
      ne += (ue += $ + (65535 & b[1])) >>> 16, ue &= 65535, q += (ne += R + C) >>> 16, ne &= 65535, Y += (q += T + z) >>> 16, q &= 65535, Y += E + ie, Y &= 65535, g[0] = Y << 16 | q, g[1] = ne << 16 | ue;
    }
    function _(g, b) {
      var E = g[0] >>> 16, T = 65535 & g[0], R = g[1] >>> 16, $ = 65535 & g[1], ie = b[0] >>> 16, z = 65535 & b[0], C = b[1] >>> 16, Y = 65535 & b[1], q = 0, ne = 0, ue = 0, Se = 0;
      ue += (Se += $ * Y) >>> 16, Se &= 65535, ne += (ue += R * Y) >>> 16, ue &= 65535, ne += (ue += $ * C) >>> 16, ue &= 65535, q += (ne += T * Y) >>> 16, ne &= 65535, q += (ne += R * C) >>> 16, ne &= 65535, q += (ne += $ * z) >>> 16, ne &= 65535, q += E * Y + T * C + R * z + $ * ie, q &= 65535, g[0] = q << 16 | ne, g[1] = ue << 16 | Se;
    }
    function w(g, b) {
      var E = g[0];
      (b %= 64) == 32 ? (g[0] = g[1], g[1] = E) : b < 32 ? (g[0] = E << b | g[1] >>> 32 - b, g[1] = g[1] << b | E >>> 32 - b) : (b -= 32, g[0] = g[1] << b | E >>> 32 - b, g[1] = E << b | g[1] >>> 32 - b);
    }
    function A(g, b) {
      (b %= 64) != 0 && (b < 32 ? (g[0] = g[1] >>> 32 - b, g[1] = g[1] << b) : (g[0] = g[1] << b - 32, g[1] = 0));
    }
    function U(g, b) {
      g[0] ^= b[0], g[1] ^= b[1];
    }
    var pe = [4283543511, 3981806797], D = [3301882366, 444984403];
    function W(g) {
      var b = [0, g[0] >>> 1];
      U(g, b), _(g, pe), b[1] = g[0] >>> 1, U(g, b), _(g, D), b[1] = g[0] >>> 1, U(g, b);
    }
    var P = [2277735313, 289559509], N = [1291169091, 658871167], H = [0, 5], j = [0, 1390208809], K = [0, 944331445];
    function ae(g, b) {
      var E = function(ue) {
        for (var Se = new Uint8Array(ue.length), De = 0; De < ue.length; De++) {
          var Ve = ue.charCodeAt(De);
          if (Ve > 127) return new TextEncoder().encode(ue);
          Se[De] = Ve;
        }
        return Se;
      }(g);
      b = b || 0;
      var T, R = [0, E.length], $ = R[1] % 16, ie = R[1] - $, z = [0, b], C = [0, b], Y = [0, 0], q = [0, 0];
      for (T = 0; T < ie; T += 16)
        Y[0] = E[T + 4] | E[T + 5] << 8 | E[T + 6] << 16 | E[T + 7] << 24, Y[1] = E[T] | E[T + 1] << 8 | E[T + 2] << 16 | E[T + 3] << 24, q[0] = E[T + 12] | E[T + 13] << 8 | E[T + 14] << 16 | E[T + 15] << 24, q[1] = E[T + 8] | E[T + 9] << 8 | E[T + 10] << 16 | E[T + 11] << 24, _(Y, P), w(Y, 31), _(Y, N), U(z, Y), w(z, 27), m(z, C), _(z, H), m(z, j), _(q, N), w(q, 33), _(q, P), U(C, q), w(C, 31), m(C, z), _(C, H), m(C, K);
      Y[0] = 0, Y[1] = 0, q[0] = 0, q[1] = 0;
      var ne = [0, 0];
      switch ($) {
        case 15:
          ne[1] = E[T + 14], A(ne, 48), U(q, ne);
        case 14:
          ne[1] = E[T + 13], A(ne, 40), U(q, ne);
        case 13:
          ne[1] = E[T + 12], A(ne, 32), U(q, ne);
        case 12:
          ne[1] = E[T + 11], A(ne, 24), U(q, ne);
        case 11:
          ne[1] = E[T + 10], A(ne, 16), U(q, ne);
        case 10:
          ne[1] = E[T + 9], A(ne, 8), U(q, ne);
        case 9:
          ne[1] = E[T + 8], U(q, ne), _(q, N), w(q, 33), _(q, P), U(C, q);
        case 8:
          ne[1] = E[T + 7], A(ne, 56), U(Y, ne);
        case 7:
          ne[1] = E[T + 6], A(ne, 48), U(Y, ne);
        case 6:
          ne[1] = E[T + 5], A(ne, 40), U(Y, ne);
        case 5:
          ne[1] = E[T + 4], A(ne, 32), U(Y, ne);
        case 4:
          ne[1] = E[T + 3], A(ne, 24), U(Y, ne);
        case 3:
          ne[1] = E[T + 2], A(ne, 16), U(Y, ne);
        case 2:
          ne[1] = E[T + 1], A(ne, 8), U(Y, ne);
        case 1:
          ne[1] = E[T], U(Y, ne), _(Y, P), w(Y, 31), _(Y, N), U(z, Y);
      }
      return U(z, R), U(C, R), m(z, C), m(C, z), W(z), W(C), m(z, C), m(C, z), ("00000000" + (z[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (z[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (C[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (C[1] >>> 0).toString(16)).slice(-8);
    }
    function ce(g) {
      return typeof g != "function";
    }
    function ee(g, b, E, T) {
      var R = Object.keys(g).filter(function(ie) {
        return !function(z, C) {
          for (var Y = 0, q = z.length; Y < q; ++Y) if (z[Y] === C) return !0;
          return !1;
        }(E, ie);
      }), $ = l(
        h(
          R,
          function(ie) {
            return function(z, C) {
              var Y = l(
                new Promise(function(q) {
                  var ne = Date.now();
                  u(z.bind(null, C), function() {
                    for (var ue = [], Se = 0; Se < arguments.length; Se++) ue[Se] = arguments[Se];
                    var De = Date.now() - ne;
                    if (!ue[0])
                      return q(function() {
                        return { error: ue[1], duration: De };
                      });
                    var Ve = ue[1];
                    if (ce(Ve))
                      return q(function() {
                        return { value: Ve, duration: De };
                      });
                    q(function() {
                      return new Promise(function(Ie) {
                        var Fe = Date.now();
                        u(Ve, function() {
                          for (var ge = [], ut = 0; ut < arguments.length; ut++)
                            ge[ut] = arguments[ut];
                          var at = De + Date.now() - Fe;
                          if (!ge[0]) return Ie({ error: ge[1], duration: at });
                          Ie({ value: ge[1], duration: at });
                        });
                      });
                    });
                  });
                })
              );
              return function() {
                return Y.then(function(q) {
                  return q();
                });
              };
            }(g[ie], b);
          },
          T
        )
      );
      return function() {
        return r(this, void 0, void 0, function() {
          var ie, z, C, Y;
          return e(this, function(q) {
            switch (q.label) {
              case 0:
                return [4, $];
              case 1:
                return [
                  4,
                  h(
                    q.sent(),
                    function(ne) {
                      return l(ne());
                    },
                    T
                  )
                ];
              case 2:
                return ie = q.sent(), [4, Promise.all(ie)];
              case 3:
                for (z = q.sent(), C = {}, Y = 0; Y < R.length; ++Y) C[R[Y]] = z[Y];
                return [2, C];
            }
          });
        });
      };
    }
    function re() {
      var g = window, b = navigator;
      return k([
        "MSCSSMatrix" in g,
        "msSetImmediate" in g,
        "msIndexedDB" in g,
        "msMaxTouchPoints" in b,
        "msPointerEnabled" in b
      ]) >= 4;
    }
    function F() {
      var g = window, b = navigator;
      return k(["msWriteProfilerMark" in g, "MSStream" in g, "msLaunchUri" in b, "msSaveBlob" in b]) >= 3 && !re();
    }
    function M() {
      var g = window, b = navigator;
      return k([
        "webkitPersistentStorage" in b,
        "webkitTemporaryStorage" in b,
        (b.vendor || "").indexOf("Google") === 0,
        "webkitResolveLocalFileSystemURL" in g,
        "BatteryManager" in g,
        "webkitMediaStream" in g,
        "webkitSpeechGrammar" in g
      ]) >= 5;
    }
    function le() {
      var g = window;
      return k([
        "ApplePayError" in g,
        "CSSPrimitiveValue" in g,
        "Counter" in g,
        navigator.vendor.indexOf("Apple") === 0,
        "RGBColor" in g,
        "WebKitMediaKeys" in g
      ]) >= 4;
    }
    function G() {
      var g = window, b = g.HTMLElement, E = g.Document;
      return k([
        "safari" in g,
        !("ongestureend" in g),
        !("TouchEvent" in g),
        !("orientation" in g),
        b && !("autocapitalize" in b.prototype),
        E && "pointerLockElement" in E.prototype
      ]) >= 4;
    }
    function te() {
      var g, b = window;
      return g = b.print, /^function\s.*?\{\s*\[native code]\s*}$/.test(String(g)) && String(b.browser) === "[object WebPageNamespace]";
    }
    function me() {
      var g, b, E = window;
      return k([
        "buildID" in navigator,
        "MozAppearance" in ((b = (g = document.documentElement) === null || g === void 0 ? void 0 : g.style) !== null && b !== void 0 ? b : {}),
        "onmozfullscreenchange" in E,
        "mozInnerScreenX" in E,
        "CSSMozDocumentRule" in E,
        "CanvasCaptureMediaStream" in E
      ]) >= 4;
    }
    function Te() {
      var g = window, b = navigator, E = g.CSS, T = g.HTMLButtonElement;
      return k([
        !("getStorageUpdates" in b),
        T && "popover" in T.prototype,
        "CSSCounterStyleRule" in g,
        E.supports("font-size-adjust: ex-height 0.5"),
        E.supports("text-transform: full-width")
      ]) >= 4;
    }
    function Xe() {
      var g = document;
      return g.fullscreenElement || g.msFullscreenElement || g.mozFullScreenElement || g.webkitFullscreenElement || null;
    }
    function Ke() {
      var g = M(), b = me(), E = window, T = navigator, R = "connection";
      return g ? k([
        !("SharedWorker" in E),
        T[R] && "ontypechange" in T[R],
        !("sinkId" in new Audio())
      ]) >= 2 : !!b && k(["onorientationchange" in E, "orientation" in E, /android/i.test(T.appVersion)]) >= 2;
    }
    function He() {
      var g = navigator, b = window, E = Audio.prototype, T = b.visualViewport;
      return k([
        "srLatency" in E,
        "srChannelCount" in E,
        "devicePosture" in g,
        T && "segments" in T,
        "getTextInformation" in Image.prototype
      ]) >= 3;
    }
    function Ae() {
      var g = window, b = g.OfflineAudioContext || g.webkitOfflineAudioContext;
      if (!b) return -2;
      if (function() {
        return le() && !G() && !(k([
          "DOMRectList" in (Y = window),
          "RTCPeerConnectionIceEvent" in Y,
          "SVGGeometryElement" in Y,
          "ontransitioncancel" in Y
        ]) >= 3);
        var Y;
      }())
        return -1;
      var E = new b(1, 5e3, 44100), T = E.createOscillator();
      T.type = "triangle", T.frequency.value = 1e4;
      var R = E.createDynamicsCompressor();
      R.threshold.value = -50, R.knee.value = 40, R.ratio.value = 12, R.attack.value = 0, R.release.value = 0.25, T.connect(R), R.connect(E.destination), T.start(0);
      var $ = function(Y) {
        var q = function() {
        };
        return [
          new Promise(function(ne, ue) {
            var Se = !1, De = 0, Ve = 0;
            Y.oncomplete = function(ge) {
              return ne(ge.renderedBuffer);
            };
            var Ie = function() {
              setTimeout(
                function() {
                  return ue(Ee("timeout"));
                },
                Math.min(500, Ve + 5e3 - Date.now())
              );
            }, Fe = function() {
              try {
                var ge = Y.startRendering();
                switch (s(ge) && l(ge), Y.state) {
                  case "running":
                    Ve = Date.now(), Se && Ie();
                    break;
                  case "suspended":
                    document.hidden || De++, Se && De >= 3 ? ue(Ee("suspended")) : setTimeout(Fe, 500);
                }
              } catch (ut) {
                ue(ut);
              }
            };
            Fe(), q = function() {
              Se || (Se = !0, Ve > 0 && Ie());
            };
          }),
          q
        ];
      }(E), ie = $[0], z = $[1], C = l(
        ie.then(
          function(Y) {
            return function(q) {
              for (var ne = 0, ue = 0; ue < q.length; ++ue) ne += Math.abs(q[ue]);
              return ne;
            }(Y.getChannelData(0).subarray(4500));
          },
          function(Y) {
            if (Y.name === "timeout" || Y.name === "suspended") return -3;
            throw Y;
          }
        )
      );
      return function() {
        return z(), C;
      };
    }
    function Ee(g) {
      var b = new Error(g);
      return b.name = g, b;
    }
    function Be(g, b, E) {
      var T, R, $;
      return E === void 0 && (E = 50), r(this, void 0, void 0, function() {
        var ie, z;
        return e(this, function(C) {
          switch (C.label) {
            case 0:
              ie = document, C.label = 1;
            case 1:
              return ie.body ? [3, 3] : [4, i(E)];
            case 2:
              return C.sent(), [3, 1];
            case 3:
              z = ie.createElement("iframe"), C.label = 4;
            case 4:
              return C.trys.push([4, , 10, 11]), [
                4,
                new Promise(function(Y, q) {
                  var ne = !1, ue = function() {
                    ne = !0, Y();
                  };
                  z.onload = ue, z.onerror = function(Ve) {
                    ne = !0, q(Ve);
                  };
                  var Se = z.style;
                  Se.setProperty("display", "block", "important"), Se.position = "absolute", Se.top = "0", Se.left = "0", Se.visibility = "hidden", b && "srcdoc" in z ? z.srcdoc = b : z.src = "about:blank", ie.body.appendChild(z);
                  var De = function() {
                    var Ve, Ie;
                    ne || (((Ie = (Ve = z.contentWindow) === null || Ve === void 0 ? void 0 : Ve.document) === null || Ie === void 0 ? void 0 : Ie.readyState) === "complete" ? ue() : setTimeout(De, 10));
                  };
                  De();
                })
              ];
            case 5:
              C.sent(), C.label = 6;
            case 6:
              return !((R = (T = z.contentWindow) === null || T === void 0 ? void 0 : T.document) === null || R === void 0) && R.body ? [3, 8] : [4, i(E)];
            case 7:
              return C.sent(), [3, 6];
            case 8:
              return [4, g(z, z.contentWindow)];
            case 9:
              return [2, C.sent()];
            case 10:
              return ($ = z.parentNode) === null || $ === void 0 || $.removeChild(z), [7];
            case 11:
              return [2];
          }
        });
      });
    }
    function Ze(g) {
      for (var b = function(Y) {
        for (var q, ne, ue = "Unexpected syntax '".concat(Y, "'"), Se = /^\s*([a-z-]*)(.*)$/i.exec(Y), De = Se[1] || void 0, Ve = {}, Ie = /([.:#][\w-]+|\[.+?\])/gi, Fe = function(nt, it) {
          Ve[nt] = Ve[nt] || [], Ve[nt].push(it);
        }; ; ) {
          var ge = Ie.exec(Se[2]);
          if (!ge) break;
          var ut = ge[0];
          switch (ut[0]) {
            case ".":
              Fe("class", ut.slice(1));
              break;
            case "#":
              Fe("id", ut.slice(1));
              break;
            case "[":
              var at = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(ut);
              if (!at) throw new Error(ue);
              Fe(
                at[1],
                (ne = (q = at[4]) !== null && q !== void 0 ? q : at[5]) !== null && ne !== void 0 ? ne : ""
              );
              break;
            default:
              throw new Error(ue);
          }
        }
        return [De, Ve];
      }(g), E = b[0], T = b[1], R = document.createElement(E ?? "div"), $ = 0, ie = Object.keys(T); $ < ie.length; $++) {
        var z = ie[$], C = T[z].join(" ");
        z === "style" ? qe(R.style, C) : R.setAttribute(z, C);
      }
      return R;
    }
    function qe(g, b) {
      for (var E = 0, T = b.split(";"); E < T.length; E++) {
        var R = T[E], $ = /^\s*([\w-]+)\s*:\s*(.+?)(\s*!([\w-]+))?\s*$/.exec(R);
        if ($) {
          var ie = $[1], z = $[2], C = $[4];
          g.setProperty(ie, z, C || "");
        }
      }
    }
    var Je = "mmMwWLliI0O&1", vt = "48px", rt = ["monospace", "sans-serif", "serif"], lt = [
      "sans-serif-thin",
      "ARNO PRO",
      "Agency FB",
      "Arabic Typesetting",
      "Arial Unicode MS",
      "AvantGarde Bk BT",
      "BankGothic Md BT",
      "Batang",
      "Bitstream Vera Sans Mono",
      "Calibri",
      "Century",
      "Century Gothic",
      "Clarendon",
      "EUROSTILE",
      "Franklin Gothic",
      "Futura Bk BT",
      "Futura Md BT",
      "GOTHAM",
      "Gill Sans",
      "HELV",
      "Haettenschweiler",
      "Helvetica Neue",
      "Humanst521 BT",
      "Leelawadee",
      "Letter Gothic",
      "Levenim MT",
      "Lucida Bright",
      "Lucida Sans",
      "Menlo",
      "MS Mincho",
      "MS Outlook",
      "MS Reference Specialty",
      "MS UI Gothic",
      "MT Extra",
      "MYRIAD PRO",
      "Marlett",
      "Meiryo UI",
      "Microsoft Uighur",
      "Minion Pro",
      "Monotype Corsiva",
      "PMingLiU",
      "Pristina",
      "SCRIPTINA",
      "Segoe UI Light",
      "Serifa",
      "SimHei",
      "Small Fonts",
      "Staccato222 BT",
      "TRAJAN PRO",
      "Univers CE 55 Medium",
      "Vrinda",
      "ZWAdobeF"
    ];
    function o(g) {
      var b, E, T, R = !1, $ = function() {
        var C = document.createElement("canvas");
        return C.width = 1, C.height = 1, [C, C.getContext("2d")];
      }(), ie = $[0], z = $[1];
      return function(C, Y) {
        return !(!Y || !C.toDataURL);
      }(ie, z) ? (R = function(C) {
        return C.rect(0, 0, 10, 10), C.rect(2, 2, 6, 6), !C.isPointInPath(5, 5, "evenodd");
      }(z), g ? E = T = "skipped" : (E = (b = function(C, Y) {
        (function(ue, Se) {
          ue.width = 240, ue.height = 60, Se.textBaseline = "alphabetic", Se.fillStyle = "#f60", Se.fillRect(100, 1, 62, 20), Se.fillStyle = "#069", Se.font = '11pt "Times New Roman"';
          var De = "Cwm fjordbank gly ".concat("😃");
          Se.fillText(De, 2, 15), Se.fillStyle = "rgba(102, 204, 0, 0.2)", Se.font = "18pt Arial", Se.fillText(De, 4, 45);
        })(C, Y);
        var q = I(C), ne = I(C);
        return q !== ne ? ["unstable", "unstable"] : (function(ue, Se) {
          ue.width = 122, ue.height = 110, Se.globalCompositeOperation = "multiply";
          for (var De = 0, Ve = [
            ["#f2f", 40, 40],
            ["#2ff", 80, 40],
            ["#ff2", 60, 80]
          ]; De < Ve.length; De++) {
            var Ie = Ve[De], Fe = Ie[0], ge = Ie[1], ut = Ie[2];
            Se.fillStyle = Fe, Se.beginPath(), Se.arc(ge, ut, 40, 0, 2 * Math.PI, !0), Se.closePath(), Se.fill();
          }
          Se.fillStyle = "#f9c", Se.arc(60, 60, 60, 0, 2 * Math.PI, !0), Se.arc(60, 60, 20, 0, 2 * Math.PI, !0), Se.fill("evenodd");
        }(C, Y), [I(C), q]);
      }(ie, z))[0], T = b[1])) : E = T = "unsupported", { winding: R, geometry: E, text: T };
    }
    function I(g) {
      return g.toDataURL();
    }
    function O() {
      var g = screen, b = function(T) {
        return y(d(T), null);
      }, E = [b(g.width), b(g.height)];
      return E.sort().reverse(), E;
    }
    var f, B, se = 2500, de = 10;
    function J() {
      var g = this;
      return function() {
        if (B === void 0) {
          var b = function() {
            var E = Le();
            Ce(E) ? B = setTimeout(b, se) : (f = E, B = void 0);
          };
          b();
        }
      }(), function() {
        return r(g, void 0, void 0, function() {
          var b;
          return e(this, function(E) {
            switch (E.label) {
              case 0:
                return Ce(b = Le()) ? f ? [2, t([], f)] : Xe() ? [
                  4,
                  (T = document, (T.exitFullscreen || T.msExitFullscreen || T.mozCancelFullScreen || T.webkitExitFullscreen).call(T))
                ] : [3, 2] : [3, 2];
              case 1:
                E.sent(), b = Le(), E.label = 2;
              case 2:
                return Ce(b) || (f = b), [2, b];
            }
            var T;
          });
        });
      };
    }
    function Le() {
      var g = screen;
      return [
        y(p(g.availTop), null),
        y(p(g.width) - p(g.availWidth) - y(p(g.availLeft), 0), null),
        y(p(g.height) - p(g.availHeight) - y(p(g.availTop), 0), null),
        y(p(g.availLeft), null)
      ];
    }
    function Ce(g) {
      for (var b = 0; b < 4; ++b) if (g[b]) return !1;
      return !0;
    }
    function Qe(g) {
      g.style.setProperty("visibility", "hidden", "important"), g.style.setProperty("display", "block", "important");
    }
    function dt(g) {
      return matchMedia("(inverted-colors: ".concat(g, ")")).matches;
    }
    function St(g) {
      return matchMedia("(forced-colors: ".concat(g, ")")).matches;
    }
    var bt = 100;
    function yt(g) {
      return matchMedia("(prefers-contrast: ".concat(g, ")")).matches;
    }
    function tt(g) {
      return matchMedia("(prefers-reduced-motion: ".concat(g, ")")).matches;
    }
    function be(g) {
      return matchMedia("(prefers-reduced-transparency: ".concat(g, ")")).matches;
    }
    function Pe(g) {
      return matchMedia("(dynamic-range: ".concat(g, ")")).matches;
    }
    var he = Math, Ge = function() {
      return 0;
    }, _e = "mmMwWLliI0fiflO&1", ze = {
      default: [],
      apple: [{ font: "-apple-system-body" }],
      serif: [{ fontFamily: "serif" }],
      sans: [{ fontFamily: "sans-serif" }],
      mono: [{ fontFamily: "monospace" }],
      min: [{ fontSize: "1px" }],
      system: [{ fontFamily: "system-ui" }]
    }, ot = function() {
      for (var g = window; ; ) {
        var b = g.parent;
        if (!b || b === g) return !1;
        try {
          if (b.location.origin !== g.location.origin) return !0;
        } catch (E) {
          if (E instanceof Error && E.name === "SecurityError") return !0;
          throw E;
        }
        g = b;
      }
    }, $e = -1, et = -2, gt = /* @__PURE__ */ new Set([
      10752,
      2849,
      2884,
      2885,
      2886,
      2928,
      2929,
      2930,
      2931,
      2932,
      2960,
      2961,
      2962,
      2963,
      2964,
      2965,
      2966,
      2967,
      2968,
      2978,
      3024,
      3042,
      3088,
      3089,
      3106,
      3107,
      32773,
      32777,
      32777,
      32823,
      32824,
      32936,
      32937,
      32938,
      32939,
      32968,
      32969,
      32970,
      32971,
      3317,
      33170,
      3333,
      3379,
      3386,
      33901,
      33902,
      34016,
      34024,
      34076,
      3408,
      3410,
      3411,
      3412,
      3413,
      3414,
      3415,
      34467,
      34816,
      34817,
      34818,
      34819,
      34877,
      34921,
      34930,
      35660,
      35661,
      35724,
      35738,
      35739,
      36003,
      36004,
      36005,
      36347,
      36348,
      36349,
      37440,
      37441,
      37443,
      7936,
      7937,
      7938
    ]), Pt = /* @__PURE__ */ new Set([34047, 35723, 36063, 34852, 34853, 34854, 34229, 36392, 36795, 38449]), Rt = ["FRAGMENT_SHADER", "VERTEX_SHADER"], ht = ["LOW_FLOAT", "MEDIUM_FLOAT", "HIGH_FLOAT", "LOW_INT", "MEDIUM_INT", "HIGH_INT"], Tt = "WEBGL_debug_renderer_info", fe = "WEBGL_polygon_mode";
    function oe(g) {
      if (g.webgl) return g.webgl.context;
      var b, E = document.createElement("canvas");
      E.addEventListener("webglCreateContextError", function() {
        return b = void 0;
      });
      for (var T = 0, R = ["webgl", "experimental-webgl"]; T < R.length; T++) {
        var $ = R[T];
        try {
          b = E.getContext($);
        } catch {
        }
        if (b) break;
      }
      return g.webgl = { context: b }, b;
    }
    function pt(g, b, E) {
      var T = g.getShaderPrecisionFormat(g[b], g[E]);
      return T ? [T.rangeMin, T.rangeMax, T.precision] : [];
    }
    function _t(g) {
      return Object.keys(g.__proto__).filter(je);
    }
    function je(g) {
      return typeof g == "string" && !g.match(/[^A-Z0-9_x]/);
    }
    function Ut() {
      return me();
    }
    function Kt(g) {
      return typeof g.getParameter == "function";
    }
    var xe = {
      fonts: function() {
        var g = this;
        return Be(function(b, E) {
          var T = E.document;
          return r(g, void 0, void 0, function() {
            var R, $, ie, z, C, Y, q, ne, ue, Se, De;
            return e(this, function(Ve) {
              for ((R = T.body).style.fontSize = vt, ($ = T.createElement("div")).style.setProperty(
                "visibility",
                "hidden",
                "important"
              ), ie = {}, z = {}, C = function(Ie) {
                var Fe = T.createElement("span"), ge = Fe.style;
                return ge.position = "absolute", ge.top = "0", ge.left = "0", ge.fontFamily = Ie, Fe.textContent = Je, $.appendChild(Fe), Fe;
              }, Y = function(Ie, Fe) {
                return C("'".concat(Ie, "',").concat(Fe));
              }, q = function() {
                for (var Ie = {}, Fe = function(at) {
                  Ie[at] = rt.map(function(nt) {
                    return Y(at, nt);
                  });
                }, ge = 0, ut = lt; ge < ut.length; ge++)
                  Fe(ut[ge]);
                return Ie;
              }, ne = function(Ie) {
                return rt.some(function(Fe, ge) {
                  return Ie[ge].offsetWidth !== ie[Fe] || Ie[ge].offsetHeight !== z[Fe];
                });
              }, ue = rt.map(C), Se = q(), R.appendChild($), De = 0; De < rt.length; De++)
                ie[rt[De]] = ue[De].offsetWidth, z[rt[De]] = ue[De].offsetHeight;
              return [
                2,
                lt.filter(function(Ie) {
                  return ne(Se[Ie]);
                })
              ];
            });
          });
        });
      },
      domBlockers: function(g) {
        var b = (g === void 0 ? {} : g).debug;
        return r(this, void 0, void 0, function() {
          var E, T, R, $, ie;
          return e(this, function(z) {
            switch (z.label) {
              case 0:
                return le() || Ke() ? (C = atob, E = {
                  abpIndo: [
                    "#Iklan-Melayang",
                    "#Kolom-Iklan-728",
                    "#SidebarIklan-wrapper",
                    '[title="ALIENBOLA" i]',
                    C("I0JveC1CYW5uZXItYWRz")
                  ],
                  abpvn: [
                    ".quangcao",
                    "#mobileCatfish",
                    C("LmNsb3NlLWFkcw=="),
                    '[id^="bn_bottom_fixed_"]',
                    "#pmadv"
                  ],
                  adBlockFinland: [
                    ".mainostila",
                    C("LnNwb25zb3JpdA=="),
                    ".ylamainos",
                    C("YVtocmVmKj0iL2NsaWNrdGhyZ2guYXNwPyJd"),
                    C("YVtocmVmXj0iaHR0cHM6Ly9hcHAucmVhZHBlYWsuY29tL2FkcyJd")
                  ],
                  adBlockPersian: [
                    "#navbar_notice_50",
                    ".kadr",
                    'TABLE[width="140px"]',
                    "#divAgahi",
                    C("YVtocmVmXj0iaHR0cDovL2cxLnYuZndtcm0ubmV0L2FkLyJd")
                  ],
                  adBlockWarningRemoval: [
                    "#adblock-honeypot",
                    ".adblocker-root",
                    ".wp_adblock_detect",
                    C("LmhlYWRlci1ibG9ja2VkLWFk"),
                    C("I2FkX2Jsb2NrZXI=")
                  ],
                  adGuardAnnoyances: [
                    ".hs-sosyal",
                    "#cookieconsentdiv",
                    'div[class^="app_gdpr"]',
                    ".as-oil",
                    '[data-cypress="soft-push-notification-modal"]'
                  ],
                  adGuardBase: [
                    ".BetterJsPopOverlay",
                    C("I2FkXzMwMFgyNTA="),
                    C("I2Jhbm5lcmZsb2F0MjI="),
                    C("I2NhbXBhaWduLWJhbm5lcg=="),
                    C("I0FkLUNvbnRlbnQ=")
                  ],
                  adGuardChinese: [
                    C("LlppX2FkX2FfSA=="),
                    C("YVtocmVmKj0iLmh0aGJldDM0LmNvbSJd"),
                    "#widget-quan",
                    C("YVtocmVmKj0iLzg0OTkyMDIwLnh5eiJd"),
                    C("YVtocmVmKj0iLjE5NTZobC5jb20vIl0=")
                  ],
                  adGuardFrench: [
                    "#pavePub",
                    C("LmFkLWRlc2t0b3AtcmVjdGFuZ2xl"),
                    ".mobile_adhesion",
                    ".widgetadv",
                    C("LmFkc19iYW4=")
                  ],
                  adGuardGerman: ['aside[data-portal-id="leaderboard"]'],
                  adGuardJapanese: [
                    "#kauli_yad_1",
                    C("YVtocmVmXj0iaHR0cDovL2FkMi50cmFmZmljZ2F0ZS5uZXQvIl0="),
                    C("Ll9wb3BJbl9pbmZpbml0ZV9hZA=="),
                    C("LmFkZ29vZ2xl"),
                    C("Ll9faXNib29zdFJldHVybkFk")
                  ],
                  adGuardMobile: [
                    C("YW1wLWF1dG8tYWRz"),
                    C("LmFtcF9hZA=="),
                    'amp-embed[type="24smi"]',
                    "#mgid_iframe1",
                    C("I2FkX2ludmlld19hcmVh")
                  ],
                  adGuardRussian: [
                    C("YVtocmVmXj0iaHR0cHM6Ly9hZC5sZXRtZWFkcy5jb20vIl0="),
                    C("LnJlY2xhbWE="),
                    'div[id^="smi2adblock"]',
                    C("ZGl2W2lkXj0iQWRGb3hfYmFubmVyXyJd"),
                    "#psyduckpockeball"
                  ],
                  adGuardSocial: [
                    C("YVtocmVmXj0iLy93d3cuc3R1bWJsZXVwb24uY29tL3N1Ym1pdD91cmw9Il0="),
                    C("YVtocmVmXj0iLy90ZWxlZ3JhbS5tZS9zaGFyZS91cmw/Il0="),
                    ".etsy-tweet",
                    "#inlineShare",
                    ".popup-social"
                  ],
                  adGuardSpanishPortuguese: [
                    "#barraPublicidade",
                    "#Publicidade",
                    "#publiEspecial",
                    "#queTooltip",
                    ".cnt-publi"
                  ],
                  adGuardTrackingProtection: [
                    "#qoo-counter",
                    C("YVtocmVmXj0iaHR0cDovL2NsaWNrLmhvdGxvZy5ydS8iXQ=="),
                    C("YVtocmVmXj0iaHR0cDovL2hpdGNvdW50ZXIucnUvdG9wL3N0YXQucGhwIl0="),
                    C("YVtocmVmXj0iaHR0cDovL3RvcC5tYWlsLnJ1L2p1bXAiXQ=="),
                    "#top100counter"
                  ],
                  adGuardTurkish: [
                    "#backkapat",
                    C("I3Jla2xhbWk="),
                    C("YVtocmVmXj0iaHR0cDovL2Fkc2Vydi5vbnRlay5jb20udHIvIl0="),
                    C("YVtocmVmXj0iaHR0cDovL2l6bGVuemkuY29tL2NhbXBhaWduLyJd"),
                    C("YVtocmVmXj0iaHR0cDovL3d3dy5pbnN0YWxsYWRzLm5ldC8iXQ==")
                  ],
                  bulgarian: [
                    C("dGQjZnJlZW5ldF90YWJsZV9hZHM="),
                    "#ea_intext_div",
                    ".lapni-pop-over",
                    "#xenium_hot_offers"
                  ],
                  easyList: [
                    ".yb-floorad",
                    C("LndpZGdldF9wb19hZHNfd2lkZ2V0"),
                    C("LnRyYWZmaWNqdW5reS1hZA=="),
                    ".textad_headline",
                    C("LnNwb25zb3JlZC10ZXh0LWxpbmtz")
                  ],
                  easyListChina: [
                    C("LmFwcGd1aWRlLXdyYXBbb25jbGljayo9ImJjZWJvcy5jb20iXQ=="),
                    C("LmZyb250cGFnZUFkdk0="),
                    "#taotaole",
                    "#aafoot.top_box",
                    ".cfa_popup"
                  ],
                  easyListCookie: [
                    ".ezmob-footer",
                    ".cc-CookieWarning",
                    "[data-cookie-number]",
                    C("LmF3LWNvb2tpZS1iYW5uZXI="),
                    ".sygnal24-gdpr-modal-wrap"
                  ],
                  easyListCzechSlovak: [
                    "#onlajny-stickers",
                    C("I3Jla2xhbW5pLWJveA=="),
                    C("LnJla2xhbWEtbWVnYWJvYXJk"),
                    ".sklik",
                    C("W2lkXj0ic2tsaWtSZWtsYW1hIl0=")
                  ],
                  easyListDutch: [
                    C("I2FkdmVydGVudGll"),
                    C("I3ZpcEFkbWFya3RCYW5uZXJCbG9jaw=="),
                    ".adstekst",
                    C("YVtocmVmXj0iaHR0cHM6Ly94bHR1YmUubmwvY2xpY2svIl0="),
                    "#semilo-lrectangle"
                  ],
                  easyListGermany: [
                    "#SSpotIMPopSlider",
                    C("LnNwb25zb3JsaW5rZ3J1ZW4="),
                    C("I3dlcmJ1bmdza3k="),
                    C("I3Jla2xhbWUtcmVjaHRzLW1pdHRl"),
                    C("YVtocmVmXj0iaHR0cHM6Ly9iZDc0Mi5jb20vIl0=")
                  ],
                  easyListItaly: [
                    C("LmJveF9hZHZfYW5udW5jaQ=="),
                    ".sb-box-pubbliredazionale",
                    C("YVtocmVmXj0iaHR0cDovL2FmZmlsaWF6aW9uaWFkcy5zbmFpLml0LyJd"),
                    C("YVtocmVmXj0iaHR0cHM6Ly9hZHNlcnZlci5odG1sLml0LyJd"),
                    C("YVtocmVmXj0iaHR0cHM6Ly9hZmZpbGlhemlvbmlhZHMuc25haS5pdC8iXQ==")
                  ],
                  easyListLithuania: [
                    C("LnJla2xhbW9zX3RhcnBhcw=="),
                    C("LnJla2xhbW9zX251b3JvZG9z"),
                    C("aW1nW2FsdD0iUmVrbGFtaW5pcyBza3lkZWxpcyJd"),
                    C("aW1nW2FsdD0iRGVkaWt1b3RpLmx0IHNlcnZlcmlhaSJd"),
                    C("aW1nW2FsdD0iSG9zdGluZ2FzIFNlcnZlcmlhaS5sdCJd")
                  ],
                  estonian: [C("QVtocmVmKj0iaHR0cDovL3BheTRyZXN1bHRzMjQuZXUiXQ==")],
                  fanboyAnnoyances: [
                    "#ac-lre-player",
                    ".navigate-to-top",
                    "#subscribe_popup",
                    ".newsletter_holder",
                    "#back-top"
                  ],
                  fanboyAntiFacebook: [".util-bar-module-firefly-visible"],
                  fanboyEnhancedTrackers: [
                    ".open.pushModal",
                    "#issuem-leaky-paywall-articles-zero-remaining-nag",
                    "#sovrn_container",
                    'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
                    ".BlockNag__Card"
                  ],
                  fanboySocial: [
                    "#FollowUs",
                    "#meteored_share",
                    "#social_follow",
                    ".article-sharer",
                    ".community__social-desc"
                  ],
                  frellwitSwedish: [
                    C("YVtocmVmKj0iY2FzaW5vcHJvLnNlIl1bdGFyZ2V0PSJfYmxhbmsiXQ=="),
                    C("YVtocmVmKj0iZG9rdG9yLXNlLm9uZWxpbmsubWUiXQ=="),
                    "article.category-samarbete",
                    C("ZGl2LmhvbGlkQWRz"),
                    "ul.adsmodern"
                  ],
                  greekAdBlock: [
                    C("QVtocmVmKj0iYWRtYW4ub3RlbmV0LmdyL2NsaWNrPyJd"),
                    C("QVtocmVmKj0iaHR0cDovL2F4aWFiYW5uZXJzLmV4b2R1cy5nci8iXQ=="),
                    C("QVtocmVmKj0iaHR0cDovL2ludGVyYWN0aXZlLmZvcnRobmV0LmdyL2NsaWNrPyJd"),
                    "DIV.agores300",
                    "TABLE.advright"
                  ],
                  hungarian: [
                    "#cemp_doboz",
                    ".optimonk-iframe-container",
                    C("LmFkX19tYWlu"),
                    C("W2NsYXNzKj0iR29vZ2xlQWRzIl0="),
                    "#hirdetesek_box"
                  ],
                  iDontCareAboutCookies: [
                    '.alert-info[data-block-track*="CookieNotice"]',
                    ".ModuleTemplateCookieIndicator",
                    ".o--cookies--container",
                    "#cookies-policy-sticky",
                    "#stickyCookieBar"
                  ],
                  icelandicAbp: [
                    C("QVtocmVmXj0iL2ZyYW1ld29yay9yZXNvdXJjZXMvZm9ybXMvYWRzLmFzcHgiXQ==")
                  ],
                  latvian: [
                    C(
                      "YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiAxMjBweDsgaGVpZ2h0OiA0MHB4OyBvdmVyZmxvdzogaGlkZGVuOyBwb3NpdGlvbjogcmVsYXRpdmU7Il0="
                    ),
                    C(
                      "YVtocmVmPSJodHRwOi8vd3d3LnNhbGlkemluaS5sdi8iXVtzdHlsZT0iZGlzcGxheTogYmxvY2s7IHdpZHRoOiA4OHB4OyBoZWlnaHQ6IDMxcHg7IG92ZXJmbG93OiBoaWRkZW47IHBvc2l0aW9uOiByZWxhdGl2ZTsiXQ=="
                    )
                  ],
                  listKr: [
                    C("YVtocmVmKj0iLy9hZC5wbGFuYnBsdXMuY28ua3IvIl0="),
                    C("I2xpdmVyZUFkV3JhcHBlcg=="),
                    C("YVtocmVmKj0iLy9hZHYuaW1hZHJlcC5jby5rci8iXQ=="),
                    C("aW5zLmZhc3R2aWV3LWFk"),
                    ".revenue_unit_item.dable"
                  ],
                  listeAr: [
                    C("LmdlbWluaUxCMUFk"),
                    ".right-and-left-sponsers",
                    C("YVtocmVmKj0iLmFmbGFtLmluZm8iXQ=="),
                    C("YVtocmVmKj0iYm9vcmFxLm9yZyJd"),
                    C("YVtocmVmKj0iZHViaXp6bGUuY29tL2FyLz91dG1fc291cmNlPSJd")
                  ],
                  listeFr: [
                    C("YVtocmVmXj0iaHR0cDovL3Byb21vLnZhZG9yLmNvbS8iXQ=="),
                    C("I2FkY29udGFpbmVyX3JlY2hlcmNoZQ=="),
                    C("YVtocmVmKj0id2Vib3JhbWEuZnIvZmNnaS1iaW4vIl0="),
                    ".site-pub-interstitiel",
                    'div[id^="crt-"][data-criteo-id]'
                  ],
                  officialPolish: [
                    "#ceneo-placeholder-ceneo-12",
                    C("W2hyZWZePSJodHRwczovL2FmZi5zZW5kaHViLnBsLyJd"),
                    C(
                      "YVtocmVmXj0iaHR0cDovL2Fkdm1hbmFnZXIudGVjaGZ1bi5wbC9yZWRpcmVjdC8iXQ=="
                    ),
                    C("YVtocmVmXj0iaHR0cDovL3d3dy50cml6ZXIucGwvP3V0bV9zb3VyY2UiXQ=="),
                    C("ZGl2I3NrYXBpZWNfYWQ=")
                  ],
                  ro: [
                    C("YVtocmVmXj0iLy9hZmZ0cmsuYWx0ZXgucm8vQ291bnRlci9DbGljayJd"),
                    C("YVtocmVmXj0iaHR0cHM6Ly9ibGFja2ZyaWRheXNhbGVzLnJvL3Ryay9zaG9wLyJd"),
                    C(
                      "YVtocmVmXj0iaHR0cHM6Ly9ldmVudC4ycGVyZm9ybWFudC5jb20vZXZlbnRzL2NsaWNrIl0="
                    ),
                    C("YVtocmVmXj0iaHR0cHM6Ly9sLnByb2ZpdHNoYXJlLnJvLyJd"),
                    'a[href^="/url/"]'
                  ],
                  ruAd: [
                    C("YVtocmVmKj0iLy9mZWJyYXJlLnJ1LyJd"),
                    C("YVtocmVmKj0iLy91dGltZy5ydS8iXQ=="),
                    C("YVtocmVmKj0iOi8vY2hpa2lkaWtpLnJ1Il0="),
                    "#pgeldiz",
                    ".yandex-rtb-block"
                  ],
                  thaiAds: [
                    "a[href*=macau-uta-popup]",
                    C("I2Fkcy1nb29nbGUtbWlkZGxlX3JlY3RhbmdsZS1ncm91cA=="),
                    C("LmFkczMwMHM="),
                    ".bumq",
                    ".img-kosana"
                  ],
                  webAnnoyancesUltralist: [
                    "#mod-social-share-2",
                    "#social-tools",
                    C("LmN0cGwtZnVsbGJhbm5lcg=="),
                    ".zergnet-recommend",
                    ".yt.btn-link.btn-md.btn"
                  ]
                }, T = Object.keys(E), [
                  4,
                  function(Y) {
                    var q;
                    return r(this, void 0, void 0, function() {
                      var ne, ue, Se, De, Ve, Ie, Fe;
                      return e(this, function(ge) {
                        switch (ge.label) {
                          case 0:
                            for (ne = document, ue = ne.createElement("div"), Se = new Array(Y.length), De = {}, Qe(ue), Fe = 0; Fe < Y.length; ++Fe)
                              (Ve = Ze(Y[Fe])).tagName === "DIALOG" && Ve.show(), Qe(Ie = ne.createElement("div")), Ie.appendChild(Ve), ue.appendChild(Ie), Se[Fe] = Ve;
                            ge.label = 1;
                          case 1:
                            return ne.body ? [3, 3] : [4, i(50)];
                          case 2:
                            return ge.sent(), [3, 1];
                          case 3:
                            ne.body.appendChild(ue);
                            try {
                              for (Fe = 0; Fe < Y.length; ++Fe)
                                Se[Fe].offsetParent || (De[Y[Fe]] = !0);
                            } finally {
                              (q = ue.parentNode) === null || q === void 0 || q.removeChild(ue);
                            }
                            return [2, De];
                        }
                      });
                    });
                  }(
                    (ie = []).concat.apply(
                      ie,
                      T.map(function(Y) {
                        return E[Y];
                      })
                    )
                  )
                ]) : [2, void 0];
              case 1:
                return R = z.sent(), b && function(Y, q) {
                  for (var ne = "DOM blockers debug:\n```", ue = 0, Se = Object.keys(Y); ue < Se.length; ue++) {
                    var De = Se[ue];
                    ne += `
`.concat(De, ":");
                    for (var Ve = 0, Ie = Y[De]; Ve < Ie.length; Ve++) {
                      var Fe = Ie[Ve];
                      ne += `
  `.concat(q[Fe] ? "ðŸš«" : "âž¡ï¸", " ").concat(Fe);
                    }
                  }
                  console.log("".concat(ne, "\n```"));
                }(E, R), ($ = T.filter(function(Y) {
                  var q = E[Y];
                  return k(
                    q.map(function(ne) {
                      return R[ne];
                    })
                  ) > 0.6 * q.length;
                })).sort(), [2, $];
            }
            var C;
          });
        });
      },
      fontPreferences: function() {
        return g = function(E, T) {
          for (var R = {}, $ = {}, ie = 0, z = Object.keys(ze); ie < z.length; ie++) {
            var C = z[ie], Y = ze[C], q = Y[0], ne = q === void 0 ? {} : q, ue = Y[1], Se = ue === void 0 ? _e : ue, De = E.createElement("span");
            De.textContent = Se, De.style.whiteSpace = "nowrap";
            for (var Ve = 0, Ie = Object.keys(ne); Ve < Ie.length; Ve++) {
              var Fe = Ie[Ve], ge = ne[Fe];
              ge !== void 0 && (De.style[Fe] = ge);
            }
            R[C] = De, T.append(E.createElement("br"), De);
          }
          for (var ut = 0, at = Object.keys(ze); ut < at.length; ut++)
            $[C = at[ut]] = R[C].getBoundingClientRect().width;
          return $;
        }, b === void 0 && (b = 4e3), Be(function(E, T) {
          var R = T.document, $ = R.body, ie = $.style;
          ie.width = "".concat(b, "px"), ie.webkitTextSizeAdjust = ie.textSizeAdjust = "none", M() ? $.style.zoom = "".concat(1 / T.devicePixelRatio) : le() && ($.style.zoom = "reset");
          var z = R.createElement("div");
          return z.textContent = t([], Array(b / 20 << 0)).map(function() {
            return "word";
          }).join(" "), $.appendChild(z), g(R, $);
        }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
        var g, b;
      },
      audio: function() {
        return le() && Te() && te() || M() && He() && (g = window, b = g.URLPattern, k([
          "union" in Set.prototype,
          "Iterator" in g,
          b && "hasRegExpGroups" in b.prototype,
          "RGB8" in WebGLRenderingContext.prototype
        ]) >= 3) ? -4 : Ae();
        var g, b;
      },
      screenFrame: function() {
        var g = this;
        if (le() && Te() && te())
          return function() {
            return Promise.resolve(void 0);
          };
        var b = J();
        return function() {
          return r(g, void 0, void 0, function() {
            var E, T;
            return e(this, function(R) {
              switch (R.label) {
                case 0:
                  return [4, b()];
                case 1:
                  return E = R.sent(), [
                    2,
                    [
                      (T = function($) {
                        return $ === null ? null : Q($, de);
                      })(E[0]),
                      T(E[1]),
                      T(E[2]),
                      T(E[3])
                    ]
                  ];
              }
            });
          });
        };
      },
      canvas: function() {
        return o(le() && Te() && te());
      },
      osCpu: function() {
        return navigator.oscpu;
      },
      languages: function() {
        var g, b = navigator, E = [], T = b.language || b.userLanguage || b.browserLanguage || b.systemLanguage;
        if (T !== void 0 && E.push([T]), Array.isArray(b.languages))
          M() && k([
            !("MediaSettingsRange" in (g = window)),
            "RTCEncodedAudioFrame" in g,
            "" + g.Intl == "[object Intl]",
            "" + g.Reflect == "[object Reflect]"
          ]) >= 3 || E.push(b.languages);
        else if (typeof b.languages == "string") {
          var R = b.languages;
          R && E.push(R.split(","));
        }
        return E;
      },
      colorDepth: function() {
        return window.screen.colorDepth;
      },
      deviceMemory: function() {
        return y(p(navigator.deviceMemory), void 0);
      },
      screenResolution: function() {
        if (!(le() && Te() && te())) return O();
      },
      hardwareConcurrency: function() {
        return y(d(navigator.hardwareConcurrency), void 0);
      },
      timezone: function() {
        var g, b = (g = window.Intl) === null || g === void 0 ? void 0 : g.DateTimeFormat;
        if (b) {
          var E = new b().resolvedOptions().timeZone;
          if (E) return E;
        }
        var T, R = (T = (/* @__PURE__ */ new Date()).getFullYear(), -Math.max(
          p(new Date(T, 0, 1).getTimezoneOffset()),
          p(new Date(T, 6, 1).getTimezoneOffset())
        ));
        return "UTC".concat(R >= 0 ? "+" : "").concat(R);
      },
      sessionStorage: function() {
        try {
          return !!window.sessionStorage;
        } catch {
          return !0;
        }
      },
      localStorage: function() {
        try {
          return !!window.localStorage;
        } catch {
          return !0;
        }
      },
      indexedDB: function() {
        if (!re() && !F())
          try {
            return !!window.indexedDB;
          } catch {
            return !0;
          }
      },
      openDatabase: function() {
        return !!window.openDatabase;
      },
      cpuClass: function() {
        return navigator.cpuClass;
      },
      platform: function() {
        var g = navigator.platform;
        return g === "MacIntel" && le() && !G() ? function() {
          if (navigator.platform === "iPad") return !0;
          var b = screen, E = b.width / b.height;
          return k([
            "MediaSource" in window,
            !!Element.prototype.webkitRequestFullscreen,
            E > 0.65 && E < 1.53
          ]) >= 2;
        }() ? "iPad" : "iPhone" : g;
      },
      plugins: function() {
        var g = navigator.plugins;
        if (g) {
          for (var b = [], E = 0; E < g.length; ++E) {
            var T = g[E];
            if (T) {
              for (var R = [], $ = 0; $ < T.length; ++$) {
                var ie = T[$];
                R.push({ type: ie.type, suffixes: ie.suffixes });
              }
              b.push({ name: T.name, description: T.description, mimeTypes: R });
            }
          }
          return b;
        }
      },
      touchSupport: function() {
        var g, b = navigator, E = 0;
        b.maxTouchPoints !== void 0 ? E = d(b.maxTouchPoints) : b.msMaxTouchPoints !== void 0 && (E = b.msMaxTouchPoints);
        try {
          document.createEvent("TouchEvent"), g = !0;
        } catch {
          g = !1;
        }
        return { maxTouchPoints: E, touchEvent: g, touchStart: "ontouchstart" in window };
      },
      vendor: function() {
        return navigator.vendor || "";
      },
      vendorFlavors: function() {
        for (var g = [], b = 0, E = [
          "chrome",
          "safari",
          "__crWeb",
          "__gCrWeb",
          "yandex",
          "__yb",
          "__ybro",
          "__firefox__",
          "__edgeTrackingPreventionStatistics",
          "webkit",
          "oprt",
          "samsungAr",
          "ucweb",
          "UCShellJava",
          "puffinDevice"
        ]; b < E.length; b++) {
          var T = E[b], R = window[T];
          R && typeof R == "object" && g.push(T);
        }
        return g.sort();
      },
      cookiesEnabled: function() {
        var g = document;
        try {
          g.cookie = "cookietest=1; SameSite=Strict;";
          var b = g.cookie.indexOf("cookietest=") !== -1;
          return g.cookie = "cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT", b;
        } catch {
          return !1;
        }
      },
      colorGamut: function() {
        for (var g = 0, b = ["rec2020", "p3", "srgb"]; g < b.length; g++) {
          var E = b[g];
          if (matchMedia("(color-gamut: ".concat(E, ")")).matches) return E;
        }
      },
      invertedColors: function() {
        return !!dt("inverted") || !dt("none") && void 0;
      },
      forcedColors: function() {
        return !!St("active") || !St("none") && void 0;
      },
      monochrome: function() {
        if (matchMedia("(min-monochrome: 0)").matches) {
          for (var g = 0; g <= bt; ++g)
            if (matchMedia("(max-monochrome: ".concat(g, ")")).matches) return g;
          throw new Error("Too high value");
        }
      },
      contrast: function() {
        return yt("no-preference") ? 0 : yt("high") || yt("more") ? 1 : yt("low") || yt("less") ? -1 : yt("forced") ? 10 : void 0;
      },
      reducedMotion: function() {
        return !!tt("reduce") || !tt("no-preference") && void 0;
      },
      reducedTransparency: function() {
        return !!be("reduce") || !be("no-preference") && void 0;
      },
      hdr: function() {
        return !!Pe("high") || !Pe("standard") && void 0;
      },
      math: function() {
        var g, b = he.acos || Ge, E = he.acosh || Ge, T = he.asin || Ge, R = he.asinh || Ge, $ = he.atanh || Ge, ie = he.atan || Ge, z = he.sin || Ge, C = he.sinh || Ge, Y = he.cos || Ge, q = he.cosh || Ge, ne = he.tan || Ge, ue = he.tanh || Ge, Se = he.exp || Ge, De = he.expm1 || Ge, Ve = he.log1p || Ge;
        return {
          acos: b(0.12312423423423424),
          acosh: E(1e308),
          acoshPf: (g = 1e154, he.log(g + he.sqrt(g * g - 1))),
          asin: T(0.12312423423423424),
          asinh: R(1),
          asinhPf: function(Ie) {
            return he.log(Ie + he.sqrt(Ie * Ie + 1));
          }(1),
          atanh: $(0.5),
          atanhPf: function(Ie) {
            return he.log((1 + Ie) / (1 - Ie)) / 2;
          }(0.5),
          atan: ie(0.5),
          sin: z(-1e300),
          sinh: C(1),
          sinhPf: function(Ie) {
            return he.exp(Ie) - 1 / he.exp(Ie) / 2;
          }(1),
          cos: Y(10.000000000123),
          cosh: q(1),
          coshPf: function(Ie) {
            return (he.exp(Ie) + 1 / he.exp(Ie)) / 2;
          }(1),
          tan: ne(-1e300),
          tanh: ue(1),
          tanhPf: function(Ie) {
            return (he.exp(2 * Ie) - 1) / (he.exp(2 * Ie) + 1);
          }(1),
          exp: Se(1),
          expm1: De(1),
          expm1Pf: function(Ie) {
            return he.exp(Ie) - 1;
          }(1),
          log1p: Ve(10),
          log1pPf: function(Ie) {
            return he.log(1 + Ie);
          }(10),
          powPI: function(Ie) {
            return he.pow(he.PI, Ie);
          }(-100)
        };
      },
      pdfViewerEnabled: function() {
        return navigator.pdfViewerEnabled;
      },
      architecture: function() {
        var g = new Float32Array(1), b = new Uint8Array(g.buffer);
        return g[0] = 1 / 0, g[0] = g[0] - g[0], b[3];
      },
      applePay: function() {
        var g = window.ApplePaySession;
        if (typeof (g == null ? void 0 : g.canMakePayments) != "function")
          return -1;
        if (ot()) return -3;
        try {
          return g.canMakePayments() ? 1 : 0;
        } catch (b) {
          return function(E) {
            if (E instanceof Error && E.name === "InvalidAccessError" && /\bfrom\b.*\binsecure\b/i.test(E.message))
              return -2;
            throw E;
          }(b);
        }
      },
      privateClickMeasurement: function() {
        var g, b = document.createElement("a"), E = (g = b.attributionSourceId) !== null && g !== void 0 ? g : b.attributionsourceid;
        return E === void 0 ? void 0 : String(E);
      },
      audioBaseLatency: function() {
        var g;
        return Ke() || le() ? window.AudioContext && (g = new AudioContext().baseLatency) !== null && g !== void 0 ? g : -1 : -2;
      },
      dateTimeLocale: function() {
        if (!window.Intl) return -1;
        var g = window.Intl.DateTimeFormat;
        if (!g) return -2;
        var b = g().resolvedOptions().locale;
        return b || b === "" ? b : -3;
      },
      webGlBasics: function(g) {
        var b, E, T, R, $, ie, z = oe(g.cache);
        if (!z) return $e;
        if (!Kt(z)) return et;
        var C = Ut() ? null : z.getExtension(Tt);
        return {
          version: ((b = z.getParameter(z.VERSION)) === null || b === void 0 ? void 0 : b.toString()) || "",
          vendor: ((E = z.getParameter(z.VENDOR)) === null || E === void 0 ? void 0 : E.toString()) || "",
          vendorUnmasked: C ? (T = z.getParameter(C.UNMASKED_VENDOR_WEBGL)) === null || T === void 0 ? void 0 : T.toString() : "",
          renderer: ((R = z.getParameter(z.RENDERER)) === null || R === void 0 ? void 0 : R.toString()) || "",
          rendererUnmasked: C ? ($ = z.getParameter(C.UNMASKED_RENDERER_WEBGL)) === null || $ === void 0 ? void 0 : $.toString() : "",
          shadingLanguageVersion: ((ie = z.getParameter(z.SHADING_LANGUAGE_VERSION)) === null || ie === void 0 ? void 0 : ie.toString()) || ""
        };
      },
      webGlExtensions: function(g) {
        var b = oe(g.cache);
        if (!b) return $e;
        if (!Kt(b)) return et;
        var E = b.getSupportedExtensions(), T = b.getContextAttributes(), R = [], $ = [], ie = [], z = [], C = [];
        if (T)
          for (var Y = 0, q = Object.keys(T); Y < q.length; Y++) {
            var ne = q[Y];
            $.push("".concat(ne, "=").concat(T[ne]));
          }
        for (var ue = 0, Se = _t(b); ue < Se.length; ue++) {
          var De = b[nt = Se[ue]];
          ie.push(
            "".concat(nt, "=").concat(De).concat(gt.has(De) ? "=".concat(b.getParameter(De)) : "")
          );
        }
        if (E)
          for (var Ve = 0, Ie = E; Ve < Ie.length; Ve++) {
            var Fe = Ie[Ve];
            if (!(Fe === Tt && Ut() || Fe === fe && (M() || le()))) {
              var ge = b.getExtension(Fe);
              if (ge)
                for (var ut = 0, at = _t(ge); ut < at.length; ut++) {
                  var nt;
                  De = ge[nt = at[ut]], z.push(
                    "".concat(nt, "=").concat(De).concat(Pt.has(De) ? "=".concat(b.getParameter(De)) : "")
                  );
                }
              else R.push(Fe);
            }
          }
        for (var it = 0, kt = Rt; it < kt.length; it++)
          for (var Vt = kt[it], xt = 0, Dt = ht; xt < Dt.length; xt++) {
            var Mt = Dt[xt], Gt = pt(b, Vt, Mt);
            C.push("".concat(Vt, ".").concat(Mt, "=").concat(Gt.join(",")));
          }
        return z.sort(), ie.sort(), {
          contextAttributes: $,
          parameters: ie,
          shaderPrecisions: C,
          extensions: E,
          extensionParameters: z,
          unsupportedExtensions: R
        };
      }
    }, ft = "$ if upgrade to Pro: https://fpjs.dev/pro";
    function x(g) {
      var b = function(T) {
        if (Ke()) return 0.4;
        if (le()) return !G() || Te() && te() ? 0.3 : 0.5;
        var R = "value" in T.platform ? T.platform.value : "";
        return /^Win/.test(R) ? 0.6 : /^Mac/.test(R) ? 0.5 : 0.7;
      }(g), E = function(T) {
        return Q(0.99 + 0.01 * T, 1e-4);
      }(b);
      return { score: b, comment: ft.replace(/\$/g, "".concat(E)) };
    }
    function ye(g) {
      return JSON.stringify(
        g,
        function(b, E) {
          return E instanceof Error ? c(
            {
              name: (T = E).name,
              message: T.message,
              stack: (R = T.stack) === null || R === void 0 ? void 0 : R.split(`
`)
            },
            T
          ) : E;
          var T, R;
        },
        2
      );
    }
    function S(g) {
      return ae(
        function(b) {
          for (var E = "", T = 0, R = Object.keys(b).sort(); T < R.length; T++) {
            var $ = R[T], ie = b[$], z = "error" in ie ? "error" : JSON.stringify(ie.value);
            E += "".concat(E ? "|" : "").concat($.replace(/([:|\\])/g, "\\$1"), ":").concat(z);
          }
          return E;
        }(g)
      );
    }
    function Oe(g) {
      return g === void 0 && (g = 50), function(b, E) {
        E === void 0 && (E = 1 / 0);
        var T = window.requestIdleCallback;
        return T ? new Promise(function(R) {
          return T.call(
            window,
            function() {
              return R();
            },
            { timeout: E }
          );
        }) : i(Math.min(b, E));
      }(g, 2 * g);
    }
    function V(g, b) {
      var E = Date.now();
      return {
        get: function(T) {
          return r(this, void 0, void 0, function() {
            var R, $, ie;
            return e(this, function(z) {
              switch (z.label) {
                case 0:
                  return R = Date.now(), [4, g()];
                case 1:
                  return $ = z.sent(), ie = function(C) {
                    var Y, q = x(C);
                    return {
                      get visitorId() {
                        return Y === void 0 && (Y = S(this.components)), Y;
                      },
                      set visitorId(ne) {
                        Y = ne;
                      },
                      confidence: q,
                      components: C,
                      version: n
                    };
                  }($), (b || T != null && T.debug) && console.log(
                    "Copy the text below to get the debug data:\n\n```\nversion: ".concat(ie.version, `
userAgent: `).concat(navigator.userAgent, `
timeBetweenLoadAndGet: `).concat(R - E, `
visitorId: `).concat(ie.visitorId, `
components: `).concat(ye($), "\n```")
                  ), [2, ie];
              }
            });
          });
        }
      };
    }
    function ve(g) {
      var b;
      return g === void 0 && (g = {}), r(this, void 0, void 0, function() {
        var E, T;
        return e(this, function(R) {
          switch (R.label) {
            case 0:
              return ((b = g.monitoring) === null || b === void 0 || b) && function() {
                if (!(window.__fpjs_d_m || Math.random() >= 1e-3))
                  try {
                    var $ = new XMLHttpRequest();
                    $.open(
                      "get",
                      "https://m1.openfpcdn.io/fingerprintjs/v".concat(
                        n,
                        "/npm-monitoring"
                      ),
                      !0
                    ), $.send();
                  } catch (ie) {
                    console.error(ie);
                  }
              }(), E = g.delayFallback, T = g.debug, [4, Oe(E)];
            case 1:
              return R.sent(), [
                2,
                V(
                  function($) {
                    return ee(xe, $, []);
                  }({ cache: {}, debug: T }),
                  T
                )
              ];
          }
        });
      });
    }
    var we = { load: ve, hashComponents: S, componentsToDebugString: ye }, Ne = ae;
    return a.componentsToDebugString = ye, a.default = we, a.getFullscreenElement = Xe, a.getUnstableAudioFingerprint = Ae, a.getUnstableCanvasFingerprint = o, a.getUnstableScreenFrame = J, a.getUnstableScreenResolution = O, a.getWebGLContext = oe, a.hashComponents = S, a.isAndroid = Ke, a.isChromium = M, a.isDesktopWebKit = G, a.isEdgeHTML = F, a.isGecko = me, a.isSamsungInternet = He, a.isTrident = re, a.isWebKit = le, a.load = ve, a.loadSources = ee, a.murmurX64Hash128 = Ne, a.prepareForSources = Oe, a.sources = xe, a.transformSource = function(g, b) {
      var E = function(T) {
        return ce(T) ? b(T) : function() {
          var R = T();
          return s(R) ? R.then(b) : b(R);
        };
      };
      return function(T) {
        var R = g(T);
        return s(R) ? R.then(E) : E(R);
      };
    }, a.withIframe = Be, Object.defineProperty(a, "__esModule", { value: !0 }), a;
  }({}), (X || (X = {})).BroprintJS = function(a) {
    const c = function(t, n = 0) {
      let i = 3735928559 ^ n, s = 1103547991 ^ n;
      for (let u, h = 0; h < t.length; h++)
        u = t.charCodeAt(h), i = Math.imul(i ^ u, 2654435761), s = Math.imul(s ^ u, 1597334677);
      return i = Math.imul(i ^ i >>> 16, 2246822507) ^ Math.imul(s ^ s >>> 13, 3266489909), 4294967296 * (2097151 & (s = Math.imul(s ^ s >>> 16, 2246822507) ^ Math.imul(i ^ i >>> 13, 3266489909))) + (i >>> 0);
    }, r = () => {
      if (!(() => {
        const s = document.createElement("canvas");
        return !(!s.getContext || !s.getContext("2d"));
      })())
        return "canvas not supported";
      var t = document.createElement("canvas"), n = t.getContext("2d"), i = "BroPrint.65@345876";
      return n.textBaseline = "top", n.font = "14px 'Arial'", n.textBaseline = "alphabetic", n.fillStyle = "#f60", n.fillRect(125, 1, 62, 20), n.fillStyle = "#069", n.fillText(i, 2, 15), n.fillStyle = "rgba(102, 204, 0, 0.7)", n.fillText(i, 4, 17), t.toDataURL();
    }, e = /* @__PURE__ */ function() {
      let t = null, n = null, i = null, s = null, u = null, h = null;
      function l(p, y) {
        s[p] !== void 0 && typeof s[p].setValueAtTime == "function" && s[p].setValueAtTime(y, t.currentTime);
      }
      function d(p) {
        (function(y) {
          let k = null;
          for (var Q = 4500; 5e3 > Q; Q++) {
            var m = y.renderedBuffer.getChannelData(0)[Q];
            k += Math.abs(m);
          }
          u = k.toString(), typeof h == "function" && h(u);
        })(p), s.disconnect();
      }
      return {
        run: function(p, y = !1) {
          h = p;
          try {
            (function() {
              let k = window.OfflineAudioContext || window.webkitOfflineAudioContext;
              t = new k(1, 44100, 44100);
            })(), n = t.currentTime, (i = t.createOscillator()).type = "triangle", i.frequency.setValueAtTime(1e4, n), s = t.createDynamicsCompressor(), l("threshold", -50), l("knee", 40), l("ratio", 12), l("reduction", -20), l("attack", 0), l("release", 0.25), i.connect(s), s.connect(t.destination), i.start(0), t.startRendering(), t.oncomplete = d;
          } catch (k) {
            if (y) throw k;
          }
        }
      };
    }();
    return a.getCurrentBrowserFingerPrint = function() {
      const t = new Promise((n, i) => {
        e.run(function(s) {
          n(s);
        });
      });
      return new Promise((n, i) => {
        t.then(async (s) => {
          let u = "";
          navigator.brave && await navigator.brave.isBrave(), u = window.btoa(s) + r(), n(c(u, 0));
        }).catch(() => {
          try {
            n(c(r()).toString());
          } catch {
            i("Failed to generate the finger print of this browser");
          }
        });
      });
    }, Object.defineProperty(a, "__esModule", { value: !0 }), a;
  }({}), function(a) {
    var c, r, e = function(P, N) {
      var H = typeof Symbol == "function" && P[Symbol.iterator];
      if (!H) return P;
      var j, K, ae = H.call(P), ce = [];
      try {
        for (; (N === void 0 || N-- > 0) && !(j = ae.next()).done; ) ce.push(j.value);
      } catch (ee) {
        K = { error: ee };
      } finally {
        try {
          j && !j.done && (H = ae.return) && H.call(ae);
        } finally {
          if (K) throw K.error;
        }
      }
      return ce;
    }, t = function(P, N, H) {
      if (arguments.length === 2)
        for (var j, K = 0, ae = N.length; K < ae; K++)
          !j && K in N || (j || (j = Array.prototype.slice.call(N, 0, K)), j[K] = N[K]);
      return P.concat(j || Array.prototype.slice.call(N));
    }, n = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), u = /* @__PURE__ */ new WeakMap(), h = /* @__PURE__ */ new WeakMap(), l = {
      get: function(P, N, H) {
        if (P instanceof IDBTransaction) {
          if (N === "done") return i.get(P);
          if (N === "objectStoreNames") return P.objectStoreNames || s.get(P);
          if (N === "store")
            return H.objectStoreNames[1] ? void 0 : H.objectStore(H.objectStoreNames[0]);
        }
        return y(P[N]);
      },
      set: function(P, N, H) {
        return P[N] = H, !0;
      },
      has: function(P, N) {
        return P instanceof IDBTransaction && (N === "done" || N === "store") || N in P;
      }
    };
    function d(P) {
      return P !== IDBDatabase.prototype.transaction || "objectStoreNames" in IDBTransaction.prototype ? (r || (r = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
      ])).includes(P) ? function() {
        for (var N = [], H = 0; H < arguments.length; H++) N[H] = arguments[H];
        return P.apply(k(this), N), y(n.get(this));
      } : function() {
        for (var N = [], H = 0; H < arguments.length; H++) N[H] = arguments[H];
        return y(P.apply(k(this), N));
      } : function(N) {
        for (var H = [], j = 1; j < arguments.length; j++) H[j - 1] = arguments[j];
        var K = P.call.apply(P, t([k(this), N], e(H), !1));
        return s.set(K, N.sort ? N.sort() : [N]), y(K);
      };
    }
    function p(P) {
      return typeof P == "function" ? d(P) : (P instanceof IDBTransaction && function(H) {
        if (!i.has(H)) {
          var j = new Promise(function(K, ae) {
            var ce = function() {
              H.removeEventListener("complete", ee), H.removeEventListener("error", re), H.removeEventListener("abort", re);
            }, ee = function() {
              K(), ce();
            }, re = function() {
              ae(H.error || new DOMException("AbortError", "AbortError")), ce();
            };
            H.addEventListener("complete", ee), H.addEventListener("error", re), H.addEventListener("abort", re);
          });
          i.set(H, j);
        }
      }(P), N = P, (c || (c = [IDBDatabase, IDBObjectStore, IDBIndex, IDBCursor, IDBTransaction])).some(
        function(H) {
          return N instanceof H;
        }
      ) ? new Proxy(P, l) : P);
      var N;
    }
    function y(P) {
      if (P instanceof IDBRequest)
        return N = P, (H = new Promise(function(K, ae) {
          var ce = function() {
            N.removeEventListener("success", ee), N.removeEventListener("error", re);
          }, ee = function() {
            K(y(N.result)), ce();
          }, re = function() {
            ae(N.error), ce();
          };
          N.addEventListener("success", ee), N.addEventListener("error", re);
        })).then(function(K) {
          K instanceof IDBCursor && n.set(K, N);
        }).catch(function() {
        }), h.set(H, N), H;
      var N, H;
      if (u.has(P)) return u.get(P);
      var j = p(P);
      return j !== P && (u.set(P, j), h.set(j, P)), j;
    }
    var k = function(P) {
      return h.get(P);
    }, Q = function() {
      return (Q = Object.assign || function(P) {
        for (var N, H = 1, j = arguments.length; H < j; H++)
          for (var K in N = arguments[H])
            Object.prototype.hasOwnProperty.call(N, K) && (P[K] = N[K]);
        return P;
      }).apply(this, arguments);
    }, m = function(P, N, H, j) {
      return new (H || (H = Promise))(function(K, ae) {
        function ce(F) {
          try {
            re(j.next(F));
          } catch (M) {
            ae(M);
          }
        }
        function ee(F) {
          try {
            re(j.throw(F));
          } catch (M) {
            ae(M);
          }
        }
        function re(F) {
          var M;
          F.done ? K(F.value) : (M = F.value, M instanceof H ? M : new H(function(le) {
            le(M);
          })).then(ce, ee);
        }
        re((j = j.apply(P, [])).next());
      });
    }, _ = function(P, N) {
      var H, j, K, ae, ce = {
        label: 0,
        sent: function() {
          if (1 & K[0]) throw K[1];
          return K[1];
        },
        trys: [],
        ops: []
      };
      return ae = { next: ee(0), throw: ee(1), return: ee(2) }, typeof Symbol == "function" && (ae[Symbol.iterator] = function() {
        return this;
      }), ae;
      function ee(re) {
        return function(F) {
          return function(M) {
            if (H) throw new TypeError("Generator is already executing.");
            for (; ce; )
              try {
                if (H = 1, j && (K = 2 & M[0] ? j.return : M[0] ? j.throw || ((K = j.return) && K.call(j), 0) : j.next) && !(K = K.call(j, M[1])).done)
                  return K;
                switch (j = 0, K && (M = [2 & M[0], K.value]), M[0]) {
                  case 0:
                  case 1:
                    K = M;
                    break;
                  case 4:
                    return ce.label++, { value: M[1], done: !1 };
                  case 5:
                    ce.label++, j = M[1], M = [0];
                    continue;
                  case 7:
                    M = ce.ops.pop(), ce.trys.pop();
                    continue;
                  default:
                    if (!((K = (K = ce.trys).length > 0 && K[K.length - 1]) || M[0] !== 6 && M[0] !== 2)) {
                      ce = 0;
                      continue;
                    }
                    if (M[0] === 3 && (!K || M[1] > K[0] && M[1] < K[3])) {
                      ce.label = M[1];
                      break;
                    }
                    if (M[0] === 6 && ce.label < K[1]) {
                      ce.label = K[1], K = M;
                      break;
                    }
                    if (K && ce.label < K[2]) {
                      ce.label = K[2], ce.ops.push(M);
                      break;
                    }
                    K[2] && ce.ops.pop(), ce.trys.pop();
                    continue;
                }
                M = N.call(P, ce);
              } catch (le) {
                M = [6, le], j = 0;
              } finally {
                H = K = 0;
              }
            if (5 & M[0]) throw M[1];
            return { value: M[0] ? M[1] : void 0, done: !0 };
          }([re, F]);
        };
      }
    }, w = function(P, N) {
      var H = typeof Symbol == "function" && P[Symbol.iterator];
      if (!H) return P;
      var j, K, ae = H.call(P), ce = [];
      try {
        for (; (N === void 0 || N-- > 0) && !(j = ae.next()).done; ) ce.push(j.value);
      } catch (ee) {
        K = { error: ee };
      } finally {
        try {
          j && !j.done && (H = ae.return) && H.call(ae);
        } finally {
          if (K) throw K.error;
        }
      }
      return ce;
    }, A = function(P, N, H) {
      if (arguments.length === 2)
        for (var j, K = 0, ae = N.length; K < ae; K++)
          !j && K in N || (j || (j = Array.prototype.slice.call(N, 0, K)), j[K] = N[K]);
      return P.concat(j || Array.prototype.slice.call(N));
    }, U = ["get", "getKey", "getAll", "getAllKeys", "count"], pe = ["put", "add", "delete", "clear"], D = /* @__PURE__ */ new Map();
    function W(P, N) {
      if (P instanceof IDBDatabase && !(N in P) && typeof N == "string") {
        if (D.get(N)) return D.get(N);
        var H = N.replace(/FromIndex$/, ""), j = N !== H, K = pe.includes(H);
        if (H in (j ? IDBIndex : IDBObjectStore).prototype && (K || U.includes(H))) {
          var ae = function(ce) {
            for (var ee = [], re = 1; re < arguments.length; re++) ee[re - 1] = arguments[re];
            return m(this, void 0, void 0, function() {
              var F, M, le;
              return _(this, function(G) {
                switch (G.label) {
                  case 0:
                    return F = this.transaction(ce, K ? "readwrite" : "readonly"), M = F.store, j && (M = M.index(ee.shift())), [4, Promise.all([(le = M)[H].apply(le, A([], w(ee), !1)), K && F.done])];
                  case 1:
                    return [2, G.sent()[0]];
                }
              });
            });
          };
          return D.set(N, ae), ae;
        }
      }
    }
    l = function(P) {
      return Q(Q({}, P), {
        get: function(N, H, j) {
          return W(N, H) || P.get(N, H, j);
        },
        has: function(N, H) {
          return !!W(N, H) || P.has(N, H);
        }
      });
    }(l), a.deleteDB = function(P, N) {
      var H = (N === void 0 ? {} : N).blocked, j = indexedDB.deleteDatabase(P);
      return H && j.addEventListener("blocked", function(K) {
        return H(K.oldVersion, K);
      }), y(j).then(function() {
      });
    }, a.openDB = function(P, N, H) {
      var j = H === void 0 ? {} : H, K = j.blocked, ae = j.upgrade, ce = j.blocking, ee = j.terminated, re = indexedDB.open(P, N), F = y(re);
      return ae && re.addEventListener("upgradeneeded", function(M) {
        ae(y(re.result), M.oldVersion, M.newVersion, y(re.transaction), M);
      }), K && re.addEventListener("blocked", function(M) {
        return K(M.oldVersion, M.newVersion, M);
      }), F.then(function(M) {
        ee && M.addEventListener("close", function() {
          return ee();
        }), ce && M.addEventListener("versionchange", function(le) {
          return ce(le.oldVersion, le.newVersion, le);
        });
      }).catch(function() {
      }), F;
    }, a.unwrap = k, a.wrap = y;
  }(X || (X = {})), function(a) {
    function c(r, e) {
      var t;
      e = e || {}, this._id = c._generateUUID(), this._promise = e.promise || Promise, this._frameId = e.frameId || "CrossStorageClient-" + this._id, this._origin = c._getOrigin(r), this._requests = {}, this._connected = !1, this._closed = !1, this._count = 0, this._timeout = e.timeout || 5e3, this._listener = null, this._installListener(), e.frameId && (t = document.getElementById(e.frameId)), t && this._poll(), t = t || this._createFrame(r), this._hub = t.contentWindow;
    }
    c.frameStyle = {
      width: 0,
      height: 0,
      border: "none",
      display: "none",
      position: "absolute",
      top: "-999px",
      left: "-999px"
    }, c._getOrigin = function(r) {
      var e;
      return (e = document.createElement("a")).href = r, e.host || (e = window.location), ((e.protocol && e.protocol !== ":" ? e.protocol : window.location.protocol) + "//" + e.host).replace(/:80$|:443$/, "");
    }, c._generateUUID = function() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(r) {
        var e = 16 * Math.random() | 0;
        return (r == "x" ? e : 3 & e | 8).toString(16);
      });
    }, c.prototype.onConnect = function() {
      var r = this;
      return this._connected ? this._promise.resolve() : this._closed ? this._promise.reject(new Error("CrossStorageClient has closed")) : (this._requests.connect || (this._requests.connect = []), new this._promise(function(e, t) {
        var n = setTimeout(function() {
          t(new Error("CrossStorageClient could not connect"));
        }, r._timeout);
        r._requests.connect.push(function(i) {
          if (clearTimeout(n), i) return t(i);
          e();
        });
      }));
    }, c.prototype.set = function(r, e) {
      return this._request("set", { key: r, value: e });
    }, c.prototype.getSignedPayload = function(r, e) {
      return this._request("getSignedData", { payload: r, deviceId: e });
    }, c.prototype.getDeviceDetails = function(r) {
      return this._request("getDeviceDetails", { deviceName: r });
    }, c.prototype.setDeviceDetails = function(r, e) {
      return this._request("setDeviceDetails", { deviceName: r, deviceId: e });
    }, c.prototype.get = function(r) {
      var e = Array.prototype.slice.call(arguments);
      return this._request("get", { keys: e });
    }, c.prototype.del = function() {
      var r = Array.prototype.slice.call(arguments);
      return this._request("del", { keys: r });
    }, c.prototype.clear = function() {
      return this._request("clear");
    }, c.prototype.getKeys = function() {
      return this._request("getKeys");
    }, c.prototype.close = function(r) {
      const e = this._frameId, t = this;
      this._request("close").catch(function(n) {
      }).finally(function() {
        try {
          var n = document.getElementById(e);
          n && !r && n.parentNode.removeChild(n), window.removeEventListener ? window.removeEventListener("message", t._listener, !1) : window.detachEvent("onmessage", t._listener), t._connected = !1, t._closed = !0;
        } catch {
        }
      });
    }, c.prototype._installListener = function() {
      var r = this;
      this._listener = function(e) {
        var t, n, i;
        if (!r._closed && e.data && typeof e.data == "string" && (e.origin === "null" ? "file://" : e.origin) === r._origin)
          if (e.data !== "cross-storage:unavailable") {
            if (e.data.indexOf("cross-storage:") !== -1 && !r._connected) {
              if (r._connected = !0, !r._requests.connect) return;
              for (t = 0; t < r._requests.connect.length; t++) r._requests.connect[t](n);
              delete r._requests.connect;
            }
            if (e.data !== "cross-storage:ready") {
              try {
                i = JSON.parse(e.data);
              } catch {
                return;
              }
              i.id && r._requests[i.id] && r._requests[i.id](i.error, i.result);
            }
          } else {
            if (r._closed || r.close(), !r._requests.connect) return;
            for (n = new Error("Closing client. Could not access localStorage in hub."), t = 0; t < r._requests.connect.length; t++)
              r._requests.connect[t](n);
          }
      }, window.addEventListener ? window.addEventListener("message", this._listener, !1) : window.attachEvent("onmessage", this._listener);
    }, c.prototype._poll = function() {
      var r, e, t;
      t = (r = this)._origin === "file://" ? "*" : r._origin, e = setInterval(function() {
        if (r._connected) return clearInterval(e);
        r._hub && r._hub.postMessage("cross-storage:poll", t);
      }, 1e3);
    }, c.prototype._createFrame = function(r) {
      var e, t;
      for (t in (e = window.document.createElement("iframe")).id = this._frameId, c.frameStyle)
        c.frameStyle.hasOwnProperty(t) && (e.style[t] = c.frameStyle[t]);
      return window.document.body.appendChild(e), e.src = r, e;
    }, c.prototype._request = function(r, e) {
      var t, n;
      return this._closed ? this._promise.reject(new Error("CrossStorageClient has closed")) : ((n = this)._count++, t = { id: this._id + ":" + n._count, method: "cross-storage:" + r, params: e }, new this._promise(function(i, s) {
        var u, h, l;
        u = setTimeout(function() {
          n._requests[t.id] && (delete n._requests[t.id], s(new Error("Timeout: could not perform " + t.method)));
        }, n._timeout), n._requests[t.id] = function(d, p) {
          if (clearTimeout(u), delete n._requests[t.id], d) return s(new Error(d));
          i(p);
        }, Array.prototype.toJSON && (h = Array.prototype.toJSON, Array.prototype.toJSON = null), l = n._origin === "file://" ? "*" : n._origin, n._hub.postMessage(JSON.stringify(t), l), h && (Array.prototype.toJSON = h);
      }));
    }, a.CrossStorageClient = c;
  }(X || (X = {})), function() {
    typeof Object.assign != "function" && Object.defineProperty(Object, "assign", {
      value: function(a, c) {
        if (a == null)
          throw new TypeError("Cannot convert undefined or null to object");
        for (var r = Object(a), e = 1; e < arguments.length; e++) {
          var t = arguments[e];
          if (t != null)
            for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (r[n] = t[n]);
        }
        return r;
      },
      writable: !0,
      configurable: !0
    });
  }(), Array.from || (Array.from = function() {
    var a = Object.prototype.toString, c = function(t) {
      return typeof t == "function" || a.call(t) === "[object Function]";
    }, r = Math.pow(2, 53) - 1, e = function(t) {
      var n = function(i) {
        var s = Number(i);
        return isNaN(s) ? 0 : s !== 0 && isFinite(s) ? (s > 0 ? 1 : -1) * Math.floor(Math.abs(s)) : s;
      }(t);
      return Math.min(Math.max(n, 0), r);
    };
    return function(t) {
      var n = Object(t);
      if (t == null)
        throw new TypeError("Array.from requires an array-like object - not null or undefined");
      var i, s = arguments.length > 1 ? arguments[1] : void 0;
      if (s !== void 0) {
        if (!c(s))
          throw new TypeError(
            "Array.from: when provided, the second argument must be a function"
          );
        arguments.length > 2 && (i = arguments[2]);
      }
      for (var u, h = e(n.length), l = c(this) ? Object(new this(h)) : new Array(h), d = 0; d < h; )
        u = n[d], l[d] = s ? i === void 0 ? s(u, d) : s.call(i, u, d) : u, d += 1;
      return l.length = h, l;
    };
  }()), function() {
    String.prototype.endsWith || (String.prototype.endsWith = function(a, c) {
      return (c === void 0 || c > this.length) && (c = this.length), this.substring(c - a.length, c) === a;
    });
  }(), function() {
    Promise.allSettled = Promise.allSettled || function(a) {
      return Promise.all(
        a.map(function(c) {
          return c.then(function(r) {
            return { status: "fulfilled", value: r };
          }).catch(function(r) {
            return { status: "rejected", reason: r };
          });
        })
      );
    };
  }(), function(a, c) {
    var r, e = 500, t = "user-agent", n = "", i = "function", s = "undefined", u = "object", h = "string", l = "browser", d = "cpu", p = "device", y = "engine", k = "os", Q = "result", m = "name", _ = "type", w = "vendor", A = "version", U = "architecture", pe = "major", D = "model", W = "mobile", P = "tablet", N = "smarttv", H = "brands", j = "formFactors", K = "fullVersionList", ae = "platform", ce = "platformVersion", ee = "bitness", re = "sec-ch-ua", F = re + "-full-version-list", M = re + "-arch", le = re + "-" + ee, G = re + "-form-factors", te = re + "-" + W, me = re + "-" + D, Te = re + "-" + ae, Xe = Te + "-version", Ke = [H, K, W, D, ae, ce, U, j, ee], He = "Chromium", Ae = "Windows", Ee = typeof window !== s && window.navigator ? window.navigator : c, Be = Ee && Ee.userAgentData ? Ee.userAgentData : c, Ze = function(be, Pe) {
      var he = {}, Ge = Pe;
      if (!vt(Pe))
        for (var _e in Ge = {}, Pe)
          for (var ze in Pe[_e]) Ge[ze] = Pe[_e][ze].concat(Ge[ze] ? Ge[ze] : []);
      for (var ot in be) he[ot] = Ge[ot] && Ge[ot].length % 2 == 0 ? Ge[ot].concat(be[ot]) : be[ot];
      return he;
    }, qe = function(be) {
      for (var Pe = {}, he = 0; he < be.length; he++) Pe[be[he].toUpperCase()] = be[he];
      return Pe;
    }, Je = function(be, Pe) {
      if (typeof be === u && be.length > 0) {
        for (var he in be) if (o(be[he]) == o(Pe)) return !0;
        return !1;
      }
      return !!rt(be) && o(Pe).indexOf(o(be)) !== -1;
    }, vt = function(be, Pe) {
      for (var he in be) return /^(browser|cpu|device|engine|os)$/.test(he) || !!Pe && vt(be[he]);
    }, rt = function(be) {
      return typeof be === h;
    }, lt = function(be) {
      if (!be) return c;
      for (var Pe = [], he = f(/\\?\"/g, be).split(","), Ge = 0; Ge < he.length; Ge++)
        if (he[Ge].indexOf(";") > -1) {
          var _e = se(he[Ge]).split(";v=");
          Pe[Ge] = { brand: _e[0], version: _e[1] };
        } else Pe[Ge] = se(he[Ge]);
      return Pe;
    }, o = function(be) {
      return rt(be) ? be.toLowerCase() : be;
    }, I = function(be) {
      return rt(be) ? f(/[^\d\.]/g, be).split(".")[0] : c;
    }, O = function(be) {
      for (var Pe in be) {
        var he = be[Pe];
        typeof he == u && he.length == 2 ? this[he[0]] = he[1] : this[he] = c;
      }
      return this;
    }, f = function(be, Pe) {
      return rt(Pe) ? Pe.replace(be, n) : Pe;
    }, B = function(be) {
      return f(/\\?\"/g, be);
    }, se = function(be, Pe) {
      if (rt(be)) return be = f(/^\s\s*/, be), typeof Pe === s ? be : be.substring(0, e);
    }, de = function(be, Pe) {
      if (be && Pe)
        for (var he, Ge, _e, ze, ot, $e, et = 0; et < Pe.length && !ot; ) {
          var gt = Pe[et], Pt = Pe[et + 1];
          for (he = Ge = 0; he < gt.length && !ot && gt[he]; )
            if (ot = gt[he++].exec(be))
              for (_e = 0; _e < Pt.length; _e++)
                $e = ot[++Ge], typeof (ze = Pt[_e]) === u && ze.length > 0 ? ze.length === 2 ? typeof ze[1] == i ? this[ze[0]] = ze[1].call(this, $e) : this[ze[0]] = ze[1] : ze.length === 3 ? typeof ze[1] !== i || ze[1].exec && ze[1].test ? this[ze[0]] = $e ? $e.replace(ze[1], ze[2]) : c : this[ze[0]] = $e ? ze[1].call(this, $e, ze[2]) : c : ze.length === 4 && (this[ze[0]] = $e ? ze[3].call(this, $e.replace(ze[1], ze[2])) : c) : this[ze] = $e || c;
          et += 2;
        }
    }, J = function(be, Pe) {
      for (var he in Pe)
        if (typeof Pe[he] === u && Pe[he].length > 0) {
          for (var Ge = 0; Ge < Pe[he].length; Ge++) if (Je(Pe[he][Ge], be)) return he === "?" ? c : he;
        } else if (Je(Pe[he], be)) return he === "?" ? c : he;
      return Pe.hasOwnProperty("*") ? Pe["*"] : be;
    }, Le = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2e3: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      8.1: "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    }, Ce = {
      embedded: "Automotive",
      mobile: "Mobile",
      tablet: ["Tablet", "EInk"],
      smarttv: "TV",
      wearable: "Watch",
      xr: ["VR", "XR"],
      "?": ["Desktop", "Unknown"],
      "*": c
    }, Qe = {
      browser: [
        [/\b(?:crmo|crios)\/([\w\.]+)/i],
        [A, [m, "Mobile Chrome"]],
        [/edg(?:e|ios|a)?\/([\w\.]+)/i],
        [A, [m, "Edge"]],
        [
          /(opera mini)\/([-\w\.]+)/i,
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
        ],
        [m, A],
        [/opios[\/ ]+([\w\.]+)/i],
        [A, [m, "Opera Mini"]],
        [/\bop(?:rg)?x\/([\w\.]+)/i],
        [A, [m, "Opera GX"]],
        [/\bopr\/([\w\.]+)/i],
        [A, [m, "Opera"]],
        [/\bb[a]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i],
        [A, [m, "Baidu"]],
        [/\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i],
        [A, [m, "Maxthon"]],
        [
          /(kindle)\/([\w\.]+)/i,
          /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
          /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
          /(?:ms|\()(ie) ([\w\.]+)/i,
          /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
          /(heytap|ovi|115)browser\/([\d\.]+)/i,
          /(weibo)__([\d\.]+)/i
        ],
        [m, A],
        [/quark(?:pc)?\/([-\w\.]+)/i],
        [A, [m, "Quark"]],
        [/\bddg\/([\w\.]+)/i],
        [A, [m, "DuckDuckGo"]],
        [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],
        [A, [m, "UCBrowser"]],
        [
          /microm.+\bqbcore\/([\w\.]+)/i,
          /\bqbcore\/([\w\.]+).+microm/i,
          /micromessenger\/([\w\.]+)/i
        ],
        [A, [m, "WeChat"]],
        [/konqueror\/([\w\.]+)/i],
        [A, [m, "Konqueror"]],
        [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],
        [A, [m, "IE"]],
        [/ya(?:search)?browser\/([\w\.]+)/i],
        [A, [m, "Yandex"]],
        [/slbrowser\/([\w\.]+)/i],
        [A, [m, "Smart Lenovo Browser"]],
        [/(avast|avg)\/([\w\.]+)/i],
        [[m, /(.+)/, "$1 Secure Browser"], A],
        [/\bfocus\/([\w\.]+)/i],
        [A, [m, "Firefox Focus"]],
        [/\bopt\/([\w\.]+)/i],
        [A, [m, "Opera Touch"]],
        [/coc_coc\w+\/([\w\.]+)/i],
        [A, [m, "Coc Coc"]],
        [/dolfin\/([\w\.]+)/i],
        [A, [m, "Dolphin"]],
        [/coast\/([\w\.]+)/i],
        [A, [m, "Opera Coast"]],
        [/miuibrowser\/([\w\.]+)/i],
        [A, [m, "MIUI Browser"]],
        [/fxios\/([\w\.-]+)/i],
        [A, [m, "Mobile Firefox"]],
        [/\bqihoobrowser\/?([\w\.]*)/i],
        [A, [m, "360"]],
        [/\b(qq)\/([\w\.]+)/i],
        [[m, /(.+)/, "$1Browser"], A],
        [/(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i],
        [[m, /(.+)/, "$1 Browser"], A],
        [/samsungbrowser\/([\w\.]+)/i],
        [A, [m, "Samsung Internet"]],
        [/metasr[\/ ]?([\d\.]+)/i],
        [A, [m, "Sogou Explorer"]],
        [/(sogou)mo\w+\/([\d\.]+)/i],
        [[m, "Sogou Mobile"], A],
        [
          /(electron)\/([\w\.]+) safari/i,
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
        ],
        [m, A],
        [/(lbbrowser|rekonq)/i],
        [m],
        [/ome\/([\w\.]+) \w* ?(iron) saf/i, /ome\/([\w\.]+).+qihu (360)[es]e/i],
        [A, m],
        [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],
        [[m, "Facebook"], A, [_, "inapp"]],
        [
          /(Klarna)\/([\w\.]+)/i,
          /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
          /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
          /(daum)apps[\/ ]([\w\.]+)/i,
          /safari (line)\/([\w\.]+)/i,
          /\b(line)\/([\w\.]+)\/iab/i,
          /(alipay)client\/([\w\.]+)/i,
          /(twitter)(?:and| f.+e\/([\w\.]+))/i,
          /(instagram|snapchat)[\/ ]([-\w\.]+)/i
        ],
        [m, A, [_, "inapp"]],
        [/\bgsa\/([\w\.]+) .*safari\//i],
        [A, [m, "GSA"], [_, "inapp"]],
        [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i],
        [A, [m, "TikTok"], [_, "inapp"]],
        [/\[(linkedin)app\]/i],
        [m, [_, "inapp"]],
        [/(chromium)[\/ ]([-\w\.]+)/i],
        [m, A],
        [/headlesschrome(?:\/([\w\.]+)| )/i],
        [A, [m, "Chrome Headless"]],
        [/ wv\).+(chrome)\/([\w\.]+)/i],
        [[m, "Chrome WebView"], A],
        [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],
        [A, [m, "Android Browser"]],
        [/chrome\/([\w\.]+) mobile/i],
        [A, [m, "Mobile Chrome"]],
        [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],
        [m, A],
        [/version\/([\w\.\,]+) .*mobile(?:\/\w+ | ?)safari/i],
        [A, [m, "Mobile Safari"]],
        [/iphone .*mobile(?:\/\w+ | ?)safari/i],
        [[m, "Mobile Safari"]],
        [/version\/([\w\.\,]+) .*(safari)/i],
        [A, m],
        [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],
        [m, [A, "1"]],
        [/(webkit|khtml)\/([\w\.]+)/i],
        [m, A],
        [/(?:mobile|tablet);.*(firefox)\/([\w\.-]+)/i],
        [[m, "Mobile Firefox"], A],
        [/(navigator|netscape\d?)\/([-\w\.]+)/i],
        [[m, "Netscape"], A],
        [/(wolvic|librewolf)\/([\w\.]+)/i],
        [m, A],
        [/mobile vr; rv:([\w\.]+)\).+firefox/i],
        [A, [m, "Firefox Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          /(swiftfox)/i,
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          /(firefox)\/([\w\.]+)/i,
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          /\b(links) \(([\w\.]+)/i
        ],
        [m, [A, /_/g, "."]],
        [/(cobalt)\/([\w\.]+)/i],
        [m, [A, /[^\d\.]+./, n]]
      ],
      cpu: [
        [/\b((amd|x|x86[-_]?|wow|win)64)\b/i],
        [[U, "amd64"]],
        [/(ia32(?=;))/i, /\b((i[346]|x)86)(pc)?\b/i],
        [[U, "ia32"]],
        [/\b(aarch64|arm(v?[89]e?l?|_?64))\b/i],
        [[U, "arm64"]],
        [/\b(arm(v[67])?ht?n?[fl]p?)\b/i],
        [[U, "armhf"]],
        [/( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i],
        [[U, "arm"]],
        [/((ppc|powerpc)(64)?)( mac|;|\))/i],
        [[U, /ower/, n, o]],
        [/ sun4\w[;\)]/i],
        [[U, "sparc"]],
        [
          /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
        ],
        [[U, o]]
      ],
      device: [
        [/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],
        [D, [w, "Samsung"], [_, P]],
        [
          /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
          /samsung[- ]((?!sm-[lr])[-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [D, [w, "Samsung"], [_, W]],
        [/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i],
        [D, [w, "Apple"], [_, W]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [D, [w, "Apple"], [_, P]],
        [/(macintosh);/i],
        [D, [w, "Apple"]],
        [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],
        [D, [w, "Sharp"], [_, W]],
        [
          /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
        ],
        [D, [w, "Honor"], [_, P]],
        [/honor([-\w ]+)[;\)]/i],
        [D, [w, "Honor"], [_, W]],
        [
          /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
        ],
        [D, [w, "Huawei"], [_, P]],
        [
          /(?:huawei)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [D, [w, "Huawei"], [_, W]],
        [
          /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
          /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
        ],
        [
          [D, /_/g, " "],
          [w, "Xiaomi"],
          [_, P]
        ],
        [
          /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
          /\b; (\w+) build\/hm\1/i,
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
          / ([\w ]+) miui\/v?\d/i
        ],
        [
          [D, /_/g, " "],
          [w, "Xiaomi"],
          [_, W]
        ],
        [
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [D, [w, "OPPO"], [_, W]],
        [/\b(opd2(\d{3}a?))(?: bui|\))/i],
        [D, [w, J, { OnePlus: ["304", "403", "203"], "*": "OPPO" }], [_, P]],
        [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i],
        [D, [w, "Vivo"], [_, W]],
        [/\b(rmx[1-3]\d{3})(?: bui|;|\))/i],
        [D, [w, "Realme"], [_, W]],
        [
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [D, [w, "Motorola"], [_, W]],
        [/\b(mz60\d|xoom[2 ]{0,2}) build\//i],
        [D, [w, "Motorola"], [_, P]],
        [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],
        [D, [w, "LG"], [_, P]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [D, [w, "LG"], [_, W]],
        [
          /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
          /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
        ],
        [D, [w, "Lenovo"], [_, P]],
        [/(nokia) (t[12][01])/i],
        [w, D, [_, P]],
        [/(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i, /nokia[-_ ]?(([-\w\. ]*))/i],
        [
          [D, /_/g, " "],
          [_, W],
          [w, "Nokia"]
        ],
        [/(pixel (c|tablet))\b/i],
        [D, [w, "Google"], [_, P]],
        [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],
        [D, [w, "Google"], [_, W]],
        [
          /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [D, [w, "Sony"], [_, W]],
        [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i],
        [
          [D, "Xperia Tablet"],
          [w, "Sony"],
          [_, P]
        ],
        [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],
        [D, [w, "OnePlus"], [_, W]],
        [
          /(alexa)webm/i,
          /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
          /(kf[a-z]+)( bui|\)).+silk\//i
        ],
        [D, [w, "Amazon"], [_, P]],
        [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],
        [
          [D, /(.+)/g, "Fire Phone $1"],
          [w, "Amazon"],
          [_, W]
        ],
        [/(playbook);[-\w\),; ]+(rim)/i],
        [D, w, [_, P]],
        [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i],
        [D, [w, "BlackBerry"], [_, W]],
        [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],
        [D, [w, "ASUS"], [_, P]],
        [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],
        [D, [w, "ASUS"], [_, W]],
        [/(nexus 9)/i],
        [D, [w, "HTC"], [_, P]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
        ],
        [w, [D, /_/g, " "], [_, W]],
        [
          /tcl (xess p17aa)/i,
          /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])(_\w(\w|\w\w))?(\)| bui)/i
        ],
        [D, [w, "TCL"], [_, P]],
        [
          /droid [\w\.]+; (418(?:7d|8v)|5087z|5102l|61(?:02[dh]|25[adfh]|27[ai]|56[dh]|59k|65[ah])|a509dl|t(?:43(?:0w|1[adepqu])|50(?:6d|7[adju])|6(?:09dl|10k|12b|71[efho]|76[hjk])|7(?:66[ahju]|67[hw]|7[045][bh]|71[hk]|73o|76[ho]|79w|81[hks]?|82h|90[bhsy]|99b)|810[hs]))(_\w(\w|\w\w))?(\)| bui)/i
        ],
        [D, [w, "TCL"], [_, W]],
        [/(itel) ((\w+))/i],
        [[w, o], D, [_, J, { tablet: ["p10001l", "w7001"], "*": "mobile" }]],
        [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],
        [D, [w, "Acer"], [_, P]],
        [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i],
        [D, [w, "Meizu"], [_, W]],
        [/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i],
        [D, [w, "Ulefone"], [_, W]],
        [/; (energy ?\w+)(?: bui|\))/i, /; energizer ([\w ]+)(?: bui|\))/i],
        [D, [w, "Energizer"], [_, W]],
        [/; cat (b35);/i, /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i],
        [D, [w, "Cat"], [_, W]],
        [/((?:new )?andromax[\w- ]+)(?: bui|\))/i],
        [D, [w, "Smartfren"], [_, W]],
        [/droid.+; (a(?:015|06[35]|142p?))/i],
        [D, [w, "Nothing"], [_, W]],
        [/(imo) (tab \w+)/i, /(infinix) (x1101b?)/i],
        [w, D, [_, P]],
        [
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
          /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
          /(hp) ([\w ]+\w)/i,
          /(microsoft); (lumia[\w ]+)/i,
          /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
          /(oppo) ?([\w ]+) bui/i
        ],
        [w, D, [_, W]],
        [
          /(kobo)\s(ereader|touch)/i,
          /(archos) (gamepad2?)/i,
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          /(kindle)\/([\w\.]+)/i
        ],
        [w, D, [_, P]],
        [/(surface duo)/i],
        [D, [w, "Microsoft"], [_, P]],
        [/droid [\d\.]+; (fp\du?)(?: b|\))/i],
        [D, [w, "Fairphone"], [_, W]],
        [/((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i],
        [D, [w, "Nvidia"], [_, P]],
        [/(sprint) (\w+)/i],
        [w, D, [_, W]],
        [/(kin\.[onetw]{3})/i],
        [
          [D, /\./g, " "],
          [w, "Microsoft"],
          [_, W]
        ],
        [/droid.+; ([c6]+|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],
        [D, [w, "Zebra"], [_, P]],
        [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],
        [D, [w, "Zebra"], [_, W]],
        [/smart-tv.+(samsung)/i],
        [w, [_, N]],
        [/hbbtv.+maple;(\d+)/i],
        [
          [D, /^/, "SmartTV"],
          [w, "Samsung"],
          [_, N]
        ],
        [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],
        [
          [w, "LG"],
          [_, N]
        ],
        [/(apple) ?tv/i],
        [w, [D, "Apple TV"], [_, N]],
        [/crkey.*devicetype\/chromecast/i],
        [
          [D, "Chromecast Third Generation"],
          [w, "Google"],
          [_, N]
        ],
        [/crkey.*devicetype\/([^/]*)/i],
        [
          [D, /^/, "Chromecast "],
          [w, "Google"],
          [_, N]
        ],
        [/fuchsia.*crkey/i],
        [
          [D, "Chromecast Nest Hub"],
          [w, "Google"],
          [_, N]
        ],
        [/crkey/i],
        [
          [D, "Chromecast"],
          [w, "Google"],
          [_, N]
        ],
        [/droid.+aft(\w+)( bui|\))/i],
        [D, [w, "Amazon"], [_, N]],
        [/(shield \w+ tv)/i],
        [D, [w, "Nvidia"], [_, N]],
        [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i],
        [D, [w, "Sharp"], [_, N]],
        [/(bravia[\w ]+)( bui|\))/i],
        [D, [w, "Sony"], [_, N]],
        [/(mi(tv|box)-?\w+) bui/i],
        [D, [w, "Xiaomi"], [_, N]],
        [/Hbbtv.*(technisat) (.*);/i],
        [w, D, [_, N]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
        ],
        [
          [w, se],
          [D, se],
          [_, N]
        ],
        [/droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i],
        [D, [_, N]],
        [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],
        [[_, N]],
        [/(ouya)/i, /(nintendo) (\w+)/i],
        [w, D, [_, "console"]],
        [/droid.+; (shield)( bui|\))/i],
        [D, [w, "Nvidia"], [_, "console"]],
        [/(playstation \w+)/i],
        [D, [w, "Sony"], [_, "console"]],
        [/\b(xbox(?: one)?(?!; xbox))[\); ]/i],
        [D, [w, "Microsoft"], [_, "console"]],
        [/\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i],
        [D, [w, "Samsung"], [_, "wearable"]],
        [/((pebble))app/i, /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i],
        [w, D, [_, "wearable"]],
        [/(ow(?:19|20)?we?[1-3]{1,3})/i],
        [D, [w, "OPPO"], [_, "wearable"]],
        [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i],
        [D, [w, "Apple"], [_, "wearable"]],
        [/(opwwe\d{3})/i],
        [D, [w, "OnePlus"], [_, "wearable"]],
        [/(moto 360)/i],
        [D, [w, "Motorola"], [_, "wearable"]],
        [/(smartwatch 3)/i],
        [D, [w, "Sony"], [_, "wearable"]],
        [/(g watch r)/i],
        [D, [w, "LG"], [_, "wearable"]],
        [/droid.+; (wt63?0{2,3})\)/i],
        [D, [w, "Zebra"], [_, "wearable"]],
        [/droid.+; (glass) \d/i],
        [D, [w, "Google"], [_, "xr"]],
        [/(pico) (4|neo3(?: link|pro)?)/i],
        [w, D, [_, "xr"]],
        [/; (quest( \d| pro)?)/i],
        [D, [w, "Facebook"], [_, "xr"]],
        [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],
        [w, [_, "embedded"]],
        [/(aeobc)\b/i],
        [D, [w, "Amazon"], [_, "embedded"]],
        [/(homepod).+mac os/i],
        [D, [w, "Apple"], [_, "embedded"]],
        [/windows iot/i],
        [[_, "embedded"]],
        [/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+?(mobile|vr|\d) safari/i],
        [D, [_, J, { mobile: "Mobile", xr: "VR", "*": P }]],
        [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],
        [[_, P]],
        [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],
        [[_, W]],
        [/droid .+?; ([\w\. -]+)( bui|\))/i],
        [D, [w, "Generic"]]
      ],
      engine: [
        [/windows.+ edge\/([\w\.]+)/i],
        [A, [m, "EdgeHTML"]],
        [/(arkweb)\/([\w\.]+)/i],
        [m, A],
        [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],
        [A, [m, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
          /ekioh(flow)\/([\w\.]+)/i,
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          /(icab)[\/ ]([23]\.[\d\.]+)/i,
          /\b(libweb)/i
        ],
        [m, A],
        [/ladybird\//i],
        [[m, "LibWeb"]],
        [/rv\:([\w\.]{1,9})\b.+(gecko)/i],
        [A, m]
      ],
      os: [
        [/microsoft (windows) (vista|xp)/i],
        [m, A],
        [/(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i],
        [m, [A, J, Le]],
        [
          /windows nt 6\.2; (arm)/i,
          /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
          /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [
          [A, J, Le],
          [m, Ae]
        ],
        [
          /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
          /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
          /cfnetwork\/.+darwin/i
        ],
        [
          [A, /_/g, "."],
          [m, "iOS"]
        ],
        [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i],
        [
          [m, "macOS"],
          [A, /_/g, "."]
        ],
        [/android ([\d\.]+).*crkey/i],
        [A, [m, "Chromecast Android"]],
        [/fuchsia.*crkey\/([\d\.]+)/i],
        [A, [m, "Chromecast Fuchsia"]],
        [/crkey\/([\d\.]+).*devicetype\/smartspeaker/i],
        [A, [m, "Chromecast SmartSpeaker"]],
        [/linux.*crkey\/([\d\.]+)/i],
        [A, [m, "Chromecast Linux"]],
        [/crkey\/([\d\.]+)/i],
        [A, [m, "Chromecast"]],
        [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i],
        [A, m],
        [/(ubuntu) ([\w\.]+) like android/i],
        [[m, /(.+)/, "$1 Touch"], A],
        [
          /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
        ],
        [m, A],
        [/\(bb(10);/i],
        [A, [m, "BlackBerry"]],
        [/(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i],
        [A, [m, "Symbian"]],
        [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],
        [A, [m, "Firefox OS"]],
        [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],
        [A, [m, "webOS"]],
        [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i],
        [A, [m, "watchOS"]],
        [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i],
        [[m, "Chrome OS"], A],
        [
          /panasonic;(viera)/i,
          /(netrange)mmh/i,
          /(nettv)\/(\d+\.[\w\.]+)/i,
          /(nintendo|playstation) (\w+)/i,
          /(xbox); +xbox ([^\);]+)/i,
          /(pico) .+os([\w\.]+)/i,
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          /(mint)[\/\(\) ]?(\w*)/i,
          /(mageia|vectorlinux)[; ]/i,
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
          /(gnu) ?([\w\.]*)/i,
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          /(haiku) (\w+)/i
        ],
        [m, A],
        [/(sunos) ?([\w\.\d]*)/i],
        [[m, "Solaris"], A],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
          /(unix) ?([\w\.]*)/i
        ],
        [m, A]
      ]
    }, dt = (r = { init: {}, isIgnore: {}, isIgnoreRgx: {}, toString: {} }, O.call(r.init, [
      [l, [m, A, pe, _]],
      [d, [U]],
      [p, [_, D, w]],
      [y, [m, A]],
      [k, [m, A]]
    ]), O.call(r.isIgnore, [
      [l, [A, pe]],
      [y, [A]],
      [k, [A]]
    ]), O.call(r.isIgnoreRgx, [
      [l, / ?browser$/i],
      [k, / ?os$/i]
    ]), O.call(r.toString, [
      [l, [m, A]],
      [d, [U]],
      [p, [w, D]],
      [y, [m, A]],
      [k, [m, A]]
    ]), r), St = function(be, Pe) {
      var he = dt.init[Pe], Ge = dt.isIgnore[Pe] || 0, _e = dt.isIgnoreRgx[Pe] || 0, ze = dt.toString[Pe] || 0;
      function ot() {
        O.call(this, he);
      }
      return ot.prototype.getItem = function() {
        return be;
      }, ot.prototype.withClientHints = function() {
        return Be ? Be.getHighEntropyValues(Ke).then(function($e) {
          return be.setCH(new bt($e, !1)).parseCH().get();
        }) : be.parseCH().get();
      }, ot.prototype.withFeatureCheck = function() {
        return be.detectFeature().get();
      }, Pe != Q && (ot.prototype.is = function($e) {
        var et = !1;
        for (var gt in this)
          if (this.hasOwnProperty(gt) && !Je(Ge, gt) && o(_e ? f(_e, this[gt]) : this[gt]) == o(_e ? f(_e, $e) : $e)) {
            if (et = !0, $e != s) break;
          } else if ($e == s && et) {
            et = !et;
            break;
          }
        return et;
      }, ot.prototype.toString = function() {
        var $e = n;
        for (var et in ze) typeof this[ze[et]] !== s && ($e += ($e ? " " : n) + this[ze[et]]);
        return $e || s;
      }), Be || (ot.prototype.then = function($e) {
        var et = this, gt = function() {
          for (var Rt in et) et.hasOwnProperty(Rt) && (this[Rt] = et[Rt]);
        };
        gt.prototype = { is: ot.prototype.is, toString: ot.prototype.toString };
        var Pt = new gt();
        return $e(Pt), Pt;
      }), new ot();
    };
    function bt(be, Pe) {
      if (be = be || {}, O.call(this, Ke), Pe)
        O.call(this, [
          [H, lt(be[re])],
          [K, lt(be[F])],
          [W, /\?1/.test(be[te])],
          [D, B(be[me])],
          [ae, B(be[Te])],
          [ce, B(be[Xe])],
          [U, B(be[M])],
          [j, lt(be[G])],
          [ee, B(be[le])]
        ]);
      else for (var he in be) this.hasOwnProperty(he) && typeof be[he] !== s && (this[he] = be[he]);
    }
    function yt(be, Pe, he, Ge) {
      return this.get = function(_e) {
        return _e ? this.data.hasOwnProperty(_e) ? this.data[_e] : c : this.data;
      }, this.set = function(_e, ze) {
        return this.data[_e] = ze, this;
      }, this.setCH = function(_e) {
        return this.uaCH = _e, this;
      }, this.detectFeature = function() {
        if (Ee && Ee.userAgent == this.ua)
          switch (this.itemType) {
            case l:
              Ee.brave && typeof Ee.brave.isBrave == i && this.set(m, "Brave");
              break;
            case p:
              !this.get(_) && Be && Be[W] && this.set(_, W), this.get(D) == "Macintosh" && Ee && typeof Ee.standalone !== s && Ee.maxTouchPoints && Ee.maxTouchPoints > 2 && this.set(D, "iPad").set(_, P);
              break;
            case k:
              !this.get(m) && Be && Be[ae] && this.set(m, Be[ae]);
              break;
            case Q:
              var _e = this.data, ze = function(ot) {
                return _e[ot].getItem().detectFeature().get();
              };
              this.set(l, ze(l)).set(d, ze(d)).set(p, ze(p)).set(y, ze(y)).set(k, ze(k));
          }
        return this;
      }, this.parseUA = function() {
        return this.itemType != Q && de.call(this.data, this.ua, this.rgxMap), this.itemType == l && this.set(pe, I(this.get(A))), this;
      }, this.parseCH = function() {
        var _e = this.uaCH, ze = this.rgxMap;
        switch (this.itemType) {
          case l:
          case y:
            var ot, $e = _e[K] || _e[H];
            if ($e)
              for (var et in $e) {
                var gt = $e[et].brand || $e[et], Pt = $e[et].version;
                this.itemType != l || /not.a.brand/i.test(gt) || ot && (!/chrom/i.test(ot) || gt == He) || (gt = J(gt, {
                  Chrome: "Google Chrome",
                  Edge: "Microsoft Edge",
                  "Chrome WebView": "Android WebView",
                  "Chrome Headless": "HeadlessChrome"
                }), this.set(m, gt).set(A, Pt).set(pe, I(Pt)), ot = gt), this.itemType == y && gt == He && this.set(A, Pt);
              }
            break;
          case d:
            var Rt = _e[U];
            Rt && (Rt && _e[ee] == "64" && (Rt += "64"), de.call(this.data, Rt + ";", ze));
            break;
          case p:
            if (_e[W] && this.set(_, W), _e[D] && (this.set(D, _e[D]), !this.get(_) || !this.get(w))) {
              var ht = {};
              de.call(ht, "droid 9; " + _e[D] + ")", ze), !this.get(_) && ht.type && this.set(_, ht.type), !this.get(w) && ht.vendor && this.set(w, ht.vendor);
            }
            if (_e[j]) {
              var Tt;
              if (typeof _e[j] != "string")
                for (var fe = 0; !Tt && fe < _e[j].length; ) Tt = J(_e[j][fe++], Ce);
              else Tt = J(_e[j], Ce);
              this.set(_, Tt);
            }
            break;
          case k:
            var oe = _e[ae];
            if (oe) {
              var pt = _e[ce];
              oe == Ae && (pt = parseInt(I(pt), 10) >= 13 ? "11" : "10"), this.set(m, oe).set(A, pt);
            }
            this.get(m) == Ae && _e[D] == "Xbox" && this.set(m, "Xbox").set(A, c);
            break;
          case Q:
            var _t = this.data, je = function(Ut) {
              return _t[Ut].getItem().setCH(_e).parseCH().get();
            };
            this.set(l, je(l)).set(d, je(d)).set(p, je(p)).set(y, je(y)).set(k, je(k));
        }
        return this;
      }, O.call(this, [
        ["itemType", be],
        ["ua", Pe],
        ["uaCH", Ge],
        ["rgxMap", he],
        ["data", St(this, be)]
      ]), this;
    }
    function tt(be, Pe, he) {
      if (typeof be === u ? (vt(be, !0) ? (typeof Pe === u && (he = Pe), Pe = be) : (he = be, Pe = c), be = c) : typeof be !== h || vt(Pe, !0) || (he = Pe, Pe = c), he && typeof he.append === i) {
        var Ge = {};
        he.forEach(function(et, gt) {
          Ge[gt] = et;
        }), he = Ge;
      }
      if (!(this instanceof tt)) return new tt(be, Pe, he).getResult();
      var _e = typeof be === h ? be : he && he[t] ? he[t] : Ee && Ee.userAgent ? Ee.userAgent : n, ze = new bt(he, !0), ot = Pe ? Ze(Qe, Pe) : Qe, $e = function(et) {
        return et == Q ? function() {
          return new yt(et, _e, ot, ze).set("ua", _e).set(l, this.getBrowser()).set(d, this.getCPU()).set(p, this.getDevice()).set(y, this.getEngine()).set(k, this.getOS()).get();
        } : function() {
          return new yt(et, _e, ot[et], ze).parseUA().get();
        };
      };
      return O.call(this, [
        ["getBrowser", $e(l)],
        ["getCPU", $e(d)],
        ["getDevice", $e(p)],
        ["getEngine", $e(y)],
        ["getOS", $e(k)],
        ["getResult", $e(Q)],
        [
          "getUA",
          function() {
            return _e;
          }
        ],
        [
          "setUA",
          function(et) {
            return rt(et) && (_e = et.length > e ? se(et, e) : et), this;
          }
        ]
      ]).setUA(_e), this;
    }
    tt.VERSION = "2.0.2", tt.BROWSER = qe([m, A, pe, _]), tt.CPU = qe([U]), tt.DEVICE = qe([D, w, _, "console", W, N, P, "wearable", "embedded"]), tt.ENGINE = tt.OS = qe([m, A]), a.UAParser = tt;
  }(X || (X = {})), (X || (X = {})).evaluateModernizr = function() {
    (function(a, c, r, e) {
      function t(G, te) {
        return typeof G === te;
      }
      function n() {
        return typeof r.createElement != "function" ? r.createElement(arguments[0]) : pe ? r.createElementNS.call(r, "http://www.w3.org/2000/svg", arguments[0]) : r.createElement.apply(r, arguments);
      }
      function i(G, te) {
        return !!~("" + G).indexOf(te);
      }
      function s(G, te, me, Te) {
        var Xe, Ke, He, Ae, Ee = "modernizr", Be = n("div"), Ze = function() {
          var qe = r.body;
          return qe || ((qe = n(pe ? "svg" : "body")).fake = !0), qe;
        }();
        if (parseInt(me, 10))
          for (; me--; ) (He = n("div")).id = Ee + (me + 1), Be.appendChild(He);
        return (Xe = n("style")).type = "text/css", Xe.id = "s" + Ee, (Ze.fake ? Ze : Be).appendChild(Xe), Ze.appendChild(Be), Xe.styleSheet ? Xe.styleSheet.cssText = G : Xe.appendChild(r.createTextNode(G)), Be.id = Ee, Ze.fake && (Ze.style.background = "", Ze.style.overflow = "hidden", Ae = U.style.overflow, U.style.overflow = "hidden", U.appendChild(Ze)), Ke = te(Be, G), Ze.fake && Ze.parentNode ? (Ze.parentNode.removeChild(Ze), U.style.overflow = Ae, U.offsetHeight) : Be.parentNode.removeChild(Be), !!Ke;
      }
      function u(G) {
        return G.replace(/([A-Z])/g, function(te, me) {
          return "-" + me.toLowerCase();
        }).replace(/^ms-/, "-ms-");
      }
      function h(G, te, me) {
        var Te;
        if ("getComputedStyle" in c) {
          Te = getComputedStyle.call(c, G, te);
          var Xe = c.console;
          Te !== null ? Te = Te.getPropertyValue(me) : Xe && Xe[Xe.error ? "error" : "log"].call(
            Xe,
            "getComputedStyle returning null, its possible modernizr test results are inaccurate"
          );
        } else Te = G.currentStyle && G.currentStyle[me];
        return Te;
      }
      function l(G, te) {
        var me = G.length;
        if (c && c.CSS && "supports" in c.CSS) {
          for (; me--; ) if (c.CSS.supports(u(G[me]), te)) return !0;
          return !1;
        }
        if ("CSSSupportsRule" in c) {
          for (var Te = []; me--; ) Te.push("(" + u(G[me]) + ":" + te + ")");
          return s(
            "@supports (" + (Te = Te.join(" or ")) + ") { #modernizr { position: absolute; } }",
            function(Xe) {
              return h(Xe, null, "position") === "absolute";
            }
          );
        }
        return e;
      }
      function d(G) {
        return G.replace(/([a-z])-([a-z])/g, function(te, me, Te) {
          return me + Te.toUpperCase();
        }).replace(/^-/, "");
      }
      function p(G, te, me, Te) {
        function Xe() {
          He && (delete H.style, delete H.modElem);
        }
        if (Te = !t(Te, "undefined") && Te, !t(me, "undefined")) {
          var Ke = l(G, me);
          if (!t(Ke, "undefined")) return Ke;
        }
        for (var He, Ae, Ee, Be, Ze, qe = ["modernizr", "tspan", "samp"]; !H.style && qe.length; )
          He = !0, H.modElem = n(qe.shift()), H.style = H.modElem.style;
        for (Ee = G.length, Ae = 0; Ae < Ee; Ae++)
          if (Be = G[Ae], Ze = H.style[Be], i(Be, "-") && (Be = d(Be)), H.style[Be] !== e) {
            if (Te || t(me, "undefined")) return Xe(), te !== "pfx" || Be;
            try {
              H.style[Be] = me;
            } catch {
            }
            if (H.style[Be] !== Ze) return Xe(), te !== "pfx" || Be;
          }
        return Xe(), !1;
      }
      function y(G, te) {
        return function() {
          return G.apply(te, arguments);
        };
      }
      function k(G, te, me, Te, Xe) {
        var Ke = G.charAt(0).toUpperCase() + G.slice(1), He = (G + " " + P.join(Ke + " ") + Ke).split(" ");
        return t(te, "string") || t(te, "undefined") ? p(He, te, Te, Xe) : function(Ae, Ee, Be) {
          var Ze;
          for (var qe in Ae)
            if (Ae[qe] in Ee)
              return Be === !1 ? Ae[qe] : t(Ze = Ee[Ae[qe]], "function") ? y(Ze, Be || Ee) : Ze;
          return !1;
        }(He = (G + " " + j.join(Ke + " ") + Ke).split(" "), te, me);
      }
      function Q(G, te, me) {
        return k(G, e, e, te, me);
      }
      var m = [], _ = {
        _version: "3.13.0",
        _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 },
        _q: [],
        on: function(G, te) {
          var me = this;
          setTimeout(function() {
            te(me[G]);
          }, 0);
        },
        addTest: function(G, te, me) {
          m.push({ name: G, fn: te, options: me });
        },
        addAsyncTest: function(G) {
          m.push({ name: null, fn: G });
        }
      }, w = function() {
      };
      w.prototype = _, w = new w();
      var A = [], U = r.documentElement, pe = U.nodeName.toLowerCase() === "svg", D = function() {
        var G = !("onblur" in U);
        return function(te, me) {
          var Te;
          return !!te && (me && typeof me != "string" || (me = n(me || "div")), !(Te = (te = "on" + te) in me) && G && (me.setAttribute || (me = n("div")), me.setAttribute(te, ""), Te = typeof me[te] == "function", me[te] !== e && (me[te] = e), me.removeAttribute(te)), Te);
        };
      }();
      _.hasEvent = D, w.addTest("ambientlight", D("devicelight", c)), w.addTest("applicationcache", "applicationCache" in c), function() {
        var G = n("audio");
        w.addTest("audio", function() {
          var te = !1;
          try {
            (te = !!G.canPlayType) && (te = new Boolean(te));
          } catch {
          }
          return te;
        });
        try {
          G.canPlayType && (w.addTest(
            "audio.ogg",
            G.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, "")
          ), w.addTest(
            "audio.mp3",
            G.canPlayType('audio/mpeg; codecs="mp3"').replace(/^no$/, "")
          ), w.addTest(
            "audio.opus",
            G.canPlayType('audio/ogg; codecs="opus"') || G.canPlayType('audio/webm; codecs="opus"').replace(/^no$/, "")
          ), w.addTest("audio.wav", G.canPlayType('audio/wav; codecs="1"').replace(/^no$/, "")), w.addTest(
            "audio.m4a",
            (G.canPlayType("audio/x-m4a;") || G.canPlayType("audio/aac;")).replace(
              /^no$/,
              ""
            )
          ));
        } catch {
        }
      }();
      var W = "Moz O ms Webkit", P = _._config.usePrefixes ? W.split(" ") : [];
      _._cssomPrefixes = P;
      var N = { elem: n("modernizr") };
      w._q.push(function() {
        delete N.elem;
      });
      var H = { style: N.elem.style };
      w._q.unshift(function() {
        delete H.style;
      });
      var j = _._config.usePrefixes ? W.toLowerCase().split(" ") : [];
      _._domPrefixes = j, _.testAllProps = k;
      var K = function(G) {
        var te, me = re.length, Te = c.CSSRule;
        if (Te === void 0) return e;
        if (!G) return !1;
        if ((te = (G = G.replace(/^@/, "")).replace(/-/g, "_").toUpperCase() + "_RULE") in Te)
          return "@" + G;
        for (var Xe = 0; Xe < me; Xe++) {
          var Ke = re[Xe];
          if (Ke.toUpperCase() + "_" + te in Te) return "@-" + Ke.toLowerCase() + "-" + G;
        }
        return !1;
      };
      _.atRule = K;
      var ae = _.prefixed = function(G, te, me) {
        return G.indexOf("@") === 0 ? K(G) : (G.indexOf("-") !== -1 && (G = d(G)), te ? k(G, te, me) : k(G, "pfx"));
      };
      w.addTest("batteryapi", !!ae("battery", navigator) || !!ae("getBattery", navigator), {
        aliases: ["battery-api"]
      }), w.addTest(
        "blobconstructor",
        function() {
          try {
            return !!new Blob();
          } catch {
            return !1;
          }
        },
        { aliases: ["blob-constructor"] }
      ), w.addTest("contextmenu", "contextMenu" in U && "HTMLMenuItemElement" in c), w.addTest("cors", "XMLHttpRequest" in c && "withCredentials" in new XMLHttpRequest());
      var ce = ae("crypto", c);
      w.addTest("crypto", !!ae("subtle", ce)), w.addTest("customelements", "customElements" in c), w.addTest("customprotocolhandler", function() {
        if (!navigator.registerProtocolHandler) return !1;
        try {
          navigator.registerProtocolHandler("thisShouldFail");
        } catch (G) {
          return G instanceof TypeError;
        }
        return !1;
      }), w.addTest("customevent", "CustomEvent" in c && typeof c.CustomEvent == "function"), w.addTest("dart", !!ae("startDart", navigator)), w.addTest(
        "dataview",
        typeof DataView < "u" && "getFloat64" in DataView.prototype
      ), w.addTest("eventlistener", "addEventListener" in c), w.addTest("forcetouch", function() {
        return !!D(ae("mouseforcewillbegin", c, !1), c) && MouseEvent.WEBKIT_FORCE_AT_MOUSE_DOWN && MouseEvent.WEBKIT_FORCE_AT_FORCE_MOUSE_DOWN;
      }), w.addTest("fullscreen", !(!ae("exitFullscreen", r, !1) && !ae("cancelFullScreen", r, !1))), w.addTest("gamepads", !!ae("getGamepads", navigator)), w.addTest("geolocation", "geolocation" in navigator), w.addTest("ie8compat", !c.addEventListener && !!r.documentMode && r.documentMode === 7), w.addTest("intl", !!ae("Intl", c)), w.addTest("json", "JSON" in c && "parse" in JSON && "stringify" in JSON), _.testAllProps = Q, w.addTest("ligatures", Q("fontFeatureSettings", '"liga" 1')), w.addTest("messagechannel", "MessageChannel" in c), w.addTest("notification", function() {
        if (!c.Notification || !c.Notification.requestPermission) return !1;
        if (c.Notification.permission === "granted") return !0;
        try {
          new c.Notification("");
        } catch (G) {
          if (G.name === "TypeError") return !1;
        }
        return !0;
      }), w.addTest("pagevisibility", !!ae("hidden", r, !1)), w.addTest("performance", !!ae("performance", c));
      var ee = [""].concat(j);
      _._domPrefixesAll = ee, w.addTest("pointerevents", function() {
        for (var G = 0, te = ee.length; G < te; G++) if (D(ee[G] + "pointerdown")) return !0;
        return !1;
      }), w.addTest("pointerlock", !!ae("exitPointerLock", r)), w.addTest("queryselector", "querySelector" in r && "querySelectorAll" in r), w.addTest("quotamanagement", function() {
        var G = ae("temporaryStorage", navigator), te = ae("persistentStorage", navigator);
        return !(!G || !te);
      }), w.addTest("requestanimationframe", !!ae("requestAnimationFrame", c), { aliases: ["raf"] }), w.addTest("serviceworker", "serviceWorker" in navigator);
      var re = _._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
      _._prefixes = re;
      var F = function() {
        var G = c.matchMedia || c.msMatchMedia;
        return G ? function(te) {
          var me = G(te);
          return me && me.matches || !1;
        } : function(te) {
          var me = !1;
          return s("@media " + te + " { #modernizr { position: absolute; } }", function(Te) {
            me = h(Te, null, "position") === "absolute";
          }), me;
        };
      }();
      _.mq = F, w.addTest("touchevents", function() {
        if ("ontouchstart" in c || c.TouchEvent || c.DocumentTouch && r instanceof DocumentTouch)
          return !0;
        var G = ["(", re.join("touch-enabled),("), "heartz", ")"].join("");
        return F(G);
      }), w.addTest("typedarrays", "ArrayBuffer" in c), w.addTest("vibrate", !!ae("vibrate", navigator)), function() {
        var G = n("video");
        w.addTest("video", function() {
          var te = !1;
          try {
            (te = !!G.canPlayType) && (te = new Boolean(te));
          } catch {
          }
          return te;
        });
        try {
          G.canPlayType && (w.addTest(
            "video.ogg",
            G.canPlayType('video/ogg; codecs="theora"').replace(/^no$/, "")
          ), w.addTest(
            "video.h264",
            G.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, "")
          ), w.addTest(
            "video.h265",
            G.canPlayType('video/mp4; codecs="hev1"').replace(/^no$/, "")
          ), w.addTest(
            "video.webm",
            G.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/, "")
          ), w.addTest(
            "video.vp9",
            G.canPlayType('video/webm; codecs="vp9"').replace(/^no$/, "")
          ), w.addTest(
            "video.hls",
            G.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/, "")
          ), w.addTest(
            "video.av1",
            G.canPlayType('video/mp4; codecs="av01"').replace(/^no$/, "")
          ));
        } catch {
        }
      }(), w.addTest("webgl", function() {
        return "WebGLRenderingContext" in c;
      });
      var M = !1;
      try {
        M = "WebSocket" in c && c.WebSocket.CLOSING === 2;
      } catch {
      }
      w.addTest("websockets", M), w.addTest("xdomainrequest", "XDomainRequest" in c), w.addTest("matchmedia", !!ae("matchMedia", c)), function() {
        var G, te, me, Te, Xe, Ke;
        for (var He in m)
          if (m.hasOwnProperty(He)) {
            if (G = [], (te = m[He]).name && (G.push(te.name.toLowerCase()), te.options && te.options.aliases && te.options.aliases.length))
              for (me = 0; me < te.options.aliases.length; me++)
                G.push(te.options.aliases[me].toLowerCase());
            for (Te = t(te.fn, "function") ? te.fn() : te.fn, Xe = 0; Xe < G.length; Xe++)
              (Ke = G[Xe].split(".")).length === 1 ? w[Ke[0]] = Te : (w[Ke[0]] && (!w[Ke[0]] || w[Ke[0]] instanceof Boolean) || (w[Ke[0]] = new Boolean(w[Ke[0]])), w[Ke[0]][Ke[1]] = Te), A.push((Te ? "" : "no-") + Ke.join("-"));
          }
      }(), delete _.addTest, delete _.addAsyncTest;
      for (var le = 0; le < w._q.length; le++) w._q[le]();
      a.Modernizr = w;
    })(X || (X = {}), window, document);
  }, (X !== void 0 ? X : X = {}).AiaSignals = function(a) {
    var c = [
      { name: "IS_USER_VERIFYING_PLATFORM_AUTHENTICATOR_AVAILABLE", value: !1, error: null },
      { name: "FILE_INJECT_JS_FOUND", value: !1, error: null },
      { name: "FILE_CONTENT_JS_FOUND", value: !1, error: null },
      { name: "WINDOW_GLOBAL_KEY_FOUND", value: !1, error: null }
    ], r = { webAuthn: 1e3, manus: 5e3, anchor: 5e3, skyvern: 5e3, detect: 1e4 };
    function e(l) {
      for (var d = 0; d < c.length; d++) if (c[d].name === l) return c[d];
      return null;
    }
    function t(l, d) {
      var p = e(l);
      p && (p.value = d, p.error = null);
    }
    function n(l, d, p) {
      var y = e(l);
      y && (y.value = d, y.error = p);
    }
    function i() {
      return new Promise(function(l) {
        var d = r.webAuthn, p = setTimeout(function() {
          n("IS_USER_VERIFYING_PLATFORM_AUTHENTICATOR_AVAILABLE", !1, 1004), l(c);
        }, d);
        try {
          window.PublicKeyCredential && typeof PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable == "function" ? PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable().then(function(y) {
            clearTimeout(p), y ? t("IS_USER_VERIFYING_PLATFORM_AUTHENTICATOR_AVAILABLE", !0) : n("IS_USER_VERIFYING_PLATFORM_AUTHENTICATOR_AVAILABLE", !1, 1001), l(c);
          }).catch(function() {
            clearTimeout(p), n("IS_USER_VERIFYING_PLATFORM_AUTHENTICATOR_AVAILABLE", !1, 1002), l(c);
          }) : (clearTimeout(p), n("IS_USER_VERIFYING_PLATFORM_AUTHENTICATOR_AVAILABLE", !1, 1003), l(c));
        } catch {
          clearTimeout(p), n("IS_USER_VERIFYING_PLATFORM_AUTHENTICATOR_AVAILABLE", !1, 1002), l(c);
        }
      });
    }
    function s() {
      return new Promise(function(l) {
        var d, p = r.manus, y = document.createElement("script");
        y.src = "chrome-extension://mljmkmodkfigdopcpgboaalildgijkoc/content.ts.js", y.onload = function() {
          clearTimeout(d), t("FILE_CONTENT_JS_FOUND", !0), l(c);
        }, y.onerror = function() {
          clearTimeout(d), n("FILE_CONTENT_JS_FOUND", !1, 2002), l(c);
        }, document.getElementsByTagName("head")[0].appendChild(y), d = setTimeout(function() {
          n("FILE_CONTENT_JS_FOUND", !1, 2001), l(c);
        }, p);
      });
    }
    function u() {
      return new Promise(function(l) {
        var d, p = r.anchor, y = document.createElement("script");
        y.src = "chrome-extension://bppehibnhionalpjigdjdilknbljaeai/inject.js", y.onload = function() {
          clearTimeout(d), t("FILE_INJECT_JS_FOUND", !0), l(c);
        }, y.onerror = function() {
          clearTimeout(d), n("FILE_INJECT_JS_FOUND", !1, 4002), l(c);
        }, document.getElementsByTagName("head")[0].appendChild(y), d = setTimeout(function() {
          n("FILE_INJECT_JS_FOUND", !1, 4001), l(c);
        }, p);
      });
    }
    function h() {
      return new Promise(function(l) {
        var d = r.skyvern, p = 1e3, y = 0;
        function k() {
          if (window.globalDomDepthMap || window.GlobalEnableAllTextualElements || window.globalObserverForDOMIncrement || window.globalListnerFlag || window.globalDomDepthMap || window.globalOneTimeIncrementElements || window.globalHoverStylesMap || window.globalParsedElementCounter)
            return t("WINDOW_GLOBAL_KEY_FOUND", !0), void l(c);
          for (var Q in window)
            if (typeof Q == "string" && Q.toLowerCase().indexOf("skyvern") !== -1 && Q !== "isSkyvern")
              return t("WINDOW_GLOBAL_KEY_FOUND", !0), void l(c);
          (y += p) >= d ? (n("WINDOW_GLOBAL_KEY_FOUND", !1, 5002), l(c)) : setTimeout(k, p);
        }
        document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", k) : k();
      });
    }
    return a.detect = function() {
      return new Promise(function(l) {
        var d = setTimeout(function() {
          l(c);
        }, r.detect);
        i().then(function(p) {
          var y = e("IS_USER_VERIFYING_PLATFORM_AUTHENTICATOR_AVAILABLE");
          if (y && y.value) return clearTimeout(d), void l(c);
          for (var k = [
            s().then(function(w) {
              return { key: "manus", result: w };
            }),
            u().then(function(w) {
              return { key: "anchor", result: w };
            }),
            h().then(function(w) {
              return { key: "skyvern", result: w };
            })
          ], Q = 0, m = function() {
            ++Q === k.length && (clearTimeout(d), l(c));
          }, _ = 0; _ < k.length; _++)
            k[_].then(m).catch(function() {
              m();
            });
        }).catch(function() {
          clearTimeout(d), l(c);
        });
      });
    }, a.checkWebAuthnPlatformSupport = i, a.isManus = s, a.isAnchor = u, a.isSkyvern = h, Object.defineProperty(a, "__esModule", { value: !0 }), a;
  }({}), (X || (X = {})).pako = function a(c, r, e) {
    function t(s, u) {
      if (!r[s]) {
        if (!c[s]) {
          var h = typeof require == "function" && require;
          if (!u && h) return h(s, !0);
          if (n) return n(s, !0);
          var l = new Error("Cannot find module '" + s + "'");
          throw l.code = "MODULE_NOT_FOUND", l;
        }
        var d = r[s] = { exports: {} };
        c[s][0].call(
          d.exports,
          function(p) {
            var y = c[s][1][p];
            return t(y || p);
          },
          d,
          d.exports,
          a,
          c,
          r,
          e
        );
      }
      return r[s].exports;
    }
    for (var n = typeof require == "function" && require, i = 0; i < e.length; i++) t(e[i]);
    return t;
  }(
    {
      1: [
        function(a, c, r) {
          function e(s, u) {
            return Object.prototype.hasOwnProperty.call(s, u);
          }
          var t = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
          r.assign = function(s) {
            for (var u = Array.prototype.slice.call(arguments, 1); u.length; ) {
              var h = u.shift();
              if (h) {
                if (typeof h != "object") throw new TypeError(h + "must be non-object");
                for (var l in h) e(h, l) && (s[l] = h[l]);
              }
            }
            return s;
          }, r.shrinkBuf = function(s, u) {
            return s.length === u ? s : s.subarray ? s.subarray(0, u) : (s.length = u, s);
          };
          var n = {
            arraySet: function(s, u, h, l, d) {
              if (u.subarray && s.subarray) s.set(u.subarray(h, h + l), d);
              else for (var p = 0; p < l; p++) s[d + p] = u[h + p];
            },
            flattenChunks: function(s) {
              var u, h, l, d, p, y;
              for (l = 0, u = 0, h = s.length; u < h; u++) l += s[u].length;
              for (y = new Uint8Array(l), d = 0, u = 0, h = s.length; u < h; u++)
                p = s[u], y.set(p, d), d += p.length;
              return y;
            }
          }, i = {
            arraySet: function(s, u, h, l, d) {
              for (var p = 0; p < l; p++) s[d + p] = u[h + p];
            },
            flattenChunks: function(s) {
              return [].concat.apply([], s);
            }
          };
          r.setTyped = function(s) {
            s ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, n)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, i));
          }, r.setTyped(t);
        },
        {}
      ],
      2: [
        function(a, c, r) {
          function e(h, l) {
            if (l < 65537 && (h.subarray && i || !h.subarray && n))
              return String.fromCharCode.apply(null, t.shrinkBuf(h, l));
            for (var d = "", p = 0; p < l; p++) d += String.fromCharCode(h[p]);
            return d;
          }
          var t = a("./common"), n = !0, i = !0;
          try {
            String.fromCharCode.apply(null, [0]);
          } catch {
            n = !1;
          }
          try {
            String.fromCharCode.apply(null, new Uint8Array(1));
          } catch {
            i = !1;
          }
          for (var s = new t.Buf8(256), u = 0; u < 256; u++)
            s[u] = u >= 252 ? 6 : u >= 248 ? 5 : u >= 240 ? 4 : u >= 224 ? 3 : u >= 192 ? 2 : 1;
          s[254] = s[254] = 1, r.string2buf = function(h) {
            var l, d, p, y, k, Q = h.length, m = 0;
            for (y = 0; y < Q; y++)
              (64512 & (d = h.charCodeAt(y))) == 55296 && y + 1 < Q && (64512 & (p = h.charCodeAt(y + 1))) == 56320 && (d = 65536 + (d - 55296 << 10) + (p - 56320), y++), m += d < 128 ? 1 : d < 2048 ? 2 : d < 65536 ? 3 : 4;
            for (l = new t.Buf8(m), k = 0, y = 0; k < m; y++)
              (64512 & (d = h.charCodeAt(y))) == 55296 && y + 1 < Q && (64512 & (p = h.charCodeAt(y + 1))) == 56320 && (d = 65536 + (d - 55296 << 10) + (p - 56320), y++), d < 128 ? l[k++] = d : d < 2048 ? (l[k++] = 192 | d >>> 6, l[k++] = 128 | 63 & d) : d < 65536 ? (l[k++] = 224 | d >>> 12, l[k++] = 128 | d >>> 6 & 63, l[k++] = 128 | 63 & d) : (l[k++] = 240 | d >>> 18, l[k++] = 128 | d >>> 12 & 63, l[k++] = 128 | d >>> 6 & 63, l[k++] = 128 | 63 & d);
            return l;
          }, r.buf2binstring = function(h) {
            return e(h, h.length);
          }, r.binstring2buf = function(h) {
            for (var l = new t.Buf8(h.length), d = 0, p = l.length; d < p; d++)
              l[d] = h.charCodeAt(d);
            return l;
          }, r.buf2string = function(h, l) {
            var d, p, y, k, Q = l || h.length, m = new Array(2 * Q);
            for (p = 0, d = 0; d < Q; )
              if ((y = h[d++]) < 128) m[p++] = y;
              else if ((k = s[y]) > 4) m[p++] = 65533, d += k - 1;
              else {
                for (y &= k === 2 ? 31 : k === 3 ? 15 : 7; k > 1 && d < Q; )
                  y = y << 6 | 63 & h[d++], k--;
                k > 1 ? m[p++] = 65533 : y < 65536 ? m[p++] = y : (y -= 65536, m[p++] = 55296 | y >> 10 & 1023, m[p++] = 56320 | 1023 & y);
              }
            return e(m, p);
          }, r.utf8border = function(h, l) {
            var d;
            for ((l = l || h.length) > h.length && (l = h.length), d = l - 1; d >= 0 && (192 & h[d]) == 128; )
              d--;
            return d < 0 || d === 0 ? l : d + s[h[d]] > l ? d : l;
          };
        },
        { "./common": 1 }
      ],
      3: [
        function(a, c, r) {
          c.exports = function(e, t, n, i) {
            for (var s = 65535 & e | 0, u = e >>> 16 & 65535 | 0, h = 0; n !== 0; ) {
              n -= h = n > 2e3 ? 2e3 : n;
              do
                u = u + (s = s + t[i++] | 0) | 0;
              while (--h);
              s %= 65521, u %= 65521;
            }
            return s | u << 16 | 0;
          };
        },
        {}
      ],
      4: [
        function(a, c, r) {
          var e = function() {
            for (var t, n = [], i = 0; i < 256; i++) {
              t = i;
              for (var s = 0; s < 8; s++) t = 1 & t ? 3988292384 ^ t >>> 1 : t >>> 1;
              n[i] = t;
            }
            return n;
          }();
          c.exports = function(t, n, i, s) {
            var u = e, h = s + i;
            t ^= -1;
            for (var l = s; l < h; l++) t = t >>> 8 ^ u[255 & (t ^ n[l])];
            return -1 ^ t;
          };
        },
        {}
      ],
      5: [
        function(a, c, r) {
          function e(o, I) {
            return o.msg = j[I], I;
          }
          function t(o) {
            return (o << 1) - (o > 4 ? 9 : 0);
          }
          function n(o) {
            for (var I = o.length; --I >= 0; ) o[I] = 0;
          }
          function i(o) {
            var I = o.state, O = I.pending;
            O > o.avail_out && (O = o.avail_out), O !== 0 && (W.arraySet(o.output, I.pending_buf, I.pending_out, O, o.next_out), o.next_out += O, I.pending_out += O, o.total_out += O, o.avail_out -= O, I.pending -= O, I.pending === 0 && (I.pending_out = 0));
          }
          function s(o, I) {
            P._tr_flush_block(
              o,
              o.block_start >= 0 ? o.block_start : -1,
              o.strstart - o.block_start,
              I
            ), o.block_start = o.strstart, i(o.strm);
          }
          function u(o, I) {
            o.pending_buf[o.pending++] = I;
          }
          function h(o, I) {
            o.pending_buf[o.pending++] = I >>> 8 & 255, o.pending_buf[o.pending++] = 255 & I;
          }
          function l(o, I, O, f) {
            var B = o.avail_in;
            return B > f && (B = f), B === 0 ? 0 : (o.avail_in -= B, W.arraySet(I, o.input, o.next_in, B, O), o.state.wrap === 1 ? o.adler = N(o.adler, I, B, O) : o.state.wrap === 2 && (o.adler = H(o.adler, I, B, O)), o.next_in += B, o.total_in += B, B);
          }
          function d(o, I) {
            var O, f, B = o.max_chain_length, se = o.strstart, de = o.prev_length, J = o.nice_match, Le = o.strstart > o.w_size - Be ? o.strstart - (o.w_size - Be) : 0, Ce = o.window, Qe = o.w_mask, dt = o.prev, St = o.strstart + Ee, bt = Ce[se + de - 1], yt = Ce[se + de];
            o.prev_length >= o.good_match && (B >>= 2), J > o.lookahead && (J = o.lookahead);
            do
              if (Ce[(O = I) + de] === yt && Ce[O + de - 1] === bt && Ce[O] === Ce[se] && Ce[++O] === Ce[se + 1]) {
                se += 2, O++;
                do
                  ;
                while (Ce[++se] === Ce[++O] && Ce[++se] === Ce[++O] && Ce[++se] === Ce[++O] && Ce[++se] === Ce[++O] && Ce[++se] === Ce[++O] && Ce[++se] === Ce[++O] && Ce[++se] === Ce[++O] && Ce[++se] === Ce[++O] && se < St);
                if (f = Ee - (St - se), se = St - Ee, f > de) {
                  if (o.match_start = I, de = f, f >= J) break;
                  bt = Ce[se + de - 1], yt = Ce[se + de];
                }
              }
            while ((I = dt[I & Qe]) > Le && --B != 0);
            return de <= o.lookahead ? de : o.lookahead;
          }
          function p(o) {
            var I, O, f, B, se, de = o.w_size;
            do {
              if (B = o.window_size - o.lookahead - o.strstart, o.strstart >= de + (de - Be)) {
                W.arraySet(o.window, o.window, de, de, 0), o.match_start -= de, o.strstart -= de, o.block_start -= de, I = O = o.hash_size;
                do
                  f = o.head[--I], o.head[I] = f >= de ? f - de : 0;
                while (--O);
                I = O = de;
                do
                  f = o.prev[--I], o.prev[I] = f >= de ? f - de : 0;
                while (--O);
                B += de;
              }
              if (o.strm.avail_in === 0) break;
              if (O = l(o.strm, o.window, o.strstart + o.lookahead, B), o.lookahead += O, o.lookahead + o.insert >= Ae)
                for (se = o.strstart - o.insert, o.ins_h = o.window[se], o.ins_h = (o.ins_h << o.hash_shift ^ o.window[se + 1]) & o.hash_mask; o.insert && (o.ins_h = (o.ins_h << o.hash_shift ^ o.window[se + Ae - 1]) & o.hash_mask, o.prev[se & o.w_mask] = o.head[o.ins_h], o.head[o.ins_h] = se, se++, o.insert--, !(o.lookahead + o.insert < Ae)); ) ;
            } while (o.lookahead < Be && o.strm.avail_in !== 0);
          }
          function y(o, I) {
            for (var O, f; ; ) {
              if (o.lookahead < Be) {
                if (p(o), o.lookahead < Be && I === K) return Je;
                if (o.lookahead === 0) break;
              }
              if (O = 0, o.lookahead >= Ae && (o.ins_h = (o.ins_h << o.hash_shift ^ o.window[o.strstart + Ae - 1]) & o.hash_mask, O = o.prev[o.strstart & o.w_mask] = o.head[o.ins_h], o.head[o.ins_h] = o.strstart), O !== 0 && o.strstart - O <= o.w_size - Be && (o.match_length = d(o, O)), o.match_length >= Ae)
                if (f = P._tr_tally(o, o.strstart - o.match_start, o.match_length - Ae), o.lookahead -= o.match_length, o.match_length <= o.max_lazy_match && o.lookahead >= Ae) {
                  o.match_length--;
                  do
                    o.strstart++, o.ins_h = (o.ins_h << o.hash_shift ^ o.window[o.strstart + Ae - 1]) & o.hash_mask, O = o.prev[o.strstart & o.w_mask] = o.head[o.ins_h], o.head[o.ins_h] = o.strstart;
                  while (--o.match_length != 0);
                  o.strstart++;
                } else
                  o.strstart += o.match_length, o.match_length = 0, o.ins_h = o.window[o.strstart], o.ins_h = (o.ins_h << o.hash_shift ^ o.window[o.strstart + 1]) & o.hash_mask;
              else f = P._tr_tally(o, 0, o.window[o.strstart]), o.lookahead--, o.strstart++;
              if (f && (s(o, !1), o.strm.avail_out === 0)) return Je;
            }
            return o.insert = o.strstart < Ae - 1 ? o.strstart : Ae - 1, I === ae ? (s(o, !0), o.strm.avail_out === 0 ? rt : lt) : o.last_lit && (s(o, !1), o.strm.avail_out === 0) ? Je : vt;
          }
          function k(o, I) {
            for (var O, f, B; ; ) {
              if (o.lookahead < Be) {
                if (p(o), o.lookahead < Be && I === K) return Je;
                if (o.lookahead === 0) break;
              }
              if (O = 0, o.lookahead >= Ae && (o.ins_h = (o.ins_h << o.hash_shift ^ o.window[o.strstart + Ae - 1]) & o.hash_mask, O = o.prev[o.strstart & o.w_mask] = o.head[o.ins_h], o.head[o.ins_h] = o.strstart), o.prev_length = o.match_length, o.prev_match = o.match_start, o.match_length = Ae - 1, O !== 0 && o.prev_length < o.max_lazy_match && o.strstart - O <= o.w_size - Be && (o.match_length = d(o, O), o.match_length <= 5 && (o.strategy === F || o.match_length === Ae && o.strstart - o.match_start > 4096) && (o.match_length = Ae - 1)), o.prev_length >= Ae && o.match_length <= o.prev_length) {
                B = o.strstart + o.lookahead - Ae, f = P._tr_tally(o, o.strstart - 1 - o.prev_match, o.prev_length - Ae), o.lookahead -= o.prev_length - 1, o.prev_length -= 2;
                do
                  ++o.strstart <= B && (o.ins_h = (o.ins_h << o.hash_shift ^ o.window[o.strstart + Ae - 1]) & o.hash_mask, O = o.prev[o.strstart & o.w_mask] = o.head[o.ins_h], o.head[o.ins_h] = o.strstart);
                while (--o.prev_length != 0);
                if (o.match_available = 0, o.match_length = Ae - 1, o.strstart++, f && (s(o, !1), o.strm.avail_out === 0))
                  return Je;
              } else if (o.match_available) {
                if ((f = P._tr_tally(o, 0, o.window[o.strstart - 1])) && s(o, !1), o.strstart++, o.lookahead--, o.strm.avail_out === 0)
                  return Je;
              } else o.match_available = 1, o.strstart++, o.lookahead--;
            }
            return o.match_available && (f = P._tr_tally(o, 0, o.window[o.strstart - 1]), o.match_available = 0), o.insert = o.strstart < Ae - 1 ? o.strstart : Ae - 1, I === ae ? (s(o, !0), o.strm.avail_out === 0 ? rt : lt) : o.last_lit && (s(o, !1), o.strm.avail_out === 0) ? Je : vt;
          }
          function Q(o, I) {
            for (var O, f, B, se, de = o.window; ; ) {
              if (o.lookahead <= Ee) {
                if (p(o), o.lookahead <= Ee && I === K) return Je;
                if (o.lookahead === 0) break;
              }
              if (o.match_length = 0, o.lookahead >= Ae && o.strstart > 0 && (B = o.strstart - 1, (f = de[B]) === de[++B] && f === de[++B] && f === de[++B])) {
                se = o.strstart + Ee;
                do
                  ;
                while (f === de[++B] && f === de[++B] && f === de[++B] && f === de[++B] && f === de[++B] && f === de[++B] && f === de[++B] && f === de[++B] && B < se);
                o.match_length = Ee - (se - B), o.match_length > o.lookahead && (o.match_length = o.lookahead);
              }
              if (o.match_length >= Ae ? (O = P._tr_tally(o, 1, o.match_length - Ae), o.lookahead -= o.match_length, o.strstart += o.match_length, o.match_length = 0) : (O = P._tr_tally(o, 0, o.window[o.strstart]), o.lookahead--, o.strstart++), O && (s(o, !1), o.strm.avail_out === 0))
                return Je;
            }
            return o.insert = 0, I === ae ? (s(o, !0), o.strm.avail_out === 0 ? rt : lt) : o.last_lit && (s(o, !1), o.strm.avail_out === 0) ? Je : vt;
          }
          function m(o, I) {
            for (var O; ; ) {
              if (o.lookahead === 0 && (p(o), o.lookahead === 0)) {
                if (I === K) return Je;
                break;
              }
              if (o.match_length = 0, O = P._tr_tally(o, 0, o.window[o.strstart]), o.lookahead--, o.strstart++, O && (s(o, !1), o.strm.avail_out === 0))
                return Je;
            }
            return o.insert = 0, I === ae ? (s(o, !0), o.strm.avail_out === 0 ? rt : lt) : o.last_lit && (s(o, !1), o.strm.avail_out === 0) ? Je : vt;
          }
          function _(o, I, O, f, B) {
            this.good_length = o, this.max_lazy = I, this.nice_length = O, this.max_chain = f, this.func = B;
          }
          function w() {
            this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = G, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new W.Buf16(2 * Ke), this.dyn_dtree = new W.Buf16(2 * (2 * Te + 1)), this.bl_tree = new W.Buf16(2 * (2 * Xe + 1)), n(this.dyn_ltree), n(this.dyn_dtree), n(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new W.Buf16(He + 1), this.heap = new W.Buf16(2 * me + 1), n(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new W.Buf16(2 * me + 1), n(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
          }
          function A(o) {
            var I;
            return o && o.state ? (o.total_in = o.total_out = 0, o.data_type = le, (I = o.state).pending = 0, I.pending_out = 0, I.wrap < 0 && (I.wrap = -I.wrap), I.status = I.wrap ? Ze : qe, o.adler = I.wrap === 2 ? 0 : 1, I.last_flush = K, P._tr_init(I), ce) : e(o, ee);
          }
          function U(o) {
            var I = A(o);
            return I === ce && function(O) {
              O.window_size = 2 * O.w_size, n(O.head), O.max_lazy_match = D[O.level].max_lazy, O.good_match = D[O.level].good_length, O.nice_match = D[O.level].nice_length, O.max_chain_length = D[O.level].max_chain, O.strstart = 0, O.block_start = 0, O.lookahead = 0, O.insert = 0, O.match_length = O.prev_length = Ae - 1, O.match_available = 0, O.ins_h = 0;
            }(o.state), I;
          }
          function pe(o, I, O, f, B, se) {
            if (!o) return ee;
            var de = 1;
            if (I === re && (I = 6), f < 0 ? (de = 0, f = -f) : f > 15 && (de = 2, f -= 16), B < 1 || B > te || O !== G || f < 8 || f > 15 || I < 0 || I > 9 || se < 0 || se > M)
              return e(o, ee);
            f === 8 && (f = 9);
            var J = new w();
            return o.state = J, J.strm = o, J.wrap = de, J.gzhead = null, J.w_bits = f, J.w_size = 1 << J.w_bits, J.w_mask = J.w_size - 1, J.hash_bits = B + 7, J.hash_size = 1 << J.hash_bits, J.hash_mask = J.hash_size - 1, J.hash_shift = ~~((J.hash_bits + Ae - 1) / Ae), J.window = new W.Buf8(2 * J.w_size), J.head = new W.Buf16(J.hash_size), J.prev = new W.Buf16(J.w_size), J.lit_bufsize = 1 << B + 6, J.pending_buf_size = 4 * J.lit_bufsize, J.pending_buf = new W.Buf8(J.pending_buf_size), J.d_buf = 1 * J.lit_bufsize, J.l_buf = 3 * J.lit_bufsize, J.level = I, J.strategy = se, J.method = O, U(o);
          }
          var D, W = a("../utils/common"), P = a("./trees"), N = a("./adler32"), H = a("./crc32"), j = a("./messages"), K = 0, ae = 4, ce = 0, ee = -2, re = -1, F = 1, M = 4, le = 2, G = 8, te = 9, me = 286, Te = 30, Xe = 19, Ke = 2 * me + 1, He = 15, Ae = 3, Ee = 258, Be = Ee + Ae + 1, Ze = 42, qe = 113, Je = 1, vt = 2, rt = 3, lt = 4;
          D = [
            new _(0, 0, 0, 0, function(o, I) {
              var O = 65535;
              for (O > o.pending_buf_size - 5 && (O = o.pending_buf_size - 5); ; ) {
                if (o.lookahead <= 1) {
                  if (p(o), o.lookahead === 0 && I === K) return Je;
                  if (o.lookahead === 0) break;
                }
                o.strstart += o.lookahead, o.lookahead = 0;
                var f = o.block_start + O;
                if ((o.strstart === 0 || o.strstart >= f) && (o.lookahead = o.strstart - f, o.strstart = f, s(o, !1), o.strm.avail_out === 0) || o.strstart - o.block_start >= o.w_size - Be && (s(o, !1), o.strm.avail_out === 0))
                  return Je;
              }
              return o.insert = 0, I === ae ? (s(o, !0), o.strm.avail_out === 0 ? rt : lt) : (o.strstart > o.block_start && (s(o, !1), o.strm.avail_out), Je);
            }),
            new _(4, 4, 8, 4, y),
            new _(4, 5, 16, 8, y),
            new _(4, 6, 32, 32, y),
            new _(4, 4, 16, 16, k),
            new _(8, 16, 32, 32, k),
            new _(8, 16, 128, 128, k),
            new _(8, 32, 128, 256, k),
            new _(32, 128, 258, 1024, k),
            new _(32, 258, 258, 4096, k)
          ], r.deflateInit = function(o, I) {
            return pe(o, I, G, 15, 8, 0);
          }, r.deflateInit2 = pe, r.deflateReset = U, r.deflateResetKeep = A, r.deflateSetHeader = function(o, I) {
            return o && o.state ? o.state.wrap !== 2 ? ee : (o.state.gzhead = I, ce) : ee;
          }, r.deflate = function(o, I) {
            var O, f, B, se;
            if (!o || !o.state || I > 5 || I < 0) return o ? e(o, ee) : ee;
            if (f = o.state, !o.output || !o.input && o.avail_in !== 0 || f.status === 666 && I !== ae)
              return e(o, o.avail_out === 0 ? -5 : ee);
            if (f.strm = o, O = f.last_flush, f.last_flush = I, f.status === Ze)
              if (f.wrap === 2)
                o.adler = 0, u(f, 31), u(f, 139), u(f, 8), f.gzhead ? (u(
                  f,
                  (f.gzhead.text ? 1 : 0) + (f.gzhead.hcrc ? 2 : 0) + (f.gzhead.extra ? 4 : 0) + (f.gzhead.name ? 8 : 0) + (f.gzhead.comment ? 16 : 0)
                ), u(f, 255 & f.gzhead.time), u(f, f.gzhead.time >> 8 & 255), u(f, f.gzhead.time >> 16 & 255), u(f, f.gzhead.time >> 24 & 255), u(f, f.level === 9 ? 2 : f.strategy >= 2 || f.level < 2 ? 4 : 0), u(f, 255 & f.gzhead.os), f.gzhead.extra && f.gzhead.extra.length && (u(f, 255 & f.gzhead.extra.length), u(f, f.gzhead.extra.length >> 8 & 255)), f.gzhead.hcrc && (o.adler = H(o.adler, f.pending_buf, f.pending, 0)), f.gzindex = 0, f.status = 69) : (u(f, 0), u(f, 0), u(f, 0), u(f, 0), u(f, 0), u(f, f.level === 9 ? 2 : f.strategy >= 2 || f.level < 2 ? 4 : 0), u(f, 3), f.status = qe);
              else {
                var de = G + (f.w_bits - 8 << 4) << 8;
                de |= (f.strategy >= 2 || f.level < 2 ? 0 : f.level < 6 ? 1 : f.level === 6 ? 2 : 3) << 6, f.strstart !== 0 && (de |= 32), de += 31 - de % 31, f.status = qe, h(f, de), f.strstart !== 0 && (h(f, o.adler >>> 16), h(f, 65535 & o.adler)), o.adler = 1;
              }
            if (f.status === 69)
              if (f.gzhead.extra) {
                for (B = f.pending; f.gzindex < (65535 & f.gzhead.extra.length) && (f.pending !== f.pending_buf_size || (f.gzhead.hcrc && f.pending > B && (o.adler = H(o.adler, f.pending_buf, f.pending - B, B)), i(o), B = f.pending, f.pending !== f.pending_buf_size)); )
                  u(f, 255 & f.gzhead.extra[f.gzindex]), f.gzindex++;
                f.gzhead.hcrc && f.pending > B && (o.adler = H(o.adler, f.pending_buf, f.pending - B, B)), f.gzindex === f.gzhead.extra.length && (f.gzindex = 0, f.status = 73);
              } else f.status = 73;
            if (f.status === 73)
              if (f.gzhead.name) {
                B = f.pending;
                do {
                  if (f.pending === f.pending_buf_size && (f.gzhead.hcrc && f.pending > B && (o.adler = H(o.adler, f.pending_buf, f.pending - B, B)), i(o), B = f.pending, f.pending === f.pending_buf_size)) {
                    se = 1;
                    break;
                  }
                  se = f.gzindex < f.gzhead.name.length ? 255 & f.gzhead.name.charCodeAt(f.gzindex++) : 0, u(f, se);
                } while (se !== 0);
                f.gzhead.hcrc && f.pending > B && (o.adler = H(o.adler, f.pending_buf, f.pending - B, B)), se === 0 && (f.gzindex = 0, f.status = 91);
              } else f.status = 91;
            if (f.status === 91)
              if (f.gzhead.comment) {
                B = f.pending;
                do {
                  if (f.pending === f.pending_buf_size && (f.gzhead.hcrc && f.pending > B && (o.adler = H(o.adler, f.pending_buf, f.pending - B, B)), i(o), B = f.pending, f.pending === f.pending_buf_size)) {
                    se = 1;
                    break;
                  }
                  se = f.gzindex < f.gzhead.comment.length ? 255 & f.gzhead.comment.charCodeAt(f.gzindex++) : 0, u(f, se);
                } while (se !== 0);
                f.gzhead.hcrc && f.pending > B && (o.adler = H(o.adler, f.pending_buf, f.pending - B, B)), se === 0 && (f.status = 103);
              } else f.status = 103;
            if (f.status === 103 && (f.gzhead.hcrc ? (f.pending + 2 > f.pending_buf_size && i(o), f.pending + 2 <= f.pending_buf_size && (u(f, 255 & o.adler), u(f, o.adler >> 8 & 255), o.adler = 0, f.status = qe)) : f.status = qe), f.pending !== 0) {
              if (i(o), o.avail_out === 0) return f.last_flush = -1, ce;
            } else if (o.avail_in === 0 && t(I) <= t(O) && I !== ae) return e(o, -5);
            if (f.status === 666 && o.avail_in !== 0) return e(o, -5);
            if (o.avail_in !== 0 || f.lookahead !== 0 || I !== K && f.status !== 666) {
              var J = f.strategy === 2 ? m(f, I) : f.strategy === 3 ? Q(f, I) : D[f.level].func(f, I);
              if (J !== rt && J !== lt || (f.status = 666), J === Je || J === rt)
                return o.avail_out === 0 && (f.last_flush = -1), ce;
              if (J === vt && (I === 1 ? P._tr_align(f) : I !== 5 && (P._tr_stored_block(f, 0, 0, !1), I === 3 && (n(f.head), f.lookahead === 0 && (f.strstart = 0, f.block_start = 0, f.insert = 0))), i(o), o.avail_out === 0))
                return f.last_flush = -1, ce;
            }
            return I !== ae ? ce : f.wrap <= 0 ? 1 : (f.wrap === 2 ? (u(f, 255 & o.adler), u(f, o.adler >> 8 & 255), u(f, o.adler >> 16 & 255), u(f, o.adler >> 24 & 255), u(f, 255 & o.total_in), u(f, o.total_in >> 8 & 255), u(f, o.total_in >> 16 & 255), u(f, o.total_in >> 24 & 255)) : (h(f, o.adler >>> 16), h(f, 65535 & o.adler)), i(o), f.wrap > 0 && (f.wrap = -f.wrap), f.pending !== 0 ? ce : 1);
          }, r.deflateEnd = function(o) {
            var I;
            return o && o.state ? (I = o.state.status) !== Ze && I !== 69 && I !== 73 && I !== 91 && I !== 103 && I !== qe && I !== 666 ? e(o, ee) : (o.state = null, I === qe ? e(o, -3) : ce) : ee;
          }, r.deflateSetDictionary = function(o, I) {
            var O, f, B, se, de, J, Le, Ce, Qe = I.length;
            if (!o || !o.state || (O = o.state, (se = O.wrap) === 2 || se === 1 && O.status !== Ze || O.lookahead))
              return ee;
            for (se === 1 && (o.adler = N(o.adler, I, Qe, 0)), O.wrap = 0, Qe >= O.w_size && (se === 0 && (n(O.head), O.strstart = 0, O.block_start = 0, O.insert = 0), Ce = new W.Buf8(O.w_size), W.arraySet(Ce, I, Qe - O.w_size, O.w_size, 0), I = Ce, Qe = O.w_size), de = o.avail_in, J = o.next_in, Le = o.input, o.avail_in = Qe, o.next_in = 0, o.input = I, p(O); O.lookahead >= Ae; ) {
              f = O.strstart, B = O.lookahead - (Ae - 1);
              do
                O.ins_h = (O.ins_h << O.hash_shift ^ O.window[f + Ae - 1]) & O.hash_mask, O.prev[f & O.w_mask] = O.head[O.ins_h], O.head[O.ins_h] = f, f++;
              while (--B);
              O.strstart = f, O.lookahead = Ae - 1, p(O);
            }
            return O.strstart += O.lookahead, O.block_start = O.strstart, O.insert = O.lookahead, O.lookahead = 0, O.match_length = O.prev_length = Ae - 1, O.match_available = 0, o.next_in = J, o.input = Le, o.avail_in = de, O.wrap = se, ce;
          }, r.deflateInfo = "pako deflate (from Nodeca project)";
        },
        { "../utils/common": 1, "./adler32": 3, "./crc32": 4, "./messages": 6, "./trees": 7 }
      ],
      6: [
        function(a, c, r) {
          c.exports = {
            2: "need dictionary",
            1: "stream end",
            0: "",
            "-1": "file error",
            "-2": "stream error",
            "-3": "data error",
            "-4": "insufficient memory",
            "-5": "buffer error",
            "-6": "incompatible version"
          };
        },
        {}
      ],
      7: [
        function(a, c, r) {
          function e(o) {
            for (var I = o.length; --I >= 0; ) o[I] = 0;
          }
          function t(o, I, O, f, B) {
            this.static_tree = o, this.extra_bits = I, this.extra_base = O, this.elems = f, this.max_length = B, this.has_stree = o && o.length;
          }
          function n(o, I) {
            this.dyn_tree = o, this.max_code = 0, this.stat_desc = I;
          }
          function i(o) {
            return o < 256 ? Ee[o] : Ee[256 + (o >>> 7)];
          }
          function s(o, I) {
            o.pending_buf[o.pending++] = 255 & I, o.pending_buf[o.pending++] = I >>> 8 & 255;
          }
          function u(o, I, O) {
            o.bi_valid > re - O ? (o.bi_buf |= I << o.bi_valid & 65535, s(o, o.bi_buf), o.bi_buf = I >> re - o.bi_valid, o.bi_valid += O - re) : (o.bi_buf |= I << o.bi_valid & 65535, o.bi_valid += O);
          }
          function h(o, I, O) {
            u(o, O[2 * I], O[2 * I + 1]);
          }
          function l(o, I) {
            var O = 0;
            do
              O |= 1 & o, o >>>= 1, O <<= 1;
            while (--I > 0);
            return O >>> 1;
          }
          function d(o, I, O) {
            var f, B, se = new Array(ee + 1), de = 0;
            for (f = 1; f <= ee; f++) se[f] = de = de + O[f - 1] << 1;
            for (B = 0; B <= I; B++) {
              var J = o[2 * B + 1];
              J !== 0 && (o[2 * B] = l(se[J]++, J));
            }
          }
          function p(o) {
            var I;
            for (I = 0; I < j; I++) o.dyn_ltree[2 * I] = 0;
            for (I = 0; I < K; I++) o.dyn_dtree[2 * I] = 0;
            for (I = 0; I < ae; I++) o.bl_tree[2 * I] = 0;
            o.dyn_ltree[2 * M] = 1, o.opt_len = o.static_len = 0, o.last_lit = o.matches = 0;
          }
          function y(o) {
            o.bi_valid > 8 ? s(o, o.bi_buf) : o.bi_valid > 0 && (o.pending_buf[o.pending++] = o.bi_buf), o.bi_buf = 0, o.bi_valid = 0;
          }
          function k(o, I, O, f) {
            var B = 2 * I, se = 2 * O;
            return o[B] < o[se] || o[B] === o[se] && f[I] <= f[O];
          }
          function Q(o, I, O) {
            for (var f = o.heap[O], B = O << 1; B <= o.heap_len && (B < o.heap_len && k(I, o.heap[B + 1], o.heap[B], o.depth) && B++, !k(I, f, o.heap[B], o.depth)); )
              o.heap[O] = o.heap[B], O = B, B <<= 1;
            o.heap[O] = f;
          }
          function m(o, I, O) {
            var f, B, se, de, J = 0;
            if (o.last_lit !== 0)
              do
                f = o.pending_buf[o.d_buf + 2 * J] << 8 | o.pending_buf[o.d_buf + 2 * J + 1], B = o.pending_buf[o.l_buf + J], J++, f === 0 ? h(o, B, I) : (h(o, (se = Be[B]) + H + 1, I), (de = me[se]) !== 0 && u(o, B -= Ze[se], de), h(o, se = i(--f), O), (de = Te[se]) !== 0 && u(o, f -= qe[se], de));
              while (J < o.last_lit);
            h(o, M, I);
          }
          function _(o, I) {
            var O, f, B, se = I.dyn_tree, de = I.stat_desc.static_tree, J = I.stat_desc.has_stree, Le = I.stat_desc.elems, Ce = -1;
            for (o.heap_len = 0, o.heap_max = ce, O = 0; O < Le; O++)
              se[2 * O] !== 0 ? (o.heap[++o.heap_len] = Ce = O, o.depth[O] = 0) : se[2 * O + 1] = 0;
            for (; o.heap_len < 2; )
              se[2 * (B = o.heap[++o.heap_len] = Ce < 2 ? ++Ce : 0)] = 1, o.depth[B] = 0, o.opt_len--, J && (o.static_len -= de[2 * B + 1]);
            for (I.max_code = Ce, O = o.heap_len >> 1; O >= 1; O--) Q(o, se, O);
            B = Le;
            do
              O = o.heap[1], o.heap[1] = o.heap[o.heap_len--], Q(o, se, 1), f = o.heap[1], o.heap[--o.heap_max] = O, o.heap[--o.heap_max] = f, se[2 * B] = se[2 * O] + se[2 * f], o.depth[B] = (o.depth[O] >= o.depth[f] ? o.depth[O] : o.depth[f]) + 1, se[2 * O + 1] = se[2 * f + 1] = B, o.heap[1] = B++, Q(o, se, 1);
            while (o.heap_len >= 2);
            o.heap[--o.heap_max] = o.heap[1], function(Qe, dt) {
              var St, bt, yt, tt, be, Pe, he = dt.dyn_tree, Ge = dt.max_code, _e = dt.stat_desc.static_tree, ze = dt.stat_desc.has_stree, ot = dt.stat_desc.extra_bits, $e = dt.stat_desc.extra_base, et = dt.stat_desc.max_length, gt = 0;
              for (tt = 0; tt <= ee; tt++) Qe.bl_count[tt] = 0;
              for (he[2 * Qe.heap[Qe.heap_max] + 1] = 0, St = Qe.heap_max + 1; St < ce; St++)
                (tt = he[2 * he[2 * (bt = Qe.heap[St]) + 1] + 1] + 1) > et && (tt = et, gt++), he[2 * bt + 1] = tt, bt > Ge || (Qe.bl_count[tt]++, be = 0, bt >= $e && (be = ot[bt - $e]), Pe = he[2 * bt], Qe.opt_len += Pe * (tt + be), ze && (Qe.static_len += Pe * (_e[2 * bt + 1] + be)));
              if (gt !== 0) {
                do {
                  for (tt = et - 1; Qe.bl_count[tt] === 0; ) tt--;
                  Qe.bl_count[tt]--, Qe.bl_count[tt + 1] += 2, Qe.bl_count[et]--, gt -= 2;
                } while (gt > 0);
                for (tt = et; tt !== 0; tt--)
                  for (bt = Qe.bl_count[tt]; bt !== 0; )
                    (yt = Qe.heap[--St]) > Ge || (he[2 * yt + 1] !== tt && (Qe.opt_len += (tt - he[2 * yt + 1]) * he[2 * yt], he[2 * yt + 1] = tt), bt--);
              }
            }(o, I), d(se, Ce, o.bl_count);
          }
          function w(o, I, O) {
            var f, B, se = -1, de = I[1], J = 0, Le = 7, Ce = 4;
            for (de === 0 && (Le = 138, Ce = 3), I[2 * (O + 1) + 1] = 65535, f = 0; f <= O; f++)
              B = de, de = I[2 * (f + 1) + 1], ++J < Le && B === de || (J < Ce ? o.bl_tree[2 * B] += J : B !== 0 ? (B !== se && o.bl_tree[2 * B]++, o.bl_tree[2 * le]++) : J <= 10 ? o.bl_tree[2 * G]++ : o.bl_tree[2 * te]++, J = 0, se = B, de === 0 ? (Le = 138, Ce = 3) : B === de ? (Le = 6, Ce = 3) : (Le = 7, Ce = 4));
          }
          function A(o, I, O) {
            var f, B, se = -1, de = I[1], J = 0, Le = 7, Ce = 4;
            for (de === 0 && (Le = 138, Ce = 3), f = 0; f <= O; f++)
              if (B = de, de = I[2 * (f + 1) + 1], !(++J < Le && B === de)) {
                if (J < Ce)
                  do
                    h(o, B, o.bl_tree);
                  while (--J != 0);
                else
                  B !== 0 ? (B !== se && (h(o, B, o.bl_tree), J--), h(o, le, o.bl_tree), u(o, J - 3, 2)) : J <= 10 ? (h(o, G, o.bl_tree), u(o, J - 3, 3)) : (h(o, te, o.bl_tree), u(o, J - 11, 7));
                J = 0, se = B, de === 0 ? (Le = 138, Ce = 3) : B === de ? (Le = 6, Ce = 3) : (Le = 7, Ce = 4);
              }
          }
          function U(o, I, O, f) {
            u(o, (P << 1) + (f ? 1 : 0), 3), function(B, se, de, J) {
              y(B), s(B, de), s(B, ~de), pe.arraySet(B.pending_buf, B.window, se, de, B.pending), B.pending += de;
            }(o, I, O);
          }
          var pe = a("../utils/common"), D = 0, W = 1, P = 0, N = 29, H = 256, j = H + 1 + N, K = 30, ae = 19, ce = 2 * j + 1, ee = 15, re = 16, F = 7, M = 256, le = 16, G = 17, te = 18, me = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0
          ], Te = [
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13
          ], Xe = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7], Ke = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], He = new Array(2 * (j + 2));
          e(He);
          var Ae = new Array(2 * K);
          e(Ae);
          var Ee = new Array(512);
          e(Ee);
          var Be = new Array(256);
          e(Be);
          var Ze = new Array(N);
          e(Ze);
          var qe = new Array(K);
          e(qe);
          var Je, vt, rt, lt = !1;
          r._tr_init = function(o) {
            lt || (function() {
              var I, O, f, B, se, de = new Array(ee + 1);
              for (f = 0, B = 0; B < N - 1; B++)
                for (Ze[B] = f, I = 0; I < 1 << me[B]; I++) Be[f++] = B;
              for (Be[f - 1] = B, se = 0, B = 0; B < 16; B++)
                for (qe[B] = se, I = 0; I < 1 << Te[B]; I++) Ee[se++] = B;
              for (se >>= 7; B < K; B++)
                for (qe[B] = se << 7, I = 0; I < 1 << Te[B] - 7; I++) Ee[256 + se++] = B;
              for (O = 0; O <= ee; O++) de[O] = 0;
              for (I = 0; I <= 143; ) He[2 * I + 1] = 8, I++, de[8]++;
              for (; I <= 255; ) He[2 * I + 1] = 9, I++, de[9]++;
              for (; I <= 279; ) He[2 * I + 1] = 7, I++, de[7]++;
              for (; I <= 287; ) He[2 * I + 1] = 8, I++, de[8]++;
              for (d(He, j + 1, de), I = 0; I < K; I++) Ae[2 * I + 1] = 5, Ae[2 * I] = l(I, 5);
              Je = new t(He, me, H + 1, j, ee), vt = new t(Ae, Te, 0, K, ee), rt = new t(new Array(0), Xe, 0, ae, F);
            }(), lt = !0), o.l_desc = new n(o.dyn_ltree, Je), o.d_desc = new n(o.dyn_dtree, vt), o.bl_desc = new n(o.bl_tree, rt), o.bi_buf = 0, o.bi_valid = 0, p(o);
          }, r._tr_stored_block = U, r._tr_flush_block = function(o, I, O, f) {
            var B, se, de = 0;
            o.level > 0 ? (o.strm.data_type === 2 && (o.strm.data_type = function(J) {
              var Le, Ce = 4093624447;
              for (Le = 0; Le <= 31; Le++, Ce >>>= 1)
                if (1 & Ce && J.dyn_ltree[2 * Le] !== 0) return D;
              if (J.dyn_ltree[18] !== 0 || J.dyn_ltree[20] !== 0 || J.dyn_ltree[26] !== 0)
                return W;
              for (Le = 32; Le < H; Le++) if (J.dyn_ltree[2 * Le] !== 0) return W;
              return D;
            }(o)), _(o, o.l_desc), _(o, o.d_desc), de = function(J) {
              var Le;
              for (w(J, J.dyn_ltree, J.l_desc.max_code), w(J, J.dyn_dtree, J.d_desc.max_code), _(J, J.bl_desc), Le = ae - 1; Le >= 3 && J.bl_tree[2 * Ke[Le] + 1] === 0; Le--) ;
              return J.opt_len += 3 * (Le + 1) + 5 + 5 + 4, Le;
            }(o), B = o.opt_len + 3 + 7 >>> 3, (se = o.static_len + 3 + 7 >>> 3) <= B && (B = se)) : B = se = O + 5, O + 4 <= B && I !== -1 ? U(o, I, O, f) : o.strategy === 4 || se === B ? (u(o, 2 + (f ? 1 : 0), 3), m(o, He, Ae)) : (u(o, 4 + (f ? 1 : 0), 3), function(J, Le, Ce, Qe) {
              var dt;
              for (u(J, Le - 257, 5), u(J, Ce - 1, 5), u(J, Qe - 4, 4), dt = 0; dt < Qe; dt++)
                u(J, J.bl_tree[2 * Ke[dt] + 1], 3);
              A(J, J.dyn_ltree, Le - 1), A(J, J.dyn_dtree, Ce - 1);
            }(o, o.l_desc.max_code + 1, o.d_desc.max_code + 1, de + 1), m(o, o.dyn_ltree, o.dyn_dtree)), p(o), f && y(o);
          }, r._tr_tally = function(o, I, O) {
            return o.pending_buf[o.d_buf + 2 * o.last_lit] = I >>> 8 & 255, o.pending_buf[o.d_buf + 2 * o.last_lit + 1] = 255 & I, o.pending_buf[o.l_buf + o.last_lit] = 255 & O, o.last_lit++, I === 0 ? o.dyn_ltree[2 * O]++ : (o.matches++, I--, o.dyn_ltree[2 * (Be[O] + H + 1)]++, o.dyn_dtree[2 * i(I)]++), o.last_lit === o.lit_bufsize - 1;
          }, r._tr_align = function(o) {
            u(o, 2, 3), h(o, M, He), function(I) {
              I.bi_valid === 16 ? (s(I, I.bi_buf), I.bi_buf = 0, I.bi_valid = 0) : I.bi_valid >= 8 && (I.pending_buf[I.pending++] = 255 & I.bi_buf, I.bi_buf >>= 8, I.bi_valid -= 8);
            }(o);
          };
        },
        { "../utils/common": 1 }
      ],
      8: [
        function(a, c, r) {
          c.exports = function() {
            this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
          };
        },
        {}
      ],
      "/lib/deflate.js": [
        function(a, c, r) {
          function e(Q) {
            if (!(this instanceof e)) return new e(Q);
            this.options = i.assign(
              {
                level: p,
                method: k,
                chunkSize: 16384,
                windowBits: 15,
                memLevel: 8,
                strategy: y,
                to: ""
              },
              Q || {}
            );
            var m = this.options;
            m.raw && m.windowBits > 0 ? m.windowBits = -m.windowBits : m.gzip && m.windowBits > 0 && m.windowBits < 16 && (m.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new h(), this.strm.avail_out = 0;
            var _ = n.deflateInit2(
              this.strm,
              m.level,
              m.method,
              m.windowBits,
              m.memLevel,
              m.strategy
            );
            if (_ !== d) throw new Error(u[_]);
            if (m.header && n.deflateSetHeader(this.strm, m.header), m.dictionary) {
              var w;
              if (w = typeof m.dictionary == "string" ? s.string2buf(m.dictionary) : l.call(m.dictionary) === "[object ArrayBuffer]" ? new Uint8Array(m.dictionary) : m.dictionary, (_ = n.deflateSetDictionary(this.strm, w)) !== d)
                throw new Error(u[_]);
              this._dict_set = !0;
            }
          }
          function t(Q, m) {
            var _ = new e(m);
            if (_.push(Q, !0), _.err) throw _.msg || u[_.err];
            return _.result;
          }
          var n = a("./zlib/deflate"), i = a("./utils/common"), s = a("./utils/strings"), u = a("./zlib/messages"), h = a("./zlib/zstream"), l = Object.prototype.toString, d = 0, p = -1, y = 0, k = 8;
          e.prototype.push = function(Q, m) {
            var _, w, A = this.strm, U = this.options.chunkSize;
            if (this.ended) return !1;
            w = m === ~~m ? m : m === !0 ? 4 : 0, typeof Q == "string" ? A.input = s.string2buf(Q) : l.call(Q) === "[object ArrayBuffer]" ? A.input = new Uint8Array(Q) : A.input = Q, A.next_in = 0, A.avail_in = A.input.length;
            do {
              if (A.avail_out === 0 && (A.output = new i.Buf8(U), A.next_out = 0, A.avail_out = U), (_ = n.deflate(A, w)) !== 1 && _ !== d)
                return this.onEnd(_), this.ended = !0, !1;
              A.avail_out !== 0 && (A.avail_in !== 0 || w !== 4 && w !== 2) || (this.options.to === "string" ? this.onData(s.buf2binstring(i.shrinkBuf(A.output, A.next_out))) : this.onData(i.shrinkBuf(A.output, A.next_out)));
            } while ((A.avail_in > 0 || A.avail_out === 0) && _ !== 1);
            return w === 4 ? (_ = n.deflateEnd(this.strm), this.onEnd(_), this.ended = !0, _ === d) : w !== 2 || (this.onEnd(d), A.avail_out = 0, !0);
          }, e.prototype.onData = function(Q) {
            this.chunks.push(Q);
          }, e.prototype.onEnd = function(Q) {
            Q === d && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = Q, this.msg = this.strm.msg;
          }, r.Deflate = e, r.deflate = t, r.deflateRaw = function(Q, m) {
            return (m = m || {}).raw = !0, t(Q, m);
          }, r.gzip = function(Q, m) {
            return (m = m || {}).gzip = !0, t(Q, m);
          };
        },
        {
          "./utils/common": 1,
          "./utils/strings": 2,
          "./zlib/deflate": 5,
          "./zlib/messages": 6,
          "./zlib/zstream": 8
        }
      ]
    },
    {},
    []
  )("/lib/deflate.js");
  var Me = function(a, c, r, e) {
    return new (r || (r = Promise))(function(t, n) {
      function i(h) {
        try {
          u(e.next(h));
        } catch (l) {
          n(l);
        }
      }
      function s(h) {
        try {
          u(e.throw(h));
        } catch (l) {
          n(l);
        }
      }
      function u(h) {
        var l;
        h.done ? t(h.value) : (l = h.value, l instanceof r ? l : new r(function(d) {
          d(l);
        })).then(i, s);
      }
      u((e = e.apply(a, c || [])).next());
    });
  }, Re = function(a, c) {
    var r, e, t, n, i = {
      label: 0,
      sent: function() {
        if (1 & t[0]) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    };
    return n = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (n[Symbol.iterator] = function() {
      return this;
    }), n;
    function s(u) {
      return function(h) {
        return function(l) {
          if (r) throw new TypeError("Generator is already executing.");
          for (; i; )
            try {
              if (r = 1, e && (t = 2 & l[0] ? e.return : l[0] ? e.throw || ((t = e.return) && t.call(e), 0) : e.next) && !(t = t.call(e, l[1])).done)
                return t;
              switch (e = 0, t && (l = [2 & l[0], t.value]), l[0]) {
                case 0:
                case 1:
                  t = l;
                  break;
                case 4:
                  return i.label++, { value: l[1], done: !1 };
                case 5:
                  i.label++, e = l[1], l = [0];
                  continue;
                case 7:
                  l = i.ops.pop(), i.trys.pop();
                  continue;
                default:
                  if (!(t = (t = i.trys).length > 0 && t[t.length - 1]) && (l[0] === 6 || l[0] === 2)) {
                    i = 0;
                    continue;
                  }
                  if (l[0] === 3 && (!t || l[1] > t[0] && l[1] < t[3])) {
                    i.label = l[1];
                    break;
                  }
                  if (l[0] === 6 && i.label < t[1]) {
                    i.label = t[1], t = l;
                    break;
                  }
                  if (t && i.label < t[2]) {
                    i.label = t[2], i.ops.push(l);
                    break;
                  }
                  t[2] && i.ops.pop(), i.trys.pop();
                  continue;
              }
              l = c.call(a, i);
            } catch (d) {
              l = [6, d], e = 0;
            } finally {
              r = t = 0;
            }
          if (5 & l[0]) throw l[1];
          return { value: l[0] ? l[1] : void 0, done: !0 };
        }([u, h]);
      };
    }
  }, Ct = function() {
    return (Ct = Object.assign || function(a) {
      for (var c, r = 1, e = arguments.length; r < e; r++)
        for (var t in c = arguments[r])
          Object.prototype.hasOwnProperty.call(c, t) && (a[t] = c[t]);
      return a;
    }).apply(this, arguments);
  };
  (function(a) {
    (function(c) {
      var r = function() {
        function e() {
          this._isIphoneOrIPad = !1, (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i)) && (this._isIphoneOrIPad = !0), this.initUAParser();
        }
        return Object.defineProperty(e.prototype, "userAgentData", {
          get: function() {
            return this._userAgentData;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "deviceType", {
          get: function() {
            return this._deviceType || (c.Util.isMobile ? this._deviceType = this.mobileType || this.desktopType || e.UNKNOWN_DEVICE_TYPE : this._deviceType = this.desktopType || this.mobileType || e.UNKNOWN_DEVICE_TYPE), this._deviceType;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "isIphoneOrIPad", {
          get: function() {
            return this._isIphoneOrIPad;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "browserName", {
          get: function() {
            return this._userAgentData && this._userAgentData.browser && this._userAgentData.browser.name ? this._userAgentData.browser.name.trim() : "";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "browserVersion", {
          get: function() {
            return this._userAgentData && this._userAgentData.browser && this._userAgentData.browser.version ? this._userAgentData.browser.version.trim() : "";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "browserMajor", {
          get: function() {
            return this._userAgentData && this._userAgentData.browser && this._userAgentData.browser.major ? this._userAgentData.browser.major.trim() : "";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "browserType", {
          get: function() {
            return this._userAgentData && this._userAgentData.browser && this._userAgentData.browser.type ? this._userAgentData.browser.type.trim() : "";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "osName", {
          get: function() {
            return this._userAgentData && this._userAgentData.os && this._userAgentData.os.name ? this._userAgentData.os.name.trim() : "";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "osVersion", {
          get: function() {
            return this._userAgentData && this._userAgentData.os && this._userAgentData.os.version ? this._userAgentData.os.version.trim() : "";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "deviceCategory", {
          get: function() {
            return this._userAgentData && this._userAgentData.device && this._userAgentData.device.type ? this._userAgentData.device.type.trim() : "";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "engineName", {
          get: function() {
            return this._userAgentData && this._userAgentData.engine && this._userAgentData.engine.name ? this._userAgentData.engine.name.trim() : "";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "engineVersion", {
          get: function() {
            return this._userAgentData && this._userAgentData.engine && this._userAgentData.engine.version ? this._userAgentData.engine.version.trim() : "";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "cpuArchitecture", {
          get: function() {
            return this._userAgentData && this._userAgentData.cpu && this._userAgentData.cpu.architecture ? this._userAgentData.cpu.architecture.trim() : "";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "deviceModel", {
          get: function() {
            return this._userAgentData && this._userAgentData.device && this._userAgentData.device.model ? this._userAgentData.device.model.trim() : "";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "deviceVendor", {
          get: function() {
            return this._userAgentData && this._userAgentData.device && this._userAgentData.device.vendor ? this._userAgentData.device.vendor.trim() : "";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "desktopType", {
          get: function() {
            var t = this.browserName;
            this.browserVersion && (t = t + "(" + this.browserVersion + ")");
            var n = this.osName;
            this.osVersion && (n = n + "(" + this.osVersion + ")");
            var i = t && n ? t + "-" + n : t || n;
            return i ? i.trim() : "";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "mobileType", {
          get: function() {
            var t = this.deviceModel, n = this.deviceVendor, i = t && n ? t + " " + n : t || n;
            return i ? i.trim() : "";
          },
          enumerable: !1,
          configurable: !0
        }), e.prototype.initUAParser = function() {
          try {
            var t = new a.UAParser();
            t.setUA(navigator.userAgent), this._userAgentData = t.getResult();
          } catch (n) {
            c.Logger.warn("UAParser failure", n);
          }
        }, e.UNKNOWN_DEVICE_TYPE = "unknown", e;
      }();
      c.BrowserInfo = r;
    })(a._POSignalsUtils || (a._POSignalsUtils = {}));
  })(X || (X = {})), function(a) {
    (function(c) {
      var r = function() {
        function e() {
        }
        return Object.defineProperty(e, "CLIENT_VERSION", {
          get: function() {
            return "5.6.4w";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "SALT", {
          get: function() {
            return "ST8irbd3bB";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "TAB_UUID_KEY", {
          get: function() {
            return "pos_tid";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "OPS_KEY", {
          get: function() {
            return "pos_ops";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "DEVICE_ID_KEY", {
          get: function() {
            return "SecuredTouchDeviceId";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "DEVICE_ID_CREATED_AT", {
          get: function() {
            return "pos_dca";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "LAST_DEVICE_KEY_RESYNC", {
          get: function() {
            return "DeviceRefreshDate";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "CAPTURED_KEYBOARD_INTERACTIONS", {
          get: function() {
            return "pos_cki";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "CAPTURED_MOUSE_INTERACTIONS", {
          get: function() {
            return "pos_cmi";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "CAPTURED_GESTURES", {
          get: function() {
            return "pos_cg";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "CAPTURED_INDIRECT", {
          get: function() {
            return "pos_cie";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "CAPTURED_TAGS", {
          get: function() {
            return "pos_ct";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "CAPTURED_MOUSE_INTERACTIONS_SUMMARY", {
          get: function() {
            return "pos_mdp";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "KEYBOARD_INTERACTIONS_COUNT", {
          get: function() {
            return "pos_kic";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "MOUSE_INTERACTIONS_COUNT", {
          get: function() {
            return "pos_mic";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "GESTURES_COUNT", {
          get: function() {
            return "pos_gc";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "EVENT_COUNTERS", {
          get: function() {
            return "pos_ec";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "PINGID_AGENT_DEFAULT_PORT", {
          get: function() {
            return 9400;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "PINGID_AGENT_DEFAULT_TIMEOUT", {
          get: function() {
            return 1e3;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "MOUSE_EVENT_COUNTERS", {
          get: function() {
            return "pos_mec";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "KEYBOARD_EVENT_COUNTERS", {
          get: function() {
            return "pos_kec";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "TOUCH_EVENT_COUNTERS", {
          get: function() {
            return "pos_tec";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "INDIRECT_EVENT_COUNTERS", {
          get: function() {
            return "pos_iec";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "GeoDataKey", {
          get: function() {
            return "pos_geo";
          },
          enumerable: !1,
          configurable: !0
        }), e;
      }();
      c.Constants = r;
    })(a._POSignalsUtils || (a._POSignalsUtils = {}));
  }(X || (X = {})), function(a) {
    (function(c) {
      var r = function() {
        function e(t, n, i) {
          if (t === void 0 && (t = "ECDSA"), n === void 0 && (n = ["sign", "verify"]), i === void 0 && (i = "SHA-256"), this.signingKeyType = t, this.keyUsage = n, this.algorithm = i, this._crypto = window.crypto || window.msCrypto, !this._crypto || !this._crypto.subtle)
            throw new Error("Cryptography API not supported in this browser");
        }
        return e.prototype.generateKeys = function() {
          return Me(this, void 0, void 0, function() {
            return Re(this, function(t) {
              return [
                2,
                this._crypto.subtle.generateKey(
                  { name: this.signingKeyType, namedCurve: "P-256" },
                  !1,
                  this.keyUsage
                )
              ];
            });
          });
        }, e.prototype.exportPublicKey = function(t) {
          return Me(this, void 0, void 0, function() {
            var n, i, s, u;
            return Re(this, function(h) {
              switch (h.label) {
                case 0:
                  return [4, this._crypto.subtle.exportKey("spki", t.publicKey)];
                case 1:
                  return n = h.sent(), i = c.Util.ab2str(n), s = btoa(i), u = `-----BEGIN PUBLIC KEY-----
` + s + `
-----END PUBLIC KEY-----`, c.Logger.debug("Exported base64 pub key: ", u), [2, u];
              }
            });
          });
        }, e.prototype.exportPublicKeyJwk = function(t) {
          return Me(this, void 0, void 0, function() {
            return Re(this, function(n) {
              switch (n.label) {
                case 0:
                  return [4, window.crypto.subtle.exportKey("jwk", t.publicKey)];
                case 1:
                  return [2, n.sent()];
              }
            });
          });
        }, e.prototype.exportPrivateKey = function(t) {
          return Me(this, void 0, void 0, function() {
            var n, i, s, u;
            return Re(this, function(h) {
              switch (h.label) {
                case 0:
                  return [4, this._crypto.subtle.exportKey("pkcs8", t.privateKey)];
                case 1:
                  return n = h.sent(), i = c.Util.ab2str(n), s = btoa(i), u = `-----BEGIN PRIVATE KEY-----
` + s + `
-----END PRIVATE KEY-----`, c.Logger.debug("Exported base64 pem:", u), [2, u];
              }
            });
          });
        }, e.prototype.signJWT = function(t, n, i, s, u) {
          return Me(this, void 0, void 0, function() {
            var h, l, d, p, y, k, Q, m, _;
            return Re(this, function(w) {
              switch (w.label) {
                case 0:
                  return [4, this.exportPublicKeyJwk(n)];
                case 1:
                  if (h = w.sent(), l = { alg: "ES256", typ: "JWT", jwk: h, kid: u }, d = { deviceAttributesSerialized: t, iat: Math.floor(s / 1e3) }, !n.privateKey)
                    throw new Error("Require key");
                  if (l.alg !== "ES256" && l.typ !== "JWT")
                    throw new Error(
                      "jwt-encode only support the ES256 algorithm and the JWT type of hash"
                    );
                  return p = c.Util.encode(l), y = c.Util.encode(d), k = p + "." + y, Q = c.Util.string2buf(k), [
                    4,
                    this._crypto.subtle.sign(
                      { name: this.signingKeyType, hash: this.algorithm },
                      n.privateKey,
                      Q
                    )
                  ];
                case 2:
                  return m = w.sent(), _ = c.Util.base64url(btoa(c.Util.ab2str(m))), c.Logger.debug("Signed JWT: ", k + "." + _), [2, k + "." + _];
              }
            });
          });
        }, e.prototype.verifyJwtToken = function(t, n) {
          return Me(this, void 0, void 0, function() {
            var i, s, u, h, l, d, p;
            return Re(this, function(y) {
              switch (y.label) {
                case 0:
                  if (i = t.split("."), s = i[0], u = i[1], h = i[2], (l = c.Util.parseJwt(s)).alg !== "ES256" && l.typ !== "JWT")
                    throw new Error(
                      "JWT header supports only ES256 algorithm and the JWT type of hash"
                    );
                  return c.Util.parseJwt(u), d = Uint8Array.from(
                    atob(h.replace(/-/g, "+").replace(/_/g, "/")),
                    function(k) {
                      return k.charCodeAt(0);
                    }
                  ), p = c.Util.string2buf(s + "." + u), [
                    4,
                    this._crypto.subtle.verify(
                      { name: this.signingKeyType, hash: this.algorithm },
                      n,
                      d,
                      p
                    )
                  ];
                case 1:
                  return [2, y.sent()];
              }
            });
          });
        }, e;
      }();
      c.CryptoOperator = r;
    })(a._POSignalsUtils || (a._POSignalsUtils = {}));
  }(X || (X = {})), function(a) {
    (function(c) {
      var r = function() {
        function e() {
        }
        return Object.defineProperty(e, "isLogEnabled", {
          get: function() {
            return this._isLogEnabled || window["enable-logs-pingOneSignals"];
          },
          set: function(t) {
            this._isLogEnabled = t;
          },
          enumerable: !1,
          configurable: !0
        }), e.debug = function(t) {
          for (var n = [], i = 1; i < arguments.length; i++) n[i - 1] = arguments[i];
          t = e.TAG + " " + t, e.isLogEnabled && (n && n.length > 0 ? console.debug ? console.debug(t, n) : console.log(t, n) : console.debug ? console.debug(t) : console.log(t));
        }, e.error = function(t) {
          for (var n = [], i = 1; i < arguments.length; i++) n[i - 1] = arguments[i];
          t = e.TAG + " " + t, e.isLogEnabled && (n && n.length > 0 ? console.error(t, n) : console.error(t));
        }, e.warn = function(t) {
          for (var n = [], i = 1; i < arguments.length; i++) n[i - 1] = arguments[i];
          t = e.TAG + " " + t, e.isLogEnabled && (n && n.length > 0 ? console.warn(t, n) : console.warn(t));
        }, e.info = function(t) {
          for (var n = [], i = 1; i < arguments.length; i++) n[i - 1] = arguments[i];
          t = e.TAG + " " + t, e.isLogEnabled && (n && n.length > 0 ? console.info(t, n) : console.info(t));
        }, e.TAG = "[SignalsSDK]", e;
      }();
      c.Logger = r;
    })(a._POSignalsUtils || (a._POSignalsUtils = {}));
  }(X || (X = {})), function(a) {
    (function(c) {
      var r = function() {
        function e() {
        }
        return Object.defineProperty(e, "INITIALIZATION_ERROR", {
          get: function() {
            return "INITIALIZATION_ERROR";
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "UNEXPECTED_ERROR", {
          get: function() {
            return "UNEXPECTED_ERROR";
          },
          enumerable: !1,
          configurable: !0
        }), e;
      }();
      c.POErrorCodes = r;
    })(a._POSignalsUtils || (a._POSignalsUtils = {}));
  }(X || (X = {}));
  var Co = {
    115: "115",
    2345: "2345",
    360: "360",
    ALIPAY: "Alipay",
    AMAYA: "Amaya",
    ANDROID: "Android Browser",
    ARORA: "Arora",
    AVANT: "Avant",
    AVAST: "Avast Secure Browser",
    AVG: "AVG Secure Browser",
    BAIDU: "Baidu Browser",
    BASILISK: "Basilisk",
    BLAZER: "Blazer",
    BOLT: "Bolt",
    BOWSER: "Bowser",
    BRAVE: "Brave",
    CAMINO: "Camino",
    CHIMERA: "Chimera",
    CHROME: "Chrome",
    CHROME_HEADLESS: "Chrome Headless",
    CHROME_MOBILE: "Mobile Chrome",
    CHROME_WEBVIEW: "Chrome WebView",
    CHROMIUM: "Chromium",
    COBALT: "Cobalt",
    COC_COC: "Coc Coc",
    CONKEROR: "Conkeror",
    DAUM: "Daum",
    DILLO: "Dillo",
    DOLPHIN: "Dolphin",
    DORIS: "Doris",
    DRAGON: "Dragon",
    DUCKDUCKGO: "DuckDuckGo",
    EDGE: "Edge",
    EPIPHANY: "Epiphany",
    FACEBOOK: "Facebook",
    FALKON: "Falkon",
    FIREBIRD: "Firebird",
    FIREFOX: "Firefox",
    FIREFOX_FOCUS: "Firefox Focus",
    FIREFOX_MOBILE: "Mobile Firefox",
    FIREFOX_REALITY: "Firefox Reality",
    FENNEC: "Fennec",
    FLOCK: "Flock",
    FLOW: "Flow",
    GO: "GoBrowser",
    GOOGLE_SEARCH: "GSA",
    HELIO: "Helio",
    HEYTAP: "HeyTap",
    HONOR: "Honor",
    HUAWEI: "Huawei Browser",
    ICAB: "iCab",
    ICE: "ICE Browser",
    ICEAPE: "IceApe",
    ICECAT: "IceCat",
    ICEDRAGON: "IceDragon",
    ICEWEASEL: "IceWeasel",
    IE: "IE",
    INSTAGRAM: "Instagram",
    IRIDIUM: "Iridium",
    IRON: "Iron",
    JASMINE: "Jasmine",
    KONQUEROR: "Konqueror",
    KAKAO: "KakaoTalk",
    KHTML: "KHTML",
    K_MELEON: "K-Meleon",
    KLAR: "Klar",
    KLARNA: "Klarna",
    KINDLE: "Kindle",
    LENOVO: "Smart Lenovo Browser",
    LADYBIRD: "Ladybird",
    LIBREWOLF: "LibreWolf",
    LIEBAO: "LBBROWSER",
    LINE: "Line",
    LINKEDIN: "LinkedIn",
    LINKS: "Links",
    LUNASCAPE: "Lunascape",
    LYNX: "Lynx",
    MAEMO: "Maemo Browser",
    MAXTHON: "Maxthon",
    MIDORI: "Midori",
    MINIMO: "Minimo",
    MIUI: "MIUI Browser",
    MOZILLA: "Mozilla",
    MOSAIC: "Mosaic",
    NAVER: "Naver",
    NETFRONT: "NetFront",
    NETSCAPE: "Netscape",
    NETSURF: "Netsurf",
    NOKIA: "Nokia Browser",
    OBIGO: "Obigo",
    OCULUS: "Oculus Browser",
    OMNIWEB: "OmniWeb",
    OPERA: "Opera",
    OPERA_COAST: "Opera Coast",
    OPERA_GX: "Opera GX",
    OPERA_MINI: "Opera Mini",
    OPERA_MOBI: "Opera Mobi",
    OPERA_TABLET: "Opera Tablet",
    OPERA_TOUCH: "Opera Touch",
    OVI: "OviBrowser",
    PALEMOON: "PaleMoon",
    PHANTOMJS: "PhantomJS",
    PHOENIX: "Phoenix",
    PICOBROWSER: "Pico Browser",
    POLARIS: "Polaris",
    PUFFIN: "Puffin",
    QQ: "QQBrowser",
    QQ_LITE: "QQBrowserLite",
    QUARK: "Quark",
    QUPZILLA: "QupZilla",
    REKONQ: "rekonq",
    ROCKMELT: "Rockmelt",
    SAFARI: "Safari",
    SAFARI_MOBILE: "Mobile Safari",
    SAILFISH: "Sailfish Browser",
    SAMSUNG: "Samsung Internet",
    SEAMONKEY: "SeaMonkey",
    SILK: "Silk",
    SKYFIRE: "Skyfire",
    SLEIPNIR: "Sleipnir",
    SLIMBOAT: "SlimBoat",
    SLIMBROWSER: "SlimBrowser",
    SLIMJET: "Slimjet",
    SNAPCHAT: "Snapchat",
    SOGOU_EXPLORER: "Sogou Explorer",
    SOGOU_MOBILE: "Sogou Mobile",
    SWIFTFOX: "Swiftfox",
    TESLA: "Tesla",
    TIKTOK: "TikTok",
    TIZEN: "Tizen Browser",
    TWITTER: "Twitter",
    UC: "UCBrowser",
    UP: "UP.Browser",
    VIVALDI: "Vivaldi",
    VIVO: "Vivo Browser",
    W3M: "w3m",
    WATERFOX: "Waterfox",
    WEBKIT: "WebKit",
    WECHAT: "WeChat",
    WEIBO: "Weibo",
    WHALE: "Whale",
    WOLVIC: "Wolvic",
    YANDEX: "Yandex"
  }, Po = {
    CRAWLER: "crawler",
    CLI: "cli",
    EMAIL: "email",
    FETCHER: "fetcher",
    INAPP: "inapp",
    MEDIAPLAYER: "mediaplayer",
    LIBRARY: "library"
  }, Do = {
    "68K": "68k",
    ARM: "arm",
    ARM_64: "arm64",
    ARM_HF: "armhf",
    AVR: "avr",
    AVR_32: "avr32",
    IA64: "ia64",
    IRIX: "irix",
    IRIX_64: "irix64",
    MIPS: "mips",
    MIPS_64: "mips64",
    PA_RISC: "pa-risc",
    PPC: "ppc",
    SPARC: "sparc",
    SPARC_64: "sparc64",
    X86: "ia32",
    X86_64: "amd64"
  }, Mo = {
    CONSOLE: "console",
    DESKTOP: "desktop",
    EMBEDDED: "embedded",
    MOBILE: "mobile",
    SMARTTV: "smarttv",
    TABLET: "tablet",
    WEARABLE: "wearable",
    XR: "xr"
  }, Ro = {
    ACER: "Acer",
    ADVAN: "Advan",
    ALCATEL: "Alcatel",
    APPLE: "Apple",
    AMAZON: "Amazon",
    ARCHOS: "Archos",
    ASUS: "ASUS",
    ATT: "AT&T",
    BENQ: "BenQ",
    BLACKBERRY: "BlackBerry",
    CAT: "Cat",
    DELL: "Dell",
    ENERGIZER: "Energizer",
    ESSENTIAL: "Essential",
    FACEBOOK: "Facebook",
    FAIRPHONE: "Fairphone",
    GEEKSPHONE: "GeeksPhone",
    GENERIC: "Generic",
    GOOGLE: "Google",
    HMD: "HMD",
    HP: "HP",
    HTC: "HTC",
    HUAWEI: "Huawei",
    IMO: "IMO",
    INFINIX: "Infinix",
    ITEL: "itel",
    JOLLA: "Jolla",
    KOBO: "Kobo",
    LENOVO: "Lenovo",
    LG: "LG",
    MEIZU: "Meizu",
    MICROMAX: "Micromax",
    MICROSOFT: "Microsoft",
    MOTOROLA: "Motorola",
    NEXIAN: "Nexian",
    NINTENDO: "Nintendo",
    NOKIA: "Nokia",
    NOTHING: "Nothing",
    NVIDIA: "Nvidia",
    ONEPLUS: "OnePlus",
    OPPO: "OPPO",
    OUYA: "Ouya",
    PALM: "Palm",
    PANASONIC: "Panasonic",
    PEBBLE: "Pebble",
    PICO: "Pico",
    POLYTRON: "Polytron",
    REALME: "Realme",
    RIM: "RIM",
    ROKU: "Roku",
    SAMSUNG: "Samsung",
    SHARP: "Sharp",
    SIEMENS: "Siemens",
    SMARTFREN: "Smartfren",
    SONY: "Sony",
    SPRINT: "Sprint",
    TCL: "TCL",
    TECHNISAT: "TechniSAT",
    TECNO: "Tecno",
    TESLA: "Tesla",
    ULEFONE: "Ulefone",
    VIVO: "Vivo",
    VODAFONE: "Vodafone",
    XBOX: "Xbox",
    XIAOMI: "Xiaomi",
    ZEBRA: "Zebra",
    ZTE: "ZTE"
  }, Ln = {
    AMAYA: "Amaya",
    ARKWEB: "ArkWeb",
    BLINK: "Blink",
    EDGEHTML: "EdgeHTML",
    FLOW: "Flow",
    GECKO: "Gecko",
    GOANNA: "Goanna",
    ICAB: "iCab",
    KHTML: "KHTML",
    LIBWEB: "LibWeb",
    LINKS: "Links",
    LYNX: "Lynx",
    NETFRONT: "NetFront",
    NETSURF: "NetSurf",
    PRESTO: "Presto",
    SERVO: "Servo",
    TASMAN: "Tasman",
    TRIDENT: "Trident",
    W3M: "w3m",
    WEBKIT: "WebKit"
  }, Uo = {
    AIX: "AIX",
    AMIGA_OS: "Amiga OS",
    ANDROID: "Android",
    ANDROID_X86: "Android-x86",
    ARCH: "Arch",
    BADA: "Bada",
    BEOS: "BeOS",
    BLACKBERRY: "BlackBerry",
    CENTOS: "CentOS",
    CHROME_OS: "Chrome OS",
    CHROMECAST: "Chromecast",
    CHROMECAST_ANDROID: "Chromecast Android",
    CHROMECAST_FUCHSIA: "Chromecast Fuchsia",
    CHROMECAST_LINUX: "Chromecast Linux",
    CHROMECAST_SMARTSPEAKER: "Chromecast SmartSpeaker",
    CONTIKI: "Contiki",
    DEBIAN: "Debian",
    DEEPIN: "Deepin",
    DRAGONFLY: "DragonFly",
    ELEMENTARY_OS: "elementary OS",
    FEDORA: "Fedora",
    FIREFOX_OS: "Firefox OS",
    FREEBSD: "FreeBSD",
    FUCHSIA: "Fuchsia",
    GENTOO: "Gentoo",
    GHOSTBSD: "GhostBSD",
    GNU: "GNU",
    HAIKU: "Haiku",
    HARMONYOS: "HarmonyOS",
    HP_UX: "HP-UX",
    HURD: "Hurd",
    IOS: "iOS",
    JOLI: "Joli",
    KAIOS: "KaiOS",
    KUBUNTU: "Kubuntu",
    LINPUS: "Linpus",
    LINSPIRE: "Linspire",
    LINUX: "Linux",
    MACOS: "macOS",
    MAEMO: "Maemo",
    MAGEIA: "Mageia",
    MANDRIVA: "Mandriva",
    MANJARO: "Manjaro",
    MEEGO: "MeeGo",
    MINIX: "Minix",
    MINT: "Mint",
    MORPH_OS: "Morph OS",
    NETBSD: "NetBSD",
    NETRANGE: "NetRange",
    NETTV: "NetTV",
    NINTENDO: "Nintendo",
    OPENHARMONY: "OpenHarmony",
    OPENBSD: "OpenBSD",
    OPENVMS: "OpenVMS",
    OS2: "OS/2",
    PALM: "Palm",
    PC_BSD: "PC-BSD",
    PCLINUXOS: "PCLinuxOS",
    PICO: "Pico",
    PLAN9: "Plan9",
    PLAYSTATION: "PlayStation",
    QNX: "QNX",
    RASPBIAN: "Raspbian",
    REDHAT: "RedHat",
    RIM_TABLET_OS: "RIM Tablet OS",
    RISC_OS: "RISC OS",
    SABAYON: "Sabayon",
    SAILFISH: "Sailfish",
    SERENITYOS: "SerenityOS",
    SERIES40: "Series40",
    SLACKWARE: "Slackware",
    SOLARIS: "Solaris",
    SUSE: "SUSE",
    SYMBIAN: "Symbian",
    TIZEN: "Tizen",
    UBUNTU: "Ubuntu",
    UBUNTU_TOUCH: "Ubuntu Touch",
    UNIX: "Unix",
    VECTORLINUX: "VectorLinux",
    WATCHOS: "watchOS",
    WEBOS: "WebOS",
    WINDOWS: "Windows",
    WINDOWS_IOT: "Windows IoT",
    WINDOWS_MOBILE: "Windows Mobile",
    WINDOWS_PHONE: "Windows Phone",
    XBOX: "Xbox",
    ZENWALK: "Zenwalk"
  };
  (function(a) {
    (function(c) {
      var r = function() {
        function e() {
        }
        return Object.defineProperty(e, "Browser", {
          get: function() {
            return Co;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "BrowserType", {
          get: function() {
            return Po;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "CPU", {
          get: function() {
            return Do;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "Device", {
          get: function() {
            return Mo;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "Vendor", {
          get: function() {
            return Ro;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "Engine", {
          get: function() {
            return Ln;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e, "UAParserEnumOS", {
          get: function() {
            return Uo;
          },
          enumerable: !1,
          configurable: !0
        }), e;
      }();
      c.UAParserEnums = r;
    })(a._POSignalsUtils || (a._POSignalsUtils = {}));
  })(X || (X = {})), function(a) {
    (function(c) {
      var r = function() {
        function e() {
        }
        return Object.defineProperty(e, "isMobile", {
          get: function() {
            var t, n = !1;
            return t = navigator.userAgent || navigator.vendor || window.opera, (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
              t
            ) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
              t.substr(0, 4)
            )) && (n = !0), n;
          },
          enumerable: !1,
          configurable: !0
        }), e.newGuid = function() {
          return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
            var n = 16 * Math.random() | 0;
            return (t === "x" ? n : 3 & n | 8).toString(16);
          });
        }, e.ieFix = function() {
          (navigator.userAgent.indexOf("MSIE") != -1 ? /MSIE (\d+\.\d+);/ : /Trident.*rv[ :]*(\d+\.\d+)/).test(navigator.userAgent) && (document.body.setAttribute("style", "-ms-touch-action:none;"), document.body.style.touchAction = "none", document.body.style.msTouchAction = "none");
        }, e.now = function() {
          var t = window.performance || {};
          return t.now = t.now || t.webkitNow || t.msNow || t.oNow || t.mozNow || function() {
            return (/* @__PURE__ */ new Date()).getTime();
          }, t.now();
        }, e.base64Uint8Array = function(t) {
          var n, i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = t.length, u = "";
          for (n = 0; n < s; n += 3)
            u += i[t[n] >> 2], u += i[(3 & t[n]) << 4 | t[n + 1] >> 4], u += i[(15 & t[n + 1]) << 2 | t[n + 2] >> 6], u += i[63 & t[n + 2]];
          return s % 3 == 2 ? u = u.substring(0, u.length - 1) + "=" : s % 3 == 1 && (u = u.substring(0, u.length - 2) + "=="), u;
        }, e.string2buf = function(t) {
          if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
            return new TextEncoder().encode(t);
          var n, i, s, u, h, l = t.length, d = 0;
          for (u = 0; u < l; u++)
            (64512 & (i = t.charCodeAt(u))) == 55296 && u + 1 < l && (64512 & (s = t.charCodeAt(u + 1))) == 56320 && (i = 65536 + (i - 55296 << 10) + (s - 56320), u++), d += i < 128 ? 1 : i < 2048 ? 2 : i < 65536 ? 3 : 4;
          for (n = new Uint8Array(d), h = 0, u = 0; h < d; u++)
            (64512 & (i = t.charCodeAt(u))) == 55296 && u + 1 < l && (64512 & (s = t.charCodeAt(u + 1))) == 56320 && (i = 65536 + (i - 55296 << 10) + (s - 56320), u++), i < 128 ? n[h++] = i : i < 2048 ? (n[h++] = 192 | i >>> 6, n[h++] = 128 | 63 & i) : i < 65536 ? (n[h++] = 224 | i >>> 12, n[h++] = 128 | i >>> 6 & 63, n[h++] = 128 | 63 & i) : (n[h++] = 240 | i >>> 18, n[h++] = 128 | i >>> 12 & 63, n[h++] = 128 | i >>> 6 & 63, n[h++] = 128 | 63 & i);
          return n;
        }, e.utf8Encode = function(t) {
          t = t.replace(/\r\n/g, `
`);
          for (var n = "", i = 0; i < t.length; i++) {
            var s = t.charCodeAt(i);
            s < 128 ? n += String.fromCharCode(s) : s > 127 && s < 2048 ? (n += String.fromCharCode(s >> 6 | 192), n += String.fromCharCode(63 & s | 128)) : (n += String.fromCharCode(s >> 12 | 224), n += String.fromCharCode(s >> 6 & 63 | 128), n += String.fromCharCode(63 & s | 128));
          }
          return n;
        }, e.hash = function(t) {
          var n = e.hashCache.get(t);
          return n || (n = a.sha256(t + c.Constants.SALT), e.hashCache.set(t, n)), n;
        }, e.hashMini = function(t) {
          var n, i, s = "" + JSON.stringify(t), u = 2166136261;
          for (n = 0, i = s.length; n < i; n++) u = Math.imul(31, u) + s.charCodeAt(n) | 0;
          return ("0000000" + (u >>> 0).toString(16)).substr(-8);
        }, e.hashCode = function(t) {
          var n = 0, i = t ? t.length : 0, s = 0;
          if (i > 0) for (; s < i; ) n = (n << 5) - n + t.charCodeAt(s++) | 0;
          return n;
        }, e.mod = function(t, n) {
          return (e.hashCode(t) % n + n) % n;
        }, e.isEmail = function(t) {
          try {
            return t && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              t.toLowerCase()
            );
          } catch (n) {
            return c.Logger.warn("isEmail function failed to parse string", n), !1;
          }
        }, e.getEmailDomain = function(t) {
          return e.isEmail(t) ? t.substring(t.lastIndexOf("@") + 1) : "";
        }, e.extendPrimitiveValues = function(t, n, i) {
          for (var s = e.allKeys(n), u = 0; u < s.length; )
            e.isObject(n[s[u]]) || i && (!i || t[s[u]] !== void 0) || (t[s[u]] = n[s[u]]), u++;
          return t;
        }, e.flatten = function(t) {
          var n = {};
          return e.dive("", t, n), n;
        }, e.isFunction = function(t) {
          return t && typeof t == "function";
        }, e.isPassiveSupported = function() {
          var t = !1, n = function() {
          };
          try {
            var i = {
              get passive() {
                return t = !0, !0;
              }
            };
            window.addEventListener("test", n, i), window.removeEventListener("test", n, !1);
          } catch {
            t = !1;
          }
          return t;
        }, e.getAttribute = function(t, n) {
          try {
            if (t && typeof t.getAttribute == "function") return t.getAttribute(n) || "";
          } catch {
          }
          return "";
        }, e.createInvisibleElement = function(t) {
          try {
            var n = document.createElement(t);
            return n.style.display = "none", n.style.border = "none", n.style.position = "absolute", n.style.top = "-999px", n.style.left = "-999px", n.style.width = "0", n.style.height = "0", n.style.visibility = "hidden", n;
          } catch (i) {
            return c.Logger.warn("Failed to create element", i), null;
          }
        }, e.values = function(t) {
          for (var n = e.allKeys(t), i = n.length, s = Array(i), u = 0; u < i; u++)
            s[u] = t[n[u]];
          return s;
        }, e.getValuesOfMap = function(t) {
          if (this.isFunction(t.values)) return Array.from(t.values());
          var n = [];
          return t.forEach(function(i) {
            return n.push(i);
          }), n;
        }, e.typesCounter = function(t) {
          for (var n = { epochTs: Date.now() }, i = 0, s = t; i < s.length; i++) {
            var u = s[i];
            n[u.type] = (n[u.type] || 0) + 1;
          }
          return n;
        }, e.modifiersKeys = function(t) {
          var n = [];
          return t.getModifierState && [
            "Alt",
            "AltGraph",
            "CapsLock",
            "Control",
            "Fn",
            "FnLock",
            "Hyper",
            "Meta",
            "NumLock",
            "OS",
            "ScrollLock",
            "Shift",
            "Super",
            "Symbol",
            "SymbolLock"
          ].forEach(function(i) {
            t.getModifierState(i.toString()) && n.push(i);
          }), n;
        }, e.getElementText = function(t) {
          var n, i;
          return t instanceof HTMLInputElement ? ["checkbox", "radio"].indexOf(t.type) >= 0 ? "" + t.checked : t.value : t instanceof HTMLSelectElement ? (i = (n = t.selectedOptions) === null || n === void 0 ? void 0 : n[0]) === null || i === void 0 ? void 0 : i.innerText : t.innerText;
        }, e.getSrcElement = function(t) {
          return t.srcElement || t.target;
        }, e.getObjectType = function(t) {
          try {
            var n = /function (.{1,})\(/.exec(t.constructor.toString());
            return n && n.length > 1 ? n[1] : "";
          } catch {
            return "";
          }
        }, e.isSelectorMatches = function(t, n, i) {
          try {
            var s = Element.prototype, u = s.matches || s.webkitMatchesSelector || s.mozMatchesSelector || s.msMatchesSelector, h = 0;
            do {
              if (u.call(t, n)) return t;
              t = t.parentElement || t.parentNode;
            } while (t !== null && t.nodeType === 1 && h++ < i);
            return null;
          } catch {
            return null;
          }
        }, e.anySelectorMatches = function(t, n, i) {
          try {
            for (var s = 0, u = n; s < u.length; s++) {
              var h = u[s];
              if (this.isSelectorMatches(t, h, i)) return !0;
            }
          } catch (l) {
            c.Logger.warn(l);
          }
          return !1;
        }, e.isArray = function(t) {
          return Array.isArray ? Array.isArray(t) : Object.prototype.toString.call(t) === "[object Array]";
        }, e.safeJsonParse = function(t) {
          var n = null;
          try {
            t && (n = JSON.parse(t));
          } catch (i) {
            c.Logger.warn("Failed to parse object " + i), n = null;
          }
          return n;
        }, e.getElementSelectionStart = function(t) {
          var n;
          try {
            n = t.selectionStart;
          } catch {
            n = "";
          }
          return n;
        }, e.getElementSelectionEnd = function(t) {
          var n;
          try {
            n = t.selectionEnd;
          } catch {
            n = "";
          }
          return n;
        }, e.isClickableInput = function(t) {
          return t && [
            "button",
            "checkbox",
            "color",
            "radio",
            "range",
            "image",
            "submit",
            "file",
            "reset"
          ].indexOf(t.type) >= 0;
        }, e.isTextInput = function(t) {
          return t && [
            "date",
            "datetime-local",
            "email",
            "month",
            "number",
            "password",
            "search",
            "tel",
            "text",
            "time",
            "url",
            "week",
            "datetime"
          ].indexOf(t.type) >= 0;
        }, e.getDeviceOrientation = function() {
          var t = screen.orientation || screen.mozOrientation || {}, n = screen.msOrientation || t.type, i = t.angle;
          return {
            orientation: n == null ? void 0 : n.toString(),
            angle: i == null ? void 0 : i.toString()
          };
        }, e.getDevToolsState = function() {
          var t, n, i = window.outerWidth - window.innerWidth > 160, s = window.outerHeight - window.innerHeight > 160, u = i ? "vertical" : "horizontal";
          return s && i || !(!((n = (t = window.Firebug) === null || t === void 0 ? void 0 : t.chrome) === null || n === void 0) && n.isInitialized || i || s) ? { open: !1, orientation: void 0 } : { open: !0, orientation: u };
        }, e.getCookie = function(t) {
          var n = document.cookie.match("(^|;) ?" + t + "=([^;]*)(;|$)");
          return n ? n[2] : null;
        }, e.setCookie = function(t, n, i) {
          var s = /* @__PURE__ */ new Date();
          s.setTime(s.getTime() + 1e3 * i), document.cookie = t + "=" + n + ";path=/;secure;SameSite=None;expires=" + s.toUTCString();
        }, e.deleteCookie = function(t) {
          e.setCookie(t, "", -1);
        }, e.delay = function(t) {
          return new Promise(function(n) {
            return setTimeout(n, t);
          });
        }, e.getHostnameFromRegex = function(t) {
          if (t) {
            var n = t.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
            return n && n[1];
          }
          return null;
        }, e.inIframe = function() {
          try {
            return window.self !== window.top;
          } catch {
            return !0;
          }
        }, e.promiseTimeout = function(t, n) {
          var i = new Promise(function(s, u) {
            var h = setTimeout(function() {
              clearTimeout(h), u(new Error("Timed out in " + t + "ms."));
            }, t);
          });
          return Promise.race([n, i]);
        }, e.getProperty = function(t, n) {
          return n.split(".").reduce(function(i, s) {
            return i ? i[s] : null;
          }, t);
        }, e.filterReduce = function(t, n) {
          return Object.keys(t).filter(function(i) {
            return n(t[i]);
          }).reduce(function(i, s) {
            var u;
            return Ct(Ct({}, i), ((u = {})[s] = t[s], u));
          }, {});
        }, e.dive = function(t, n, i) {
          for (var s in n)
            if (n.hasOwnProperty(s)) {
              var u = s, h = n[s];
              t.length > 0 && (u = t + "." + s), e.isObject(h) ? e.dive(u, h, i) : i[u] = h;
            }
        }, e.isObject = function(t) {
          var n = typeof t;
          return n === "function" || n === "object" && !!t;
        }, e.allKeys = function(t) {
          if (!e.isObject(t)) return [];
          var n = [];
          for (var i in t) n.push(i);
          return n;
        }, e.encryptionString = function(t, n) {
          for (var i = [], s = 0; s < t.length; s++) {
            var u = t.charCodeAt(s) ^ n.charCodeAt(s % n.length);
            i.push(String.fromCharCode(u));
          }
          return i.join("");
        }, e.encryptionBytes = function(t, n) {
          for (var i = new Uint8Array(t.length), s = 0; s < t.length; s++)
            i[s] = t[s] ^ n.charCodeAt(s % n.length);
          return i;
        }, e.parseJwt = function(t) {
          var n = t.replace(/-/g, "+").replace(/_/g, "/"), i = decodeURIComponent(
            window.atob(n).split("").map(function(s) {
              return "%" + ("00" + s.charCodeAt(0).toString(16)).slice(-2);
            }).join("")
          );
          return JSON.parse(i);
        }, e.calculateMeanTimeDeltasBetweenEvents = function(t) {
          var n = 0;
          if ((t == null ? void 0 : t.length) > 1) {
            for (var i = t[0].epochTs, s = 1; s < t.length; s++)
              n += t[s].epochTs - i, i = t[s].epochTs;
            n /= t.length - 1;
          }
          return n;
        }, e.sortEventsByTimestamp = function(t) {
          return t.sort(function(n, i) {
            return n.eventTs > i.eventTs ? 1 : n.eventTs < i.eventTs ? -1 : n.epochTs > i.epochTs ? 1 : n.epochTs < i.epochTs ? -1 : n.type === "click" ? 1 : -1;
          });
        }, e.distanceBetweenPoints = function(t, n) {
          return Math.sqrt(Math.pow(t.getX() - n.getX(), 2) + Math.pow(t.getY() - n.getY(), 2));
        }, e.calculateMeanDistanceBetweenPoints = function(t) {
          var n = 0;
          if ((t == null ? void 0 : t.length) > 1) {
            for (var i = 1; i < t.length; i++) n += e.distanceBetweenPoints(t[i - 1], t[i]);
            n /= t.length - 1;
          }
          return n;
        }, e.filterArrayByLength = function(t, n) {
          return t.length <= n ? t : t.slice(0, n).concat(t[t.length - 1]);
        }, e.keepFirstEventsWithDistance = function(t) {
          var n = t.events, i = t.threshold, s = t.min, u = t.max;
          if (n.length <= s) return n;
          var h, l = n[0];
          for (h = 1; h < n.length && h < u && !(Math.max(Math.abs(n[h].getX() - l.getX()), Math.abs(n[h].getY() - l.getY())) >= i); h++)
            ;
          return n.slice(0, Math.max(h + 1, s));
        }, e.ab2str = function(t) {
          return String.fromCharCode.apply(null, new Uint8Array(t));
        }, e.str2ab = function(t) {
          for (var n = new ArrayBuffer(t.length), i = new Uint8Array(n), s = 0, u = t.length; s < u; s++)
            i[s] = t.charCodeAt(s);
          return n;
        }, e.encode = function(t) {
          var n = JSON.stringify(t), i = new TextEncoder().encode(n), s = e.base64Uint8Array(i);
          return e.base64url(s);
        }, e.base64url = function(t) {
          return t.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
        }, e.hashCache = /* @__PURE__ */ new Map(), e.keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", e;
      }();
      c.Util = r;
    })(a._POSignalsUtils || (a._POSignalsUtils = {}));
  }(X || (X = {})), Me = function(a, c, r, e) {
    return new (r || (r = Promise))(function(t, n) {
      function i(h) {
        try {
          u(e.next(h));
        } catch (l) {
          n(l);
        }
      }
      function s(h) {
        try {
          u(e.throw(h));
        } catch (l) {
          n(l);
        }
      }
      function u(h) {
        var l;
        h.done ? t(h.value) : (l = h.value, l instanceof r ? l : new r(function(d) {
          d(l);
        })).then(i, s);
      }
      u((e = e.apply(a, c || [])).next());
    });
  }, Re = function(a, c) {
    var r, e, t, n, i = {
      label: 0,
      sent: function() {
        if (1 & t[0]) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    };
    return n = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (n[Symbol.iterator] = function() {
      return this;
    }), n;
    function s(u) {
      return function(h) {
        return function(l) {
          if (r) throw new TypeError("Generator is already executing.");
          for (; i; )
            try {
              if (r = 1, e && (t = 2 & l[0] ? e.return : l[0] ? e.throw || ((t = e.return) && t.call(e), 0) : e.next) && !(t = t.call(e, l[1])).done)
                return t;
              switch (e = 0, t && (l = [2 & l[0], t.value]), l[0]) {
                case 0:
                case 1:
                  t = l;
                  break;
                case 4:
                  return i.label++, { value: l[1], done: !1 };
                case 5:
                  i.label++, e = l[1], l = [0];
                  continue;
                case 7:
                  l = i.ops.pop(), i.trys.pop();
                  continue;
                default:
                  if (!(t = (t = i.trys).length > 0 && t[t.length - 1]) && (l[0] === 6 || l[0] === 2)) {
                    i = 0;
                    continue;
                  }
                  if (l[0] === 3 && (!t || l[1] > t[0] && l[1] < t[3])) {
                    i.label = l[1];
                    break;
                  }
                  if (l[0] === 6 && i.label < t[1]) {
                    i.label = t[1], t = l;
                    break;
                  }
                  if (t && i.label < t[2]) {
                    i.label = t[2], i.ops.push(l);
                    break;
                  }
                  t[2] && i.ops.pop(), i.trys.pop();
                  continue;
              }
              l = c.call(a, i);
            } catch (d) {
              l = [6, d], e = 0;
            } finally {
              r = t = 0;
            }
          if (5 & l[0]) throw l[1];
          return { value: l[0] ? l[1] : void 0, done: !0 };
        }([u, h]);
      };
    }
  }, function(a) {
    var c = a.openDB;
    (function(r) {
      var e = function() {
        function t() {
        }
        return t.initDB = function() {
          return Me(this, void 0, void 0, function() {
            var n, i = this;
            return Re(this, function(s) {
              if (!(window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB))
                throw new Error("IndexedDB is not supported");
              return n = new t(), [
                2,
                new Promise(function(u) {
                  return Me(i, void 0, void 0, function() {
                    var h;
                    return Re(this, function(l) {
                      switch (l.label) {
                        case 0:
                          return h = n, [
                            4,
                            c(this._PingDBName, t._version, {
                              upgrade: function(d, p, y, k, Q) {
                                d.createObjectStore(t._storeDefaultName);
                              }
                            })
                          ];
                        case 1:
                          return h.indexedDatabase = l.sent(), u(n), [2];
                      }
                    });
                  });
                })
              ];
            });
          });
        }, t.prototype.close = function() {
          this.indexedDatabase.close();
        }, t.prototype.getValue = function(n) {
          return this.indexedDatabase.get(t._storeDefaultName, n);
        }, t.prototype.setValue = function(n, i) {
          return this.indexedDatabase.put(t._storeDefaultName, i, n);
        }, t._PingDBName = "Ping", t._version = 1, t._storeDefaultName = "PING_ONE", t;
      }();
      r.IndexedDBStorage = e;
    })(a._POSignalsStorage || (a._POSignalsStorage = {}));
  }(X || (X = {})), function(a) {
    (function(c) {
      var r = function() {
        function t(n, i) {
          this.crossStorageClient = new a.CrossStorageClient(n, i);
        }
        return t.prototype.get = function(n) {
          var i = a._POSignalsUtils.Util.hash(n);
          return this.crossStorageClient.get(i);
        }, t.prototype.del = function(n) {
          return this.crossStorageClient.del(a._POSignalsUtils.Util.hash(n));
        }, t.prototype.set = function(n, i, s) {
          return this.crossStorageClient.set(a._POSignalsUtils.Util.hash(n), i, s);
        }, t.prototype.onConnect = function() {
          return this.crossStorageClient.onConnect();
        }, t.prototype.close = function(n) {
          return this.crossStorageClient.close(n);
        }, t.prototype.getSignedPayload = function(n, i) {
          return this.crossStorageClient.getSignedPayload(n, i);
        }, t.prototype.getDeviceDetails = function(n) {
          var i = a._POSignalsUtils.Util.hash(n);
          return this.crossStorageClient.getDeviceDetails(i);
        }, t.prototype.setDeviceDetails = function(n, i) {
          var s = a._POSignalsUtils.Util.hash(n);
          return this.crossStorageClient.setDeviceDetails(s, i);
        }, t;
      }();
      c.CrossStorage = r;
      var e = function() {
        function t(n) {
          this.storage = n;
        }
        return t.prototype.get = function(n) {
          return Promise.resolve(this.storage.getItem(n));
        }, t.prototype.del = function(n) {
          return this.storage.removeItem(n), Promise.resolve();
        }, t.prototype.set = function(n, i) {
          return this.storage.setItem(n, i), Promise.resolve();
        }, t.prototype.onConnect = function() {
          return Promise.resolve();
        }, t.prototype.close = function(n) {
          return Promise.resolve();
        }, t.prototype.getSignedPayload = function(n, i) {
          return Promise.resolve([]);
        }, t.prototype.getDeviceDetails = function(n) {
          return Promise.resolve([]);
        }, t.prototype.setDeviceDetails = function(n, i) {
          return Promise.resolve([]);
        }, t;
      }();
      c.CrossStorageFallback = e;
    })(a._POSignalsStorage || (a._POSignalsStorage = {}));
  }(X || (X = {})), function(a) {
    var c = function() {
      function r(e, t, n) {
        this.deviceId = e, this.dbStorage = t, this.cryptoHandler = n;
      }
      return r.prototype.getExportedPublicKey = function() {
        return Me(this, void 0, void 0, function() {
          var e, t;
          return Re(this, function(n) {
            switch (n.label) {
              case 0:
                return this.cachedPublicKey ? [3, 3] : [4, this.getDeviceKeys()];
              case 1:
                return (e = n.sent()) ? (t = this, [4, this.cryptoHandler.exportPublicKey(e)]) : [3, 3];
              case 2:
                t.cachedPublicKey = n.sent(), n.label = 3;
              case 3:
                return a._POSignalsUtils.Logger.info("Exported public key:", this.cachedPublicKey), [2, this.cachedPublicKey];
            }
          });
        });
      }, r.prototype.setDeviceKeys = function(e) {
        return Me(this, void 0, void 0, function() {
          var t;
          return Re(this, function(n) {
            switch (n.label) {
              case 0:
                return [4, this.dbStorage.setValue(this.deviceId, e)];
              case 1:
                return t = n.sent(), this.cachedDeviceKey = e, [2, t];
            }
          });
        });
      }, r.prototype.associateDeviceKeys = function() {
        return Me(this, void 0, void 0, function() {
          var e;
          return Re(this, function(t) {
            switch (t.label) {
              case 0:
                return [4, this.cryptoHandler.generateKeys()];
              case 1:
                return e = t.sent(), a._POSignalsUtils.Logger.info("Associating new device domain keys"), [4, this.setDeviceKeys(e)];
              case 2:
                return t.sent(), [2, e];
            }
          });
        });
      }, r.prototype.getDeviceKeys = function() {
        return Me(this, void 0, void 0, function() {
          var e;
          return Re(this, function(t) {
            switch (t.label) {
              case 0:
                return this.cachedDeviceKey ? [3, 2] : (e = this, [4, this.dbStorage.getValue(this.deviceId)]);
              case 1:
                e.cachedDeviceKey = t.sent(), t.label = 2;
              case 2:
                return [2, this.cachedDeviceKey];
            }
          });
        });
      }, r.prototype.signDeviceAttributeWithJWT = function(e, t, n) {
        return Me(this, void 0, void 0, function() {
          var i, s, u;
          return Re(this, function(h) {
            switch (h.label) {
              case 0:
                return s = (i = this.cryptoHandler).signJWT, u = [e], [4, this.getDeviceKeys()];
              case 1:
                return [4, s.apply(i, u.concat([h.sent(), r._default_salt, t, n]))];
              case 2:
                return [2, h.sent()];
            }
          });
        });
      }, r.prototype.verifyJWT = function(e) {
        return Me(this, void 0, void 0, function() {
          var t, n, i;
          return Re(this, function(s) {
            switch (s.label) {
              case 0:
                return n = (t = this.cryptoHandler).verifyJwtToken, i = [e], [4, this.getDeviceKeys()];
              case 1:
                return [2, n.apply(t, i.concat([s.sent().publicKey]))];
            }
          });
        });
      }, r._default_salt = 32, r;
    }();
    a.DeviceKeys = c;
  }(X || (X = {})), function(a) {
    (function(c) {
      var r = function() {
        function e() {
          this._disabledStorage = [], this.assertionValues = [
            "BROWSER_ENGINE_VERSION",
            "NAVIGATOR_LANGUAGE",
            "OS_NAME",
            "OS_VERSION",
            "NAVIGATOR_USER_AGENT",
            "FINGER_PRINT",
            "RESOLUTION",
            "PUSH_NOTIFICATIONS_SUPPORTED",
            "COOKIES_ENABLED",
            "IS_INCOGNITO",
            "IS_PRIVATE_MODE"
          ];
          try {
            window.sessionStorage.setItem("_st_storage_enabled_check", "test"), window.sessionStorage.removeItem("_st_storage_enabled_check"), this.signalsSessionStorage = window.sessionStorage;
          } catch {
            a._POSignalsUtils.Logger.warn("session storage disabled"), this._disabledStorage.push("sessionStorage"), this.signalsSessionStorage = new c.StorageFallback();
          }
          try {
            window.localStorage.setItem("_st_storage_enabled_check", "test"), window.localStorage.removeItem("_st_storage_enabled_check"), this.signalsLocalStorage = new c.StorageWrapper(window.localStorage);
          } catch {
            a._POSignalsUtils.Logger.warn("local storage disabled"), this._disabledStorage.push("localStorage"), this.signalsLocalStorage = new c.StorageWrapper(new c.StorageFallback()), this.crossStorage = new c.CrossStorageFallback(this.signalsLocalStorage);
          }
        }
        return e.prototype.setStorageConfig = function(t) {
          this.disableHub = !0, this.hubUrl = "", this.universalTrustEnabled = this.isConfigurationEnabled(
            t.universalDeviceIdentification
          ), this.agentIdentificationEnabled = this.isConfigurationEnabled(
            t.agentIdentification
          ), this.devEnv = t.devEnv, this.agentPort = t.agentPort, this.agentTimeout = t.agentTimeout, this.htmlGeoLocation = this.isConfigurationEnabled(t.htmlGeoLocation), this.isIAFDetectionEnabled = this.isConfigurationEnabled(t.isIAFDetectionEnabled);
        }, Object.defineProperty(e, "instance", {
          get: function() {
            return e._instance || (e._instance = new e()), e._instance;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "tabUUID", {
          get: function() {
            var t = this.signalsSessionStorage.getItem(
              a._POSignalsUtils.Constants.TAB_UUID_KEY
            );
            return t || (t = a._POSignalsUtils.Util.newGuid(), this.signalsSessionStorage.setItem(
              a._POSignalsUtils.Constants.TAB_UUID_KEY,
              t
            )), t;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "ops", {
          get: function() {
            var t = Number(
              this.signalsSessionStorage.getItem(a._POSignalsUtils.Constants.OPS_KEY)
            );
            return isNaN(t) ? null : t;
          },
          set: function(t) {
            t ? this.signalsSessionStorage.setItem(
              a._POSignalsUtils.Constants.OPS_KEY,
              t.toString()
            ) : this.signalsSessionStorage.removeItem(a._POSignalsUtils.Constants.OPS_KEY);
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "disabledStorage", {
          get: function() {
            return this._disabledStorage;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "sessionStorage", {
          get: function() {
            return this.signalsSessionStorage;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(e.prototype, "localStorage", {
          get: function() {
            return this.signalsLocalStorage;
          },
          enumerable: !1,
          configurable: !0
        }), e.prototype.initDeviceIdentity = function() {
          return Me(this, void 0, void 0, function() {
            var t, n, i, s;
            return Re(this, function(u) {
              switch (u.label) {
                case 0:
                  return n = this.signalsLocalStorage.getItem(
                    a._POSignalsUtils.Constants.DEVICE_ID_KEY
                  ), i = this.signalsLocalStorage.getItem(
                    a._POSignalsUtils.Constants.DEVICE_ID_CREATED_AT
                  ), n && (this.cachedDeviceId = n), this.universalTrustEnabled ? (this.deviceTrust = { attestation: {}, dtts: (/* @__PURE__ */ new Date()).getTime() }, s = this, [4, c.IndexedDBStorage.initDB()]) : [3, 3];
                case 1:
                  return s.indexedDBStorage = u.sent(), [4, this.loadLocalDeviceTrust()];
                case 2:
                  t = u.sent(), u.label = 3;
                case 3:
                  return this.disableHub || n && !this.shouldFallbackToP1Key(t) ? [3, 5] : [4, this.fallbackToCrossStorage(this.hubUrl)];
                case 4:
                  return u.sent(), [3, 6];
                case 5:
                  this.crossStorage = new c.CrossStorageFallback(this.signalsLocalStorage), u.label = 6;
                case 6:
                  return this.getDeviceId() ? [3, 8] : [4, this.associateDeviceDetails(this.disableHub)];
                case 7:
                  u.sent(), u.label = 8;
                case 8:
                  return i || this.signalsLocalStorage.setItem(
                    a._POSignalsUtils.Constants.DEVICE_ID_CREATED_AT,
                    Date.now()
                  ), !this.universalTrustEnabled || this.getDeviceId() && t ? [3, 10] : [4, this.createDomainKeys(this.disableHub)];
                case 9:
                  u.sent(), u.label = 10;
                case 10:
                  return [2, this.getDeviceId()];
              }
            });
          });
        }, e.prototype.shouldFallbackToP1Key = function(t) {
          return this.universalTrustEnabled && !this.disableHub && (!t || this.isRefreshRequired(this.deviceKeyRsyncIntervals));
        }, e.prototype.isRefreshRequired = function(t) {
          if (t === void 0 && (t = 3), !this.deviceTrust.dtts) return !0;
          var n = this.signalsLocalStorage.getItem(
            a._POSignalsUtils.Constants.LAST_DEVICE_KEY_RESYNC
          );
          if (!n || isNaN(parseInt(n))) return !0;
          var i = this.deviceTrust.dtts - n > 864e5 * t;
          return i && a._POSignalsUtils.Logger.debug("Refresh required"), i;
        }, e.prototype.loadLocalDeviceTrust = function() {
          return Me(this, void 0, void 0, function() {
            var t, n;
            return Re(this, function(i) {
              switch (i.label) {
                case 0:
                  return i.trys.push([0, 4, , 5]), this.cachedDeviceId ? this.cachedDeviceId ? (this.domainDeviceKeys = new a.DeviceKeys(
                    this.getDeviceId(),
                    this.indexedDBStorage,
                    new a._POSignalsUtils.CryptoOperator()
                  ), [4, this.domainDeviceKeys.getDeviceKeys()]) : [3, 3] : (a._POSignalsUtils.Logger.debug(
                    "No device id found on customer domain"
                  ), [2, !1]);
                case 1:
                  return i.sent() ? (t = this.deviceTrust.attestation, [4, this.domainDeviceKeys.getExportedPublicKey()]) : (a._POSignalsUtils.Logger.debug(
                    "No device keys found on customer domain"
                  ), [2, !1]);
                case 2:
                  return t.deviceKey = i.sent(), this.crossStorage = new c.CrossStorageFallback(this.signalsLocalStorage), [2, !0];
                case 3:
                  return [3, 5];
                case 4:
                  return n = i.sent(), a._POSignalsUtils.Logger.error("Domain PKI initialization failed", n), [2, !1];
                case 5:
                  return [2];
              }
            });
          });
        }, e.prototype.createDomainKeys = function(t) {
          return Me(this, void 0, void 0, function() {
            var n, i;
            return Re(this, function(s) {
              switch (s.label) {
                case 0:
                  return s.trys.push([0, 3, , 4]), !t && this._disabledStorage.lastIndexOf("hub") > -1 ? (a._POSignalsUtils.Logger.debug(
                    "Hub unavailable - skipping domain trust creation"
                  ), [2]) : (this.domainDeviceKeys = new a.DeviceKeys(
                    this.getDeviceId(),
                    this.indexedDBStorage,
                    new a._POSignalsUtils.CryptoOperator()
                  ), [4, this.domainDeviceKeys.associateDeviceKeys()]);
                case 1:
                  return s.sent(), n = this.deviceTrust.attestation, [4, this.domainDeviceKeys.getExportedPublicKey()];
                case 2:
                  return n.deviceKey = s.sent(), [3, 4];
                case 3:
                  return i = s.sent(), a._POSignalsUtils.Logger.error("Domain PKI initialization failed", i), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }, e.prototype.getDeviceId = function() {
          return this.cachedDeviceId;
        }, e.prototype.getDeviceCreatedAt = function() {
          return this.signalsLocalStorage.getItem(
            a._POSignalsUtils.Constants.DEVICE_ID_CREATED_AT
          );
        }, e.prototype.associateDeviceDetails = function(t) {
          var n, i;
          return Me(this, void 0, void 0, function() {
            var s;
            return Re(this, function(u) {
              switch (u.label) {
                case 0:
                  return a._POSignalsUtils.Logger.debug("Associating fresh device details"), this.cachedDeviceId = "Id-" + a._POSignalsUtils.Util.newGuid(), this.signalsLocalStorage.setItem(
                    a._POSignalsUtils.Constants.DEVICE_ID_KEY,
                    this.cachedDeviceId
                  ), this.signalsLocalStorage.setItem(
                    a._POSignalsUtils.Constants.DEVICE_ID_CREATED_AT,
                    Date.now()
                  ), t ? [3, 4] : this.universalTrustEnabled ? (s = this.deviceTrust.attestation, [
                    4,
                    this.crossStorage.setDeviceDetails(
                      a._POSignalsUtils.Constants.DEVICE_ID_KEY,
                      this.cachedDeviceId
                    )
                  ]) : [3, 2];
                case 1:
                  return s.fallbackDeviceKey = u.sent()[0], [3, 4];
                case 2:
                  return [
                    4,
                    this.crossStorage.set(
                      a._POSignalsUtils.Constants.DEVICE_ID_KEY,
                      this.cachedDeviceId
                    )
                  ];
                case 3:
                  u.sent(), u.label = 4;
                case 4:
                  return a._POSignalsUtils.Logger.debug(
                    "PingOne Signals deviceId: " + this.cachedDeviceId
                  ), [
                    2,
                    [
                      this.cachedDeviceId,
                      (i = (n = this.deviceTrust) === null || n === void 0 ? void 0 : n.attestation) === null || i === void 0 ? void 0 : i.fallbackDeviceKey
                    ]
                  ];
              }
            });
          });
        }, e.prototype.closeTrustStore = function() {
          try {
            this.crossStorage.close(this.devEnv), this.indexedDBStorage && this.indexedDBStorage.close();
          } catch (t) {
            a._POSignalsUtils.Logger.info("Unable to close trust store:", t);
          }
        }, e.prototype.fallbackToCrossStorage = function(t) {
          return Me(this, void 0, void 0, function() {
            var n;
            return Re(this, function(i) {
              switch (i.label) {
                case 0:
                  a._POSignalsUtils.Logger.debug(
                    "PingOne Signals cross storage is required, initializing"
                  ), i.label = 1;
                case 1:
                  return i.trys.push([1, 3, , 4]), [4, this.initCrossStorage(t)];
                case 2:
                  return i.sent(), a._POSignalsUtils.Logger.info("PingOne Signals cross storage initiated"), [3, 4];
                case 3:
                  return n = i.sent(), a._POSignalsUtils.Logger.warn(
                    "PingOne Signals Session crossStorage failed to connect " + n
                  ), this._disabledStorage.push("hub"), this.crossStorage = new c.CrossStorageFallback(this.signalsLocalStorage), [3, 4];
                case 4:
                  return [2];
              }
            });
          });
        }, e.prototype.initCrossStorage = function(t) {
          return Me(this, void 0, void 0, function() {
            var n, i, s, u, h;
            return Re(this, function(l) {
              switch (l.label) {
                case 0:
                  return n = this.universalTrustEnabled ? "1.0.7" : "1.0.1", i = "https://apps.pingone.com/signals/web-sdk/hub-" + n + "/hub.html", (s = ((t == null ? void 0 : t.trim()) || i).replace(
                    /\/$/,
                    ""
                  )).endsWith("html") || (s += "/hub.html"), this.crossStorage = new c.CrossStorage(s, { timeout: 2e3 }), [4, this.crossStorage.onConnect()];
                case 1:
                  return l.sent(), this.universalTrustEnabled ? [
                    4,
                    this.crossStorage.getDeviceDetails(
                      a._POSignalsUtils.Constants.DEVICE_ID_KEY
                    )
                  ] : [3, 3];
                case 2:
                  return u = l.sent(), this.cachedDeviceId = u[0], [3, 5];
                case 3:
                  return h = this, [4, this.crossStorage.get(a._POSignalsUtils.Constants.DEVICE_ID_KEY)];
                case 4:
                  h.cachedDeviceId = l.sent(), l.label = 5;
                case 5:
                  return this.cachedDeviceId ? this.signalsLocalStorage.setItem(
                    a._POSignalsUtils.Constants.DEVICE_ID_KEY,
                    this.cachedDeviceId
                  ) : a._POSignalsUtils.Logger.info("no device id from hub"), this.universalTrustEnabled && (u && u[1] ? (this.deviceTrust.attestation.fallbackDeviceKey = u[1], a._POSignalsUtils.Logger.info(
                    "Using fallback device keys from hub " + this.deviceTrust.attestation.fallbackDeviceKey
                  )) : a._POSignalsUtils.Logger.info("failed to use any device keys")), [2];
              }
            });
          });
        }, e.prototype.isConfigurationEnabled = function(t) {
          return t != null && (typeof t == "boolean" ? t : typeof t == "string" && t.toLowerCase() === "true");
        }, e.prototype.signJWTChallenge = function(t, n, i) {
          return Me(this, void 0, void 0, function() {
            return Re(this, function(s) {
              return [2, this.domainDeviceKeys.signDeviceAttributeWithJWT(t, n, i)];
            });
          });
        }, e.prototype.getGeoSessionData = function() {
          var t = this.signalsSessionStorage.getItem(a._POSignalsUtils.Constants.GeoDataKey);
          return t ?? null;
        }, e;
      }();
      c.SessionStorage = r;
    })(a._POSignalsStorage || (a._POSignalsStorage = {}));
  }(X || (X = {})), function(a) {
    (function(c) {
      var r = function() {
        function t(n) {
          this.storage = n;
        }
        return t.prototype.getItem = function(n) {
          var i = a._POSignalsUtils.Util.hash(n), s = this.storage.getItem(i);
          return s || (s = this.storage.getItem(n)) && (this.storage.setItem(i, s), this.storage.removeItem(n)), s;
        }, t.prototype.removeItem = function(n) {
          return this.storage.removeItem(a._POSignalsUtils.Util.hash(n));
        }, t.prototype.setItem = function(n, i) {
          return this.storage.setItem(a._POSignalsUtils.Util.hash(n), i);
        }, t;
      }();
      c.StorageWrapper = r;
      var e = function() {
        function t() {
          this.internalStorageMap = /* @__PURE__ */ new Map();
        }
        return t.prototype.getItem = function(n) {
          return this.internalStorageMap.get(n);
        }, t.prototype.removeItem = function(n) {
          this.internalStorageMap.delete(n);
        }, t.prototype.setItem = function(n, i) {
          this.internalStorageMap.set(n, i);
        }, t;
      }();
      c.StorageFallback = e;
    })(a._POSignalsStorage || (a._POSignalsStorage = {}));
  }(X || (X = {}));
  var Ht = Ue;
  (function(a, c) {
    for (var r = 1064, e = 803, t = 1147, n = 748, i = 753, s = 720, u = 1245, h = Ue, l = pn(); ; )
      try {
        if (-parseInt(h(r)) / 1 + -parseInt(h(715)) / 2 + -parseInt(h(1241)) / 3 * (-parseInt(h(652)) / 4) + -parseInt(h(868)) / 5 * (parseInt(h(e)) / 6) + parseInt(h(t)) / 7 * (-parseInt(h(n)) / 8) + -parseInt(h(i)) / 9 * (-parseInt(h(s)) / 10) + -parseInt(h(u)) / 11 === 328021)
          break;
        l.push(l.shift());
      } catch {
        l.push(l.shift());
      }
  })(), Ct = function() {
    var a = 601, c = 816, r = Ht;
    return (Ct = Object[r(1188)] || function(e) {
      for (var t, n = r, i = 1, s = arguments[n(a)]; i < s; i++)
        for (var u in t = arguments[i]) Object[n(c)][n(1232)][n(675)](t, u) && (e[u] = t[u]);
      return e;
    })[r(1209)](this, arguments);
  }, Me = function(a, c, r, e) {
    var t = { _0x17e08c: 893 };
    return new (r || (r = Promise))(function(n, i) {
      var s = Ue;
      function u(d) {
        var p = Ue;
        try {
          l(e[p(704)](d));
        } catch (y) {
          i(y);
        }
      }
      function h(d) {
        try {
          l(e.throw(d));
        } catch (p) {
          i(p);
        }
      }
      function l(d) {
        var p, y = Ue;
        d.done ? n(d[y(809)]) : (p = d.value, p instanceof r ? p : new r(function(k) {
          k(p);
        }))[y(t._0x17e08c)](u, h);
      }
      l((e = e[s(1209)](a, c || []))[s(704)]());
    });
  }, Re = function(a, c) {
    var r, e, t, n, i = {
      _0x180a2e: 852,
      _0x654500: 704,
      _0x35e1a5: 675,
      _0x2178ca: 968,
      _0x1d2c43: 699,
      _0x23a91f: 766,
      _0x1a8942: 737,
      _0x585542: 601,
      _0x846770: 1161,
      _0x35b40c: 737
    }, s = Ht, u = {
      label: 0,
      sent: function() {
        if (1 & t[0]) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    };
    return n = { next: h(0), throw: h(1), return: h(2) }, typeof Symbol === s(974) && (n[Symbol.iterator] = function() {
      return this;
    }), n;
    function h(l) {
      return function(d) {
        return function(p) {
          var y = s;
          if (r) throw new TypeError("Generator is already executing.");
          for (; u; )
            try {
              if (r = 1, e && (t = 2 & p[0] ? e.return : p[0] ? e[y(905)] || ((t = e[y(i._0x180a2e)]) && t.call(e), 0) : e[y(i._0x654500)]) && !(t = t[y(i._0x35e1a5)](e, p[1]))[y(805)])
                return t;
              switch (e = 0, t && (p = [2 & p[0], t.value]), p[0]) {
                case 0:
                case 1:
                  t = p;
                  break;
                case 4:
                  return u[y(i._0x2178ca)]++, { value: p[1], done: !1 };
                case 5:
                  u[y(968)]++, e = p[1], p = [0];
                  continue;
                case 7:
                  p = u[y(i._0x1d2c43)][y(i._0x23a91f)](), u.trys[y(766)]();
                  continue;
                default:
                  if (!(t = (t = u[y(i._0x1a8942)])[y(i._0x585542)] > 0 && t[t[y(601)] - 1]) && (p[0] === 6 || p[0] === 2)) {
                    u = 0;
                    continue;
                  }
                  if (p[0] === 3 && (!t || p[1] > t[0] && p[1] < t[3])) {
                    u[y(968)] = p[1];
                    break;
                  }
                  if (p[0] === 6 && u[y(968)] < t[1]) {
                    u[y(i._0x2178ca)] = t[1], t = p;
                    break;
                  }
                  if (t && u[y(968)] < t[2]) {
                    u.label = t[2], u[y(699)][y(i._0x846770)](p);
                    break;
                  }
                  t[2] && u[y(i._0x1d2c43)].pop(), u[y(i._0x35b40c)].pop();
                  continue;
              }
              p = c.call(a, u);
            } catch (k) {
              p = [6, k], e = 0;
            } finally {
              r = t = 0;
            }
          if (5 & p[0]) throw p[1];
          return { value: p[0] ? p[1] : void 0, done: !0 };
        }([l, d]);
      };
    }
  };
  var fn = function() {
    for (var a = Ht, c = 0, r = 0, e = arguments[a(601)]; r < e; r++)
      c += arguments[r].length;
    var t = Array(c), n = 0;
    for (r = 0; r < e; r++)
      for (var i = arguments[r], s = 0, u = i[a(601)]; s < u; s++, n++) t[n] = i[s];
    return t;
  };
  (function(a) {
    var c = 709, r = 816, e = 756, t = 816, n = 813, i = 1262, s = 750, u = 1163, h = 1098, l = 816, d = 596, p = 816, y = 1197, k = 547, Q = 816, m = 1295, _ = 1334, w = 659, A = 816, U = 1043, pe = 691, D = 602, W = Ht;
    (function(P) {
      var N = 900, H = 1145, j = 599, K = 815, ae = 1043, ce = 886, ee = 526, re = 991, F = 929, M = 745, le = 996, G = 1160, te = 1185, me = 1019, Te = 776, Xe = 1019, Ke = 981, He = 708, Ae = 982, Ee = {
        _0x43ccf4: 982,
        _0x168bc9: 1125,
        _0x999568: 646,
        _0x356ce9: 572,
        _0x986a95: 1321,
        _0x215d28: 710,
        _0x3a661b: 1174,
        _0xb9732d: 1182,
        _0x688888: 863,
        _0x2f97f2: 611,
        _0x5cfaa9: 854,
        _0x41c264: 946,
        _0x121c2f: 1148,
        _0x5ce79b: 692,
        _0x630a2e: 1180,
        _0x52c419: 934,
        _0xe785b8: 655,
        _0x28bde2: 712,
        _0x3be455: 1301,
        _0x3b90b6: 917,
        _0x51ad63: 921,
        _0x5134e2: 502,
        _0xb56e9: 1005,
        _0x5a9bc0: 509,
        _0x29b917: 1275,
        _0xa2e74: 1026,
        _0x4254d: 614,
        _0x44f51a: 1078,
        _0x19272b: 1035,
        _0x257ce9: 1281
      }, Be = function() {
        var qe = 550, Je = 525, vt = 1067, rt = 1265, lt = 684, o = 1078, I = 589, O = 1023, f = 676, B = 1160, se = 1160, de = 1146, J = 954, Le = 478, Ce = 1151, Qe = 1160, dt = 587, St = 927, bt = 979, yt = 1086, tt = 878, be = 815, Pe = 948, he = 1117, Ge = 796, _e = 1160, ze = 851, ot = 1232, $e = 639, et = 1160, gt = 807, Pt = 1085, Rt = 522, ht = 778, Tt = 596, fe = 1326, oe = 1074, pt = 1004, _t = 1121, je = 841, Ut = 815, Kt = 526, xe = Ue;
        function ft(x, ye, S, Oe) {
          var V = Ue;
          this[V(Ee._0x43ccf4)] = x, this[V(636)] = ye, this.externalIdentifiers = S, this[V(701)] = Oe, this[V(Ee._0x168bc9)] = null, this[V(Ee._0x999568)] = null, this[V(1117)] = null, this[V(557)] = null, this[V(1179)] = null, this[V(1266)] = null, this[V(Ee._0x356ce9)] = null, this[V(Ee._0x986a95)] = null, this[V(1298)] = null, this[V(985)] = null, this.headlessTests = /* @__PURE__ */ new Map(), this.lieTests = {}, this[V(Ee._0x215d28)] = null, this[V(Ee._0x3a661b)] = /* @__PURE__ */ new Set([
            V(1226),
            "architecture",
            V(830),
            V(725),
            V(Ee._0xb9732d),
            V(Ee._0x688888),
            V(677),
            V(Ee._0x2f97f2),
            V(Ee._0x5cfaa9),
            V(683),
            V(Ee._0x41c264),
            V(Ee._0x121c2f),
            V(1172),
            "fontPreferences",
            V(1031),
            V(Ee._0x5ce79b),
            "hardwareConcurrency",
            V(918),
            V(496),
            V(Ee._0x630a2e),
            V(590),
            V(Ee._0x52c419),
            V(Ee._0xe785b8),
            "openDatabase",
            V(Ee._0x28bde2),
            "pdfViewerEnabled",
            V(622),
            V(Ee._0x3be455),
            "privateClickMeasurement",
            "reducedMotion",
            V(1051),
            V(Ee._0x3b90b6),
            V(779),
            V(Ee._0x51ad63),
            V(752),
            "touchSupport",
            V(799),
            V(1123),
            V(Ee._0x5134e2)
          ]), this[V(Ee._0xb56e9)] = -1, this[V(Ee._0x5a9bc0)] = 0, this[V(Ee._0x29b917)] = 0, this[V(Ee._0xa2e74)] = [], this.audioInputDevices = [], this[V(Ee._0x4254d)] = [], this[V(919)] = /* @__PURE__ */ new Map(), this[V(Ee._0x44f51a)] = null, this[V(1001)] = null, this[V(695)] = 0, this[V(Ee._0x19272b)] = new a[V(Ee._0x257ce9)](1), this[V(942)] = null, this[V(684)] = null;
        }
        return Object.defineProperty(ft[xe(816)], xe(872), {
          get: function() {
            var x = xe;
            if (!this.metadataParams[x(Ke)][x(He)]) return 0;
            var ye = this[x(982)][x(699)];
            return !ye && (ye = this.getOps(), this[x(Ae)].ops = ye), ye;
          },
          enumerable: !1,
          configurable: !0
        }), ft[xe(816)][xe(e)] = function() {
          var x = 1035;
          return Me(this, void 0, void 0, function() {
            var ye = this;
            return Re(this, function(S) {
              return [
                2,
                this[Ue(x)].add(function() {
                  var Oe = 968, V = 1163, ve = 1023, we = 1225, Ne = 599, g = 1023, b = 833, E = 646, T = 968, R = 601, $ = 818, ie = 1324, z = 601, C = 548, Y = 813, q = 643, ne = 602, ue = 1167, Se = 942, De = 1078;
                  return Me(ye, void 0, void 0, function() {
                    var Ve, Ie;
                    return Re(this, function(Fe) {
                      var ge = Ue;
                      switch (Fe[ge(Oe)]) {
                        case 0:
                          return this.lastCalculatedMetadata ? [3, 2] : (Ve = this, [4, this[ge(V)]()]);
                        case 1:
                          Ve.lastCalculatedMetadata = Fe[ge(1278)](), a._POSignalsUtils.Logger[ge(ve)](ge(we)), a[ge(815)][ge(Ne)][ge(g)](ge(561) + this[ge(1125)]), a[ge(815)].Logger[ge(1023)](ge(b) + this[ge(E)]), this[ge(982)].closeTrustStore(), Fe[ge(T)] = 2;
                        case 2:
                          return Ie = typeof window !== ge(727) && window[ge(1324)] && typeof window[ge(1324)][ge(R)] === ge($) ? window[ge(ie)][ge(z)] : null, this[ge(1078)] && (this[ge(1078)][ge(853)] = Ie), this.sessionData && this[ge(982)][ge(C)] ? [4, this[ge(Y)]()] : [3, 4];
                        case 3:
                          Fe[ge(1278)](), Fe.label = 4;
                        case 4:
                          return [4, this.refreshDeviceAttributes()];
                        case 5:
                          return Fe.sent(), this.sessionData && this[ge(982)][ge(q)] && this[ge(ne)](), this[ge(982)][ge(ue)] && (this[ge(Se)] = JSON.stringify(this[ge(De)])), [2, this.lastCalculatedMetadata];
                      }
                    });
                  });
                })
              ];
            });
          });
        }, ft[xe(t)][xe(n)] = function() {
          var x, ye, S, Oe, V = 1078, ve = 1006, we = 539, Ne = 831, g = 539, b = 641, E = 1270, T = 1278, R = 865, $ = 801, ie = 982, z = 1274, C = 1078, Y = 609, q = 1229, ne = 768, ue = 1078, Se = 1251, De = 1078, Ve = 1317, Ie = 626, Fe = 724, ge = 599, ut = 865, at = 1189;
          return Me(this, void 0, void 0, function() {
            var nt, it, kt, Vt, xt, Dt, Mt, Gt, It, qt = 953, Jt = 801, ke = 943, wt = 543, st = 521, on = 838, an = 899, $t = 1078, Nt = this;
            return Re(this, function(Wt) {
              var We = Ue;
              switch (Wt.label) {
                case 0:
                  return this[We(V)] = Ct(Ct({}, this.lastCalculatedMetadata), {
                    htmlGeoLocation_latitude: void 0,
                    htmlGeoLocation_longitude: void 0,
                    htmlGeoLocation_accuracy: void 0,
                    htmlGeoLocation_speed: void 0,
                    htmlGeoLocation_heading: void 0,
                    htmlGeoLocation_timestamp: void 0,
                    htmlGeoLocation_ErrorMessage: "",
                    htmlGeoLocation_ErrorCode: ""
                  }), nt = function(Bt, Ot) {
                    var jt = We;
                    Ot === void 0 && (Ot = "");
                    var zt = Bt.length > 255 ? Bt[jt(an)](0, 252) + jt(650) : Bt;
                    return Nt.lastCalculatedMetadata.htmlGeoLocation_ErrorMessage = zt, Nt[jt($t)].htmlGeoLocation_ErrorCode = Ot, { status: jt(690), message: zt };
                  }, it = function(Bt) {
                    var Ot = We;
                    switch (Bt) {
                      case 1:
                        return nt(Ot(qt), Ot(Jt));
                      case 2:
                        return nt(Ot(ke), Ot(838));
                      case 3:
                        return nt(Ot(wt), Ot(st));
                      default:
                        return nt(Ot(1252), Ot(on));
                    }
                  }, navigator[We(633)] ? (kt = this[We(1078)][We(492)][We(ve)](), Vt = kt[We(we)](We(Ne)), xt = kt[We(g)](We(891)), Dt = !1, [4, navigator[We(b)][We(E)]({ name: We(633) })]) : [2, nt(We(1175), We(1282))];
                case 1:
                  if (Mt = Wt[We(T)](), this[We(V)]["PERMISSIONS.geolocation"] = Mt[We(865)], Mt[We(865)] === We(635))
                    return [2, nt(We(1096) + Mt[We(R)] + " in browser '" + kt + "'.", We($))];
                  if (Gt = this[We(ie)][We(z)]())
                    try {
                      if ((It = JSON.parse(Gt)) && It[We(1319)] && It.longitude)
                        this[We(C)].htmlGeoLocation_latitude = It.latitude ? parseFloat(It[We(1319)][We(768)](2)) : null, this[We(C)][We(Y)] = It[We(1229)] ? parseFloat(It[We(q)][We(ne)](2)) : null, this.lastCalculatedMetadata.htmlGeoLocation_accuracy = (x = It[We(573)]) !== null && x !== void 0 ? x : null, this[We(ue)].htmlGeoLocation_speed = (ye = It[We(Se)]) !== null && ye !== void 0 ? ye : null, this[We(De)].htmlGeoLocation_heading = (S = It[We(999)]) !== null && S !== void 0 ? S : null, this[We(1078)][We(Ve)] = (Oe = It[We(Ie)]) !== null && Oe !== void 0 ? Oe : null, delete this[We(ue)][We(Fe)], delete this[We(1078)].htmlGeoLocation_ErrorCode, Dt = !0;
                      else if (It && It.error_code) return Dt = !1, [2, it(It[We(518)])];
                    } catch (Bt) {
                      a[We(815)][We(ge)][We(840)](We(523), Bt);
                    }
                  return Mt.state !== "granted" ? [3, 3] : [
                    4,
                    new Promise(function(Bt) {
                      var Ot = 932, jt = 1236, zt = 1319, en = 999, Z = 1078, tn = 768, gn = 768, sn = 546, mn = 724, bn = { timeout: 500 }, un = function(cn) {
                        cn === void 0 && (cn = 1), navigator.geolocation.getCurrentPosition(
                          function(Yt) {
                            var ln, At = Ue, Zt = Yt[At(jt)], nn = Zt[At(zt)], rn = Zt[At(1229)], yn = Zt.accuracy, _n = Zt.speed, dn = Zt[At(en)];
                            if ((!nn || !rn || nn === 0 || rn === 0) && (Vt || xt) && cn === 1)
                              return un(2);
                            Nt[At(Z)].htmlGeoLocation_latitude = nn ? parseFloat(nn[At(tn)](2)) : void 0, Nt[At(1078)][At(609)] = rn ? parseFloat(rn[At(gn)](2)) : void 0, Nt[At(1078)][At(sn)] = yn, Nt[At(1078)].htmlGeoLocation_speed = _n, Nt.lastCalculatedMetadata[At(741)] = dn, Nt[At(Z)].htmlGeoLocation_timestamp = (ln = Yt[At(626)]) !== null && ln !== void 0 ? ln : null, delete Nt[At(Z)][At(mn)], delete Nt[At(1078)][At(955)], Dt = !0, Bt({ status: "granted" });
                          },
                          function(Yt) {
                            Bt(it(Yt[Ue(Ot)])), Dt = !1;
                          },
                          bn
                        );
                      };
                      un();
                    })
                  ];
                case 2:
                  return [2, Wt[We(1278)]()];
                case 3:
                  return Dt ? [2] : [
                    2,
                    nt(
                      "Geolocation permission state is '" + Mt[We(ut)] + We(at) + kt + "'",
                      We(838)
                    )
                  ];
              }
            });
          });
        }, ft[xe(816)][xe(i)] = function() {
          return Me(this, void 0, void 0, function() {
            var x, ye = 750, S = 727, Oe = 1324, V = 1324;
            return Re(this, function(ve) {
              var we = Ue;
              switch (ve.label) {
                case 0:
                  return [4, this[we(ye)]()];
                case 1:
                  return ve[we(1278)](), x = typeof window !== we(S) && window[we(Oe)] && typeof window[we(V)].length === we(818) ? window[we(1324)][we(601)] : null, this[we(1078)] && (this[we(1078)].BROWSER_TAB_HISTORY_LENGTH = x), [2];
              }
            });
          });
        }, ft.prototype[xe(s)] = function() {
          return Me(this, void 0, void 0, function() {
            var x, ye, S, Oe, V = 686, ve = 1206, we = 603, Ne = 1078, g = 1104, b = 1078, E = 980;
            return Re(this, function(T) {
              var R = Ue;
              return x = 160, ye = window[R(898)] - window[R(V)] > x, S = window[R(508)] - window[R(ve)] > x, Oe = R(ye ? 581 : we), this[R(Ne)].devToolsOpen = R(ye || S ? 1250 : g), this[R(b)].devToolsOrientation = ye || S ? Oe : R(E), [2];
            });
          });
        }, ft[xe(816)][xe(679)] = function() {
          var x = 1077;
          return Me(this, void 0, void 0, function() {
            var ye = this;
            return Re(this, function(S) {
              var Oe = Ue;
              return [
                2,
                this.metadataQueue[Oe(x)](function() {
                  var V = 968, ve = 1154, we = 1001, Ne = 701, g = 1278;
                  return Me(ye, void 0, void 0, function() {
                    var b;
                    return Re(this, function(E) {
                      var T = Ue;
                      switch (E[T(V)]) {
                        case 0:
                          return this.localAgentJwtRequestCount >= 5 ? [2, this[T(1001)]] : this[T(982)][T(ve)] ? this[T(we)] ? [3, 2] : (b = this, [4, this[T(Ne)][T(1055)]()]) : [3, 3];
                        case 1:
                          b[T(we)] = E[T(g)](), E.label = 2;
                        case 2:
                          return this[T(695)]++, [2, this.localAgentJwt];
                        case 3:
                          return [2];
                      }
                    });
                  });
                })
              ];
            });
          });
        }, ft.prototype.getObfsInfo = function() {
          return { identifier: "x1", key: xe(538) };
        }, ft[xe(t)][xe(1015)] = function() {
          return this[xe(942)];
        }, ft[xe(816)][xe(u)] = function() {
          var x = 968, ye = 633, S = 636, Oe = 1169, V = 920, ve = 857, we = 1197, Ne = 559, g = 1337, b = 1071, E = 1125, T = 888, R = 644, $ = 646, ie = 845, z = 827, C = 1100, Y = 815, q = 1125, ne = 646, ue = 636, Se = 1326, De = 504, Ve = 1025, Ie = 1209, Fe = 552;
          return Me(this, void 0, void 0, function() {
            var ge, ut, at, nt, it, kt = 599, Vt = 815;
            return Re(this, function(xt) {
              var Dt = 840, Mt = 815, Gt = 599, It = 599, qt = 599, Jt = 1227, ke = Ue;
              switch (xt[ke(x)]) {
                case 0:
                  return this.gpsSupported = navigator[ke(ye)] != null, ge = this[ke(S)][ke(Oe)], ut = [
                    this[ke(982)][ke(V)]()[ke(ve)](function(wt) {
                      var st = ke;
                      a[st(Vt)].Logger.warn(st(612), wt);
                    }),
                    this[ke(we)](ge).catch(function(wt) {
                      var st = ke;
                      a._POSignalsUtils[st(qt)][st(840)](st(Jt), wt.message);
                    }),
                    this.getBroPrintFingerPrint().catch(function(wt) {
                      var st = ke;
                      a[st(815)][st(599)][st(840)](
                        "failed to get broJsFingerprint info",
                        wt[st(990)]
                      );
                    }),
                    P[ke(Ne)][ke(g)]().catch(function(wt) {
                      var st = ke;
                      return a[st(815)][st(It)].warn("failed to get private mode info", wt);
                    }),
                    this[ke(1295)]()[ke(857)](function(wt) {
                      var st = ke;
                      return a[st(Mt)][st(Gt)].warn("failed to get permissions info", wt);
                    }),
                    new P.DetectHeadless(ge).getHeadlessResults()[ke(ve)](function(wt) {
                      var st = ke;
                      return a[st(815)][st(599)].warn(st(971), wt);
                    }),
                    new P[ke(733)](ge)[ke(b)]()[ke(857)](function(wt) {
                      var st = ke;
                      return a._POSignalsUtils[st(kt)][st(840)](st(597), wt);
                    }),
                    this[ke(501)]()[ke(ve)](function(wt) {
                      var st = ke;
                      return a[st(815)][st(599)][st(840)]("failed to get audio-video info", wt);
                    }),
                    this[ke(1098)]().catch(function(wt) {
                      var st = ke;
                      return a[st(815)].Logger[st(Dt)]("failed to get battery info", wt);
                    })
                  ], [4, Promise.all(ut)];
                case 1:
                  return it = xt[ke(1278)](), this[ke(E)] = it[0], this[ke(640)] = it[1], this.broJsFingerprint = it[2], this[ke(T)] = it[3], this[ke(641)] = it[4], this[ke(765)] = it[5], this[ke(R)] = it[6], this[ke($)] = this.sessionData.getDeviceCreatedAt(), at = {
                    ops: this.OPS,
                    devicePixelRatio: window[ke(997)],
                    screenWidth: window.screen[ke(ie)],
                    screenHeight: window[ke(z)][ke(C)]
                  }, a[ke(Y)].Util.extendPrimitiveValues(at, screen, !1), nt = [
                    {
                      deviceId: this[ke(q)],
                      device_created_ts: this[ke(ne)],
                      deviceType: this[ke(ue)].browserInfo[ke(535)],
                      osVersion: (this[ke(636)][ke(981)][ke(894)] + " " + this[ke(ue)][ke(981)][ke(859)])[ke(Se)]() || "",
                      externalIdentifiers: this[ke(De)],
                      origin: location[ke(Ve)],
                      href: location[ke(1024)]
                    }
                  ], [4, this[ke(553)](ge)];
                case 2:
                  return [
                    2,
                    Ct[ke(1209)](void 0, [
                      Ct[ke(Ie)](void 0, [
                        Ct[ke(Ie)](void 0, [
                          Ct[ke(1209)](void 0, nt[ke(922)]([xt.sent()])),
                          this.getIoMetadata()
                        ]),
                        this[ke(Fe)]()
                      ]),
                      at
                    ])
                  ];
              }
            });
          });
        }, ft.prototype[xe(h)] = function() {
          return Me(this, void 0, void 0, function() {
            var x, ye = 1278, S = this;
            return Re(this, function(Oe) {
              var V = 815, ve = 599, we = 815, Ne = 669, g = 1298, b = 836, E = Ue;
              switch (Oe[E(968)]) {
                case 0:
                  return x = this, [
                    4,
                    a[E(815)][E(526)][E(1138)](
                      50,
                      new Promise(function(T, R) {
                        var $ = E;
                        navigator[$(889)] ? (S[$(1266)] = !0, navigator.getBattery()[$(893)](function(ie) {
                          var z = $;
                          ie && (x[z(572)] = ie[z(Ne)], x.batteryCharging = ie[z(1230)], x[z(g)] = ie[z(1247)], x[z(985)] = ie[z(b)]), T();
                        }).catch(function(ie) {
                          var z = $;
                          a[z(we)][z(599)][z(840)](z(1037) + ie), T();
                        })) : (a[$(V)][$(ve)][$(1202)]($(1135)), T());
                      })
                    )
                  ];
                case 1:
                  return Oe[E(ye)](), [2];
              }
            });
          });
        }, ft[xe(l)].enumerateDevicesEnabled = function() {
          var x = xe, ye = /^((?!chrome|android).)*safari/i[x(649)](navigator[x(je)]);
          return !a[x(Ut)][x(Kt)][x(524)]() || !ye;
        }, ft.prototype[xe(d)] = function() {
          var x = xe, ye = window[x(1030)] || window[x(te)] || window[x(me)];
          if (!ye) {
            var S = window[x(Te)];
            S && (ye = S.RTCPeerConnection || S[x(1185)] || S[x(Xe)]);
          }
          return ye;
        }, ft.prototype[xe(1016)] = function() {
          var x = 700, ye = 802, S = 717, Oe = 563, V = 717, ve = xe, we = this;
          try {
            var Ne = {}, g = this[ve(Tt)](), b = new g(
              { iceServers: [{ urls: this[ve(636)][ve(762)][ve(fe)]() }] },
              { optional: [{ RtpDataChannels: !0 }] }
            );
            b[ve(oe)] = function(E) {
              var T = ve;
              if (E.candidate) {
                var R = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/[T(x)](
                  E.candidate[T(ye)]
                )[1];
                Ne[R] === void 0 && (E[T(802)].candidate[T(S)](T(Oe)) > 0 ? we[T(919)][T(1181)]("WEB_RTC_HOST_IP", R) : E[T(ye)].candidate[T(V)]("srflx") > 0 && we.webRtcIps.set(T(1318), R)), Ne[R] = !0;
              }
            }, b[ve(pt)](""), b[ve(_t)](
              function(E) {
                b[ve(620)](
                  E,
                  function() {
                  },
                  function() {
                  }
                );
              },
              function() {
              }
            );
          } catch {
          }
        }, ft[xe(p)][xe(501)] = function() {
          return Me(this, void 0, void 0, function() {
            var x, ye = 968, S = 1138, Oe = this;
            return Re(this, function(V) {
              var ve = 1224, we = 1202, Ne = 815, g = 599, b = 1202, E = 1325, T = 713, R = 1140, $ = Ue;
              switch (V[$(ye)]) {
                case 0:
                  return x = this, [
                    4,
                    a._POSignalsUtils.Util[$(S)](
                      50,
                      new Promise(function(ie, z) {
                        var C = 815, Y = 599, q = 840, ne = 1117, ue = 1161, Se = 1091, De = 1179, Ve = 968, Ie = 1283, Fe = 1161, ge = $;
                        return Oe[ge(ve)]() ? navigator.mediaDevices && navigator[ge(713)].enumerateDevices ? void navigator[ge(T)][ge(1220)]()[ge(893)](function(ut) {
                          var at = ge;
                          ut[at(R)](function(nt) {
                            var it = at;
                            nt[it(1091)] && (nt[it(1091)][it(1006)]() == it(1307) ? (x[it(ne)] = !0, x[it(1275)]++, nt.label && x[it(638)][it(ue)](nt[it(968)])) : nt[it(Se)].toLowerCase() == "videoinput" ? (x[it(De)] = !0, x.numberOfVideoDevices++, nt.label && x[it(1026)].push(nt[it(Ve)])) : nt[it(1091)][it(1006)]() == it(Ie) && (x[it(557)] = !0, x.numberOfAudioDevices++, nt[it(968)] && x.audioOutputDevices[it(Fe)](nt.label)));
                          }), ie();
                        })[ge(857)](function(ut) {
                          var at = ge;
                          a[at(C)][at(Y)][at(q)](at(529), ut), ie();
                        }) : (a[ge(Ne)][ge(g)][ge(b)](ge(E)), void ie()) : (a[ge(815)][ge(599)][ge(we)](
                          "enumerateDevices() cannot run within safari iframe"
                        ), void ie());
                      })
                    )
                  ];
                case 1:
                  return V.sent(), [2];
              }
            });
          });
        }, ft.prototype[xe(y)] = function(x) {
          var ye = 732, S = 1054, Oe = 1255, V = 1278;
          return Me(this, void 0, void 0, function() {
            var ve, we, Ne = this;
            return Re(this, function(g) {
              var b = Ue;
              switch (g[b(968)]) {
                case 0:
                  return x[b(886)](b(ye)) ? [2, Promise[b(S)]("")] : (ve = new Promise(function(E, T) {
                    return Me(Ne, void 0, void 0, function() {
                      var R, $, ie, z = 1278, C = 661, Y = 599, q = 570;
                      return Re(this, function(ne) {
                        var ue = Ue;
                        switch (ne[ue(968)]) {
                          case 0:
                            return ne.trys.push([0, 3, , 4]), [4, a[ue(743)].load()];
                          case 1:
                            return [4, ne[ue(z)]().get()];
                          case 2:
                            return R = ne[ue(1278)](), this[ue(640)] = R[ue(C)], this[ue(1073)] = R[ue(593)], E(R[ue(661)]), [3, 4];
                          case 3:
                            return $ = ne[ue(1278)](), a._POSignalsUtils[ue(Y)][ue(840)](ue(527) + $), ie = { err: $, message: ue(q) }, T(ie), [3, 4];
                          case 4:
                            return [2];
                        }
                      });
                    });
                  }), we = new Promise(function(E, T) {
                    return Me(Ne, void 0, void 0, function() {
                      var R = 968, $ = 792, ie = 636, z = 1278;
                      return Re(this, function(C) {
                        var Y = Ue;
                        switch (C[Y(R)]) {
                          case 0:
                            return [4, a._POSignalsUtils.Util[Y($)](this[Y(ie)][Y(586)])];
                          case 1:
                            return C[Y(z)](), T({ message: "Fingerprint timeout" }), [2];
                        }
                      });
                    });
                  }), [4, Promise[b(Oe)]([ve, we])]);
                case 1:
                  return [2, g[b(V)]()];
              }
            });
          });
        }, ft.prototype.getBroPrintFingerPrint = function() {
          return Me(this, void 0, void 0, function() {
            var x = 857, ye = this;
            return Re(this, function(S) {
              return [
                2,
                new Promise(function(Oe, V) {
                  var ve = 599, we = Ue;
                  a[we(978)][we(1164)]().then(function(Ne) {
                    ye[we(936)] = Ne, Oe(Ne);
                  })[we(x)](function(Ne) {
                    var g = we;
                    a[g(815)][g(ve)].warn(
                      "Failed to get Fingerprint from getCurrentBrowserFingerPrint",
                      Ne
                    ), V(Ne);
                  });
                })
              ];
            });
          });
        }, ft[xe(816)].getSensorsMetadata = function() {
          var x = xe, ye = {};
          return this.flatAndAddMetadata(ye, "DEDVCE_LIGHT_SUPPORTED", function() {
            return "ondevicelight" in window;
          }), this[x(1160)](ye, x(1294), function() {
            return x(ht) in window;
          }), !window.DeviceMotionEvent && this[x(1160)](ye, x(Pt), function() {
            return !1;
          }), !window[x(1331)] && this[x(1160)](ye, x(Rt), function() {
            return !1;
          }), this.flatAndAddMetadata(ye, "PROXIMITY_SUPPORTED", function() {
            return x(1264) in window;
          }), ye;
        }, ft[xe(816)][xe(553)] = function(x) {
          return Me(this, void 0, void 0, function() {
            var ye, S, Oe, V, ve, we, Ne, g, b, E, T, R, $, ie, z, C, Y, q, ne, ue, Se, De, Ve = 968, Ie = 981, Fe = 1160, ge = 1115, ut = 1160, at = 636, nt = 1160, it = 1012, kt = 930, Vt = 487, xt = 1160, Dt = 519, Mt = 1272, Gt = 1160, It = 1160, qt = 820, Jt = 1160, ke = 651, wt = 1076, st = 1160, on = 1136, an = 887, $t = 1160, Nt = 1060, Wt = 995, We = 722, Bt = 497, Ot = 1160, jt = 1186, zt = 621, en = 1278, Z = 1097, tn = 1160, gn = 966, sn = 1160, mn = 1160, bn = 1160, un = 738, cn = 1160, Yt = 1160, ln = 1160, At = 1160, Zt = 824, nn = 877, rn = 1105, yn = 555, _n = 574, dn = 1160, Cn = 689, Pn = 817, Dn = 1073, Mn = 1073, Rn = 564, Un = 1233, kn = 566, xn = 520, Nn = 1156, Bn = 1160, Fn = 945, Hn = 1160, Vn = 1124, Gn = 540, jn = 578, Wn = 619, Kn = 667, zn = 1022, Yn = 1198, wn = 1160, Xn = 1160, qn = 731, Jn = 1093, Zn = 1160, Qn = 1160, $n = 1263, ei = 949, ti = 773, ni = 1292, ii = 823, ri = 876, oi = 1165, ai = 714, si = 1160, ui = 1214, ci = 982, li = 503, En = 1140, di = 919, hi = 1160, fi = 1153, pi = 536, gi = 1089, vi = 512, mi = 1160, bi = 1192, yi = 639, _i = 1232, wi = 1142, Ei = 1160, Si = 628, Ii = 686, Ti = 714, Ai = 607, Oi = 1233, Li = 1022, Ci = 1022, Pi = 821, Di = 1160, Mi = 794, Ri = 1047, Ui = 565, ki = 638, xi = 565, Ni = 601, Bi = 1161, Fi = 1114, Hi = 1301, Vi = 765, Gi = 947, ji = 490, Wi = 947, Ki = 1003, zi = 1036, Yi = 828, Xi = 799, qi = 947, Ji = 828, Zi = 1013, Qi = 1087, $i = 590, er = 498, tr = 976, nr = 519, ir = 825, rr = 636, or = 981, ar = 519, sr = 1183, ur = 981, cr = 519, lr = 636, dr = 981, hr = 636, fr = 494, pr = 981, gr = 819, vr = 562, mr = 812, br = 981, yr = 640, ct = this;
            return Re(this, function(Xt) {
              var _r = 925, wr = 1038, Sn = 781, Er = 571, Sr = 781, Ir = 1160, Tr = 1302, Ar = 1223, Or = 1007, Lr = 1069, Cr = 1223, Pr = 1302, Dr = 1116, Mr = 1190, Rr = 1334, Ur = 1327, kr = 1026, xr = 565, Nr = 509, Br = 1286, Fr = 660, Hr = 1205, Vr = 644, Gr = 882, jr = 1005, Wr = 888, Kr = 663, zr = 1073, Yr = 1031, Xr = 1160, qr = 1182, In = 1160, Jr = 809, Tn = 1160, Zr = 800, Qr = 1160, $r = 830, eo = 665, to = 989, no = 854, io = 1160, ro = 917, oo = 809, ao = 1172, so = 1081, uo = 560, An = 809, co = 601, lo = 495, ho = 809, fo = 783, po = 809, go = 947, vo = 947, mo = 975, bo = 947, yo = 601, _o = 600, wo = 1219, Eo = 837, So = 645, On = 674, Io = 601, To = 636, Ao = 981, Oo = 636, v = Ue;
              switch (Xt[v(Ve)]) {
                case 0:
                  return ye = this, S = {}, this.flatAndAddMetadata(S, v(579), function() {
                    return ct[v(yr)];
                  }), this[v(1160)](S, v(685), function() {
                    return ct[v(936)];
                  }), this[v(636)][v(Ie)].userAgentData && (this[v(Fe)](S, v(ge), function() {
                    var L = v;
                    return ct.metadataParams[L(br)][L(894)];
                  }), this[v(ut)](S, "OS_VERSION", function() {
                    var L = v;
                    return ct[L(Oo)].browserInfo[L(859)];
                  })), this[v(at)][v(981)][v(519)] && (this[v(nt)](S, v(it), function() {
                    var L = v;
                    return ct[L(636)][L(981)].deviceModel;
                  }), this[v(nt)](S, "DEVICE_VENDOR", function() {
                    var L = v;
                    return ct[L(636)][L(981)][L(mr)];
                  }), this[v(1160)](S, v(kt), function() {
                    var L = v;
                    return ct[L(636)][L(981)].deviceCategory;
                  })), this[v(at)][v(981)][v(519)] && (this.flatAndAddMetadata(S, v(Vt), function() {
                    var L = v;
                    return ct.metadataParams.browserInfo[L(vr)];
                  }), this[v(xt)](S, "BROWSER_ENGINE_VERSION", function() {
                    var L = v;
                    return ct[L(636)][L(Ao)][L(890)];
                  })), this.metadataParams[v(981)][v(Dt)] && this[v(1160)](S, v(Mt), function() {
                    var L = v;
                    return ct[L(636)][L(pr)][L(gr)];
                  }), this[v(at)][v(981)][v(519)] && (this[v(Gt)](S, v(492), function() {
                    var L = v;
                    return ct[L(hr)].browserInfo[L(fr)];
                  }), this[v(It)](S, v(850), function() {
                    var L = v;
                    return ct[L(636)].browserInfo[L(1014)];
                  }), this[v(1160)](S, "BROWSER_MAJOR", function() {
                    var L = v;
                    return ct[L(lr)][L(dr)][L(1199)];
                  }), this[v(nt)](S, v(1303), function() {
                    var L = v;
                    return ct[L(To)][L(981)][L(847)];
                  })), Oe = new P[v(qt)](), this[v(nt)](S, v(1311), function() {
                    var L = v;
                    return Oe[L(514)](ct[L(636)][L(981)][L(519)].ua);
                  }), this[v(1160)](S, v(941), function() {
                    var L = v;
                    return Oe[L(1201)](ct[L(636)][L(ur)][L(cr)].ua);
                  }), this[v(Jt)](S, "IS_CHROME_FAMILY", function() {
                    var L = v;
                    return Oe[L(ir)](ct[L(rr)][L(or)][L(ar)][L(sr)]);
                  }), this.flatAndAddMetadata(S, v(ke), function() {
                    var L = v;
                    return Oe.isElectronFamily(ct[L(636)].browserInfo[L(nr)].ua);
                  }), this[v(1160)](S, v(826), function() {
                    return navigator[v(799)];
                  }), this[v(1160)](S, v(wt), function() {
                    var L = v;
                    return navigator.plugins ? navigator[L(1301)][L(Io)] : null;
                  }), this.flatAndAddMetadata(S, v(911), function() {
                    var L = v;
                    return navigator[L(On)] ? navigator[L(On)].length : null;
                  }), this[v(st)](S, v(on), function() {
                    var L = v;
                    return navigator.language || navigator[L(er)] || navigator.browserLanguage || navigator[L(tr)];
                  }), this[v(1160)](S, v(1029), function() {
                    return navigator[v($i)];
                  }), this.flatAndAddMetadata(S, v(an), function() {
                    return navigator[v(718)] || navigator.msMaxTouchPoints;
                  }), this[v($t)](S, v(1010), function() {
                    var L = v;
                    return navigator.pointerEnabled || navigator[L(So)];
                  }), this[v(It)](S, v(Nt), function() {
                    return navigator.webdriver;
                  }), this.flatAndAddMetadata(S, v(846), function() {
                    return navigator[v(987)];
                  }), this[v($t)](S, v(Wt), function() {
                    return navigator[v(Eo)] != null;
                  }), this.flatAndAddMetadata(S, v(896), function() {
                    return "Notification" in window;
                  }), this[v(1160)](S, v(We), function() {
                    return navigator.appCodeName;
                  }), this[v(1160)](S, "NAVIGATOR_APP_NAME", function() {
                    return navigator[v(706)];
                  }), this[v(1160)](S, v(1256), function() {
                    return navigator[v(913)];
                  }), this[v(1160)](S, "NAVIGATOR_ON_LINE", function() {
                    return navigator[v(wo)];
                  }), this[v(It)](S, v(Bt), function() {
                    return navigator[v(622)];
                  }), this[v(Ot)](S, v(965), function() {
                    return navigator[v(814)];
                  }), this.flatAndAddMetadata(S, v(jt), function() {
                    return navigator[v(841)];
                  }), this[v(nt)](S, "NAVIGATOR_PDF_VIEWER_ENABLED", function() {
                    return navigator.pdfViewerEnabled;
                  }), this[v(Ot)](S, v(zt), function() {
                    return navigator.deviceMemory;
                  }), this[v(1160)](S, v(1277), function() {
                    var L = v;
                    return navigator[L(676)] ? navigator.connection[L(Qi)] : null;
                  }), x[v(886)]("modernizr") ? [3, 2] : [4, this.safeAddModernizrFeatures(S)];
                case 1:
                  Xt[v(en)](), Xt[v(Ve)] = 2;
                case 2:
                  if ((V = window[v(Z)] || window._ST_PING) ? this[v(tn)](S, v(gn), function() {
                    return V;
                  }) : this[v(Fe)](S, v(gn), function() {
                    return v(980);
                  }), this[v(sn)](S, v(853), function() {
                    var L = v;
                    return typeof window !== L(727) && window.history && typeof window.history.length === L(818) ? window.history.length : null;
                  }), ve = new P.WebGLMetadata(), this[v(mn)](S, v(870), function() {
                    return ve[v(Zi)]();
                  }), this[v(Ot)](S, v(924), function() {
                    var L = v;
                    return ve[L(947)]()[L(Xi)] + "~" + ve[L(qi)]()[L(Ji)];
                  }), this.flatAndAddMetadata(S, "IS_WEBGL2", function() {
                    return ve[v(716)]();
                  }), ve[v(716)]() ? this[v(bn)](S, v(un), function() {
                    var L = v;
                    return ve[L(947)]().vendor + "~" + ve.getWebglData()[L(Yi)];
                  }) : this[v(1160)](S, v(un), function() {
                    return "";
                  }), this[v(cn)](S, v(1203), function() {
                    var L = v;
                    return ve[L(947)]()[L(_o)];
                  }), this[v(Yt)](S, "WEBGL_SHADINGLANGUAGEVERSION", function() {
                    var L = v;
                    return ve.getWebglData()[L(zi)];
                  }), this.flatAndAddMetadata(S, v(858), function() {
                    var L = v;
                    return ve.getWebglData()[L(744)][L(yo)];
                  }), this[v(ln)](S, v(1184), function() {
                    return ve[v(947)]().maxTextureSize;
                  }), this[v(At)](S, v(613), function() {
                    var L = v;
                    return ve.getWebglData()[L(Ki)];
                  }), this.flatAndAddMetadata(S, "WEBGL_MAXTEXTUREIMAGEUNITS", function() {
                    return ve[v(947)]().maxTextureImageUnits;
                  }), this[v(1160)](S, v(Zt), function() {
                    var L = v;
                    return ve[L(bo)]()[L(1088)];
                  }), this[v(1160)](S, v(986), function() {
                    var L = v;
                    return ve[L(Wi)]()[L(544)];
                  }), this[v(1160)](S, v(nn), function() {
                    var L = v;
                    return ve.getWebglData()[L(mo)];
                  }), this[v(1160)](S, v(rn), function() {
                    var L = v;
                    return ve[L(Gi)]()[L(ji)];
                  }), this[v(tn)](S, "WEBGL_MAXVERTEXUNIFORMVECTORS", function() {
                    return ve[v(vo)]().maxVertexUniformVectors;
                  }), this[v(1160)](S, v(yn), function() {
                    var L = v;
                    return ve[L(go)]()[L(1162)];
                  }), this[v(1160)](S, v(_n), function() {
                    return ve.getHasLiedLanguages();
                  }), this.flatAndAddMetadata(S, "HASLIEDRESOLUTION", function() {
                    return ve.getHasLiedResolution();
                  }), this[v(dn)](S, v(Cn), function() {
                    return ve[v(697)]();
                  }), this[v(1160)](S, v(Pn), function() {
                    return ve[v(1132)]();
                  }), this[v(Dn)])
                    for (g in we = function(L) {
                      var Et = 809, Lt = 809, vn = 809, hn = 783, Lo = 783, Ye = v;
                      if (!Ne[Ye(1073)].hasOwnProperty(L)) return Ye(Kr);
                      var mt = Ne[Ye(zr)][L];
                      L == Ye(Yr) ? Ne[Ye(Xr)](S, "JS_FONTS", function() {
                        var Ft = Ye;
                        return mt[Ft(809)][Ft(601)];
                      }) : L == Ye(qr) ? Ne[Ye(In)](S, "IS_CANVAS", function() {
                        return mt[Ye(809)] != null;
                      }) : L == "screenResolution" && mt.value && mt[Ye(Jr)].length ? Ne[Ye(Tn)](S, Ye(Zr), function() {
                        var Ft = Ye;
                        return mt[Ft(809)][Ft(Lo)](",");
                      }) : L == "touchSupport" && mt[Ye(809)] ? Ne[Ye(Qr)](S, "TOUCH_SUPPORT", function() {
                        return mt.value;
                      }) : L == Ye($r) && mt.value ? Ne.flatAndAddMetadata(S, Ye(eo), function() {
                        return mt[Ye(809)];
                      }) : L == "osCpu" && mt[Ye(809)] ? Ne[Ye(1160)](S, Ye(to), function() {
                        return mt[Ye(809)];
                      }) : L == Ye(no) && mt.value ? Ne[Ye(io)](S, "COOKIES_ENABLED", function() {
                        return mt[Ye(po)];
                      }) : L == Ye(ro) && mt[Ye(809)] && mt[Ye(oo)].length ? Ne.flatAndAddMetadata(S, Ye(1101), function() {
                        var Ft = Ye;
                        return mt[Ft(809)][Ft(hn)](",");
                      }) : L == Ye(1304) && mt[Ye(809)] ? Ne[Ye(1160)](S, Ye(598), function() {
                        return mt.value;
                      }) : L == Ye(ao) && mt[Ye(so)] ? Ne[Ye(1160)](S, Ye(1271), function() {
                        return mt[Ye(1081)];
                      }) : L == "fontPreferences" && mt[Ye(809)] ? Ne[Ye(Tn)](S, Ye(499), function() {
                        return mt[Ye(vn)];
                      }) : L == Ye(uo) && mt[Ye(809)] ? Ne[Ye(In)](S, "PDF_VIEWER_ENABLED", function() {
                        return mt[Ye(Lt)];
                      }) : L == "vendorFlavors" && mt[Ye(An)] && mt.value[Ye(co)] ? Ne.flatAndAddMetadata(
                        S,
                        "VENDOR_FLAVORS",
                        function() {
                          var Ft = Ye;
                          return mt[Ft(809)][Ft(fo)](",");
                        }
                      ) : L == Ye(1109) && mt[Ye(An)] ? Ne.flatAndAddMetadata(
                        S,
                        "VIDEO_CARD",
                        function() {
                          var Ft = Ye;
                          return mt[Ft(Et)][Ft(828)];
                        }
                      ) : ye.fingerPrintComponentKeys[Ye(886)](L) && L != null && Ne[Ye(1160)](S, L[Ye(lo)](), function() {
                        return mt[Ye(ho)];
                      });
                    }, Ne = this, this[v(Mn)])
                      we(g);
                  for ($ in this[v(1160)](S, "IS_PRIVATE_MODE", function() {
                    return ct[v(Wr)];
                  }), this[v(1160)](S, v(Rn), function() {
                    return ct[v(jr)];
                  }), b = {
                    selenium: navigator[v(1302)] || a[v(815)].Util.getAttribute(
                      window[v(Un)].documentElement,
                      "webdriver"
                    ) || "",
                    phantomjs: {
                      _phantom: window._phantom || "",
                      __phantomas: window[v(kn)] || "",
                      callPhantom: window[v(xn)] || ""
                    },
                    nodejs: { Buffer: window.Buffer || "" },
                    couchjs: { emit: window[v(874)] || "" },
                    rhino: { spawn: window[v(Nn)] || "" },
                    chromium: {
                      domAutomationController: window[v(567)] || "",
                      domAutomation: window[v(653)] || ""
                    },
                    outerWidth: window.outerWidth,
                    outerHeight: window.outerHeight
                  }, this[v(tn)](S, "HEADLESS", function() {
                    return b;
                  }), this[v(Bn)](S, "HEADLESS", function() {
                    return ct[v(Vi)];
                  }), this.flatAndAddMetadata(S, v(Fn), function() {
                    var L = v, Et = {};
                    for (var Lt in ct.lieTests) Et[Lt] = JSON[L(Hr)](ct[L(Vr)][Lt]);
                    return Object[L(Gr)](Et).length > 0 ? Et : null;
                  }), this[v(1160)](S, "STEALTH", function() {
                    var L = v;
                    return new P.DetectStealth(x)[L(Fr)]();
                  }), this[v(Hn)](S, "REF_LINK", function() {
                    return document[v(Br)];
                  }), this.flatAndAddMetadata(S, "PLUGINS", function() {
                    for (var L = v, Et = { length: navigator.plugins[L(601)], details: [] }, Lt = 0; Lt < Et[L(Ni)]; Lt++)
                      Et.details[L(Bi)]({
                        length: navigator[L(1301)][Lt][L(601)],
                        name: navigator.plugins[Lt][L(Fi)],
                        version: navigator[L(1301)][Lt].version,
                        filename: navigator[L(Hi)][Lt][L(1215)]
                      });
                    return Et;
                  }), this.flatAndAddMetadata(S, v(Vn), function() {
                    return ct[v(1275)];
                  }), this[v(Yt)](S, "VIDEO", function() {
                    return ct[v(Nr)];
                  }), this.flatAndAddMetadata(S, v(Gn), function() {
                    var L = v;
                    return ct[L(kr)][L(xr)]();
                  }), this.flatAndAddMetadata(S, v(jn), function() {
                    var L = v;
                    return ct[L(ki)][L(xi)]();
                  }), this[v(dn)](S, "AUDIO_OUTPUT_DEVICES", function() {
                    var L = v;
                    return ct[L(614)][L(Ui)]();
                  }), this[v(1160)](S, "MEDIA_CODEC_MP4_AVC1", function() {
                    var L = v;
                    return ct.getMediaCodec(L(Ri));
                  }), this.flatAndAddMetadata(S, v(Wn), function() {
                    var L = v;
                    return ct[L(1334)](L(760));
                  }), this[v(1160)](S, v(Kn), function() {
                    var L = v;
                    return ct[L(Rr)](L(Ur));
                  }), E = this.metadataParams[v(615)], T = function(L) {
                    var Et = 1334, Lt = v;
                    if (!E.hasOwnProperty(L)) return Lt(663);
                    R[Lt(Di)](S, Lt(Mi) + L, function() {
                      return ct[Lt(Et)](E[L]);
                    });
                  }, R = this, E)
                    T($);
                  window[v(zn)] && window.performance[v(Yn)] && (this[v(wn)](S, v(1246), function() {
                    return window[v(1022)].memory.jsHeapSizeLimit;
                  }), this[v(Xn)](S, v(qn), function() {
                    var L = v;
                    return window[L(Ci)].memory[L(Pi)];
                  }), this[v(sn)](S, v(551), function() {
                    var L = v;
                    return window[L(Li)][L(1198)][L(808)];
                  })), this.flatAndAddMetadata(S, v(856), function() {
                    return navigator[v(Mr)];
                  }), this[v(Yt)](S, "selenium_in_document", function() {
                    var L = v;
                    return P[L(1116)][L(1108)]();
                  }), this[v(1160)](S, v(Jn), function() {
                    return P.SeleniumProperties.seleniumInWindow();
                  }), this[v(1160)](S, v(970), function() {
                    return P[v(Dr)].seleniumInNavigator();
                  }), this[v(Zn)](S, v(897), function() {
                    var L = v;
                    return P.SeleniumProperties[L(1053)]();
                  }), this[v(Qn)](S, v($n), function() {
                    var L = v;
                    return a._POSignalsUtils.Util.getAttribute(
                      window[L(Oi)].documentElement,
                      "selenium"
                    );
                  }), this[v(1160)](S, v(ei), function() {
                    var L = v;
                    return a[L(815)].Util[L(Lr)](window[L(1233)][L(Cr)], L(Pr));
                  }), this[v(1160)](S, "DOCUMENT_ELEMENT_DRIVER", function() {
                    var L = v;
                    return a[L(815)][L(526)][L(1069)](window[L(1233)][L(Ar)], L(Or));
                  }), this.flatAndAddMetadata(S, v(ti), function() {
                    var L = v;
                    return !!a[L(815)].Util[L(1069)](document[L(795)](L(1273))[0], L(Tr));
                  }), this[v(1160)](S, v(ni), function() {
                    return !!window[v(Ai)];
                  }), this[v(1160)](S, "window_awesomium", function() {
                    return !!window.awesomium;
                  }), this.flatAndAddMetadata(S, v(ii), function() {
                    return !!window[v(1305)];
                  }), this[v(sn)](S, v(ri), function() {
                    return !!window[v(1204)];
                  }), this[v(nt)](S, "hasTrustToken", function() {
                    return "hasTrustToken" in document;
                  }), this[v(1160)](S, v(oi), function() {
                    return "trustTokenOperationError" in XMLHttpRequest[v(816)];
                  }), this[v(1160)](S, v(513), function() {
                    var L = v;
                    return L(513) in XMLHttpRequest[L(816)];
                  }), this.flatAndAddMetadata(S, v(ai), function() {
                    var L = v;
                    return L(Ti) in HTMLIFrameElement[L(816)];
                  }), this[v(Fe)](S, "localStorage.length", function() {
                    return localStorage[v(601)];
                  }), this[v(si)](S, v(ui), function() {
                    return sessionStorage.length;
                  }), this[v(ci)][v(li)][v(En)](function(L) {
                    var Et = v;
                    ct[Et(1160)](S, L[Et(495)]() + Et(1032), function() {
                      return !0;
                    });
                  }), this[v(wn)](S, v(908), function() {
                    return !!ct[v(596)]();
                  }), this[v(at)].webRtcUrl && this[v(at)][v(762)][v(601)] > 0 && (this[v(1016)](), this[v(di)][v(En)](function(L, Et) {
                    Et != null && L != null && ct[v(Ir)](S, Et, function() {
                      return L;
                    });
                  }), this.webRtcIps.clear()), window.matchMedia && this[v(hi)](S, v(fi), function() {
                    var L = v, Et = window[L(979)]("(min-width: " + (window[L(Ii)] - 1) + "px)");
                    return { matches: Et[L(1086)], media: Et[L(1269)] };
                  }), this[v(1213)](S, x), window[v(pi)] && this[v(1160)](S, v(1217), function() {
                    var L = v;
                    return window.Notification[L(1018)];
                  }), this.flatAndAddMetadata(S, v(1222), function() {
                    var L = v;
                    return window.chrome && L(Si) in window.chrome;
                  }), this[v(1160)](S, v(855), function() {
                    var L = v;
                    return window[L(781)] && "csi" in window[L(Sr)];
                  }), this[v(1160)](S, v(gi), function() {
                    var L = v;
                    return window[L(Sn)] && L(Er) in window[L(Sn)];
                  }), this[v(1160)](S, v(vi), function() {
                    return window.chrome && "runtime" in window.chrome;
                  }), this.addClientHints(S), this[v(tn)](S, v(1092), function() {
                    return !!navigator[v(wr)];
                  }), this[v(1160)](S, "NAVIGATOR_HID_SUPPORTED", function() {
                    return !!navigator[v(761)];
                  }), this[v(mi)](S, v(1080), function() {
                    return !!navigator[v(_r)];
                  }), this[v(1160)](S, v(630), function() {
                    return !!navigator.presentation;
                  }), Xt[v(968)] = 3;
                case 3:
                  return Xt.trys[v(1161)]([3, 6, , 7]), x[v(886)](v(944)) || !a[v(526)][v(688)](document[v(bi)]) ? [3, 5] : [4, a.Util[v(1138)](100, document.interestCohort())];
                case 4:
                  ie = Xt[v(1278)](), z = ie.id, C = ie[v(yi)], this[v(dn)](S, v(729), function() {
                    return z;
                  }), this.flatAndAddMetadata(S, v(1313), function() {
                    return C;
                  }), Xt[v(968)] = 5;
                case 5:
                  return [3, 7];
                case 6:
                  return Xt[v(en)](), [3, 7];
                case 7:
                  for (ne in Y = function(L) {
                    var Et = 526, Lt = 636, vn = v;
                    q[vn(Ei)](S, L, function() {
                      var hn = vn;
                      return a[hn(815)][hn(Et)].getProperty(window, ct[hn(Lt)].dataPoints[L]);
                    });
                  }, q = this, this.metadataParams[v(568)])
                    Y(ne);
                  for (Se in ue = this[v(636)][v(1049)])
                    ue[v(_i)](Se) && (De = Se === "window" ? window : window[Se]) && this[v(wi)](De, Se.toUpperCase() + "_PROPERTY_DESCRIPTOR", ue[Se], S);
                  return [2, S];
              }
            });
          });
        }, ft[xe(p)][xe(k)] = function(x) {
          var ye = 622, S = xe;
          try {
            var Oe = navigator[S(519)];
            if (!Oe) return;
            this.flatAndAddMetadata(x, S(1285), function() {
              return Oe[S(ye)];
            }), this[S(_e)](x, "NAVIGATOR_CLIENT_HINTS_MOBILE", function() {
              return Oe[S(879)];
            });
            var V = Oe[S(871)];
            if (!V) return;
            for (var ve = function(g) {
              var b = S;
              if (V[g][b(1232)](b(ze)) && V[g][b(ot)]("version")) {
                var E = V[g][b(851)] + ":" + V[g][b($e)];
                we[b(et)](x, b(gt) + g, function() {
                  return E;
                });
              }
            }, we = this, Ne = 0; Ne < V[S(601)]; Ne++)
              ve(Ne);
          } catch (g) {
            a[S(815)].Logger.warn(S(1312), g);
          }
        }, ft.prototype.addPropertyDescriptorInfo = function(x, ye, S, Oe) {
          var V = 495, ve = xe;
          try {
            for (var we = function(E) {
              var T = 816, R = 849, $ = 952, ie = Ue;
              Ne[ie(1160)](Oe, ye + "_" + E[ie(V)](), function() {
                var z = ie, C = x[z(T)] ? x[z(816)] : x, Y = Object[z(R)](C, E);
                if (Y) {
                  var q = Y.get ? Y[z($)][z(565)]() : void 0;
                  return JSON[z(1205)]({
                    configurable: Y[z(964)],
                    enumerable: Y.enumerable,
                    value: Y[z(809)],
                    writable: Y.writable,
                    getter: q != null && q.length < 100 ? q : void 0
                  });
                }
                return z(727);
              });
            }, Ne = this, g = 0, b = S; g < b.length; g++)
              we(b[g]);
          } catch (E) {
            a[ve(815)].Logger.warn(ve(1106), E);
          }
        }, ft[xe(816)][xe(1213)] = function(x, ye) {
          var S = 486, Oe = 845, V = xe;
          if (!ye[V(ce)]("IFRAME_DATA"))
            try {
              var ve = a._POSignalsUtils[V(ee)][V(re)](V(1243));
              if (!ve) return;
              ve[V(F)] = V(1166), document[V(M)][V(le)](ve), this.flatAndAddMetadata(x, "IFRAME_CHROME", function() {
                return typeof ve.contentWindow.chrome;
              }), this[V(1160)](x, "IFRAME_WIDTH", function() {
                var we = V;
                return ve[we(S)][we(827)][we(Oe)];
              }), this[V(G)](x, "IFRAME_HEIGHT", function() {
                var we = V;
                return ve[we(486)].screen[we(1100)];
              }), ve.remove();
            } catch (we) {
              a[V(815)].Logger.warn(V(1306), we);
            }
        }, ft[xe(Q)][xe(m)] = function() {
          var x = 1041, ye = 1070, S = 673, Oe = 633, V = 618, ve = 780, we = 694, Ne = 664, g = 1157, b = 1161, E = 815;
          return Me(this, void 0, void 0, function() {
            var T, R, $, ie, z, C;
            return Re(this, function(Y) {
              var q = 1161, ne = 865, ue = Ue;
              switch (Y[ue(968)]) {
                case 0:
                  if (T = {}, R = [
                    ue(616),
                    ue(x),
                    ue(ye),
                    ue(959),
                    ue(S),
                    ue(1002),
                    ue(1150),
                    ue(Oe),
                    ue(V),
                    "magnetometer",
                    ue(625),
                    ue(ve),
                    ue(we),
                    ue(Ne),
                    ue(g),
                    "push"
                  ], $ = [], navigator.permissions)
                    for (z in ie = function(Se) {
                      var De = ue, Ve = R[Se];
                      $[De(q)](
                        navigator[De(641)].query({ name: Ve })[De(893)](function(Ie) {
                          var Fe = De;
                          T[Ve] = Ie[Fe(ne)];
                        })[De(857)](function(Ie) {
                        })
                      );
                    }, R)
                      ie(z);
                  Y[ue(968)] = 1;
                case 1:
                  return Y[ue(737)][ue(b)]([1, 3, , 4]), [4, Promise[ue(1258)]($)];
                case 2:
                  return Y[ue(1278)](), [3, 4];
                case 3:
                  return C = Y[ue(1278)](), a[ue(E)][ue(599)].warn(C), [3, 4];
                case 4:
                  return [2, T];
              }
            });
          });
        }, ft.prototype[xe(_)] = function(x) {
          var ye = xe, S = document.createElement(ye(671));
          if (S && S[ye(1056)]) return S[ye(1056)](x);
        }, ft[xe(t)].safeAddModernizrFeatures = function(x) {
          return Me(this, void 0, void 0, function() {
            var ye, S, Oe, V, ve, we, Ne = 839, g = 1066, b = 1160, E = 830, T = 1113, R = 483, $ = 1332, ie = 1068, z = 1210, C = 1160, Y = 1261, q = 480, ne = 711, ue = 541, Se = 1278, De = 1288, Ve = 977, Ie = 1160, Fe = 842, ge = 1160, ut = 1063, at = 624, nt = 884, it = 1160, kt = 940, Vt = 1248, xt = 671, Dt = 860, Mt = 1075, Gt = 842, It = 1177, qt = 730, Jt = 1240, ke = 633, wt = 784, st = 488, on = 962, an = 973, $t = 904, Nt = 830;
            return Re(this, function(Wt) {
              var We = 940, Bt = 1299, Ot = 843, jt = 774, zt = 670, en = 698, Z = Ue;
              switch (Wt[Z(968)]) {
                case 0:
                  return a[Z(728)](), ye = this, S = a[Z(Ne)], Oe = S[Z(848)], V = S[Z(g)], this.flatAndAddMetadata(x, Z(477), function() {
                    return S[Z(en)];
                  }), this[Z(b)](x, "application_cache", function() {
                    return S.applicationcache;
                  }), this[Z(1160)](x, Z(E), function() {
                    return !!S[Z(Nt)];
                  }), S.audio && this.flatAndAddMetadata(x, Z(830), function() {
                    return S.audio;
                  }), this[Z(1160)](x, "battery_api", function() {
                    return !!Oe(Z(1170), navigator) || !!Oe("getBattery", navigator);
                  }), this.flatAndAddMetadata(x, Z(T), function() {
                    return S[Z(869)];
                  }), this.flatAndAddMetadata(x, Z(657), function() {
                    return S[Z(zt)];
                  }), this[Z(b)](x, Z(R), function() {
                    return S[Z(483)];
                  }), this[Z(b)](x, Z(904), function() {
                    return S[Z($t)];
                  }), this[Z(1160)](x, Z($), function() {
                    return S.customelements;
                  }), this[Z(1160)](x, Z(ie), function() {
                    return S[Z(an)];
                  }), this[Z(b)](x, Z(z), function() {
                    return S.customevent;
                  }), this[Z(C)](x, Z(763), function() {
                    return S[Z(763)];
                  }), this[Z(C)](x, Z(Y), function() {
                    return S[Z(on)];
                  }), this[Z(b)](x, "event_listener", function() {
                    return S[Z(696)];
                  }), [4, this[Z(691)]("exiforientation")];
                case 1:
                  return ve = Wt[Z(1278)](), ye[Z(b)](x, Z(1300), function() {
                    return ve;
                  }), this[Z(b)](x, Z(q), function() {
                    return S.forcetouch;
                  }), S[Z(ne)] && (this[Z(1160)](x, "force_touch.mouse_force_will_begin", function() {
                    return V(Oe("mouseforcewillbegin", window, !1), window);
                  }), this[Z(C)](x, Z(ue), function() {
                    return MouseEvent[Z(jt)];
                  }), this[Z(1160)](
                    x,
                    "force_touch.webkit_force_at_force_mouse_down",
                    function() {
                      return MouseEvent[Z(st)];
                    }
                  )), this[Z(C)](x, Z(719), function() {
                    return S[Z(wt)];
                  }), this[Z(b)](x, Z(1178), function() {
                    return S[Z(1131)];
                  }), this[Z(1160)](x, Z(994), function() {
                    return S[Z(ke)];
                  }), this.flatAndAddMetadata(x, "ie8compat", function() {
                    return S[Z(1008)];
                  }), [4, this[Z(691)](Z(1267))];
                case 2:
                  return we = Wt[Z(Se)](), ye[Z(1160)](x, "indexed_db", function() {
                    return we;
                  }), this[Z(1160)](x, "indexed_db_blob", function() {
                    return S[Z(Jt)];
                  }), this[Z(C)](x, Z(1042), function() {
                    return S[Z(1083)];
                  }), this[Z(1160)](x, Z(730), function() {
                    return S[Z(qt)];
                  }), this.flatAndAddMetadata(x, Z(1177), function() {
                    return S[Z(It)];
                  }), this[Z(C)](x, Z(De), function() {
                    return Z(Ot) in window;
                  }), this.flatAndAddMetadata(x, Z(Ve), function() {
                    return S[Z(1103)];
                  }), this[Z(Ie)](x, Z(Fe), function() {
                    return S[Z(Gt)];
                  }), this[Z(ge)](x, Z(ut), function() {
                    return S[Z(Mt)];
                  }), this.flatAndAddMetadata(x, Z(1022), function() {
                    return S.performance;
                  }), this[Z(1160)](x, "pointer_events", function() {
                    return S[Z(1127)];
                  }), this[Z(1160)](x, "pointer_lock", function() {
                    return S[Z(617)];
                  }), this[Z(C)](x, Z(1119), function() {
                    return S[Z(1119)];
                  }), this[Z(1160)](x, "query_selector", function() {
                    return S[Z(Bt)];
                  }), this[Z(1160)](x, Z(907), function() {
                    return S.quotamanagement;
                  }), this[Z(1160)](x, Z(591), function() {
                    return S.requestanimationframe;
                  }), this[Z(1160)](x, Z(at), function() {
                    return S[Z(705)];
                  }), this.flatAndAddMetadata(x, "touch_events", function() {
                    return S[Z(Dt)];
                  }), this[Z(1160)](x, Z(nt), function() {
                    return S[Z(880)];
                  }), this[Z(Ie)](x, Z(837), function() {
                    return S[Z(837)];
                  }), this[Z(C)](x, Z(671), function() {
                    return !!S[Z(xt)];
                  }), S[Z(671)] && this[Z(1160)](x, Z(671), function() {
                    return S[Z(671)];
                  }), this[Z(1160)](x, "web_gl", function() {
                    return S[Z(505)];
                  }), this[Z(1160)](x, "web_sockets", function() {
                    return S[Z(Vt)];
                  }), this[Z(it)](x, "x_domain_request", function() {
                    return S.xdomainrequest;
                  }), this[Z(1160)](x, Z(kt), function() {
                    return S[Z(We)];
                  }), [2];
              }
            });
          });
        }, ft[xe(816)][xe(w)] = function() {
          var x = 1223, ye = 710, S = 1266, Oe = 557, V = xe, ve = this, we = {}, Ne = navigator[V(f)] || navigator.mozConnection || navigator.webkitConnection;
          return this[V(B)](we, V(912), function() {
            return Ne ? Ne.type : null;
          }), this[V(B)](we, "NETWORK_DOWNLOAD_MAX", function() {
            return Ne ? Ne[V(Ge)] : null;
          }), this[V(se)](we, V(de), function() {
            return !!navigator.bluetooth;
          }), this[V(1160)](we, V(J), function() {
            return ve[V(Oe)];
          }), this[V(1160)](we, V(1110), function() {
            return ve[V(he)];
          }), this[V(1160)](we, V(Le), function() {
            return ve[V(1179)];
          }), this.flatAndAddMetadata(we, "BATTERY_SUPPORTED", function() {
            return ve[V(S)];
          }), this[V(1160)](we, V(Ce), function() {
            return ve[V(572)];
          }), this[V(Qe)](we, "BATTERY_CHARGING", function() {
            return ve[V(1321)];
          }), this[V(1160)](we, "BATTERY_CHARGING_TIME", function() {
            return ve.batteryChargingTime;
          }), this[V(B)](we, V(885), function() {
            return ve.batteryDischargingTime;
          }), this[V(Qe)](we, V(dt), function() {
            return ve[V(ye)];
          }), this.flatAndAddMetadata(we, V(631), function() {
            var g = V;
            return a[g(be)].Util[g(Pe)];
          }), this[V(1160)](we, V(St), function() {
            return "ontouchstart" in document[V(x)];
          }), this[V(Qe)](we, V(1260), function() {
            return ve[V(641)];
          }), this[V(Qe)](we, V(1057), function() {
            var g = V;
            return window[g(bt)]("(prefers-color-scheme: light)")[g(yt)] ? "light" : window[g(979)]("(prefers-color-scheme: dark)").matches ? g(tt) : void 0;
          }), we;
        }, ft[xe(A)][xe(U)] = function(x, ye, S) {
          var Oe = xe;
          try {
            var V = new Set(this.metadataParams[Oe(1169)] || []);
            ye != null && S != null && !V.has(ye) && (x[ye] = S);
          } catch (ve) {
            a[Oe(815)].Logger.warn(Oe(1011) + ye + " -> " + S + ", " + ve);
          }
        }, ft[xe(816)][xe(pe)] = function(x) {
          var ye = 1278;
          return Me(this, void 0, void 0, function() {
            var S, Oe;
            return Re(this, function(V) {
              var ve = 599, we = Ue;
              switch (V[we(968)]) {
                case 0:
                  return S = new Promise(function(Ne) {
                    var g = we;
                    try {
                      a[g(839)].on(x, function(b) {
                        Ne(b);
                      });
                    } catch (b) {
                      Ne(null), a._POSignalsUtils[g(ve)][g(840)](g(928) + x, b);
                    }
                  }), Oe = a[we(815)].Util[we(792)](250).then(function() {
                    return null;
                  }), [4, Promise[we(1255)]([S, Oe])];
                case 1:
                  return [2, V[we(ye)]()];
              }
            });
          });
        }, ft[xe(816)][xe(1160)] = function(x, ye, S) {
          var Oe = xe;
          try {
            var V = new Set(this[Oe(636)][Oe(1169)] || []);
            if (!ye || V.has(ye)) return;
            var ve = S();
            if (typeof ve == "object" && ve !== null) {
              var we = a[Oe(K)][Oe(526)].flatten(ve);
              for (var Ne in we) this[Oe(ae)](x, ye + "." + Ne, we[Ne]);
            } else this.safeAddMetadata(x, ye, ve);
          } catch (g) {
            a[Oe(815)].Logger[Oe(840)]("Failed to add " + ye, g);
          }
        }, ft[xe(l)][xe(1335)] = function() {
          var x, ye = xe, S = /* @__PURE__ */ new Date(), Oe = 0;
          do
            Oe++, x = (/* @__PURE__ */ new Date())[ye(N)]() - S[ye(900)](), Math.sqrt(Oe * Math[ye(H)]());
          while (x < 500);
          var V = Oe / x;
          return a[ye(815)][ye(j)][ye(1202)](ye(998) + V), V;
        }, ft[xe(816)][xe(D)] = function() {
          var x = xe, ye = this;
          !this[x(lt)] && a[x(1322)][x(580)]().then(function(S) {
            ye[x(684)] = S;
          })[x(857)](function(S) {
            var Oe = x;
            a._POSignalsUtils.Logger[Oe(O)](Oe(702), S);
          }), this.aiSignalsResult && (this[x(o)][x(I)] = this[x(684)]);
        }, ft[xe(1059)] = function() {
          var x = xe;
          return Math[x(qe)](0.123) == 1.4474840516030247 && Math.acosh(Math[x(775)]) == 0.881373587019543 && Math.atan(2) == 1.1071487177940904 && Math[x(972)](0.5) == 0.5493061443340548 && Math[x(577)](Math.PI) == 1.4645918875615231 && Math[x(537)](21 * Math[x(770)]) == -0.4067775970251724 && Math[x(1009)](492 * Math[x(Je)]) == 9199870313877772e292 && Math[x(vt)](1) == 1.718281828459045 && Math.hypot(6 * Math.PI, -100) == 101.76102278593319 && Math[x(759)](Math.PI) == 0.4971498726941338 && Math[x(rt)](Math.PI) == 12246467991473532e-32 && Math[x(687)](Math.PI) == 11.548739357257748 && Math[x(482)](10 * Math[x(525)]) == -3.3537128705376014 && Math[x(575)](0.123) == 0.12238344189440875 && Math[x(1084)](Math.PI, -100) == 19275814160560204e-66;
        }, ft;
      }();
      P.Metadata = Be;
      var Ze = function() {
        var qe = Ue;
        function Je(vt, rt) {
          var lt = Ue;
          this[lt(1297)] = vt, this.agentTimeout = rt, this[lt(1128)] = lt(1028), this[lt(531)] = "/device";
        }
        return Je[qe(r)][qe(1055)] = function() {
          return Me(this, void 0, void 0, function() {
            var vt, rt, lt, o, I, O, f, B = 1128, se = 1090, de = 1320, J = 1161, Le = 810, Ce = 1290, Qe = 815, dt = 599, St = 1278, bt = 1114, yt = 682, tt = 599, be = 1023, Pe = 990, he = 903;
            return Re(this, function(Ge) {
              var _e = Ue;
              switch (Ge.label) {
                case 0:
                  vt = this[_e(B)] + ":" + this[_e(1297)] + this[_e(531)], rt = new AbortController(), lt = rt[_e(se)], o = setTimeout(function() {
                    return rt[_e(he)]();
                  }, this[_e(de)]), Ge.label = 1;
                case 1:
                  return Ge[_e(737)][_e(J)]([1, 4, 5, 6]), [4, fetch(vt, { method: _e(Le), headers: { "Content-Type": _e(Ce) }, signal: lt })];
                case 2:
                  return (I = Ge[_e(1278)]()).ok ? [4, I[_e(678)]()] : (a[_e(Qe)][_e(dt)][_e(1023)](
                    "Failed to fetch the Workstation data. Invalid network response: " + I[_e(1208)]
                  ), [2, void 0]);
                case 3:
                  return O = Ge.sent(), a._POSignalsUtils[_e(599)][_e(1023)](_e(960)), [2, O];
                case 4:
                  return (f = Ge[_e(St)]())[_e(bt)] === _e(892) ? a[_e(815)][_e(599)][_e(690)](_e(yt) + this.agentTimeout + "ms") : a._POSignalsUtils[_e(tt)][_e(be)](
                    "Failed to fetch the Workstation data: " + f[_e(Pe)]
                  ), [2, void 0];
                case 5:
                  return clearTimeout(o), [7];
                case 6:
                  return [2];
              }
            });
          });
        }, Je;
      }();
      P.LocalAgentAccessor = Ze;
    })(a[W(709)] || (a[W(c)] = {}));
  })(X || (X = {})), function(a) {
    var c, r, e, t, n, i, s, u, h, l, d, p, y, k, Q, m, _, w, A, U, pe, D, W, P, N = 1108, H = 1079, j = Ht;
    c = a._POSignalsMetadata || (a[j(709)] = {}), r = 963, e = 1126, t = 788, n = 1231, i = 1308, s = 604, u = 1144, h = 993, l = 637, d = 1323, p = 585, y = 790, k = 507, Q = 1052, m = 1134, _ = 532, w = 751, A = 1020, U = 707, pe = 1126, D = 788, W = 601, P = function() {
      var K = 516, ae = 565, ce = 717, ee = Ue;
      function re() {
      }
      return re[ee(N)] = function() {
        for (var F = ee, M = 0, le = [
          F(963),
          F(w),
          F(916),
          F(A),
          F(703),
          F(U),
          F(pe),
          F(D),
          F(1293),
          F(1231),
          "__fxdriver_unwrapped"
        ]; M < le[F(W)]; M++)
          if (document[le[M]]) return !0;
        return !1;
      }, re.seleniumInWindow = function() {
        for (var F = ee, M = 0, le = [F(914), F(1139), F(923), F(520), F(1144), F(_), F(604)]; M < le[F(601)]; M++)
          if (window[le[M]]) return !0;
        return !1;
      }, re[ee(H)] = function() {
        for (var F = ee, M = 0, le = [
          "webdriver",
          F(1293),
          F(r),
          F(751),
          F(707),
          F(e),
          F(t),
          F(n),
          F(i),
          F(s),
          "_selenium",
          F(u),
          F(h),
          F(l),
          F(d),
          "webdriver-evaluate",
          F(p),
          F(988),
          F(y),
          "__webdriverFunc",
          F(703),
          F(k),
          F(Q),
          F(m),
          "__lastWatirPrompt",
          "$chrome_asyncScriptInfo",
          "$cdc_asdjflasutopfhvcZLmcfl_"
        ]; M < le[F(601)]; M++)
          if (navigator[le[M]]) return !0;
        return !1;
      }, re.seleniumSequentum = function() {
        var F = ee;
        return window[F(K)] && window[F(K)].toString() && window[F(516)][F(ae)]()[F(ce)](F(515)) != -1;
      }, re;
    }(), c.SeleniumProperties = P;
  }(X || (X = {})), function(a) {
    var c, r, e, t, n, i, s, u, h, l, d, p, y, k, Q, m, _, w, A, U = 709, pe = 879, D = 1218, W = 906, P = 1072, N = 1211, H = 1284, j = 873, K = 1200, ae = 511, ce = 1111, ee = 1284, re = 1329, F = 1330, M = 662, le = 1284, G = 1336, te = Ht;
    c = a[te(709)] || (a[te(U)] = {}), e = (r = Ue)(1114), t = r(1291), n = r(799), i = r(639), s = r(pe), u = r(D), h = r(584), l = r(W), r(P), d = r(666), p = r(N), y = r(1118), k = Object[r(H)]({
      browser: [[/(wget|curl|lynx|elinks|httpie)[\/ ]\(?([\w\.-]+)/i], [e, i, [t, l]]]
    }), Q = Object[r(1284)]({
      browser: [
        [
          /((?:ahrefs|amazon|bing|cc|dot|duckduck|exa|facebook|gpt|mj12|mojeek|oai-search|perplexity|semrush|seznam)bot)\/([\w\.-]+)/i,
          /(applebot(?:-extended)?)\/([\w\.]+)/i,
          /(baiduspider)[-imagevdonsfcpr]{0,6}\/([\w\.]+)/i,
          /(claude(?:bot|-web)|anthropic-ai)\/?([\w\.]*)/i,
          /(coccocbot-(?:image|web))\/([\w\.]+)/i,
          /(facebook(?:externalhit|catalog)|meta-externalagent)\/([\w\.]+)/i,
          /(google(?:bot|other|-inspectiontool)(?:-image|-video|-news)?|storebot-google)\/?([\w\.]*)/i,
          /(ia_archiver|archive\.org_bot)\/?([\w\.]*)/i,
          /((?:semrush|splitsignal)bot[-abcfimostw]*)\/([\w\.-]+)/i,
          /(sogou (?:pic|head|web|orion|news) spider)\/([\w\.]+)/i,
          /(y!?j-(?:asr|br[uw]|dscv|mmp|vsidx|wsc))\/([\w\.]+)/i,
          /(yandex(?:(?:mobile)?(?:accessibility|additional|renderresources|screenshot|sprav)?bot|image(?:s|resizer)|video(?:parser)?|blogs|adnet|favicons|fordomain|market|media|metrika|news|ontodb(?:api)?|pagechecker|partner|rca|tracker|turbo|vertis|webmaster|antivirus))\/([\w\.]+)/i,
          /(yeti)\/([\w\.]+)/i,
          /((?:aihit|diff|timpi|you)bot|omgili(?:bot)?|(?:magpie-|velenpublicweb)crawler|webzio-extended|(?:screaming frog seo |yisou)spider)\/?([\w\.]*)/i
        ],
        [e, i, [t, h]],
        [
          /((?:adsbot|apis|mediapartners)-google(?:-mobile)?|google-?(?:other|cloudvertexbot|extended|safety))/i,
          /\b(360spider-?(?:image|video)?|bytespider|(?:ai2|aspiegel|dataforseo|imagesift|petal|turnitin)bot|teoma|(?=yahoo! )slurp)/i
        ],
        [e, [t, h]]
      ]
    }), Object[r(H)]({
      device: [
        [
          /(nook)[\w ]+build\/(\w+)/i,
          /(dell) (strea[kpr\d ]*[\dko])/i,
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          /(trinity)[- ]*(t\d{3}) bui/i,
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          /(vodafone) ([\w ]+)(?:\)| bui)/i
        ],
        [n, "model", [t, u]],
        [/(u304aa)/i],
        ["model", [n, r(627)], [t, s]],
        [/\bsie-(\w*)/i],
        ["model", [n, r(1e3)], [t, s]],
        [/\b(rct\w+) b/i],
        ["model", [n, r(545)], [t, u]],
        [/\b(venue[\d ]{2,7}) b/i],
        ["model", [n, r(1130)], [t, u]],
        [/\b(q(?:mv|ta)\w+) b/i],
        ["model", [n, r(1276)], [t, u]],
        [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],
        ["model", [n, r(j)], [t, u]],
        [/\b(tm\d{3}\w+) b/i],
        ["model", [n, r(1033)], [t, u]],
        [/\b(k88) b/i],
        ["model", [n, r(K)], [t, u]],
        [/\b(nx\d{3}j) b/i],
        ["model", [n, r(1200)], [t, s]],
        [/\b(gen\d{3}) b.+49h/i],
        ["model", [n, "Swiss"], [t, s]],
        [/\b(zur\d{3}) b/i],
        ["model", [n, "Swiss"], [t, u]],
        [/^((zeki)?tb.*\b) b/i],
        ["model", [n, "Zeki"], [t, u]],
        [/\b([yr]\d{2}) b/i, /\b(?:dragon[- ]+touch |dt)(\w{5}) b/i],
        ["model", [n, r(576)], [t, u]],
        [/\b(ns-?\w{0,9}) b/i],
        ["model", [n, "Insignia"], [t, u]],
        [/\b((nxa|next)-?\w{0,9}) b/i],
        ["model", [n, r(594)], [t, u]],
        [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],
        [[n, r(ae)], "model", [t, s]],
        [/\b(lvtel\-)?(v1[12]) b/i],
        [[n, r(610)], "model", [t, s]],
        [/\b(ph-1) /i],
        ["model", [n, r(ce)], [t, s]],
        [/\b(v(100md|700na|7011|917g).*\b) b/i],
        ["model", [n, r(681)], [t, u]],
        [/\b(trio[-\w\. ]+) b/i],
        ["model", [n, "MachSpeed"], [t, u]],
        [/\btu_(1491) b/i],
        ["model", [n, r(1027)], [t, u]]
      ]
    }), m = Object[r(1284)]({
      browser: [
        [
          /(ahrefssiteaudit|bingpreview|chatgpt-user|mastodon|(?:discord|duckassist|linkedin|pinterest|reddit|roger|siteaudit|telegram|twitter|uptimero)bot|google-site-verification|meta-externalfetcher|y!?j-dlc|yandex(?:calendar|direct(?:dyn)?|searchshop)|yadirectfetcher)\/([\w\.]+)/i,
          /(bluesky) cardyb\/([\w\.]+)/i,
          /(slack(?:bot)?(?:-imgproxy|-linkexpanding)?) ([\w\.]+)/i,
          /(whatsapp)\/([\w\.]+)[\/ ][ianw]/i
        ],
        [e, i, [t, d]],
        [
          /(cohere-ai|vercelbot|feedfetcher-google|google(?:-read-aloud|producer)|(?=bot; )snapchat|yandex(?:sitelinks|userproxy))/i
        ],
        [e, [t, d]]
      ]
    }), Object[r(ee)]({
      browser: [
        [/chatlyio\/([\d\.]+)/i],
        [i, r(re), [t, "inapp"]],
        [/jp\.co\.yahoo\.android\.yjtop\/([\d\.]+)/i],
        [i, r(F), [t, "inapp"]]
      ]
    }), Object[r(1284)]({
      browser: [
        [
          /(apple(?:coremedia|tv))\/([\w\._]+)/i,
          /(coremedia) v([\w\._]+)/i,
          /(ares|clementine|music player daemon|nexplayer|ossproxy) ([\w\.-]+)/i,
          /^(aqualung|audacious|audimusicstream|amarok|bass|bsplayer|core|gnomemplayer|gvfs|irapp|lyssna|music on console|nero (?:home|scout)|nokia\d+|nsplayer|psp-internetradioplayer|quicktime|rma|radioapp|radioclientapplication|soundtap|stagefright|streamium|totem|videos|xbmc|xine|xmms)\/([\w\.-]+)/i,
          /(lg player|nexplayer) ([\d\.]+)/i,
          /player\/(nexplayer|lg player) ([\w\.-]+)/i,
          /(gstreamer) souphttpsrc.+libsoup\/([\w\.-]+)/i,
          /(htc streaming player) [\w_]+ \/ ([\d\.]+)/i,
          /(lavf)([\d\.]+)/i,
          /(mplayer)(?: |\/)(?:(?:sherpya-){0,1}svn)(?:-| )(r\d+(?:-\d+[\w\.-]+))/i,
          / (songbird)\/([\w\.-]+)/i,
          /(winamp)(?:3 version|mpeg| ) ([\w\.-]+)/i,
          /(vlc)(?:\/| media player - version )([\w\.-]+)/i,
          /^(foobar2000|itunes|smp)\/([\d\.]+)/i,
          /com\.(riseupradioalarm)\/([\d\.]*)/i,
          /(mplayer)(?:\s|\/| unknown-)([\w\.\-]+)/i,
          /(windows)\/([\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ home media server/i
        ],
        [e, i, [t, p]],
        [/(flrp)\/([\w\.-]+)/i],
        [[e, r(M)], i, [t, p]],
        [
          /(fstream|media player classic|inlight radio|mplayer|nativehost|nero showtime|ocms-bot|queryseekspider|tapinradio|tunein radio|winamp|yourmuze)/i
        ],
        [e, [t, p]],
        [/(htc_one_s|windows-media-player|wmplayer)\/([\w\.-]+)/i],
        [[e, /[_-]/g, " "], i, [t, p]],
        [/(rad.io|radio.(?:de|at|fr)) ([\d\.]+)/i],
        [[e, r(1221)], i, [t, p]]
      ]
    }), _ = Object.freeze({
      browser: [
        [
          /^(apache-httpclient|axios|(?:go|java)-http-client|got|guzzlehttp|java|libwww-perl|lua-resty-http|needle|node-(?:fetch|superagent)|okhttp|php-soap|postmanruntime|python-(?:urllib|requests)|scrapy)\/([\w\.]+)/i,
          /(jsdom|java)\/([\w\.]+)/i
        ],
        [e, i, [t, y]]
      ]
    }), Object[r(1284)]({
      device: [
        [/dilink.+(byd) auto/i],
        [n],
        [/(rivian) (r1t)/i],
        [n, "model"],
        [/vcc.+netfront/i],
        [[n, r(1314)]]
      ]
    }), w = Object[r(le)]({ browser: fn(k[r(G)], Q[r(G)], m[r(G)], _[r(1336)]) }), A = /* @__PURE__ */ function() {
      var me = { _0x3f4902: 825, _0x530840: 583 }, Te = { _0x423863: 601, _0x1cec5f: 649 };
      return function() {
        var Xe = 1129, Ke = 582, He = 956, Ae = 1058, Ee = 767, Be = 1107, Ze = 680, qe = 517, Je = 789, vt = 1187, rt = 634, lt = 693, o = 491, I = Ue;
        this[I(514)] = function(O) {
          var f = I;
          return [
            f(1082),
            "amazonbot",
            f(Xe),
            f(Ke),
            "claudebot",
            f(595),
            "applebot-extended",
            "bytespider",
            f(1310),
            f(He),
            f(Ae),
            f(Ee),
            f(Be),
            f(485),
            "google-extended",
            "imagesiftbot",
            "petalbot",
            f(Ze),
            f(785),
            f(qe),
            f(Je),
            f(vt),
            f(rt),
            f(1280),
            "velenpublicwebcrawler",
            f(lt),
            f(o),
            f(777),
            f(1309),
            f(1137)
          ].some(function(B) {
            var se = f;
            return O.toLowerCase()[se(539)](B);
          });
        }, this.isBot = function(O) {
          for (var f = I, B = O[f(1006)](), se = w[f(1336)], de = 0; de < se[f(601)]; de += 2)
            for (var J = se[de], Le = 0, Ce = Array.isArray(J) ? J : [J]; Le < Ce[f(Te._0x423863)]; Le++) {
              var Qe = Ce[Le];
              if (Qe instanceof RegExp && Qe[f(Te._0x1cec5f)](B)) return !0;
            }
          return !1;
        }, this[I(me._0x3f4902)] = function(O) {
          var f = I;
          return O.name === Ln[f(1268)];
        }, this[I(me._0x530840)] = function(O) {
          var f = I;
          return O[f(1006)]()[f(539)](f(1176));
        };
      };
    }(), c[r(820)] = A;
  }(X || (X = {})), function(a) {
    var c, r, e, t, n, i, s, u, h, l, d, p, y, k, Q, m, _, w, A, U, pe, D, W, P, N, H, j, K, ae, ce, ee, re, F, M, le, G, te, me, Te, Xe, Ke, He, Ae, Ee, Be, Ze, qe, Je, vt, rt, lt, o, I, O, f, B, se = 709, de = 723, J = Ht;
    c = a[J(se)] || (a[J(se)] = {}), r = 816, e = 816, t = 1238, n = 716, i = 816, s = 1006, u = 1040, h = 758, l = 717, d = 1050, p = 736, y = 1017, k = 717, Q = 861, m = 742, _ = 1207, w = 565, A = 601, U = 736, pe = 629, D = 841, W = 1006, P = 622, N = 804, H = 754, j = 1259, K = 895, ae = 717, ce = 648, ee = 721, re = 718, F = 648, M = 951, le = 717, G = 717, te = 822, me = 717, Te = 1034, Xe = 771, Ke = 1149, He = 717, Ae = 717, Ee = 1044, Be = 771, Ze = 1259, qe = 804, Je = 1296, vt = 1291, rt = 608, lt = 1182, o = 672, I = 654, O = 672, f = Ue, B = function() {
      var Le = 845, Ce = 1253, Qe = 827, dt = 1234, St = 484, bt = 654, yt = 1182, tt = 1112, be = 726, Pe = 726, he = 931, Ge = 1061, _e = 832, ze = 811, ot = 1212, $e = 1061, et = 1061, gt = 881, Pt = 1061, Rt = 1039, ht = Ue;
      function Tt() {
      }
      return Tt[ht(r)][ht(834)] = function() {
        var fe = ht, oe = document[fe(I)](fe(1182));
        return !(!oe[fe(O)] || !oe[fe(O)]("2d"));
      }, Tt[ht(e)][ht(t)] = function(fe) {
        var oe = ht, pt = document[oe(654)](oe(lt)), _t = null;
        try {
          _t = fe === "webgl" ? pt.getContext(oe(505)) || pt[oe(672)]("experimental-webgl") : pt[oe(o)]("webgl2");
        } catch {
        }
        return _t;
      }, Tt[ht(816)][ht(1296)] = function() {
        var fe = ht;
        if (!this[fe(834)]()) return { supported: !1, type: null };
        var oe = this.getWebglCanvas(fe(608));
        return oe ? { supported: !0, type: fe(608) } : (oe = this.getWebglCanvas(fe(505))) ? { supported: !0, type: fe(505) } : { supported: !1, type: null };
      }, Tt.prototype[ht(1013)] = function() {
        var fe = ht;
        return this[fe(1296)]()[fe(909)];
      }, Tt[ht(e)][ht(n)] = function() {
        var fe = ht, oe = this[fe(Je)](), pt = oe.supported, _t = oe[fe(vt)];
        return pt && _t === fe(rt);
      }, Tt[ht(816)][ht(947)] = function() {
        var fe, oe, pt, _t, je = ht, Ut = document[je(bt)](je(yt));
        try {
          !(fe = Ut[je(672)](je(608))) && !(fe = Ut.getContext(je(505)) || Ut.getContext(je(tt))) && console.log(je(be));
        } catch {
          console.log(je(Pe));
        }
        try {
          oe = fe[je(1159)]("WEBGL_debug_renderer_info"), pt = fe.getParameter(oe[je(he)]), _t = fe[je(Ge)](oe.UNMASKED_RENDERER_WEBGL);
        } catch {
          pt = fe.getParameter(fe.VENDOR), _t = fe[je(1061)](fe[je(_e)]);
        }
        return {
          vendor: pt,
          renderer: _t,
          webglVersion: fe[je(1061)](fe.VERSION),
          shadingLanguageVersion: fe[je(1061)](fe[je(668)]),
          extensions: fe[je(534)](),
          maxTextureSize: fe.getParameter(fe.MAX_TEXTURE_SIZE),
          maxRenderbufferSize: fe[je(Ge)](fe[je(ze)]),
          maxTextureImageUnits: fe[je(1061)](fe.MAX_TEXTURE_IMAGE_UNITS),
          maxVertexTextureImageUnits: fe[je(1061)](fe[je(ot)]),
          maxCombinedTextureImageUnits: fe[je($e)](fe[je(1171)]),
          maxVertexAttribs: fe[je(et)](fe[je(1316)]),
          maxVaryingVectors: fe[je($e)](fe[je(gt)]),
          maxVertexUniformVectors: fe[je(Pt)](fe[je(Rt)]),
          maxFragmentUniformVectors: fe.getParameter(fe[je(782)])
        };
      }, Tt.prototype.getHasLiedLanguages = function() {
        var fe = ht;
        if (navigator.languages !== void 0)
          try {
            if (navigator.languages[0][fe(St)](0, 2) !== navigator.language[fe(484)](0, 2))
              return !0;
          } catch {
            return !0;
          }
        return !1;
      }, Tt.prototype[ht(866)] = function() {
        var fe = ht;
        return window.screen[fe(Le)] < window[fe(827)][fe(Ce)] || window[fe(827)][fe(1100)] < window[fe(Qe)][fe(dt)];
      }, Tt[ht(i)].getHasLiedOs = function() {
        var fe, oe = ht, pt = navigator[oe(D)][oe(W)](), _t = navigator.oscpu, je = navigator[oe(P)].toLowerCase();
        return fe = pt[oe(717)]("windows phone") >= 0 ? oe(N) : pt[oe(717)](oe(H)) >= 0 ? oe(j) : pt[oe(717)](oe(1034)) >= 0 ? oe(K) : pt[oe(717)]("linux") >= 0 || pt.indexOf(oe(556)) >= 0 ? oe(735) : pt[oe(ae)](oe(1044)) >= 0 || pt[oe(717)](oe(771)) >= 0 ? oe(ce) : pt.indexOf(oe(ee)) >= 0 ? oe(915) : "Other", ("ontouchstart" in window || navigator[oe(re)] > 0 || navigator[oe(632)] > 0) && fe !== "Windows Phone" && fe !== oe(895) && fe !== oe(F) && fe !== oe(M) || typeof _t !== oe(727) && ((_t = _t[oe(1006)]())[oe(le)]("win") >= 0 && fe !== oe(j) && fe !== oe(804) || _t.indexOf("linux") >= 0 && fe !== oe(735) && fe !== oe(895) || _t.indexOf(oe(721)) >= 0 && fe !== "Mac" && fe !== oe(F) || (_t[oe(717)](oe(754)) === -1 && _t[oe(G)](oe(822)) === -1 && _t[oe(717)]("mac") === -1) != (fe === "Other")) ? !0 : je[oe(717)](oe(754)) >= 0 && fe !== oe(j) && fe !== oe(804) || (je.indexOf(oe(te)) >= 0 || je[oe(me)](oe(Te)) >= 0 || je[oe(ae)](oe(791)) >= 0) && fe !== oe(735) && fe !== oe(895) || (je[oe(717)](oe(ee)) >= 0 || je[oe(717)](oe(Xe)) >= 0 || je.indexOf(oe(Ke)) >= 0 || je.indexOf(oe(1044)) >= 0) && fe !== oe(915) && fe !== "iOS" || (je[oe(717)]("win") < 0 && je[oe(He)]("linux") < 0 && je[oe(Ae)](oe(ee)) < 0 && je[oe(717)](oe(Ee)) < 0 && je.indexOf(oe(Be)) < 0) != (fe === oe(M)) || typeof navigator[oe(1301)] === oe(727) && fe !== oe(Ze) && fe !== oe(qe);
      }, Tt.prototype[ht(1132)] = function() {
        var fe, oe = ht, pt = navigator.userAgent[oe(s)](), _t = navigator[oe(u)];
        if (((fe = pt.indexOf("firefox") >= 0 ? oe(h) : pt[oe(l)](oe(958)) >= 0 || pt.indexOf(oe(d)) >= 0 ? oe(p) : pt.indexOf("chrome") >= 0 ? oe(y) : pt[oe(k)]("safari") >= 0 ? oe(Q) : pt.indexOf(oe(m)) >= 0 ? "Internet Explorer" : oe(951)) === oe(1017) || fe === "Safari" || fe === "Opera") && _t !== oe(_))
          return !0;
        var je, Ut = eval[oe(w)]()[oe(A)];
        if (Ut === 37 && fe !== oe(Q) && fe !== "Firefox" && fe !== "Other" || Ut === 39 && fe !== oe(910) && fe !== "Other" || Ut === 33 && fe !== oe(y) && fe !== oe(U) && fe !== oe(951)) return !0;
        try {
          throw "a";
        } catch (Kt) {
          try {
            Kt[oe(pe)](), je = !0;
          } catch {
            je = !1;
          }
        }
        return je && fe !== "Firefox" && fe !== oe(951);
      }, Tt;
    }(), c[f(de)] = B;
  }(X || (X = {})), function(a) {
    var c, r, e, t, n = 816, i = 816, s = Ht;
    c = a._POSignalsMetadata || (a[s(709)] = {}), r = { _0x5e45cd: 755 }, e = Ue, t = function() {
      var u = Ue;
      function h(l) {
        this[Ue(r._0x5e45cd)] = l;
      }
      return h[u(816)][u(1328)] = function() {
        var l = 786, d = 1278, p = 1141;
        return Me(this, void 0, void 0, function() {
          var y, k = this;
          return Re(this, function(Q) {
            var m = Ue;
            switch (Q.label) {
              case 0:
                return [4, this[m(l)](window)];
              case 1:
                return y = Q[m(d)](), [
                  4,
                  this.test(y, m(p), function() {
                    return Me(k, void 0, void 0, function() {
                      var _, w, A = 968, U = 815, pe = 935, D = 745, W = 1239, P = 486, N = 565;
                      return Re(this, function(H) {
                        var j = Ue;
                        switch (H[j(A)]) {
                          case 0:
                            return Object[j(1239)] && (_ = a[j(U)][j(526)].createInvisibleElement("iframe")) ? (_[j(929)] = j(pe), document[j(D)].appendChild(_), Object[j(W)](HTMLIFrameElement[j(816)])[j(P)][j(952)][j(N)]() !== j(1315) ? [2, !0] : _.contentWindow === window ? [2, !0] : [4, this.headlessResults(_.contentWindow)]) : [2];
                          case 1:
                            return w = H[j(1278)](), _.remove(), [2, w];
                        }
                      });
                    });
                  })
                ];
              case 2:
                return Q[m(d)](), [2, y];
            }
          });
        });
      }, h[u(n)].headlessResults = function(l) {
        return Me(this, void 0, void 0, function() {
          var d, p, y = 649, k = 862, Q = 528, m = 1161, _ = 649, w = 983, A = 1048, U = 649, pe = 1278, D = this;
          return Re(this, function(W) {
            var P = Ue;
            switch (W.label) {
              case 0:
                return d = /* @__PURE__ */ new Map(), (p = [])[P(1161)](
                  this[P(y)](d, "headless_chrome", function() {
                    var N = 649;
                    return Me(D, void 0, void 0, function() {
                      return Re(this, function(H) {
                        return [2, /HeadlessChrome/[Ue(N)](l.navigator.userAgent)];
                      });
                    });
                  })
                ), p[P(1161)](
                  this[P(649)](d, P(k), function() {
                    return Me(D, void 0, void 0, function() {
                      return Re(this, function(N) {
                        var H = Ue;
                        return [2, l[H(656)][H(1302)]];
                      });
                    });
                  })
                ), p.push(
                  this.test(d, P(Q), function() {
                    var N = 649;
                    return Me(D, void 0, void 0, function() {
                      return Re(this, function(H) {
                        var j = Ue;
                        return [2, /Chrome/[j(N)](l.navigator[j(841)]) && !l[j(781)]];
                      });
                    });
                  })
                ), p[P(m)](
                  this[P(649)](d, P(961), function() {
                    return Me(D, void 0, void 0, function() {
                      var N, H = 968, j = 641, K = 656, ae = 1270, ce = 635;
                      return Re(this, function(ee) {
                        var re = Ue;
                        switch (ee[re(H)]) {
                          case 0:
                            return l[re(656)][re(j)] && l[re(536)] ? [4, l[re(K)][re(641)][re(ae)]({ name: "notifications" })] : [3, 2];
                          case 1:
                            return N = ee.sent(), [2, l[re(536)].permission === re(ce) && N[re(865)] === re(605)];
                          case 2:
                            return [2];
                        }
                      });
                    });
                  })
                ), p[P(1161)](
                  this.test(d, P(1193), function() {
                    return Me(D, void 0, void 0, function() {
                      var N, H = 1270, j = 1021, K = 565, ae = 565, ce = 565, ee = 1232, re = 658;
                      return Re(this, function(F) {
                        var M = Ue;
                        return (N = l[M(656)][M(641)]) ? N[M(H)][M(565)]() !== M(j) ? [2, !0] : N[M(1270)][M(K)][M(ae)]() !== M(1102) ? [2, !0] : N[M(1270)][M(565)][M(1232)](M(734)) && N[M(1270)][M(565)][M(1232)]("[[Target]]") && N[M(1270)][M(ce)][M(ee)](M(re)) ? [2, !0] : [2, N[M(ee)]("query")] : [2];
                      });
                    });
                  })
                ), p[P(m)](
                  this[P(_)](d, P(1158), function() {
                    var N = 601;
                    return Me(D, void 0, void 0, function() {
                      return Re(this, function(H) {
                        var j = Ue;
                        return [2, navigator[j(1301)][j(N)] === 0];
                      });
                    });
                  })
                ), p[P(1161)](
                  this[P(_)](d, P(w), function() {
                    return Me(D, void 0, void 0, function() {
                      var N = 590;
                      return Re(this, function(H) {
                        return [2, navigator[Ue(N)] === ""];
                      });
                    });
                  })
                ), p[P(m)](
                  this.test(d, P(A), function() {
                    var N = 1301, H = 1301;
                    return Me(D, void 0, void 0, function() {
                      var j;
                      return Re(this, function(K) {
                        var ae = Ue;
                        return j = PluginArray[ae(816)] === navigator[ae(N)][ae(747)], navigator[ae(1301)][ae(601)] > 0 && (j = j && Plugin[ae(816)] === navigator[ae(H)][0][ae(747)]), [2, j];
                      });
                    });
                  })
                ), p[P(m)](
                  this[P(U)](d, "consistent_mimetypes_prototype", function() {
                    return Me(D, void 0, void 0, function() {
                      var N, H = 816, j = 674, K = 601;
                      return Re(this, function(ae) {
                        var ce = Ue;
                        return N = MimeTypeArray[ce(H)] === navigator[ce(674)][ce(747)], navigator[ce(j)][ce(K)] > 0 && (N = N && MimeType.prototype === navigator[ce(674)][0].__proto__), [2, N];
                      });
                    });
                  })
                ), [4, Promise.all(p)];
              case 1:
                return W[P(pe)](), [2, d];
            }
          });
        });
      }, h[u(i)][u(649)] = function(l, d, p) {
        return Me(this, void 0, void 0, function() {
          var y, k, Q = 968, m = 1161, _ = 815, w = 840;
          return Re(this, function(A) {
            var U = Ue;
            switch (A[U(Q)]) {
              case 0:
                return A[U(737)][U(m)]([0, 3, , 4]), this[U(755)][U(886)](d) ? [3, 2] : [4, a._POSignalsUtils.Util[U(1138)](100, p())];
              case 1:
                (y = A.sent()) != null && (l[d] = y), A[U(Q)] = 2;
              case 2:
                return [3, 4];
              case 3:
                return k = A[U(1278)](), a[U(_)][U(599)][U(w)](d + U(530), k), [3, 4];
              case 4:
                return [2];
            }
          });
        });
      }, h;
    }(), c[e(1249)] = t;
  }(X || (X = {})), function(a) {
    var c = Ht;
    (function(r) {
      (a[c(709)] || (a[c(709)] = {})).detectIncognitoInternal = function() {
        var e = 857, t = { _0x4887ec: 1196, _0x596187: 649 }, n = { _0x35d710: 990 };
        return new Promise(function(i, s) {
          var u = { _0x46452b: 1095 }, h = { _0x328475: 926, _0x303829: 569, _0x4e8668: 539, _0x41dc0a: 1235 }, l = { _0x50ed0b: 506, _0x1dbfcf: 1228 }, d = Ue, p = d(787), y = !1;
          function k(U) {
            y || (y = !0, i({ isPrivate: U, browserName: p }));
          }
          function Q() {
            var U = d, pe = 0, D = parseInt("-1");
            try {
              D[U(768)](D);
            } catch (W) {
              pe = W[U(n._0x35d710)].length;
            }
            return pe;
          }
          function m() {
            return navigator[d(806)] !== void 0 && function(U) {
              var pe = d;
              try {
                return U === eval[pe(565)]()[pe(601)];
              } catch {
                return !1;
              }
            }(39);
          }
          function _() {
            var U = 883;
            return Me(this, void 0, void 0, function() {
              var pe;
              return Re(this, function(D) {
                var W = Ue;
                switch (D[W(968)]) {
                  case 0:
                    return typeof ((pe = navigator[W(U)]) === null || pe === void 0 ? void 0 : pe[W(588)]) !== W(974) ? [3, 2] : [
                      4,
                      function() {
                        var P, N = 1161, H = 588, j = 1278, K = 968, ae = 1278, ce = 990, ee = 1155;
                        return Me(this, void 0, void 0, function() {
                          var re, F, M;
                          return Re(this, function(le) {
                            var G = Ue;
                            switch (le[G(968)]) {
                              case 0:
                                return le[G(737)][G(N)]([0, 4, , 5]), typeof ((re = navigator[G(883)]) === null || re === void 0 ? void 0 : re[G(H)]) !== G(974) ? [3, 2] : [4, re[G(588)]()];
                              case 1:
                                return le[G(j)](), k(!1), [3, 3];
                              case 2:
                                k(!1), le[G(K)] = 3;
                              case 3:
                                return [3, 5];
                              case 4:
                                return F = le[G(ae)](), k(
                                  typeof (M = F instanceof Error && (P = F[G(ce)]) !== null && P !== void 0 ? P : F) === G(1133) && M[G(539)](G(ee))
                                ), [3, 5];
                              case 5:
                                return [2];
                            }
                          });
                        });
                      }()
                    ];
                  case 1:
                    return D[W(1278)](), [3, 3];
                  case 2:
                    navigator[W(718)] !== void 0 ? function() {
                      var P = d, N = String(Math.random());
                      try {
                        var H = indexedDB[P(1250)](N, 1);
                        H[P(1062)] = function(j) {
                          var K = P, ae = j[K(967)][K(h._0x328475)];
                          try {
                            ae[K(493)]("t", { autoIncrement: !0 })[K(h._0x303829)](new Blob()), k(!1);
                          } catch (ce) {
                            k((ce.message || "")[K(h._0x4e8668)]("are not yet supported"));
                          } finally {
                            ae.close(), indexedDB[K(h._0x41dc0a)](N);
                          }
                        }, H[P(510)] = function() {
                          return k(!1);
                        };
                      } catch {
                        k(!1);
                      }
                    }() : function() {
                      var P = d;
                      try {
                        window[P(t._0x4887ec)](null, null, null, null);
                      } catch {
                        return k(!0);
                      }
                      try {
                        localStorage[P(746)](P(649), "1"), localStorage.removeItem(P(t._0x596187));
                      } catch {
                        return k(!0);
                      }
                      k(!1);
                    }(), D.label = 3;
                  case 3:
                    return [2];
                }
              });
            });
          }
          function w() {
            var U = d;
            navigator[U(757)].queryUsageAndQuota(
              function(pe, D) {
                var W, P, N, H, j = U;
                k(
                  Math.round(D / 1048576) < 2 * Math[j(u._0x46452b)](
                    (N = d, ((H = (P = (W = performance) === null || W === void 0 ? void 0 : W.memory) === null || P === void 0 ? void 0 : P[N(793)]) !== null && H !== void 0 ? H : 1073741824) / 1048576)
                  )
                );
              },
              function(pe) {
                var D = U;
                s(new Error(D(1191) + pe[D(990)]));
              }
            );
          }
          function A() {
            var U = d;
            self[U(1289)] && self[U(1289)][U(1216)] ? w() : (0, window[d(1194)])(
              0,
              1,
              function() {
                return k(!1);
              },
              function() {
                return k(!0);
              }
            );
          }
          (function() {
            var U = 910;
            return Me(this, void 0, void 0, function() {
              return Re(this, function(pe) {
                var D, W, P = Ue;
                switch (pe[P(968)]) {
                  case 0:
                    return Q() !== 44 ? [3, 2] : (p = "Safari", [4, _()]);
                  case 1:
                    return pe[P(1278)](), [3, 6];
                  case 2:
                    return Q() !== 51 ? [3, 3] : (D = d, W = navigator[D(841)], p = W[D(l._0x50ed0b)](/Chrome/) ? navigator.brave !== void 0 ? D(l._0x1dbfcf) : W[D(506)](/Edg/) ? "Edge" : W.match(/OPR/) ? D(736) : D(1017) : "Chromium", A(), [3, 6]);
                  case 3:
                    return Q() !== 25 ? [3, 5] : (p = "Firefox", [
                      4,
                      function() {
                        var N = 588, H = 737, j = 1161, K = 1133, ae = 1122;
                        return Me(this, void 0, void 0, function() {
                          var ce, ee, re;
                          return Re(this, function(F) {
                            var M = Ue;
                            switch (F.label) {
                              case 0:
                                if (typeof ((ce = navigator[M(883)]) === null || ce === void 0 ? void 0 : ce[M(N)]) !== M(974))
                                  return [3, 5];
                                F[M(968)] = 1;
                              case 1:
                                return F[M(H)][M(j)]([1, 3, , 4]), [4, ce[M(588)]()];
                              case 2:
                                return F.sent(), k(!1), [3, 4];
                              case 3:
                                return ee = F[M(1278)](), k(
                                  typeof (re = ee instanceof Error ? ee[M(990)] : String(ee)) === M(K) && re[M(539)](M(ae))
                                ), [2];
                              case 4:
                                return [3, 6];
                              case 5:
                                k(navigator.serviceWorker === void 0), F[M(968)] = 6;
                              case 6:
                                return [2];
                            }
                          });
                        });
                      }()
                    ]);
                  case 4:
                    return pe.sent(), [3, 6];
                  case 5:
                    m() ? (p = P(U), k(window[d(496)] === void 0)) : s(new Error("Browser unknown")), pe[P(968)] = 6;
                  case 6:
                    return [2];
                }
              });
            });
          })()[d(e)](s);
        });
      };
    })();
  }(X || (X = {})), function(a) {
    var c, r, e, t, n, i, s, u, h, l, d, p, y, k, Q, m = 733, _ = Ht;
    c = a._POSignalsMetadata || (a[_(709)] = {}), r = 1071, e = 816, t = 829, n = 899, i = 781, s = 950, u = 1059, h = 739, l = 1279, d = 816, p = 974, y = 882, k = Ue, Q = function() {
      var w = 816, A = 764, U = 816, pe = 565, D = 899, W = 727, P = 849, N = 886, H = 901, j = 875, K = 549, ae = 1237, ce = 926, ee = Ue;
      function re(F) {
        this.propertyBlackList = F, this.result = {};
      }
      return re[ee(816)].documentLie = function(F, M) {
        var le = ee;
        if (M.lied)
          for (var G = 0, te = M[le(ae)]; G < te.length; G++) {
            var me = te[G];
            !this[le(ce)][me] && (this.result[me] = []), this[le(926)][me][le(1161)](F);
          }
      }, re[ee(816)][ee(1195)] = function(F, M, le) {
        var G = 1099, te = ee, me = this;
        if (le === void 0 && (le = null), typeof F != te(p)) return { lied: !1, lieTypes: [] };
        var Te = F.name.replace(/get\s/, ""), Xe = {
          undefined_properties: function() {
            return !!le && re[te(1173)](le, Te);
          },
          to_string: function() {
            var He = te;
            return re.getToStringLie(F, Te, me[He(G)]);
          },
          prototype_in_function: function() {
            return re[te(K)](F);
          },
          own_property: function() {
            return re[te(j)](F);
          },
          object_to_string_error: function() {
            return re[te(829)](F);
          }
        }, Ke = Object[te(y)](Xe)[te(606)](function(He) {
          var Ae = te;
          return !me.propertyBlackList[Ae(N)](Ae(H) + He) && !!Xe[He]();
        });
        return { lied: Ke[te(601)] > 0, lieTypes: Ke };
      }, re[ee(816)][ee(r)] = function() {
        return Me(this, void 0, void 0, function() {
          var F, M = 755, le = 945, G = 815, te = 991, me = 1243, Te = 745, Xe = 996, Ke = 1258, He = 500, Ae = 769, Ee = 500, Be = 623, Ze = 844, qe = 500, Je = 1220, vt = 500, rt = 1301, lt = 1278, o = 481, I = 926;
          return Re(this, function(O) {
            var f = Ue;
            switch (O.label) {
              case 0:
                return this[f(M)].has(f(le)) ? [2, this.result] : (!this[f(755)].has("LIES_IFRAME") && (F = a[f(G)].Util[f(te)](f(me))) && (document[f(Te)][f(Xe)](F), this[f(1099)] = F), [
                  4,
                  Promise[f(Ke)]([
                    this[f(He)](
                      function() {
                        return AnalyserNode;
                      },
                      { target: ["minDecibels"] }
                    ),
                    this[f(500)](
                      function() {
                        return AudioBuffer;
                      },
                      { target: [f(Ae)] }
                    ),
                    this[f(500)](
                      function() {
                        return BiquadFilterNode;
                      },
                      { target: [f(1120)] }
                    ),
                    this[f(He)](
                      function() {
                        return CanvasRenderingContext2D;
                      },
                      { target: ["getLineDash"] }
                    ),
                    this[f(500)](
                      function() {
                        return DOMRect;
                      },
                      { target: [f(1100)] }
                    ),
                    this[f(Ee)](
                      function() {
                        return DOMRectReadOnly;
                      },
                      { target: [f(Be)] }
                    ),
                    this[f(500)](
                      function() {
                        return Element;
                      },
                      { target: [f(Ze)] }
                    ),
                    this[f(qe)](
                      function() {
                        return HTMLCanvasElement;
                      },
                      { target: [f(1100)] }
                    ),
                    this[f(qe)](
                      function() {
                        return Math;
                      },
                      { target: [f(687)] }
                    ),
                    this.searchLies(
                      function() {
                        return MediaDevices;
                      },
                      { target: [f(Je)] }
                    ),
                    this[f(vt)](
                      function() {
                        return Navigator;
                      },
                      { target: [f(rt)] }
                    ),
                    this[f(He)](
                      function() {
                        return OffscreenCanvasRenderingContext2D;
                      },
                      { target: [f(489)] }
                    ),
                    this[f(500)](
                      function() {
                        return SVGRect;
                      },
                      { target: ["x"] }
                    )
                  ])
                ]);
              case 1:
                return O[f(lt)](), this[f(1099)][f(o)](), [2, this[f(I)]];
            }
          });
        });
      }, re[ee(e)][ee(500)] = function(F, M) {
        var le = 816, G = 1140, te = { _0x5c76d2: 727 }, me = ee, Te = M === void 0 ? {} : M, Xe = Te.target, Ke = Xe === void 0 ? [] : Xe, He = Te[me(479)], Ae = He === void 0 ? [] : He;
        return Me(this, void 0, void 0, function() {
          var Ee = 533, Be = 886, Ze = 1114, qe = 649, Je = 700, vt = 816, rt = 1195, lt = 1195, o = 599, I, O, f = this;
          return Re(this, function(B) {
            var se, de = Ue;
            try {
              if (I = F(), typeof (se = I) == Ue(te._0x5c76d2) || !se) return [2];
            } catch {
              return [2];
            }
            return O = I[de(le)] ? I.prototype : I, Object[de(984)](O)[de(G)](function(J) {
              var Le = de;
              if (!(J == Le(Ee) || Ke.length && !new Set(Ke)[Le(Be)](J) || Ae[Le(601)] && new Set(Ae).has(J))) {
                var Ce = /\s(.+)\]/, Qe = (I[Le(Ze)] ? I.name : Ce[Le(qe)](I) ? Ce[Le(Je)](I)[1] : void 0) + "." + J;
                try {
                  var dt = I[Le(vt)] ? I[Le(816)] : I;
                  try {
                    if (typeof dt[J] == "function") {
                      var St = f[Le(rt)](dt[J], dt);
                      return void f[Le(554)](Qe, St);
                    }
                  } catch {
                  }
                  var bt = Object[Le(849)](dt, J)[Le(952)], yt = f[Le(lt)](bt, dt, I);
                  f[Le(554)](Qe, yt);
                } catch (tt) {
                  a._POSignalsUtils[Le(o)][Le(840)](Le(797) + J + " test execution", tt);
                }
              }
            }), [2];
          });
        });
      }, re[ee(1173)] = function(F, M) {
        var le = ee, G = F[le(1114)], te = window[G.charAt(0).toLowerCase() + G[le(D)](1)];
        return !!te && (typeof Object[le(849)](te, M) != le(W) || Reflect[le(P)](te, M) !== void 0);
      }, re.getToStringLie = function(F, M, le) {
        var G, te, me = 1244, Te = 1143, Xe = 1152, Ke = 939, He = ee;
        try {
          G = le[He(764)][He(816)][He(565)][He(675)](F);
        } catch {
        }
        try {
          te = le[He(A)][He(U)][He(pe)].call(F[He(pe)]);
        } catch {
        }
        var Ae = G || F[He(565)](), Ee = te || F[He(565)][He(565)](), Be = function(Ze) {
          var qe, Je = He;
          return (qe = {})[Je(1143) + Ze + "() { [native code] }"] = !0, qe[Je(me) + Ze + Je(1333)] = !0, qe[Je(1254)] = !0, qe[Je(Te) + Ze + Je(Xe) + `
` + Je(Ke) + `
}`] = !0, qe[Je(1244) + Ze + `() {
` + Je(939) + `
}`] = !0, qe[Je(992) + `
    [native code]
}`] = !0, qe;
        };
        return !Be(M)[Ae] || !Be(He(565))[Ee];
      }, re[ee(549)] = function(F) {
        return ee(w) in F;
      }, re[ee(875)] = function(F) {
        var M = ee;
        return F[M(1232)](M(h)) || F[M(1232)](M(l)) || F.hasOwnProperty(M(d)) || F.hasOwnProperty("toString");
      }, re[ee(t)] = function(F) {
        var M = 649, le = ee;
        try {
          return Object[le(592)](F)[le(565)](), !0;
        } catch (Ke) {
          var G = Ke.stack[le(647)](`
`), te = /at Object\.apply/, me = !G[le(n)](1)[le(937)](function(He) {
            return te[le(M)](He);
          }), Te = Ke.constructor[le(1114)] == "TypeError" && G[le(601)] > 1, Xe = le(i) in window || c[le(s)][le(u)]();
          return !(!Te || !Xe || /at Function\.toString/[le(649)](G[1]) && me) || !Te;
        }
      }, re;
    }(), c[k(m)] = Q;
  }(X || (X = {})), function(a) {
    var c, r, e, t, n, i, s = 798, u = 1094, h = Ht;
    c = a[h(709)] || (a[h(709)] = {}), r = 816, e = 933, t = { _0x3ea1cb: 755 }, n = Ue, i = function() {
      var l = 1168, d = 542, p = 647, y = 649, k = 938, Q = 781, m = 950, _ = 1094, w = 926, A = 1046, U = 565, pe = 1046, D = 781, W = 902, P = 533, N = 938, H = 558, j = 929, K = Ue;
      function ae(ce) {
        var ee = Ue;
        this[ee(t._0x3ea1cb)] = ce, this[ee(926)] = /* @__PURE__ */ new Map();
      }
      return ae[K(816)][K(660)] = function() {
        var ce = 1243, ee = 815, re = 526, F = K;
        return this[F(_)]("srcdoc_throws_error", function() {
          var M = F;
          try {
            return !!document[M(654)](M(1243))[M(j)];
          } catch {
            return !0;
          }
        }), this.addStealthTest("srcdoc_triggers_window_proxy", function() {
          var M = F, le = document[M(654)](M(ce));
          return le.srcdoc = "" + a[M(ee)][M(re)].hashMini(crypto[M(1287)](new Uint32Array(10))), !!le.contentWindow;
        }), this.addStealthTest(F(749), function() {
          var M = F, le = "cookieStore" in window ? M(1065) : M(558) in window ? M(H) : M(740), G = [];
          for (var te in window) G[M(1161)](te);
          return G.indexOf("chrome") > G[M(717)](le);
        }), this[F(1094)](F(957), function() {
          var M = F;
          if (!(M(D) in window && M(902) in window.chrome)) return !1;
          try {
            return M(816) in window[M(781)][M(W)][M(867)] || M(816) in window[M(781)][M(902)][M(969)] || (new window[M(D)][M(W)][M(867)](), new window[M(D)][M(W)].connect(), !0);
          } catch (le) {
            return le[M(P)][M(1114)] != M(N);
          }
        }), this[F(1094)]("Function_prototype_toString_invalid_typeError", function() {
          var M = F, le = new ae.StackTraceTester();
          return le[M(A)](Function.prototype[M(U)]) || le[M(pe)](function() {
          });
        }), this[F(w)];
      }, ae[K(816)][K(u)] = function(ce, ee) {
        var re = K;
        if (!this.propertyBlackList[re(886)](ce))
          try {
            this.result[ce] = ee();
          } catch (F) {
            a._POSignalsUtils.Logger[re(840)](re(772) + ce + re(e), F);
          }
      }, ae[K(835)] = function() {
        var ce = K;
        function ee() {
        }
        return ee[ce(r)][ce(1046)] = function(re) {
          var F = ce, M = this;
          try {
            return this[F(l)] = function() {
              var Te = F;
              return Object[Te(592)](re)[Te(565)]();
            }, this.cant = function() {
              return M[F(1168)]();
            }, this[F(d)] = function() {
              return M[F(1257)]();
            }, this[F(542)](), !0;
          } catch (Te) {
            var le = Te[F(1242)][F(p)](`
`), G = !/at Object\.apply/[F(y)](le[1]), te = Te[F(533)][F(1114)] == F(k) && le.length >= 5, me = F(Q) in window || c[F(m)][F(1059)]();
            return !(!te || !me || G && /at Function\.toString/[F(649)](le[1]) && /\.you/.test(le[2]) && /\.cant/[F(649)](le[3]) && /\.hide/.test(le[4])) || !te;
          }
        }, ee;
      }(), ae;
    }(), c[n(s)] = i;
  }(X || (X = {})), function(a) {
    var c, r, e, t, n, i = Ht;
    c = a[i(709)] || (a[i(709)] = {}), r = 1045, e = 893, t = Ue, n = function() {
      var s = Ue;
      function u() {
      }
      return u[s(1337)] = function() {
        var h = s;
        return a[h(709)][h(r)]()[h(e)](function(l) {
          return l.isPrivate;
        })[h(857)](function() {
          return !1;
        });
      }, u;
    }(), c[t(559)] = n;
  }(X || (X = {}));
  var Qt = /* @__PURE__ */ function() {
    var a = function(c, r) {
      return (a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
        e.__proto__ = t;
      } || function(e, t) {
        for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
      })(c, r);
    };
    return function(c, r) {
      function e() {
        this.constructor = c;
      }
      a(c, r), c.prototype = r === null ? Object.create(r) : (e.prototype = r.prototype, new e());
    };
  }();
  Me = function(a, c, r, e) {
    return new (r || (r = Promise))(function(t, n) {
      function i(h) {
        try {
          u(e.next(h));
        } catch (l) {
          n(l);
        }
      }
      function s(h) {
        try {
          u(e.throw(h));
        } catch (l) {
          n(l);
        }
      }
      function u(h) {
        var l;
        h.done ? t(h.value) : (l = h.value, l instanceof r ? l : new r(function(d) {
          d(l);
        })).then(i, s);
      }
      u((e = e.apply(a, c || [])).next());
    });
  }, Re = function(a, c) {
    var r, e, t, n, i = {
      label: 0,
      sent: function() {
        if (1 & t[0]) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    };
    return n = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (n[Symbol.iterator] = function() {
      return this;
    }), n;
    function s(u) {
      return function(h) {
        return function(l) {
          if (r) throw new TypeError("Generator is already executing.");
          for (; i; )
            try {
              if (r = 1, e && (t = 2 & l[0] ? e.return : l[0] ? e.throw || ((t = e.return) && t.call(e), 0) : e.next) && !(t = t.call(e, l[1])).done)
                return t;
              switch (e = 0, t && (l = [2 & l[0], t.value]), l[0]) {
                case 0:
                case 1:
                  t = l;
                  break;
                case 4:
                  return i.label++, { value: l[1], done: !1 };
                case 5:
                  i.label++, e = l[1], l = [0];
                  continue;
                case 7:
                  l = i.ops.pop(), i.trys.pop();
                  continue;
                default:
                  if (!(t = (t = i.trys).length > 0 && t[t.length - 1]) && (l[0] === 6 || l[0] === 2)) {
                    i = 0;
                    continue;
                  }
                  if (l[0] === 3 && (!t || l[1] > t[0] && l[1] < t[3])) {
                    i.label = l[1];
                    break;
                  }
                  if (l[0] === 6 && i.label < t[1]) {
                    i.label = t[1], t = l;
                    break;
                  }
                  if (t && i.label < t[2]) {
                    i.label = t[2], i.ops.push(l);
                    break;
                  }
                  t[2] && i.ops.pop(), i.trys.pop();
                  continue;
              }
              l = c.call(a, i);
            } catch (d) {
              l = [6, d], e = 0;
            } finally {
              r = t = 0;
            }
          if (5 & l[0]) throw l[1];
          return { value: l[0] ? l[1] : void 0, done: !0 };
        }([u, h]);
      };
    }
  }, Ct = function() {
    return (Ct = Object.assign || function(a) {
      for (var c, r = 1, e = arguments.length; r < e; r++)
        for (var t in c = arguments[r])
          Object.prototype.hasOwnProperty.call(c, t) && (a[t] = c[t]);
      return a;
    }).apply(this, arguments);
  }, fn = function() {
    for (var a = 0, c = 0, r = arguments.length; c < r; c++) a += arguments[c].length;
    var e = Array(a), t = 0;
    for (c = 0; c < r; c++)
      for (var n = arguments[c], i = 0, s = n.length; i < s; i++, t++) e[t] = n[i];
    return e;
  }, function(a) {
    (function(c) {
      c[c.Unknown = 0] = "Unknown", c[c.FlingRight = 1] = "FlingRight", c[c.FlingLeft = 2] = "FlingLeft", c[c.FlingUp = 3] = "FlingUp", c[c.FlingDown = 4] = "FlingDown", c[c.Diagonal = 5] = "Diagonal", c[c.ScrollRight = 6] = "ScrollRight", c[c.ScrollLeft = 7] = "ScrollLeft", c[c.ScrollUp = 8] = "ScrollUp", c[c.ScrollDown = 9] = "ScrollDown", c[c.Tap = 10] = "Tap", c[c.DoubleTap = 11] = "DoubleTap";
    })(a.GestureType || (a.GestureType = {}));
  }(X || (X = {})), function(a) {
    var c = function() {
      function d(p, y) {
        this.handler = p, this.isOnce = y, this.isExecuted = !1;
      }
      return d.prototype.execute = function(p, y, k) {
        if (!this.isOnce || !this.isExecuted) {
          this.isExecuted = !0;
          var Q = this.handler;
          p ? setTimeout(function() {
            Q.apply(y, k);
          }, 1) : Q.apply(y, k);
        }
      }, d;
    }(), r = function() {
      function d() {
        this._wrap = new i(this), this._subscriptions = new Array();
      }
      return d.prototype.subscribe = function(p) {
        p && this._subscriptions.push(new c(p, !1));
      }, d.prototype.sub = function(p) {
        this.subscribe(p);
      }, d.prototype.one = function(p) {
        p && this._subscriptions.push(new c(p, !0));
      }, d.prototype.has = function(p) {
        if (p) {
          for (var y = 0, k = this._subscriptions; y < k.length; y++)
            if (k[y].handler == p) return !0;
        }
        return !1;
      }, d.prototype.unsubscribe = function(p) {
        if (p) {
          for (var y = 0; y < this._subscriptions.length; y++)
            if (this._subscriptions[y].handler == p) {
              this._subscriptions.splice(y, 1);
              break;
            }
        }
      }, d.prototype.unsub = function(p) {
        this.unsubscribe(p);
      }, d.prototype._dispatch = function(p, y, k) {
        for (var Q = 0; Q < this._subscriptions.length; Q++) {
          var m = this._subscriptions[Q];
          if (m.isOnce) {
            if (m.isExecuted === !0) continue;
            this._subscriptions.splice(Q, 1), Q--;
          }
          m.execute(p, y, k);
        }
      }, d.prototype.asEvent = function() {
        return this._wrap;
      }, d;
    }();
    a.DispatcherBase = r;
    var e = function(d) {
      function p() {
        return d !== null && d.apply(this, arguments) || this;
      }
      return Qt(p, d), p.prototype.dispatch = function(y, k) {
        this._dispatch(!1, this, arguments);
      }, p.prototype.dispatchAsync = function(y, k) {
        this._dispatch(!0, this, arguments);
      }, p;
    }(r);
    a.EventDispatcher = e;
    var t = function(d) {
      function p() {
        return d !== null && d.apply(this, arguments) || this;
      }
      return Qt(p, d), p.prototype.dispatch = function(y) {
        this._dispatch(!1, this, arguments);
      }, p.prototype.dispatchAsync = function(y) {
        this._dispatch(!0, this, arguments);
      }, p;
    }(r), n = function(d) {
      function p() {
        return d !== null && d.apply(this, arguments) || this;
      }
      return Qt(p, d), p.prototype.dispatch = function() {
        this._dispatch(!1, this, arguments);
      }, p.prototype.dispatchAsync = function() {
        this._dispatch(!0, this, arguments);
      }, p;
    }(r), i = function() {
      function d(p) {
        this._subscribe = function(y) {
          return p.subscribe(y);
        }, this._unsubscribe = function(y) {
          return p.unsubscribe(y);
        }, this._one = function(y) {
          return p.one(y);
        }, this._has = function(y) {
          return p.has(y);
        };
      }
      return d.prototype.subscribe = function(p) {
        this._subscribe(p);
      }, d.prototype.sub = function(p) {
        this.subscribe(p);
      }, d.prototype.unsubscribe = function(p) {
        this._unsubscribe(p);
      }, d.prototype.unsub = function(p) {
        this.unsubscribe(p);
      }, d.prototype.one = function(p) {
        this._one(p);
      }, d.prototype.has = function(p) {
        return this._has(p);
      }, d;
    }(), s = function() {
      function d() {
        this._events = {};
      }
      return d.prototype.get = function(p) {
        var y = this._events[p];
        return y || (y = this.createDispatcher(), this._events[p] = y, y);
      }, d.prototype.remove = function(p) {
        this._events[p] = null;
      }, d;
    }(), u = function(d) {
      function p() {
        return d !== null && d.apply(this, arguments) || this;
      }
      return Qt(p, d), p.prototype.createDispatcher = function() {
        return new e();
      }, p;
    }(s), h = function(d) {
      function p() {
        return d !== null && d.apply(this, arguments) || this;
      }
      return Qt(p, d), p.prototype.createDispatcher = function() {
        return new t();
      }, p;
    }(s), l = function(d) {
      function p() {
        return d !== null && d.apply(this, arguments) || this;
      }
      return Qt(p, d), p.prototype.createDispatcher = function() {
        return new n();
      }, p;
    }(s);
    (function() {
      function d() {
        this._events = new u();
      }
      Object.defineProperty(d.prototype, "events", {
        get: function() {
          return this._events;
        },
        enumerable: !1,
        configurable: !0
      }), d.prototype.subscribe = function(p, y) {
        this._events.get(p).subscribe(y);
      }, d.prototype.sub = function(p, y) {
        this.subscribe(p, y);
      }, d.prototype.unsubscribe = function(p, y) {
        this._events.get(p).unsubscribe(y);
      }, d.prototype.unsub = function(p, y) {
        this.unsubscribe(p, y);
      }, d.prototype.one = function(p, y) {
        this._events.get(p).one(y);
      }, d.prototype.has = function(p, y) {
        return this._events.get(p).has(y);
      };
    })(), function() {
      function d() {
        this._events = new h();
      }
      Object.defineProperty(d.prototype, "events", {
        get: function() {
          return this._events;
        },
        enumerable: !1,
        configurable: !0
      }), d.prototype.subscribe = function(p, y) {
        this._events.get(p).subscribe(y);
      }, d.prototype.sub = function(p, y) {
        this.subscribe(p, y);
      }, d.prototype.one = function(p, y) {
        this._events.get(p).one(y);
      }, d.prototype.has = function(p, y) {
        return this._events.get(p).has(y);
      }, d.prototype.unsubscribe = function(p, y) {
        this._events.get(p).unsubscribe(y);
      }, d.prototype.unsub = function(p, y) {
        this.unsubscribe(p, y);
      };
    }(), function() {
      function d() {
        this._events = new l();
      }
      Object.defineProperty(d.prototype, "events", {
        get: function() {
          return this._events;
        },
        enumerable: !1,
        configurable: !0
      }), d.prototype.one = function(p, y) {
        this._events.get(p).one(y);
      }, d.prototype.has = function(p, y) {
        return this._events.get(p).has(y);
      }, d.prototype.subscribe = function(p, y) {
        this._events.get(p).subscribe(y);
      }, d.prototype.sub = function(p, y) {
        this.subscribe(p, y);
      }, d.prototype.unsubscribe = function(p, y) {
        this._events.get(p).unsubscribe(y);
      }, d.prototype.unsub = function(p, y) {
        this.unsubscribe(p, y);
      };
    }();
  }(X || (X = {})), function(a) {
    var c = function() {
      function r(e) {
        this._isStarted = !1, this._isEventsStarted = !1, this._gestureTimestamps = [], this._maxSensorSamples = 0, this._sensorsTimestampDeltaInMillis = 0, this._accelerometerList = [], this._gyroscopeList = [], this._linearAccelerometerList = [], this._rotationList = [], this.orientationImplementationFix = 1, this.delegate = e, window.navigator.userAgent.match(
          /^.*(iPhone|iPad).*(OS\s[0-9]).*(CriOS|Version)\/[.0-9]*\sMobile.*$/i
        ) && (this.orientationImplementationFix = -1), this.accelerometerUpdateHandle = this.accelerometerUpdate.bind(this), this.orientationUpdateHandle = this.orientationUpdate.bind(this);
      }
      return Object.defineProperty(r.prototype, "LAST_GESTURE_SENSOR_TIMEOUT_MILI_SECONDS", {
        get: function() {
          return 3e3;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "accX", {
        get: function() {
          return this._accX;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "accY", {
        get: function() {
          return this._accY;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "accZ", {
        get: function() {
          return this._accZ;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "lienarAccX", {
        get: function() {
          return this._lienarAccX;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "lienarAccY", {
        get: function() {
          return this._lienarAccY;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "lienarAccZ", {
        get: function() {
          return this._lienarAccZ;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "isStarted", {
        get: function() {
          return this._isStarted;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "rotX", {
        get: function() {
          return this._rotX;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "rotY", {
        get: function() {
          return this._rotY;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "rotZ", {
        get: function() {
          return this._rotZ;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "maxSensorSamples", {
        get: function() {
          return this._maxSensorSamples;
        },
        set: function(e) {
          this._maxSensorSamples = e;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "sensorsTimestampDeltaInMillis", {
        get: function() {
          return this._sensorsTimestampDeltaInMillis;
        },
        set: function(e) {
          this._sensorsTimestampDeltaInMillis = e;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "accelerometerList", {
        get: function() {
          return this.getRelevantSensorSamples(this._accelerometerList);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "gyroscopeList", {
        get: function() {
          return this.getRelevantSensorSamples(this._gyroscopeList);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "linearAccelerometerList", {
        get: function() {
          return this.getRelevantSensorSamples(this._linearAccelerometerList);
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "rotationList", {
        get: function() {
          return this._rotationList;
        },
        enumerable: !1,
        configurable: !0
      }), r.prototype.start = function() {
        this._isStarted || (this._isStarted = !0, a._POSignalsUtils.Logger.debug("Sensor events started..."));
      }, r.prototype.getRotationListCopy = function() {
        return this._rotationList ? Array.from(this._rotationList) : [];
      }, r.prototype.stop = function() {
        this._isStarted && (window.DeviceMotionEvent != null && window.removeEventListener("devicemotion", this.accelerometerUpdateHandle, !0), window.DeviceOrientationEvent && window.removeEventListener("deviceorientation", this.orientationUpdateHandle, !0), this._isStarted = !1, a._POSignalsUtils.Logger.debug("Sensor events stopped"));
      }, r.prototype.getRelevantSensorSamples = function(e) {
        if (e.length == 0 || this._sensorsTimestampDeltaInMillis < 1 || this._gestureTimestamps.length == 0)
          return e;
        for (var t = /* @__PURE__ */ new Map(), n = null, i = 0, s = 0; s < e.length; s++)
          for (var u = 0; u < this._gestureTimestamps.length; u++)
            (i = e[s].timestamp) >= (n = this._gestureTimestamps[u]).start - this._sensorsTimestampDeltaInMillis && i <= n.end + this._sensorsTimestampDeltaInMillis && t.set(e[s].timestamp, e[s]);
        return a._POSignalsUtils.Util.getValuesOfMap(t);
      }, r.prototype.stopEvents = function() {
        this._isEventsStarted && (window.DeviceMotionEvent != null && window.removeEventListener("devicemotion", this.accelerometerUpdateHandle, !0), window.DeviceOrientationEvent && window.removeEventListener("deviceorientation", this.orientationUpdateHandle, !0), this._isEventsStarted = !1, a._POSignalsUtils.Logger.debug("Sensor events stopped listening"));
      }, r.prototype.startEvents = function() {
        this._isEventsStarted || (window.DeviceMotionEvent != null ? this.delegate.addEventListener(
          window,
          "devicemotion",
          this.accelerometerUpdateHandle,
          !0
        ) : a._POSignalsUtils.Logger.warn("DeviceMotion not supported!"), window.DeviceOrientationEvent ? this.delegate.addEventListener(
          window,
          "deviceorientation",
          this.orientationUpdateHandle,
          !0
        ) : a._POSignalsUtils.Logger.warn("DeviceOrientation not supported!"), a._POSignalsUtils.Logger.debug("Sensor events start listening..."), this._isEventsStarted = !0);
      }, r.prototype.reset = function() {
        this._accelerometerList = [], this._gyroscopeList = [], this._linearAccelerometerList = [], this._rotationList = [], this._gestureTimestamps.length > 0 ? this._gestureTimestamps = [
          this._gestureTimestamps[this._gestureTimestamps.length - 1]
        ] : this._gestureTimestamps = [], this._accX = 0, this._accY = 0, this._accZ = 0, this._rotX = 0, this._rotY = 0, this._rotZ = 0;
      }, r.prototype.onGesture = function(e) {
        this._isEventsStarted || this.startEvents(), e.events.length > 1 && this._gestureTimestamps.push({
          start: e.events[0].eventTs,
          end: e.events[e.events.length - 1].eventTs
        });
      }, r.prototype.puaseSensorsCollectionIfNoActivity = function(e) {
        return (this._gestureTimestamps.length > 0 ? this._gestureTimestamps[this._gestureTimestamps.length - 1].end : 0) > 0 ? Math.abs(e - this._gestureTimestamps[this._gestureTimestamps.length - 1].end) > this.LAST_GESTURE_SENSOR_TIMEOUT_MILI_SECONDS && (this.stopEvents(), !0) : (this.stopEvents(), !0);
      }, r.prototype.getDeviceAcceleration = function(e) {
        return e && e.x != null && e.y != null && e.z != null ? e : null;
      }, r.prototype.accelerometerUpdate = function(e) {
        try {
          if (!this.delegate.collectBehavioralData() || this.puaseSensorsCollectionIfNoActivity(a._POSignalsUtils.Util.now()))
            return;
          var t = this.getDeviceAcceleration(e.accelerationIncludingGravity);
          t && (this._accX = t.x * this.orientationImplementationFix, this._accY = t.y * this.orientationImplementationFix, this._accZ = t.z, this.safeAddSensorSample(
            {
              x: this._accX,
              y: this._accY,
              z: this._accX,
              timestamp: a._POSignalsUtils.Util.now()
            },
            this._accelerometerList
          ));
          var n = this.getDeviceAcceleration(e.acceleration);
          n && (this._lienarAccX = n.x * this.orientationImplementationFix, this._lienarAccY = n.y * this.orientationImplementationFix, this._lienarAccZ = n.z, this.safeAddSensorSample(
            {
              x: this._lienarAccX,
              y: this._lienarAccY,
              z: this._lienarAccZ,
              timestamp: a._POSignalsUtils.Util.now()
            },
            this._linearAccelerometerList
          )), e.rotationRate && e.rotationRate.alpha != null && e.rotationRate.beta != null && e.rotationRate.gamma != null && (this._rotX = e.rotationRate.alpha, this._rotY = e.rotationRate.beta, this._rotZ = e.rotationRate.gamma, this.safeAddSensorSample(
            {
              x: this._rotX,
              y: this._rotY,
              z: this._rotZ,
              timestamp: a._POSignalsUtils.Util.now()
            },
            this._gyroscopeList
          ));
        } catch (i) {
          a._POSignalsUtils.Logger.warn("error in accelerometer handler", i);
        }
      }, r.prototype.orientationUpdate = function(e) {
        try {
          if (!this.delegate.collectBehavioralData() || this.puaseSensorsCollectionIfNoActivity(a._POSignalsUtils.Util.now()))
            return;
          e.alpha != null && e.beta != null && e.gamma != null && this.safeAddSensorSample(
            { x: e.alpha, y: e.beta, z: e.gamma, timestamp: a._POSignalsUtils.Util.now() },
            this._rotationList
          );
        } catch (t) {
          a._POSignalsUtils.Logger.warn("error in orientation handler", t);
        }
      }, r.prototype.safeAddSensorSample = function(e, t) {
        this.maxSensorSamples > t.length && t.push(e);
      }, r;
    }();
    a.Sensors = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r() {
        this._pointerParams = new a.PointerParams();
      }
      return Object.defineProperty(r, "instance", {
        get: function() {
          return r._instance || (r._instance = new r()), r._instance;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "pointerParams", {
        get: function() {
          return this._pointerParams;
        },
        enumerable: !1,
        configurable: !0
      }), r;
    }();
    a.PointerConfig = c;
  }(X || (X = {})), function(a) {
    var c;
    (function(e) {
      e[e.Up = 1] = "Up", e[e.Down = 2] = "Down", e[e.Left = 3] = "Left", e[e.Right = 4] = "Right";
    })(c || (c = {}));
    var r = function() {
      function e(t, n) {
        this.BEHAVIORAL_TYPE = "gestures", this._isStarted = !1, this._onGesture = new a.EventDispatcher(), this.touchSnapshotsMap = /* @__PURE__ */ new Map(), this.snapshotStartTime = /* @__PURE__ */ new Map(), this.delegate = t, this.sensors = n, this.touchStartHandler = this.touchStart.bind(this), this.touchMoveHandler = this.touchMove.bind(this), this.touchEndHandler = this.touchEnd.bind(this), this.touchCancelHandler = this.touchCancel.bind(this);
      }
      return Object.defineProperty(e.prototype, "onGesture", {
        get: function() {
          return this._onGesture.asEvent();
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "isStarted", {
        get: function() {
          return this._isStarted;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "SCROLL_MIN_DURATION", {
        get: function() {
          return 500;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "SWIPE_MAX_ANGLE", {
        get: function() {
          return 45;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "TAP_MOVEMENT_TRESHOLD", {
        get: function() {
          return 10;
        },
        enumerable: !1,
        configurable: !0
      }), e.prototype.countEvents = function(t) {
        for (var n = { epochTs: Date.now() }, i = 0, s = t; i < s.length; i++) {
          var u = s[i];
          n[u.type] = (n[u.type] || 0) + 1;
        }
        return n;
      }, e.prototype.clearTouchSnapshots = function(t) {
        this.touchSnapshotsMap.delete(t), this.snapshotStartTime.delete(t);
      }, e.prototype.getTouchSnapshots = function(t) {
        var n;
        return this.touchSnapshotsMap.has(t) ? n = this.touchSnapshotsMap.get(t) : (n = [], this.touchSnapshotsMap.set(t, n)), n;
      }, e.prototype.isEmpty = function() {
        return this.touchSnapshotsMap.size === 0;
      }, e.prototype.start = function() {
        this._isStarted || (this.delegate.addEventListener(document, "touchstart", this.touchStartHandler), this.delegate.addEventListener(document, "touchmove", this.touchMoveHandler), this.delegate.addEventListener(document, "touchend", this.touchEndHandler), this.delegate.addEventListener(document, "touchcancel", this.touchCancelHandler), this._isStarted = !0);
      }, e.prototype.stop = function() {
        this._isStarted && (document.removeEventListener("touchstart", this.touchStartHandler), document.removeEventListener("touchmove", this.touchMoveHandler), document.removeEventListener("touchend", this.touchEndHandler), document.removeEventListener("touchcancel", this.touchCancelHandler), this._isStarted = !1);
      }, e.prototype.touchStart = function(t) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE) || a.PointerConfig.instance.pointerParams.eventsToIgnore.has(t.type)) return;
          a._POSignalsUtils.Logger.debug("touchstart(" + t.changedTouches.length + ")", t), t.changedTouches.length > 0 && this.pushSnapshot(t);
        } catch (n) {
          a._POSignalsUtils.Logger.warn("error in touchStart handler", n);
        }
      }, e.prototype.touchMove = function(t) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE) || a.PointerConfig.instance.pointerParams.eventsToIgnore.has(t.type)) return;
          a._POSignalsUtils.Logger.debug("touchmove(" + t.changedTouches.length + ")", t), t.changedTouches.length > 0 && this.pushSnapshot(t);
        } catch (n) {
          a._POSignalsUtils.Logger.warn("error in touchMove handler", n);
        }
      }, e.prototype.touchEnd = function(t) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE))
            return void this._onGesture.dispatch(this, null);
          if (a.PointerConfig.instance.pointerParams.eventsToIgnore.has(t.type)) return;
          a._POSignalsUtils.Logger.debug("touchend(" + t.changedTouches.length + ")", t), this.gestureEnd(t);
        } catch (n) {
          a._POSignalsUtils.Logger.warn("error in touchEnd handler", n);
        }
      }, e.prototype.touchCancel = function(t) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE))
            return void this._onGesture.dispatch(this, null);
          if (a.PointerConfig.instance.pointerParams.eventsToIgnore.has(t.type)) return;
          a._POSignalsUtils.Logger.debug("touchcancel(" + t.changedTouches.length + ")", t), this.gestureEnd(t);
        } catch (n) {
          a._POSignalsUtils.Logger.warn("error in touchCancel handler", n);
        }
      }, e.prototype.gestureEnd = function(t) {
        t.changedTouches.length > 0 && this.pushSnapshot(t);
        for (var n = 0; n < t.changedTouches.length; n++) {
          var i = t.changedTouches.item(n), s = this.getTouchSnapshots(i.identifier);
          s.length > 0 && (this.isTap(s) ? this.dispatchGesture(a.GestureType.Tap, i.identifier) : this.dispatchGesture(this.calcGestureType(s), i.identifier));
        }
      }, e.prototype.calcGestureType = function(t) {
        var n, i = this.getDirection(t);
        if (this.isFling(t))
          switch (i) {
            case c.Up:
              n = a.GestureType.FlingUp;
              break;
            case c.Right:
              n = a.GestureType.FlingRight;
              break;
            case c.Down:
              n = a.GestureType.FlingDown;
              break;
            case c.Left:
              n = a.GestureType.FlingLeft;
          }
        else if (this.isScroll(t))
          switch (i) {
            case c.Up:
              n = a.GestureType.ScrollUp;
              break;
            case c.Right:
              n = a.GestureType.ScrollRight;
              break;
            case c.Down:
              n = a.GestureType.ScrollDown;
              break;
            case c.Left:
              n = a.GestureType.ScrollLeft;
          }
        return n;
      }, e.prototype.pushSnapshot = function(t) {
        if (t.changedTouches && t.changedTouches.length > 0)
          for (var n, i = function() {
            var h = t.changedTouches.item(u);
            n = h.radiusX && h.radiusY ? (h.radiusX + h.radiusY) / 2 : null, s.snapshotStartTime.has(h.identifier) || s.snapshotStartTime.set(h.identifier, Date.now());
            var l = s.getTouchSnapshots(h.identifier);
            l.length < a.PointerConfig.instance.pointerParams.maxSnapshotsCount && l.push({
              type: t.type,
              eventTs: t.timeStamp,
              epochTs: Date.now(),
              relativeX: h.screenX,
              relativeY: h.screenY,
              x: h.clientX,
              y: h.clientY,
              pressure: h.force,
              size: n,
              xaccelerometer: s.sensors.accX,
              yaccelerometer: s.sensors.accY,
              zaccelerometer: s.sensors.accZ,
              xlinearaccelerometer: s.sensors.lienarAccX,
              ylinearaccelerometer: s.sensors.lienarAccY,
              zlinearaccelerometer: s.sensors.lienarAccZ,
              xrotation: s.sensors.rotX,
              yrotation: s.sensors.rotY,
              zrotation: s.sensors.rotZ,
              radiusX: h.radiusX,
              radiusY: h.radiusY,
              rotationAngle: h.rotationAngle,
              pageX: h.pageX,
              pageY: h.pageY,
              getX: function() {
                return h.screenX;
              },
              getY: function() {
                return h.screenY;
              }
            });
          }, s = this, u = 0; u < t.changedTouches.length; u++)
            i();
      }, e.prototype.dispatchGesture = function(t, n) {
        var i = this.touchSnapshotsMap.get(n) || [], s = i.filter(function(u) {
          return u.type === "touchmove";
        });
        this._onGesture.dispatch(this, {
          epochTs: this.snapshotStartTime.get(n) || 0,
          counter: this.delegate.gesturesCounter,
          type: t,
          events: i,
          eventCounters: this.countEvents(i),
          duration: this.delegate.getInteractionDuration(i),
          additionalData: this.delegate.additionalData,
          uiControl: void 0,
          timeProximity: a._POSignalsUtils.Util.calculateMeanTimeDeltasBetweenEvents(s),
          meanEuclidean: a._POSignalsUtils.Util.calculateMeanDistanceBetweenPoints(s),
          reduction: {},
          quality: ""
        }), this.clearTouchSnapshots(n);
      }, e.prototype.isTap = function(t) {
        var n = Math.abs(t[0].x - t[1].x), i = Math.abs(t[0].y - t[1].y);
        return t.length == 2 && n < this.TAP_MOVEMENT_TRESHOLD && i < this.TAP_MOVEMENT_TRESHOLD;
      }, e.prototype.isFling = function(t) {
        return t.length > 1 && t[t.length - 1].eventTs - t[0].eventTs < this.SCROLL_MIN_DURATION;
      }, e.prototype.isScroll = function(t) {
        return t.length > 1 && t[t.length - 1].eventTs - t[0].eventTs > this.SCROLL_MIN_DURATION;
      }, e.prototype.getDirection = function(t) {
        var n = this.calcAngle(t[0], t[t.length - 1]);
        return n > 90 - this.SWIPE_MAX_ANGLE && n <= 90 + this.SWIPE_MAX_ANGLE ? c.Up : n > 180 - this.SWIPE_MAX_ANGLE && n <= 180 + this.SWIPE_MAX_ANGLE ? c.Right : n > 270 - this.SWIPE_MAX_ANGLE && n <= 270 + this.SWIPE_MAX_ANGLE ? c.Down : c.Left;
      }, e.prototype.calcAngle = function(t, n) {
        return 180 * Math.atan2(n.y - t.y, n.x - t.x) / Math.PI + 180;
      }, e;
    }();
    a.GestureEvents = r;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r(e) {
        this.key = e, this.cache = this.loadFromStorage();
      }
      return r.prototype.loadFromStorage = function() {
        var e = r.sessionStorage.getItem(this.key);
        return e || (e = JSON.stringify([])), JSON.parse(e);
      }, r.prototype.get = function() {
        return this.cache;
      }, Object.defineProperty(r.prototype, "length", {
        get: function() {
          return this.cache.length;
        },
        enumerable: !1,
        configurable: !0
      }), r.prototype.push = function(e) {
        var t = this.cache.push(e);
        return r.sessionStorage.setItem(this.key, JSON.stringify(this.cache)), t;
      }, r.prototype.set = function(e) {
        this.cache = e, r.sessionStorage.setItem(this.key, JSON.stringify(this.cache));
      }, r.prototype.remove = function(e) {
        this.cache.splice(e, 1), r.sessionStorage.setItem(this.key, JSON.stringify(this.cache));
      }, r.prototype.concat = function(e) {
        return this.cache.concat(e);
      }, r.prototype.clear = function() {
        this.cache = [], r.sessionStorage.removeItem(this.key);
      }, r.sessionStorage = a._POSignalsStorage.SessionStorage.instance.sessionStorage, r;
    }();
    a.StorageArray = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r() {
        this.MAX_TAGS = 10, this._tags = new a.StorageArray(a._POSignalsUtils.Constants.CAPTURED_TAGS);
      }
      return Object.defineProperty(r, "instance", {
        get: function() {
          return r._instance || (r._instance = new r()), r._instance;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "tags", {
        get: function() {
          return this._tags.get();
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "disableTags", {
        set: function(e) {
          this._disableTags = e;
        },
        enumerable: !1,
        configurable: !0
      }), r.prototype.setTag = function(e, t) {
        var n;
        if (!this._disableTags)
          if (a.PointerConfig.instance.pointerParams.enabled)
            if (e) {
              var i = a.PointerConfig.instance.pointerParams.tagsBlacklistRegex;
              if (i && (e.match(i) || typeof t == "string" && (t != null && t.match(i))))
                a._POSignalsUtils.Logger.info("Tag name or value is blacklisted");
              else if (!(this._tags.length >= this.MAX_TAGS)) {
                typeof t != "number" ? this._tags.push({
                  name: e.trim(),
                  value: ((n = t == null ? void 0 : t.trim) === null || n === void 0 ? void 0 : n.call(t)) || void 0,
                  epochTs: Date.now(),
                  timestamp: Date.now()
                }) : this._tags.push({
                  name: e.trim(),
                  value: t,
                  epochTs: Date.now(),
                  timestamp: Date.now()
                });
                var s = t ? e + ":" + t : e;
                a._POSignalsUtils.Logger.info("Add tag: " + s);
              }
            } else a._POSignalsUtils.Logger.info("Can't add tag, missing name");
          else a._POSignalsUtils.Logger.info("Can't add tag, PingOneSignals SDK is disabled");
      }, r.prototype.reset = function() {
        this._tags.clear();
      }, r;
    }();
    a.Tags = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r(e) {
        this.client = e;
      }
      return r.prototype.calculateStrategyResult = function(e, t) {
        return {
          shouldCollect: this.client.getBufferSize() < a.PointerConfig.instance.pointerParams.bufferSize
        };
      }, r;
    }();
    a.FirstInteractionsStrategy = c;
  }(X || (X = {})), function(a) {
    var c;
    (function(e) {
      e[e.RICH = 3] = "RICH", e[e.CLICK = 2] = "CLICK", e[e.MOVE = 1] = "MOVE", e[e.POOR = 0] = "POOR";
    })(c || (c = {}));
    var r = function() {
      function e(t) {
        this.client = t, this.MAX_INTERACTIONS_PER_TYPE = 7, this.RICH_MOUSE_MOVES_AMOUNT = 8, this.MIN_KEYBOARD_EVENTS = 6, this.MIN_TOUCH_EVENTS = 20;
      }
      return e.prototype.isRichMouseInteraction = function(t) {
        return t.mousemove >= this.RICH_MOUSE_MOVES_AMOUNT && this.isClickInteraction(t);
      }, e.prototype.isClickInteraction = function(t) {
        return t.mousedown > 0 && t.mouseup > 0;
      }, e.prototype.isMoveInteraction = function(t) {
        return t.mousemove >= this.RICH_MOUSE_MOVES_AMOUNT;
      }, e.prototype.classifyMouseInteraction = function(t) {
        var n = a._POSignalsUtils.Util.typesCounter(t.events);
        return this.isRichMouseInteraction(n) ? c.RICH : this.isClickInteraction(n) ? c.CLICK : this.isMoveInteraction(n) ? c.MOVE : c.POOR;
      }, e.prototype.classifyKeyboardInteraction = function(t) {
        return t.events.length >= this.MIN_KEYBOARD_EVENTS ? c.RICH : c.POOR;
      }, e.prototype.classifyTouchInteraction = function(t) {
        return t.events.length >= this.MIN_TOUCH_EVENTS ? c.RICH : c.POOR;
      }, e.prototype.handleMouseInteraction = function(t, n) {
        var i = Date.now(), s = this.classifyMouseInteraction(t), u = this.getEnumKeyByValue(s);
        if (n.mouse.interactions.length < this.MAX_INTERACTIONS_PER_TYPE)
          return { shouldCollect: !0, quality: u };
        if (s === c.RICH) {
          var h = this.findOldestInteractionWithLowestQuality(n.mouse.interactions);
          if (h !== -1)
            return { shouldCollect: !0, remove: { type: "mouse", index: h }, quality: u };
        }
        var l = this.splitInteractionsByTime(n.mouse.interactions, i, 18e4), d = l[0], p = l[1];
        return d.length < 2 ? this.handleOlderInteractions(p, u) : this.handleRecentInteractions(d, p, s, u);
      }, e.prototype.splitInteractionsByTime = function(t, n, i) {
        return t.reduce(
          function(s, u) {
            return u.epochTs >= n - i ? s[0].push(u) : s[1].push(u), s;
          },
          [[], []]
        );
      }, e.prototype.handleOlderInteractions = function(t, n) {
        var i = this.findOldestInteractionWithLowestQuality(t);
        return i !== -1 ? { shouldCollect: !0, remove: { type: "mouse", index: i }, quality: n } : { shouldCollect: !1, quality: n };
      }, e.prototype.handleRecentInteractions = function(t, n, i, s) {
        var u = this.findOldestInteractionWithLowestQuality(t, i);
        if (u !== -1) {
          var h = t[u], l = this.client.getBehavioralData().mouse.interactions.indexOf(h), d = this.findOldestInteractionWithLowestQuality(
            n,
            c[this.client.getBehavioralData().mouse.interactions[l].quality]
          );
          return d !== -1 ? { shouldCollect: !0, remove: { type: "mouse", index: d }, quality: s } : { shouldCollect: !0, remove: { type: "mouse", index: l }, quality: s };
        }
        return { shouldCollect: !1, quality: s };
      }, e.prototype.handleKeyboardInteraction = function(t, n) {
        var i = Date.now(), s = this.classifyKeyboardInteraction(t), u = this.getEnumKeyByValue(s);
        if (n.keyboard.interactions.length < this.MAX_INTERACTIONS_PER_TYPE)
          return { shouldCollect: !0, quality: u };
        if (s === c.RICH) {
          var h = this.findOldestInteractionWithLowestQuality(n.keyboard.interactions);
          if (h !== -1)
            return { shouldCollect: !0, remove: { type: "keyboard", index: h }, quality: u };
        }
        var l = this.splitInteractionsByTime(n.keyboard.interactions, i, 18e4), d = l[0], p = l[1];
        return d.length < 2 ? this.handleOlderInteractions(p, u) : this.handleRecentInteractions(d, p, s, u);
      }, e.prototype.handleTouchInteraction = function(t, n) {
        var i = Date.now(), s = this.classifyTouchInteraction(t), u = this.getEnumKeyByValue(s);
        if (n.touch.interactions.length < this.MAX_INTERACTIONS_PER_TYPE)
          return { shouldCollect: !0, quality: u };
        if (s === c.RICH) {
          var h = this.findOldestInteractionWithLowestQuality(n.touch.interactions);
          if (h !== -1)
            return { shouldCollect: !0, remove: { type: "touch", index: h }, quality: u };
        }
        var l = this.splitInteractionsByTime(n.touch.interactions, i, 18e4), d = l[0], p = l[1];
        return d.length < 2 ? this.handleOlderInteractions(p, u) : this.handleRecentInteractions(d, p, s, u);
      }, e.prototype.calculateStrategyResult = function(t, n) {
        var i = this.client.getBehavioralData();
        switch (n) {
          case "mouse":
            return this.handleMouseInteraction(t, i);
          case "keyboard":
            return this.handleKeyboardInteraction(t, i);
          case "touch":
            return this.handleTouchInteraction(t, i);
          default:
            throw new Error("Unknown interaction type: " + n);
        }
      }, e.prototype.getEnumKeyByValue = function(t) {
        return Object.keys(c).find(function(n) {
          return c[n] === t;
        });
      }, e.prototype.findOldestInteractionWithLowestQuality = function(t, n) {
        for (var i = n ?? c.RICH, s = -1, u = Number.MAX_SAFE_INTEGER, h = 0; h < t.length; h++) {
          var l = c[t[h].quality];
          (l < i || l === i && t[h].epochTs < u) && (i = l, u = t[h].epochTs, s = h);
        }
        return s;
      }, e;
    }();
    a.PriorityStrategy = r;
  }(X || (X = {})), function(a) {
    var c;
    (function(e) {
      e[e.FIRST_INTERACTIONS = 0] = "FIRST_INTERACTIONS", e[e.PRIORITY_INTERACTIONS = 1] = "PRIORITY_INTERACTIONS";
    })(c = a.BufferingStrategyType || (a.BufferingStrategyType = {}));
    var r = function() {
      function e() {
      }
      return e.createBufferingStrategy = function(t, n) {
        switch (t) {
          case c.FIRST_INTERACTIONS:
            return new a.FirstInteractionsStrategy(n);
          case c.PRIORITY_INTERACTIONS:
            return new a.PriorityStrategy(n);
        }
      }, e;
    }();
    a.StrategyFactory = r;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r(e) {
        this.sessionData = e, this.instanceUUID = a._POSignalsUtils.Util.newGuid(), this._isBehavioralDataPaused = !1, this.started = !1, this.initQueue = new a.PromiseQueue(1);
      }
      return r.instance = function() {
        if (!this._instance) {
          var e = a._POSignalsStorage.SessionStorage.instance;
          if (!document.body)
            throw a._POSignalsUtils.Logger.error(
              "PingOne Signals can be started only after DOM Ready!"
            ), new Error("PingOne Signals can be started only after DOM Ready!");
          this._instance = new a.Client(e, a.BufferingStrategyType.PRIORITY_INTERACTIONS);
        }
        return this._instance;
      }, r.prototype.getData = function() {
        return Me(this, void 0, void 0, function() {
          return Re(this, function(e) {
            switch (e.label) {
              case 0:
                if (!this.startedPromise) throw new Error("SDK not initialized");
                return [4, this.startedPromise];
              case 1:
                return e.sent(), [4, this.dataHandler.getData(Date.now())];
              case 2:
                return [2, e.sent()];
            }
          });
        });
      }, r.prototype.addTag = function(e, t) {
        a.Tags.instance.setTag(e, t);
      }, r.prototype.start = function(e) {
        var t, n, i, s;
        return e === void 0 && (e = {}), Me(this, void 0, void 0, function() {
          var u, h;
          return Re(this, function(l) {
            switch (l.label) {
              case 0:
                return (t = e.waitForWindowLoad) === null || t === void 0 || t ? [4, this.loadEventPromise()] : [3, 2];
              case 1:
                l.sent(), l.label = 2;
              case 2:
                if (this.initParams = e, this.validateStartParams(e), this.clientVersion = a._POSignalsUtils.Constants.CLIENT_VERSION, this.started)
                  return a._POSignalsUtils.Logger.warn("SDK already initialized"), [2];
                this.browserInfo = new a._POSignalsUtils.BrowserInfo(), a._POSignalsUtils.Logger.isLogEnabled = !!e.consoleLogEnabled || !!e.devEnv, a._POSignalsUtils.Logger.info("Starting Signals SDK..."), a.Tags.instance.disableTags = !!this.initParams.disableTags, this.sessionData.setStorageConfig(e), u = a.PointerConfig.instance.pointerParams, h = {
                  additionalMediaCodecs: u.additionalMediaCodecs,
                  browserInfo: this.browserInfo,
                  fingerprintTimeoutMillis: u.fingerprintTimeoutMillis,
                  metadataBlackList: new Set(
                    u.metadataBlackList.concat(e.deviceAttributesToIgnore)
                  ),
                  propertyDescriptors: u.propertyDescriptors,
                  webRtcUrl: u.webRtcUrl,
                  dataPoints: u.metadataDataPoints
                }, this.localAgentAccessor = new a._POSignalsMetadata.LocalAgentAccessor(
                  (n = e.agentPort) !== null && n !== void 0 ? n : a._POSignalsUtils.Constants.PINGID_AGENT_DEFAULT_PORT,
                  (i = e.agentTimeout) !== null && i !== void 0 ? i : a._POSignalsUtils.Constants.PINGID_AGENT_DEFAULT_TIMEOUT
                ), this.metadata = new a._POSignalsMetadata.Metadata(
                  this.sessionData,
                  h,
                  e.externalIdentifiers,
                  this.localAgentAccessor
                ), this.dataHandler = new a.DataHandler(
                  this.clientVersion,
                  this.instanceUUID,
                  this.initParams,
                  this.metadata,
                  this,
                  this.sessionData
                ), ((s = this.initParams.behavioralDataCollection) === null || s === void 0 || s) && this.refreshListening(), e.lazyMetadata || (this.metadata.getDeviceAttributes(), this.metadata.getLocalAgentJwt()), this.started = !0;
                try {
                  this.logInit(), this.addStartupTags();
                } catch (d) {
                  a._POSignalsUtils.Logger.warn("SDK post init failed", d);
                }
                return [2];
            }
          });
        });
      }, r.prototype.logInit = function() {
        var e, t;
        a._POSignalsUtils.Logger.info(
          "PingOne Signals initialized. " + JSON.stringify(
            {
              timestamp: (/* @__PURE__ */ new Date()).getTime(),
              sdkVersion: this.clientVersion,
              instanceUUID: this.instanceUUID,
              tabUUID: this.sessionData.tabUUID
            },
            null,
            2
          )
        );
        var n = function() {
          return a._POSignalsUtils.Logger.info("Token Ready: " + window._pingOneSignalsToken);
        }, i = function() {
          a._POSignalsUtils.Logger.info("Signals token fetch is disabled"), window._pingOneSignalsToken = void 0;
        };
        ((e = window._pingOneSignalsToken) === null || e === void 0 ? void 0 : e.substring(0, 7)) === "skipped" ? i() : ((t = window._pingOneSignalsToken) === null || t === void 0 ? void 0 : t.substring(0, 13)) !== "uninitialized" && n(), document.addEventListener("PingOneSignalsTokenReadyEvent", n), document.addEventListener("PingOneSignalsTokenSkippedEvent", i);
      }, Object.defineProperty(r.prototype, "isBehavioralDataPaused", {
        get: function() {
          return this._isBehavioralDataPaused;
        },
        enumerable: !1,
        configurable: !0
      }), r.prototype.getSignalsToken = function() {
        var e = "";
        if (typeof window._pingOneSignalsToken == "string" && 0 <= window._pingOneSignalsToken.indexOf(":")) {
          var t = window._pingOneSignalsToken.match(/t:(.*?)(&|$)/g);
          t && 0 < t.length && (e = t[0].replace(/&s*$/, "").replace(/t:/, ""));
        } else
          typeof window._pingOneSignalsToken == "string" && (e = window._pingOneSignalsToken);
        return e;
      }, r.prototype.pauseBehavioralData = function() {
        this._isBehavioralDataPaused || (this._isBehavioralDataPaused = !0, this.addTag("SDK paused behaviorally"));
      }, r.prototype.resumeBehavioralData = function() {
        this._isBehavioralDataPaused && (this._isBehavioralDataPaused = !1, this.addTag("SDK resumed behaviorally"));
      }, r.prototype.startSignals = function(e) {
        return Me(this, void 0, void 0, function() {
          var t, n, i = this;
          return Re(this, function(s) {
            switch (s.label) {
              case 0:
                return s.trys.push([0, 2, , 3]), this.startedPromise = this.initQueue.add(function() {
                  return i.start(e);
                }), [4, this.startedPromise];
              case 1:
                return [2, s.sent()];
              case 2:
                throw t = s.sent(), n = {
                  id: a._POSignalsUtils.POErrorCodes.INITIALIZATION_ERROR,
                  message: t.message,
                  code: "SDK initialization failed."
                }, new Error(JSON.stringify(n));
              case 3:
                return [2];
            }
          });
        });
      }, r.prototype.validateStartParams = function(e) {
        if (!document.body)
          throw a._POSignalsUtils.Logger.error(
            "PingOne Signals can be started only after DOM Ready!"
          ), new Error("PingOne Signals can be started only after DOM Ready!");
        e.externalIdentifiers = e.externalIdentifiers || {};
      }, r.prototype.loadEventPromise = function() {
        return Me(this, void 0, void 0, function() {
          return Re(this, function(e) {
            return [
              2,
              new Promise(function(t) {
                document.readyState === "complete" ? t() : window.addEventListener("load", function(n) {
                  t();
                });
              })
            ];
          });
        });
      }, r.prototype.addStartupTags = function() {
        this.addTag("SDK started"), document.referrer && this.addTag("referrer", document.referrer), this.addTag("location", window.location.href);
      }, r;
    }();
    a.ClientBase = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r(e) {
        this.BEHAVIORAL_TYPE = "indirect", this._isStarted = !1, this._onClipboardEvent = new a.EventDispatcher(), this.delegate = e, this.onClipboardEventHandler = this.onEvent.bind(this);
      }
      return Object.defineProperty(r.prototype, "isStarted", {
        get: function() {
          return this._isStarted;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "onClipboardEvent", {
        get: function() {
          return this._onClipboardEvent.asEvent();
        },
        enumerable: !1,
        configurable: !0
      }), r.prototype.onEvent = function(e) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE)) return;
          this._onClipboardEvent.dispatch(this, this.createClipboardEvent(e));
        } catch (t) {
          a._POSignalsUtils.Logger.warn("error in clipboard handler", t);
        }
      }, r.prototype.createClipboardEvent = function(e) {
        var t = a._POSignalsUtils.Util.getSrcElement(e);
        return {
          category: "ClipboardEvent",
          type: e.type,
          eventTs: e.timeStamp,
          epochTs: (/* @__PURE__ */ new Date()).getTime(),
          additionalData: {
            locationHref: location.href,
            stId: this.delegate.getElementsStID(t),
            elementId: t == null ? void 0 : t.id
          }
        };
      }, r.prototype.start = function() {
        this._isStarted || (this._isStarted = !0, this.delegate.addEventListener(document, "cut", this.onClipboardEventHandler), this.delegate.addEventListener(document, "copy", this.onClipboardEventHandler), this.delegate.addEventListener(document, "paste", this.onClipboardEventHandler));
      }, r.prototype.stop = function() {
        this._isStarted && (this._isStarted = !1, document.removeEventListener("cut", this.onClipboardEventHandler), document.removeEventListener("copy", this.onClipboardEventHandler), document.removeEventListener("paste", this.onClipboardEventHandler));
      }, r;
    }();
    a.ClipboardEvents = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r(e) {
        this.BEHAVIORAL_TYPE = "indirect", this._isStarted = !1, this._onDragEvent = new a.EventDispatcher(), this.delegate = e, this.onDragEventHandler = this.onEvent.bind(this);
      }
      return Object.defineProperty(r.prototype, "isStarted", {
        get: function() {
          return this._isStarted;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "onDragEvent", {
        get: function() {
          return this._onDragEvent.asEvent();
        },
        enumerable: !1,
        configurable: !0
      }), r.prototype.createDragEvent = function(e) {
        return {
          category: "DragEvent",
          type: e.type,
          eventTs: e.timeStamp,
          epochTs: (/* @__PURE__ */ new Date()).getTime(),
          additionalData: { locationHref: location.href }
        };
      }, r.prototype.onEvent = function(e) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE)) return;
          this._onDragEvent.dispatch(this, this.createDragEvent(e));
        } catch (t) {
          a._POSignalsUtils.Logger.warn("error in drag handler", t);
        }
      }, r.prototype.start = function() {
        this._isStarted || (this._isStarted = !0, this.delegate.addEventListener(document, "dragstart", this.onDragEventHandler), this.delegate.addEventListener(document, "dragexit", this.onDragEventHandler), this.delegate.addEventListener(document, "drop", this.onDragEventHandler), this.delegate.addEventListener(document, "dragend", this.onDragEventHandler));
      }, r.prototype.stop = function() {
        this._isStarted && (this._isStarted = !1, document.removeEventListener("dragstart", this.onDragEventHandler), document.removeEventListener("dragexit", this.onDragEventHandler), document.removeEventListener("drop", this.onDragEventHandler), document.removeEventListener("dragend", this.onDragEventHandler));
      }, r;
    }();
    a.DragEvents = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r(e) {
        this.BEHAVIORAL_TYPE = "indirect", this._isStarted = !1, this._onFocusEvent = new a.EventDispatcher(), this.delegate = e, this.onFocusEventHandler = this.onEvent.bind(this);
      }
      return Object.defineProperty(r.prototype, "isStarted", {
        get: function() {
          return this._isStarted;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "onFocusEvent", {
        get: function() {
          return this._onFocusEvent.asEvent();
        },
        enumerable: !1,
        configurable: !0
      }), r.prototype.getRelatedTarget = function(e) {
        if (!e.relatedTarget) return { type: "", stId: "", elementId: "" };
        var t = {
          type: a._POSignalsUtils.Util.getObjectType(e.relatedTarget),
          stId: "",
          elementId: ""
        };
        e.relatedTarget.id && (t.elementId = e.relatedTarget.id);
        try {
          var n = e.relatedTarget;
          t.stId = this.delegate.getElementsStID(n);
        } catch {
        }
        return t;
      }, r.prototype.createFocusEvent = function(e) {
        var t = a._POSignalsUtils.Util.getSrcElement(e), n = this.getRelatedTarget(e);
        return {
          category: "FocusEvent",
          type: e.type,
          eventTs: e.timeStamp,
          epochTs: (/* @__PURE__ */ new Date()).getTime(),
          additionalData: {
            locationHref: location.href,
            stId: this.delegate.getElementsStID(t),
            elementId: t ? t.id : "",
            relatedTarget: n
          }
        };
      }, r.prototype.onEvent = function(e) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE)) return;
          this._onFocusEvent.dispatch(this, this.createFocusEvent(e));
        } catch (t) {
          a._POSignalsUtils.Logger.warn("error in focus handler", t);
        }
      }, r.prototype.start = function() {
        this._isStarted || (this._isStarted = !0, this.delegate.addEventListener(document, "DOMFocusIn", this.onFocusEventHandler), this.delegate.addEventListener(document, "DOMFocusOut", this.onFocusEventHandler), this.delegate.addEventListener(document, "focus", this.onFocusEventHandler), this.delegate.addEventListener(document, "focusin", this.onFocusEventHandler), this.delegate.addEventListener(document, "focusout", this.onFocusEventHandler));
      }, r.prototype.stop = function() {
        this._isStarted && (this._isStarted = !1, document.removeEventListener("DOMFocusIn", this.onFocusEventHandler), document.removeEventListener("DOMFocusOut", this.onFocusEventHandler), document.removeEventListener("focus", this.onFocusEventHandler), document.removeEventListener("focusin", this.onFocusEventHandler), document.removeEventListener("focusout", this.onFocusEventHandler));
      }, r;
    }();
    a.FocusEvents = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r(e) {
        this.BEHAVIORAL_TYPE = "indirect", this._isStarted = !1, this._onUIEvent = new a.EventDispatcher(), this.delegate = e, this.onUIEventHandler = this.onEvent.bind(this);
      }
      return Object.defineProperty(r.prototype, "isStarted", {
        get: function() {
          return this._isStarted;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "onUIEvent", {
        get: function() {
          return this._onUIEvent.asEvent();
        },
        enumerable: !1,
        configurable: !0
      }), r.prototype.createUIEvent = function(e) {
        return {
          category: "UIEvent",
          type: e.type,
          eventTs: e.timeStamp,
          epochTs: (/* @__PURE__ */ new Date()).getTime(),
          additionalData: { locationHref: location.href }
        };
      }, r.prototype.onEvent = function(e) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE)) return;
          this._onUIEvent.dispatch(this, this.createUIEvent(e));
        } catch (t) {
          a._POSignalsUtils.Logger.warn("error in UIEvent handler", t);
        }
      }, r.prototype.start = function() {
        this._isStarted || (this._isStarted = !0, this.delegate.addEventListener(document, "resize", this.onUIEventHandler), this.delegate.addEventListener(document, "scroll", this.onUIEventHandler), this.delegate.addEventListener(document, "select", this.onUIEventHandler));
      }, r.prototype.stop = function() {
        this._isStarted && (this._isStarted = !1, document.removeEventListener("resize", this.onUIEventHandler), document.removeEventListener("scroll", this.onUIEventHandler), document.removeEventListener("select", this.onUIEventHandler));
      }, r;
    }();
    a.UIEvents = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r(e) {
        this.BEHAVIORAL_TYPE = "indirect", this.visibilityChangeEventName = "visibilitychange", this.hiddenProperty = "hidden", this._isStarted = !1, this._onGeneralEvent = new a.EventDispatcher(), this.delegate = e, this.onGeneralEventHandler = this.onEvent.bind(this), this.onLangChangeHandler = this.onLangChangeEvent.bind(this), this.onOrientationChangeHandler = this.onOrientationChangeEvent.bind(this), this.onVisibilityChangeHandler = this.onVisibilityChangeEvent.bind(this), document.msHidden !== void 0 ? (this.hiddenProperty = "msHidden", this.visibilityChangeEventName = "msvisibilitychange") : document.webkitHidden !== void 0 && (this.hiddenProperty = "webkitHidden", this.visibilityChangeEventName = "webkitvisibilitychange");
      }
      return Object.defineProperty(r.prototype, "isStarted", {
        get: function() {
          return this._isStarted;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "onGeneralEvent", {
        get: function() {
          return this._onGeneralEvent.asEvent();
        },
        enumerable: !1,
        configurable: !0
      }), r.prototype.onEvent = function(e) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE)) return;
          this._onGeneralEvent.dispatch(this, this.createGeneralEvent(e));
        } catch (t) {
          a._POSignalsUtils.Logger.warn("error in general event handler", t);
        }
      }, r.prototype.onLangChangeEvent = function(e) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE)) return;
          var t = this.createGeneralEvent(e);
          this._onGeneralEvent.dispatch(this, t);
        } catch (n) {
          a._POSignalsUtils.Logger.warn("error in LangChange event handler", n);
        }
      }, r.prototype.onOrientationChangeEvent = function(e) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE)) return;
          var t = this.createGeneralEvent(e), n = a._POSignalsUtils.Util.getDeviceOrientation();
          t.additionalData.deviceOrientation = n.orientation, t.additionalData.deviceAngle = n.angle, this._onGeneralEvent.dispatch(this, t);
        } catch (i) {
          a._POSignalsUtils.Logger.warn("error in OrientationChange event handler", i);
        }
      }, r.prototype.onVisibilityChangeEvent = function(e) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE)) return;
          var t = this.createGeneralEvent(e);
          t.additionalData.hidden = !!document[this.hiddenProperty], document.visibilityState && (t.additionalData.visibilityState = document.visibilityState.toString()), this._onGeneralEvent.dispatch(this, t);
        } catch (n) {
          a._POSignalsUtils.Logger.warn("error in VisibilityChange event handler", n);
        }
      }, r.prototype.createGeneralEvent = function(e) {
        return {
          category: "Event",
          type: e.type,
          eventTs: e.timeStamp,
          epochTs: (/* @__PURE__ */ new Date()).getTime(),
          additionalData: { locationHref: location.href }
        };
      }, r.prototype.start = function() {
        this._isStarted || (this._isStarted = !0, this.delegate.addEventListener(
          document,
          this.visibilityChangeEventName,
          this.onVisibilityChangeHandler
        ), this.delegate.addEventListener(document, "change", this.onGeneralEventHandler), this.delegate.addEventListener(
          document,
          "fullscreenchange",
          this.onGeneralEventHandler
        ), this.delegate.addEventListener(document, "invalid", this.onGeneralEventHandler), this.delegate.addEventListener(window, "languagechange", this.onLangChangeHandler), this.delegate.addEventListener(
          window,
          "orientationchange",
          this.onOrientationChangeHandler
        ), this.delegate.addEventListener(document, "seeked", this.onGeneralEventHandler), this.delegate.addEventListener(document, "seeking", this.onGeneralEventHandler), this.delegate.addEventListener(document, "selectstart", this.onGeneralEventHandler), this.delegate.addEventListener(
          document,
          "selectionchange",
          this.onGeneralEventHandler
        ), this.delegate.addEventListener(document, "submit", this.onGeneralEventHandler), this.delegate.addEventListener(document, "volumechange", this.onGeneralEventHandler), this.delegate.addEventListener(document, "reset", this.onGeneralEventHandler), this.delegate.addEventListener(document, "textInput", this.onGeneralEventHandler));
      }, r.prototype.stop = function() {
        this._isStarted && (this._isStarted = !1, document.removeEventListener(
          this.visibilityChangeEventName,
          this.onVisibilityChangeHandler
        ), document.removeEventListener("change", this.onGeneralEventHandler), document.removeEventListener("fullscreenchange", this.onGeneralEventHandler), document.removeEventListener("invalid", this.onGeneralEventHandler), window.removeEventListener("languagechange", this.onLangChangeHandler), window.removeEventListener("orientationchange", this.onOrientationChangeHandler), document.removeEventListener("seeked", this.onGeneralEventHandler), document.removeEventListener("seeking", this.onGeneralEventHandler), document.removeEventListener("selectstart", this.onGeneralEventHandler), document.removeEventListener("selectionchange", this.onGeneralEventHandler), document.removeEventListener("submit", this.onGeneralEventHandler), document.removeEventListener("volumechange", this.onGeneralEventHandler), document.removeEventListener("reset", this.onGeneralEventHandler), document.removeEventListener("textInput", this.onGeneralEventHandler));
      }, r;
    }();
    a.GeneralEvents = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r(e) {
        this.DEFAULT_INDIRECT_IDLE_INTERVAL = 1e3, this.MAX_INDIRECT_EVENTS = 25, this._onIndirect = new a.EventDispatcher(), this.indirectEvents = [], this.idleTimeInMillis = this.DEFAULT_INDIRECT_IDLE_INTERVAL, this.lastIndirectEventTimestamp = 0, this._isStarted = !1, this.clipboardEvents = new a.ClipboardEvents(e), this.clipboardEvents.onClipboardEvent.subscribe(this.handleEvent.bind(this)), this.dragEvents = new a.DragEvents(e), this.dragEvents.onDragEvent.subscribe(this.handleEvent.bind(this)), this.focusEvents = new a.FocusEvents(e), this.focusEvents.onFocusEvent.subscribe(this.handleEvent.bind(this)), this.uiEvents = new a.UIEvents(e), this.uiEvents.onUIEvent.subscribe(this.handleEvent.bind(this)), this.generalEvents = new a.GeneralEvents(e), this.generalEvents.onGeneralEvent.subscribe(this.handleEvent.bind(this)), this.onTimeElapsedHandler = this.onTimeElapsed.bind(this);
      }
      return Object.defineProperty(r.prototype, "onIndirect", {
        get: function() {
          return this._onIndirect.asEvent();
        },
        enumerable: !1,
        configurable: !0
      }), r.prototype.onTimeElapsed = function() {
        return Me(this, void 0, void 0, function() {
          return Re(this, function(e) {
            return this.indirectEvents.length > 0 && (/* @__PURE__ */ new Date()).getTime() - this.lastIndirectEventTimestamp >= this.idleTimeInMillis && this.dispatch(), [2];
          });
        });
      }, r.prototype.handleEvent = function(e, t) {
        this.lastIndirectEventTimestamp = (/* @__PURE__ */ new Date()).getTime(), this.pushEvent(t);
      }, r.prototype.pushEvent = function(e) {
        this.indirectEvents.push(e), this.indirectEvents.length >= this.MAX_INDIRECT_EVENTS && this.dispatch();
      }, r.prototype.clearBuffer = function() {
        var e = { events: this.indirectEvents };
        return this.indirectEvents = [], e;
      }, r.prototype.dispatch = function() {
        try {
          clearInterval(this.updateIntervalHandle), this._onIndirect.dispatch(this, this.clearBuffer()), this.updateIntervalHandle = setInterval(
            this.onTimeElapsedHandler,
            a.PointerConfig.instance.pointerParams.indirectIntervalMillis
          );
        } catch (e) {
          a._POSignalsUtils.Logger.warn("Failed to dispatch indirect events", e);
        }
      }, Object.defineProperty(r.prototype, "isStarted", {
        get: function() {
          return this._isStarted;
        },
        enumerable: !1,
        configurable: !0
      }), r.prototype.start = function() {
        this._isStarted || (this.updateIntervalHandle = setInterval(
          this.onTimeElapsedHandler,
          a.PointerConfig.instance.pointerParams.indirectIntervalMillis
        ), this.clipboardEvents.start(), this.dragEvents.start(), this.focusEvents.start(), this.uiEvents.start(), this.generalEvents.start(), this._isStarted = !0);
      }, r.prototype.stop = function() {
        this._isStarted && (this.clipboardEvents.stop(), this.dragEvents.stop(), this.focusEvents.stop(), this.uiEvents.stop(), this.generalEvents.stop(), clearInterval(this.updateIntervalHandle), this.updateIntervalHandle = null, this._isStarted = !1);
      }, r.prototype.unsubscribe = function() {
        this.clipboardEvents.onClipboardEvent.unsubscribe(this.handleEvent.bind(this)), this.dragEvents.onDragEvent.unsubscribe(this.handleEvent.bind(this)), this.focusEvents.onFocusEvent.unsubscribe(this.handleEvent.bind(this)), this.uiEvents.onUIEvent.unsubscribe(this.handleEvent.bind(this)), this.generalEvents.onGeneralEvent.unsubscribe(this.handleEvent.bind(this));
      }, r;
    }();
    a.IndirectClient = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r() {
        this.config = {}, this._cacheHash = 0, this.cache = /* @__PURE__ */ new Map();
      }
      return r.prototype.refreshCssSelectors = function(e) {
        try {
          if (!e) return;
          var t = a._POSignalsUtils.Util.hashCode(JSON.stringify(e));
          if (this._cacheHash === t) return;
          this.config = e, this._cacheHash = t, this.cache = /* @__PURE__ */ new Map();
        } catch (n) {
          a._POSignalsUtils.Logger.warn("Failed to set css selectors", n);
        }
      }, r.prototype.getIdentification = function(e, t) {
        if (this.cache.get(e) === null) return null;
        if (this.cache.get(e) !== void 0) return this.cache.get(e);
        for (var n in this.config)
          try {
            if (!this.config.hasOwnProperty(n)) continue;
            var i = this.config[n] || [];
            a._POSignalsUtils.Util.isArray(i) || (i = [].concat(i));
            for (var s = 0, u = i; s < u.length; s++) {
              var h = u[s];
              if (a._POSignalsUtils.Util.isSelectorMatches(e, h, t))
                return this.cache.set(e, n), n;
            }
          } catch (l) {
            a._POSignalsUtils.Logger.warn("Failed to find selector for " + n, l);
          }
        return this.cache.set(e, null), null;
      }, Object.defineProperty(r.prototype, "cacheHash", {
        get: function() {
          return this._cacheHash;
        },
        enumerable: !1,
        configurable: !0
      }), r;
    }();
    a.ElementsIdentifications = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r(e, t) {
        this.BEHAVIORAL_TYPE = "eventKeyboard", this._isStarted = !1, this._onInteraction = new a.EventDispatcher(), this._onEnterPress = new a.EventDispatcher(), this._onObfuscatedValue = new a.EventDispatcher(), this.interactionsMap = /* @__PURE__ */ new Map(), this._fieldsIdentifications = new a.ElementsIdentifications(), this.keyStrokeMap = /* @__PURE__ */ new Map(), this.delegate = e, this.uiControlManager = t, this.onKeyDownHandle = this.onKeyDown.bind(this), this.onKeyUpHandle = this.onKeyUp.bind(this), this.onFocusHandle = this.onFocus.bind(this), this.onBlurHandle = this.onBlur.bind(this);
      }
      return Object.defineProperty(r.prototype, "isStarted", {
        get: function() {
          return this._isStarted;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "onInteraction", {
        get: function() {
          return this._onInteraction.asEvent();
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "onEnterPress", {
        get: function() {
          return this._onEnterPress.asEvent();
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "onObfuscatedValue", {
        get: function() {
          return this._onObfuscatedValue.asEvent();
        },
        enumerable: !1,
        configurable: !0
      }), r.prototype.refreshKeyboardCssSelectors = function(e) {
        this._fieldsIdentifications.refreshCssSelectors(e);
      }, Object.defineProperty(r.prototype, "modifiersKeys", {
        get: function() {
          return [
            "Alt",
            "AltGraph",
            "CapsLock",
            "Control",
            "Fn",
            "FnLock",
            "Hyper",
            "Meta",
            "NumLock",
            "OS",
            "ScrollLock",
            "Shift",
            "Super",
            "Symbol",
            "SymbolLock"
          ];
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "specialKeys", {
        get: function() {
          return [
            "Tab",
            "Shift",
            "Backspace",
            "Enter",
            "CapsLock",
            "Meta",
            "Delete",
            "Alt",
            "ArrowDown",
            "ArrowUp",
            "Control",
            "ArrowLeft",
            "End",
            "Unidentified",
            "Home",
            "ArrowRight",
            "Insert",
            "Pause",
            "PageDown",
            "PageUp",
            "F1",
            "F2",
            "F3",
            "F4",
            "F5",
            "F6",
            "F7",
            "F8",
            "F9",
            "F10",
            "F11",
            "F12",
            "AltGraph",
            "Escape"
          ];
        },
        enumerable: !1,
        configurable: !0
      }), r.prototype.countEvent = function(e, t) {
        t && (t.eventCounters[e] = (t.eventCounters[e] || 0) + 1);
      }, r.prototype.clearBuffer = function() {
        var e = a._POSignalsUtils.Util.getValuesOfMap(this.interactionsMap);
        return this.interactionsMap.clear(), e;
      }, r.prototype.start = function() {
        this._isStarted ? a._POSignalsUtils.Logger.debug("Desktop Keyboard events already listening") : (this.delegate.addEventListener(document, "keydown", this.onKeyDownHandle), this.delegate.addEventListener(document, "keyup", this.onKeyUpHandle), this.delegate.addEventListener(document, "focus", this.onFocusHandle, !0), this.delegate.addEventListener(document, "blur", this.onBlurHandle, !0), this._isStarted = !0, a._POSignalsUtils.Logger.debug("Desktop Keyboard events start listening..."));
      }, r.prototype.stop = function() {
        this._isStarted ? (document.removeEventListener("keydown", this.onKeyDownHandle), document.removeEventListener("keyup", this.onKeyUpHandle), document.removeEventListener("focus", this.onFocusHandle, !0), document.removeEventListener("blur", this.onBlurHandle, !0), this._isStarted = !1, a._POSignalsUtils.Logger.debug("Desktop Keyboard events stop listening...")) : a._POSignalsUtils.Logger.debug("Desktop Keyboard events already stopped");
      }, r.prototype.getInteractionFromElement = function(e) {
        var t, n = null, i = null, s = a._POSignalsUtils.Util.getSrcElement(e);
        if (s && s instanceof HTMLInputElement && !a._POSignalsUtils.Util.isClickableInput(s) && a._POSignalsUtils.Util.isFunction(s.getAttribute) && !(!((t = s.hasAttribute) === null || t === void 0) && t.call(s, "data-st-ignore")) && !a._POSignalsUtils.Util.anySelectorMatches(
          s,
          a.PointerConfig.instance.pointerParams.keyboardCssSelectorsBlacklist,
          0
        )) {
          i = this.delegate.getElementsStID(s);
          for (var u = a.PointerConfig.instance.pointerParams.keyboardIdentifierAttributes, h = 0; h < u.length && !i; h++)
            i = s.getAttribute(u[h]);
          i && !a.PointerConfig.instance.pointerParams.keyboardFieldBlackList.has(i) && ((n = this.interactionsMap.get(s)) || (n = {
            epochTs: Date.now(),
            stId: i,
            elementId: a._POSignalsUtils.Util.getAttribute(s, "id"),
            name: a._POSignalsUtils.Util.getAttribute(s, "name"),
            type: a._POSignalsUtils.Util.getAttribute(s, "type"),
            events: [],
            counter: this.delegate.keyboardCounter,
            eventCounters: { epochTs: Date.now() },
            duration: 0,
            numOfDeletions: 0,
            additionalData: this.delegate.additionalData,
            quality: ""
          }, this.interactionsMap.set(s, n)));
        }
        return n;
      }, r.prototype.getKeyCode = function(e) {
        return e.keyCode ? e.keyCode : e.which ? e.which : e.code ? a._POSignalsUtils.Util.hashCode(e.code) : a._POSignalsUtils.Util.hashCode(e.key) + (e.location || 0);
      }, r.prototype.getKeyboardEvent = function(e) {
        return e || window.event;
      }, r.prototype.getKeystrokeId = function(e, t) {
        var n, i = this.getKeyCode(e);
        return t === "keyup" && (this.keyStrokeMap.has(i) ? (n = this.keyStrokeMap.get(i), this.keyStrokeMap.delete(i)) : n = a._POSignalsUtils.Util.newGuid()), t === "keydown" && (this.keyStrokeMap.has(i) && e.repeat ? n = this.keyStrokeMap.get(i) : (n = a._POSignalsUtils.Util.newGuid(), this.keyStrokeMap.set(i, n))), n;
      }, r.prototype.createKeyboardInteractionEvent = function(e, t) {
        var n = a._POSignalsUtils.Util.getSrcElement(t), i = n.value ? n.value.toString().length : 0;
        return {
          type: e,
          eventTs: t.timeStamp,
          epochTs: Date.now(),
          selectionStart: a._POSignalsUtils.Util.getElementSelectionStart(n),
          selectionEnd: a._POSignalsUtils.Util.getElementSelectionEnd(n),
          key: t.key,
          keystrokeId: null,
          currentLength: i
        };
      }, r.prototype.enrichKeyboardEvent = function(e, t) {
        (this.modifiersKeys.indexOf(e.key) >= 0 || this.specialKeys.indexOf(e.key) >= 0) && (t.key = e.key), t.keystrokeId = this.getKeystrokeId(e, t.type);
        var n = a._POSignalsUtils.Util.getSrcElement(e);
        t.currentLength = String(n.value).length;
      }, r.prototype.onFocus = function(e) {
        var t, n;
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE))
            return void this._onInteraction.dispatch(this, null);
          e = this.getKeyboardEvent(e);
          var i = this.getInteractionFromElement(e);
          if (this.countEvent(e.type, i), a.PointerConfig.instance.pointerParams.eventsToIgnore.has(e.type))
            return;
          if (i) {
            var s = this.createKeyboardInteractionEvent("focus", e);
            i.events.push(s);
            var u = this.uiControlManager.createUIControlData(e);
            u && (i.uiControl = { uiElement: u.uiElement, enrichedData: u.enrichedData }, ((n = (t = u.uiElement) === null || t === void 0 ? void 0 : t.id) === null || n === void 0 ? void 0 : n.length) > 0 && a._POSignalsUtils.Logger.info(
              "Typing in element with id '" + u.uiElement.id + "'"
            ));
          }
        } catch (h) {
          a._POSignalsUtils.Logger.warn("error in keyboard focus handler", h);
        }
      }, r.prototype.onKeyUp = function(e) {
        try {
          if ((e = this.getKeyboardEvent(e)).keyCode !== 13 && e.which !== 13 || this._onEnterPress.dispatch(this, a._POSignalsUtils.Util.getSrcElement(e)), !this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE))
            return void this._onInteraction.dispatch(this, null);
          var t = this.getInteractionFromElement(e);
          if (this.countEvent(e.type, t), a.PointerConfig.instance.pointerParams.eventsToIgnore.has(e.type))
            return;
          if (t) {
            var n = this.createKeyboardInteractionEvent("keyup", e);
            this.enrichKeyboardEvent(e, n), t.events.push(n);
          } else this.keyStrokeMap.delete(this.getKeyCode(e));
        } catch (i) {
          a._POSignalsUtils.Logger.warn("error in keyUp handler", i);
        }
      }, r.prototype.isEmpty = function() {
        return this.interactionsMap.size === 0;
      }, r.prototype.onKeyDown = function(e) {
        try {
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE))
            return void this._onInteraction.dispatch(this, null);
          e = this.getKeyboardEvent(e);
          var t = this.getInteractionFromElement(e);
          if (this.countEvent(e.type, t), a.PointerConfig.instance.pointerParams.eventsToIgnore.has(e.type))
            return;
          if (t) {
            var n = this.createKeyboardInteractionEvent("keydown", e);
            this.enrichKeyboardEvent(e, n), t.events.push(n);
          }
        } catch (i) {
          a._POSignalsUtils.Logger.warn("error in keyDown handler", i);
        }
      }, r.prototype.onBlur = function(e) {
        try {
          e = this.getKeyboardEvent(e);
          var t = this.getInteractionFromElement(e);
          if (!this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE))
            return void this._onInteraction.dispatch(this, null);
          if (this.countEvent(e.type, t), a.PointerConfig.instance.pointerParams.eventsToIgnore.has(e.type))
            return;
          if (t) {
            var n = this.createKeyboardInteractionEvent("blur", e);
            t.events.push(n), t.duration = this.delegate.getInteractionDuration(t.events), t.numOfDeletions = this.calculateNumOfDeletions(t.events);
            var i = a._POSignalsUtils.Util.getSrcElement(e);
            this.interactionsMap.delete(i), this._onInteraction.dispatch(this, t);
          }
        } catch (s) {
          a._POSignalsUtils.Logger.warn("error in blur handler", s);
        }
      }, r.prototype.calculateNumOfDeletions = function(e) {
        if (!(e != null && e[0])) return 0;
        for (var t = 0, n = e[0].currentLength, i = 1; i < e.length; i++)
          e[i].currentLength < n && t++, n = e[i].currentLength;
        return t;
      }, Object.defineProperty(r.prototype, "fieldsIdentifications", {
        get: function() {
          return this._fieldsIdentifications;
        },
        enumerable: !1,
        configurable: !0
      }), r;
    }();
    a.Keyboard = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r(e, t) {
        var n, i = this, s = a.PointerConfig.instance.pointerParams.uiModelingElementFilters, u = a._POSignalsUtils.Util.getAttribute, h = (n = e.getBoundingClientRect) === null || n === void 0 ? void 0 : n.call(e);
        this._htmlElement = e, this._data = {
          location: this.getUIElementAttribute(s.location, function() {
            return window.location.href;
          }),
          id: this.getUIElementAttribute(s.id, function() {
            return u(e, "id");
          }),
          aria_label: this.getUIElementAttribute(s.aria_label, function() {
            return u(e, "aria-label");
          }),
          data_st_field: this.getUIElementAttribute(s.data_st_field, function() {
            return t.getElementsStID(e);
          }),
          data_st_tag: this.getUIElementAttribute(s.data_st_tag, function() {
            return u(e, "data-st-tag");
          }),
          data_selenium: this.getUIElementAttribute(s.data_selenium, function() {
            return u(e, "data-selenium");
          }),
          data_selenium_id: this.getUIElementAttribute(s.data_selenium_id, function() {
            return u(e, "data-selenium-id");
          }),
          data_testid: this.getUIElementAttribute(s.data_testid, function() {
            return u(e, "data-testid");
          }),
          data_test_id: this.getUIElementAttribute(s.data_test_id, function() {
            return u(e, "data-test-id");
          }),
          data_qa_id: this.getUIElementAttribute(s.data_qa_id, function() {
            return u(e, "data-qa-id");
          }),
          data_id: this.getUIElementAttribute(s.data_id, function() {
            return u(e, "data-id");
          }),
          name: this.getUIElementAttribute(s.name, function() {
            return u(e, "name");
          }),
          placeholder: this.getUIElementAttribute(s.placeholder, function() {
            return u(e, "placeholder");
          }),
          role: this.getUIElementAttribute(s.role, function() {
            return u(e, "role");
          }),
          type: this.getUIElementAttribute(s.type, function() {
            return u(e, "type");
          }),
          nodeTypeInt: this.getUIElementAttribute(s.nodeTypeInt, function() {
            return e.nodeType;
          }),
          nodeName: this.getUIElementAttribute(s.nodeName, function() {
            return e.nodeName;
          }),
          cursorType: this.getUIElementAttribute(s.cursorType, function() {
            return window.getComputedStyle(e).cursor;
          }),
          text: this.getUIElementAttribute(s.text, function() {
            return i.getElementText(e);
          }),
          textLength: this.getUIElementAttribute(s.textLength, function() {
            var l;
            return ((l = i.getElementText(e)) === null || l === void 0 ? void 0 : l.length) || null;
          }),
          bottom: this.getUIElementAttribute(s.bottom, function() {
            return h == null ? void 0 : h.bottom;
          }),
          height: this.getUIElementAttribute(s.height, function() {
            return h == null ? void 0 : h.height;
          }),
          left: this.getUIElementAttribute(s.left, function() {
            return h == null ? void 0 : h.left;
          }),
          right: this.getUIElementAttribute(s.right, function() {
            return h == null ? void 0 : h.right;
          }),
          top: this.getUIElementAttribute(s.top, function() {
            return h == null ? void 0 : h.top;
          }),
          width: this.getUIElementAttribute(s.width, function() {
            return h == null ? void 0 : h.width;
          }),
          x: this.getUIElementAttribute(s.x, function() {
            return h == null ? void 0 : h.x;
          }),
          y: this.getUIElementAttribute(s.y, function() {
            return h == null ? void 0 : h.y;
          })
        }, this._data.elementId = this.getStrongestElementID();
      }
      return Object.defineProperty(r.prototype, "data", {
        get: function() {
          return a._POSignalsUtils.Util.filterReduce(this._data, function(e) {
            return e != null && e !== "";
          });
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "htmlElement", {
        get: function() {
          return this._htmlElement;
        },
        enumerable: !1,
        configurable: !0
      }), r.prototype.getUIElementAttribute = function(e, t) {
        var n;
        try {
          if ((n = e == null ? void 0 : e.enabled) === null || n === void 0 || n) {
            var i = t();
            return typeof i == "string" && (typeof (e == null ? void 0 : e.maxLength) == "number" && i.length > e.maxLength && (i = i.substring(0, e.maxLength)), e != null && e.filterRegex && (i = i.replace(new RegExp(e.filterRegex, "g"), "*"))), i;
          }
        } catch (s) {
          a._POSignalsUtils.Logger.warn("Failed to add ui element attribute", s);
        }
        return null;
      }, r.prototype.getStrongestElementID = function() {
        return this._data.data_st_field || this._data.data_selenium_id || this._data.data_selenium || this._data.data_testid || this._data.data_test_id || this._data.data_qa_id || this._data.data_id || this._data.id || "";
      }, r.prototype.getElementText = function(e) {
        return e instanceof HTMLInputElement && !a._POSignalsUtils.Util.isClickableInput(e) ? null : a._POSignalsUtils.Util.getElementText(e);
      }, r.prototype.equals = function(e) {
        return !!e && !(e.location && location.href.indexOf(e.location) < 0) && (!e.elementId || e.elementId === this._data.elementId) && (!e.id || e.id === this._data.id) && (!e.aria_label || e.aria_label === this._data.aria_label) && (!e.data_st_field || e.data_st_field === this._data.data_st_field) && (!e.data_st_tag || e.data_st_tag === this._data.data_st_tag) && (!e.data_selenium || e.data_selenium === this._data.data_selenium) && (!e.data_selenium_id || e.data_selenium_id === this._data.data_selenium_id) && (!e.data_testid || e.data_testid === this._data.data_testid) && (!e.data_test_id || e.data_test_id === this._data.data_test_id) && (!e.data_qa_id || e.data_qa_id === this._data.data_qa_id) && (!e.data_id || e.data_id === this._data.data_id) && (!e.name || e.name === this._data.name) && (!e.placeholder || e.placeholder === this._data.placeholder) && (!e.role || e.role === this._data.role) && (!e.type || e.type === this._data.type) && (!e.nodeTypeInt || e.nodeTypeInt === this._data.nodeTypeInt) && (!e.nodeName || e.nodeName === this._data.nodeName) && (!e.cursorType || e.cursorType === this._data.cursorType) && (!e.text || e.text === this._data.text) && (!e.textLength || e.textLength === this._data.textLength) && (!e.bottom || e.bottom === this._data.bottom) && (!e.height || e.height === this._data.height) && (!e.left || e.left === this._data.left) && (!e.right || e.right === this._data.right) && (!e.top || e.top === this._data.top) && (!e.width || e.width === this._data.width) && (!e.x || e.x === this._data.x) && (!e.y || e.y === this._data.y);
      }, r.createCssSelector = function(e) {
        var t = "";
        return e != null && e.nodeName && (t += e.nodeName.toLowerCase()), e != null && e.id && (t += '[id="' + e.id + '"]'), e != null && e.aria_label && (t += '[aria-label="' + e.aria_label + '"]'), e != null && e.data_st_field && (t += '[data-st-field="' + e.data_st_field + '"]'), e != null && e.data_st_tag && (t += '[data-st-tag="' + e.data_st_tag + '"]'), e != null && e.data_selenium && (t += '[data-selenium="' + e.data_selenium + '"]'), e != null && e.data_selenium_id && (t += '[data-selenium-id="' + e.data_selenium_id + '"]'), e != null && e.data_testid && (t += '[data-testid="' + e.data_testid + '"]'), e != null && e.data_test_id && (t += '[data-test-id="' + e.data_test_id + '"]'), e != null && e.data_qa_id && (t += '[data-qa-id="' + e.data_qa_id + '"]'), e != null && e.data_id && (t += '[data-id="' + e.data_id + '"]'), e != null && e.name && (t += '[name="' + e.name + '"]'), e != null && e.placeholder && (t += '[placeholder="' + e.placeholder + '"]'), e != null && e.role && (t += '[role="' + e.role + '"]'), e != null && e.type && (t += '[type="' + e.type + '"]'), t;
      }, r;
    }();
    a.UiElement = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r(e) {
        this._clientDelegate = e;
      }
      return r.prototype.createUIControlData = function(e) {
        var t = a._POSignalsUtils.Util.getSrcElement(e);
        if (!t) return null;
        var n = a.PointerConfig.instance.pointerParams.uiModelingBlacklistRegex;
        if (n && window.location.href.match(n))
          return a._POSignalsUtils.Logger.debug("ui control data is disabled for this url"), null;
        var i = new a.UiElement(t, this._clientDelegate);
        return this.findMatchingUiControl(i) || { uiElement: i.data };
      }, r.prototype.findMatchingUiControl = function(e, t) {
        t === void 0 && (t = 0);
        try {
          var n = a.PointerConfig.instance.pointerParams.uiControlsConfig;
          if (n.length === 0 || t > a.PointerConfig.instance.pointerParams.uiModelingMaxMatchingParents)
            return null;
          for (var i = !1, s = 0, u = n; s < u.length; s++) {
            var h = u[s];
            if ((h.tagConfig || h.enrichedData) && (i = !0, e.equals(h.uiElement)))
              return {
                uiElement: e.data,
                enrichedData: h.enrichedData,
                tagConfig: h.tagConfig
              };
          }
          if (!i) return null;
          var l = e.htmlElement.parentElement;
          if ((l == null ? void 0 : l.nodeType) === Node.ELEMENT_NODE) {
            var d = new a.UiElement(l, this._clientDelegate);
            return this.findMatchingUiControl(d, t + 1);
          }
        } catch (p) {
          a._POSignalsUtils.Logger.warn("failed to find matching ui control", p);
        }
        return null;
      }, r.prototype.convertToTagValueConfig = function(e) {
        var t;
        return {
          context: (t = e == null ? void 0 : e.uiElement) === null || t === void 0 ? void 0 : t.location,
          valueSelector: a.UiElement.createCssSelector(
            e == null ? void 0 : e.uiElement
          ),
          operation: e == null ? void 0 : e.operation,
          valueMandatory: e == null ? void 0 : e.valueMandatory
        };
      }, r;
    }();
    a.UIControlManager = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r(e, t) {
        this.BEHAVIORAL_TYPE = "mouse", this._isStarted = !1, this._onInteraction = new a.EventDispatcher(), this._onClickEvent = new a.EventDispatcher(), this.lastMouseInteractionTimestamp = null, this.mouseEventsCounter = 0, this.eventCounters = { epochTs: Date.now() }, this.delegate = e, this.uiControlManager = t, this.wheelOptions = !!a._POSignalsUtils.Util.isPassiveSupported() && { passive: !0 }, this.onPointerHandle = this.onPointerEvent.bind(this), this.onClickHandle = this.onClick.bind(this), this.onDblclickHandle = this.onMouseClickEvent.bind(this), this.onMousedownHandle = this.onMouseClickEvent.bind(this), this.onMousemoveHandle = this.onMouseEvent.bind(this), this.onMouseoutHandle = this.onMouseout.bind(this), this.onMouseoverHandle = this.onMouseEvent.bind(this), this.onMouseupHandle = this.onMouseClickEvent.bind(this), this.onWheelHandle = this.onMouseEvent.bind(this), this.interactionUpdateHandle = this.interactionUpdate.bind(this);
      }
      return Object.defineProperty(r.prototype, "isStarted", {
        get: function() {
          return this._isStarted;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "onInteraction", {
        get: function() {
          return this._onInteraction.asEvent();
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "onClickEvent", {
        get: function() {
          return this._onClickEvent.asEvent();
        },
        enumerable: !1,
        configurable: !0
      }), r.prototype.countEvent = function(e) {
        this.eventCounters[e] = (this.eventCounters[e] || 0) + 1;
      }, r.prototype.interactionUpdate = function() {
        this.lastMouseInteraction ? Date.now() - this.lastMouseInteractionTimestamp >= a.PointerConfig.instance.pointerParams.mouseIdleTimeoutMillis && this.dispatch() : !this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE) && Date.now() - this.lastMouseInteractionTimestamp <= a.PointerConfig.instance.pointerParams.mouseIntervalMillis && this.dispatch();
      }, r.prototype.enrichLastInteraction = function() {
        var e;
        if (this.lastMouseInteraction) {
          this.lastMouseInteraction.eventCounters = this.eventCounters, this.lastMouseInteraction.duration = this.delegate.getInteractionDuration(
            this.lastMouseInteraction.events
          );
          var t = (e = this.lastMouseInteraction.events) === null || e === void 0 ? void 0 : e.filter(function(n) {
            return n.type === "mousemove";
          });
          this.lastMouseInteraction.timeProximity = a._POSignalsUtils.Util.calculateMeanTimeDeltasBetweenEvents(t), this.lastMouseInteraction.meanEuclidean = a._POSignalsUtils.Util.calculateMeanDistanceBetweenPoints(t);
        }
      }, r.prototype.dispatch = function() {
        try {
          this.enrichLastInteraction(), this._onInteraction.dispatch(this, this.lastMouseInteraction), this.eventCounters = { epochTs: Date.now() }, this.lastMouseInteraction = null, this.mouseEventsCounter = 0;
        } catch (e) {
          a._POSignalsUtils.Logger.warn("Failed to dispatch mouse events", e);
        }
      }, r.prototype.updateInteraction = function(e, t) {
        this.lastMouseInteraction || (this.lastMouseInteraction = {
          epochTs: Date.now(),
          events: [],
          counter: this.delegate.mouseCounter,
          additionalData: this.delegate.additionalData,
          eventCounters: { epochTs: Date.now() },
          duration: 0,
          timeProximity: 0,
          uiControl: void 0,
          meanEuclidean: 0,
          reduction: {},
          quality: ""
        }), this.lastMouseInteraction.events.push(e), this.mouseEventsCounter++, t && (this.lastMouseInteraction.uiControl = {
          uiElement: t.uiElement,
          enrichedData: t.enrichedData
        }, this.delegate.addUiControlTags(t.tagConfig)), this.mouseEventsCounter >= a.PointerConfig.instance.pointerParams.maxMouseEvents && this.dispatch();
      }, r.prototype.start = function() {
        this._isStarted ? a._POSignalsUtils.Logger.debug("Desktop Mouse events already listening") : (this.delegate.addEventListener(document, "click", this.onClickHandle, !0), this.delegate.addEventListener(document, "dblclick", this.onDblclickHandle), this.delegate.addEventListener(document, "mousedown", this.onMousedownHandle), this.delegate.addEventListener(document, "mousemove", this.onMousemoveHandle), this.delegate.addEventListener(document, "mouseout", this.onMouseoutHandle), this.delegate.addEventListener(document, "mouseover", this.onMouseoverHandle), this.delegate.addEventListener(document, "mouseup", this.onMouseupHandle), this.delegate.addEventListener(
          document,
          "wheel",
          this.onWheelHandle,
          this.wheelOptions
        ), this.delegate.addEventListener(document, "pointerover", this.onPointerHandle), this.delegate.addEventListener(document, "pointerenter", this.onPointerHandle), this.delegate.addEventListener(document, "pointerdown", this.onPointerHandle), this.delegate.addEventListener(document, "pointermove", this.onPointerHandle), this.delegate.addEventListener(document, "pointerup", this.onPointerHandle), this.delegate.addEventListener(document, "pointercancel", this.onPointerHandle), this.delegate.addEventListener(document, "pointerout", this.onPointerHandle), this.delegate.addEventListener(document, "pointerleave", this.onPointerHandle), this.updateIntervalHandle = setInterval(
          this.interactionUpdateHandle,
          a.PointerConfig.instance.pointerParams.mouseIntervalMillis
        ), this._isStarted = !0, a._POSignalsUtils.Logger.debug("Desktop Mouse events start listening..."));
      }, r.prototype.stop = function() {
        this._isStarted ? (document.removeEventListener("click", this.onClickHandle, !0), document.removeEventListener("dblclick", this.onDblclickHandle), document.removeEventListener("mousedown", this.onMousedownHandle), document.removeEventListener("mousemove", this.onMousemoveHandle), document.removeEventListener("mouseout", this.onMouseoutHandle), document.removeEventListener("mouseover", this.onMouseoverHandle), document.removeEventListener("mouseup", this.onMouseupHandle), document.removeEventListener("wheel", this.onWheelHandle, this.wheelOptions), document.removeEventListener("pointerover", this.onPointerHandle), document.removeEventListener("pointerenter", this.onPointerHandle), document.removeEventListener("pointerdown", this.onPointerHandle), document.removeEventListener("pointermove", this.onPointerHandle), document.removeEventListener("pointerup", this.onPointerHandle), document.removeEventListener("pointercancel", this.onPointerHandle), document.removeEventListener("pointerout", this.onPointerHandle), document.removeEventListener("pointerleave", this.onPointerHandle), clearInterval(this.updateIntervalHandle), this.updateIntervalHandle = null, this._isStarted = !1, a._POSignalsUtils.Logger.debug("Desktop Mouse events stop listening...")) : a._POSignalsUtils.Logger.debug("Desktop Mouse events already stopped");
      }, r.prototype.onClick = function(e) {
        var t, n;
        try {
          this.lastMouseInteractionTimestamp = Date.now();
          var i = a._POSignalsUtils.Util.getSrcElement(e);
          if (this._onClickEvent.dispatch(this, i), !this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE) || (this.countEvent(e.type), a.PointerConfig.instance.pointerParams.eventsToIgnore.has(e.type)))
            return;
          var s = this.uiControlManager.createUIControlData(e);
          this.updateInteraction(this.createMouseClickEvent(e.type, e), s), this.dispatch(), ((n = (t = s == null ? void 0 : s.uiElement) === null || t === void 0 ? void 0 : t.id) === null || n === void 0 ? void 0 : n.length) > 0 && a._POSignalsUtils.Logger.info(
            "Tapped on element with id '" + s.uiElement.id + "'"
          );
        } catch (u) {
          a._POSignalsUtils.Logger.warn("error in " + e.type + " handler", u);
        }
      }, r.prototype.onMouseout = function(e) {
        try {
          this.onMouseEvent(e);
          var t = e.relatedTarget || e.toElement;
          t && t.nodeName !== "HTML" || this.dispatch();
        } catch (n) {
          a._POSignalsUtils.Logger.warn("error in " + e.type + " handler", n);
        }
      }, r.prototype.onMouseEvent = function(e) {
        try {
          if (e.type !== "wheel" && (this.lastMouseInteractionTimestamp = Date.now()), !this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE) || (this.countEvent(e.type), a.PointerConfig.instance.pointerParams.eventsToIgnore.has(e.type)))
            return;
          this.updateInteraction(this.createMouseEvent(e.type, e));
        } catch (t) {
          a._POSignalsUtils.Logger.warn("error in " + e.type + " handler", t);
        }
      }, r.prototype.onMouseClickEvent = function(e) {
        try {
          if (this.lastMouseInteractionTimestamp = Date.now(), !this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE) || (this.countEvent(e.type), a.PointerConfig.instance.pointerParams.eventsToIgnore.has(e.type)))
            return;
          this.updateInteraction(this.createMouseClickEvent(e.type, e));
        } catch (t) {
          a._POSignalsUtils.Logger.warn("error in " + e.type + " handler", t);
        }
      }, r.prototype.onPointerEvent = function(e) {
        try {
          if (this.lastMouseInteractionTimestamp = Date.now(), !this.delegate.collectBehavioralData(this.BEHAVIORAL_TYPE) || (this.countEvent(e.type), a.PointerConfig.instance.pointerParams.eventsToIgnore.has(e.type)))
            return;
          this.updateInteraction(this.createPointerEvent(e.type, e));
        } catch (t) {
          a._POSignalsUtils.Logger.warn("error in " + e.type + " handler", t);
        }
      }, r.prototype.clearBuffer = function() {
        var e = null;
        return this.lastMouseInteraction && (e = this.lastMouseInteraction), this.lastMouseInteraction = null, e;
      }, r.prototype.isEmpty = function() {
        return !this.lastMouseInteraction;
      }, r.prototype.createMouseEvent = function(e, t) {
        return {
          type: e,
          eventTs: t.timeStamp,
          epochTs: Date.now(),
          button: t.button,
          offsetX: t.offsetX,
          offsetY: t.offsetY,
          pageX: t.pageX,
          pageY: t.pageY,
          screenX: t.screenX,
          screenY: t.screenY,
          getX: function() {
            return t.screenX;
          },
          getY: function() {
            return t.screenY;
          }
        };
      }, r.prototype.createPointerEvent = function(e, t) {
        var n = this.createMouseEvent(e, t);
        return Ct(Ct({}, n), {
          pointerId: t.pointerId,
          width: t.width,
          height: t.height,
          pressure: t.pressure,
          tangentialPressure: t.tangentialPressure,
          tiltX: t.tiltX,
          tiltY: t.tiltY,
          twist: t.twist,
          pointerType: t.pointerType,
          isPrimary: t.isPrimary
        });
      }, r.prototype.createMouseClickEvent = function(e, t) {
        var n = this.createMouseEvent(e, t);
        if (t.target && a._POSignalsUtils.Util.isFunction(t.target.getBoundingClientRect)) {
          var i = t.target.getBoundingClientRect();
          n.targetBottom = i.bottom, n.targetHeight = i.height, n.targetLeft = i.left, n.targetRight = i.right, n.targetTop = i.top, n.targetWidth = i.width, n.targetX = i.x, n.targetY = i.y;
        }
        return n;
      }, r;
    }();
    a.Mouse = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r(e) {
        this.counter = 0, this.key = e, this.counter = this.loadFromStorage();
      }
      return r.prototype.loadFromStorage = function() {
        var e = r.sessionStorage.getItem(this.key);
        return Number(e) || 0;
      }, r.prototype.get = function() {
        return this.counter;
      }, r.prototype.increment = function(e) {
        e === void 0 && (e = 1), this.counter += e, r.sessionStorage.setItem(this.key, this.counter);
      }, r.prototype.decrement = function(e) {
        e === void 0 && (e = 1), this.increment(-1 * e);
      }, r.prototype.reset = function() {
        this.counter = 0, r.sessionStorage.removeItem(this.key);
      }, r.sessionStorage = a._POSignalsStorage.SessionStorage.instance.sessionStorage, r;
    }();
    a.StorageCounter = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r(e) {
        this.mapKey = e, this.cache = this.loadFromStorage();
      }
      return r.prototype.loadFromStorage = function() {
        var e = r.sessionStorage.getItem(this.mapKey);
        return e || (e = JSON.stringify({})), JSON.parse(e);
      }, r.prototype.asMap = function() {
        return this.cache;
      }, r.prototype.set = function(e, t, n) {
        n === void 0 && (n = !0), this.cache[e] = t, n && r.sessionStorage.setItem(this.mapKey, JSON.stringify(this.cache));
      }, r.prototype.sync = function() {
        r.sessionStorage.setItem(this.mapKey, JSON.stringify(this.cache));
      }, r.prototype.get = function(e) {
        return this.cache[e];
      }, r.prototype.delete = function(e) {
        delete this.cache[e], r.sessionStorage.setItem(this.mapKey, JSON.stringify(this.cache));
      }, r.prototype.values = function() {
        return a._POSignalsUtils.Util.values(this.cache);
      }, r.prototype.clear = function() {
        this.cache = {}, r.sessionStorage.removeItem(this.mapKey);
      }, r.prototype.forEach = function(e) {
        for (var t in this.cache) this.cache.hasOwnProperty(t) && e(this.cache[t], t);
      }, r.sessionStorage = a._POSignalsStorage.SessionStorage.instance.sessionStorage, r;
    }();
    a.StorageMap = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r() {
        this.config = {}, this._cacheHash = 0, this.cache = /* @__PURE__ */ new Map();
      }
      return r.prototype.refreshConfig = function(e) {
        try {
          if (!e) return;
          var t = a._POSignalsUtils.Util.hashCode(JSON.stringify(e));
          if (this._cacheHash === t) return;
          this.config = e, this._cacheHash = t, this.cache = /* @__PURE__ */ new Map();
        } catch (n) {
          a._POSignalsUtils.Logger.warn("Failed to set css selectors", n);
        }
      }, r.prototype.getMatchingTags = function(e, t) {
        var n = this.cache.get(e);
        if (n) return n;
        var i = {};
        for (var s in this.config)
          try {
            if (!this.config.hasOwnProperty(s)) continue;
            var u = this.config[s].selector || [];
            a._POSignalsUtils.Util.isArray(u) || (u = [].concat(u));
            for (var h = 0, l = u; h < l.length; h++) {
              var d = l[h];
              a._POSignalsUtils.Util.isSelectorMatches(e, d, t) && (i[s] = this.config[s]);
            }
          } catch (p) {
            a._POSignalsUtils.Logger.warn("Failed to get the config for " + s + " tag", p);
          }
        return this.cache.set(e, i), i;
      }, r.prototype.getValue = function(e, t) {
        if (t && e)
          switch (t = t.trim(), e) {
            case "email_domain":
              return a._POSignalsUtils.Util.getEmailDomain(t);
            case "obfuscate":
              return "" + a._POSignalsUtils.Util.mod(t, 1e3);
            case "plain":
              return t;
            case "zip":
              return t.substr(0, 3);
            case "length":
              return "" + t.length;
          }
        return "";
      }, Object.defineProperty(r.prototype, "cacheHash", {
        get: function() {
          return this._cacheHash;
        },
        enumerable: !1,
        configurable: !0
      }), r;
    }();
    a.TagsIdentifications = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r() {
        this._reduceFactorMap = null;
      }
      return Object.defineProperty(r.prototype, "reduceFactorMap", {
        get: function() {
          return this._reduceFactorMap;
        },
        set: function(e) {
          this._reduceFactorMap = e;
        },
        enumerable: !1,
        configurable: !0
      }), r.prototype.reduceEventsByFactor = function(e) {
        var t = this;
        try {
          if (!e || e.length === 0 || !this.reduceFactorMap) return e;
          for (var n = /* @__PURE__ */ new Map(), i = [], s = 0; s < e.length; s++)
            n.get(e[s].type) ? n.get(e[s].type).push(s) : n.set(e[s].type, [s]);
          n.forEach(function(h, l) {
            var d = t.reduceFactorMap[l] ? Number(t.reduceFactorMap[l]) : 0;
            t.reduceByFactor(d, h, function(p) {
              i[h[p]] = !0;
            });
          });
          var u = [];
          for (s = 0; s < e.length; s++) i[s] && u.push(e[s]);
          return e.length !== u.length && a._POSignalsUtils.Logger.debug(
            e.length - u.length + " events reduced out of " + e.length
          ), u;
        } catch (h) {
          return a._POSignalsUtils.Logger.warn("Failed to reduce events", h), e;
        }
      }, r.prototype.reduceByFactor = function(e, t, n) {
        e = Math.min(e, 1);
        for (var i = Math.round(Math.max(t.length * (1 - e), 2)), s = (t.length - 1) / (i - 1), u = Math.min(t.length, i), h = 0; h < u; h++)
          n(Math.round(h * s));
      }, r;
    }();
    a.ReduceFactor = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r(e) {
        this.algorithm = e;
      }
      return r.prototype.reduce = function(e, t) {
        if (r.TYPES_TO_REDUCE.indexOf(t) === -1) return { keptEvents: e, epsilon: 0 };
        if (e.length <= r.MIN_EVENTS_TO_REDUCE) return { keptEvents: e, epsilon: 0 };
        var n = e.length < 50 ? 0.55 : e.length < 100 ? 0.35 : 0.2, i = e.length < 50 ? 1 : e.length < 100 ? 3 : 7, s = this.algorithm.reduceEvents(e, i), u = s.length / e.length;
        if (s.length >= 10 && u >= n) return { keptEvents: s, epsilon: i };
        var h = e.length < 50 ? 0.1 : e.length < 100 ? 0.3 : 0.7, l = this.algorithm.reduceEvents(e, h), d = l.length / e.length;
        if (l.length <= r.MIN_EVENTS_TO_REDUCE || d <= n) return { keptEvents: l, epsilon: h };
        var p = (Math.min(i, Math.pow(i, u / n)) * Math.abs(d - n) + h * Math.abs(u - n)) / Math.abs(u - d);
        return (p < h || p > i) && a._POSignalsUtils.Logger.warn(
          "linear weighted average - calculated epsilon is out of range, lowEpsilon: " + h + ", highEpsilon: " + i + ", epsilon: " + p
        ), { keptEvents: this.algorithm.reduceEvents(e, p), epsilon: p };
      }, r.MIN_EVENTS_TO_REDUCE = 18, r.TYPES_TO_REDUCE = ["mousemove", "touchmove"], r;
    }();
    a.RDPEpsilonStrategy = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r(e) {
        this.rdpStrategy = e;
      }
      return r.prototype.reduceWithRPD = function(e) {
        var t = this;
        if (!e || e.length === 0) return { events: e, reductionInfo: {} };
        for (var n = /* @__PURE__ */ new Map(), i = [], s = 0, u = e; s < u.length; s++) {
          var h = u[s];
          n.get(h.type) ? n.get(h.type).push(h) : n.set(h.type, [h]);
        }
        var l = {};
        return n.forEach(function(d, p) {
          var y = t.rdpStrategy.reduce(d, p), k = y.keptEvents, Q = y.epsilon;
          Q > 0 && (l[p] = { epsilon: Q, originalLength: d.length, keptLength: k.length }), i = i.concat(k);
        }), { events: a._POSignalsUtils.Util.sortEventsByTimestamp(i), reductionInfo: l };
      }, r;
    }();
    a.ReduceRDP = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r() {
      }
      return r.prototype.getSqDist = function(e, t) {
        var n = e.getX() - t.getX(), i = e.getY() - t.getY();
        return n * n + i * i;
      }, r.prototype.getSqSegDist = function(e, t, n) {
        var i = t.getX(), s = t.getY(), u = n.getX() - i, h = n.getY() - s;
        if (u !== 0 || h !== 0) {
          var l = ((e.getX() - i) * u + (e.getY() - s) * h) / (u * u + h * h);
          l > 1 ? (i = n.getX(), s = n.getY()) : l > 0 && (i += u * l, s += h * l);
        }
        return (u = e.getX() - i) * u + (h = e.getY() - s) * h;
      }, r.prototype.simplifyRadialDist = function(e, t) {
        for (var n, i = e[0], s = [i], u = 1, h = e.length; u < h; u++)
          n = e[u], this.getSqDist(n, i) > t && (s.push(n), i = n);
        return i !== n && s.push(n), s;
      }, r.prototype.simplifyDPStep = function(e, t, n, i, s) {
        for (var u, h = i, l = t + 1; l < n; l++) {
          var d = this.getSqSegDist(e[l], e[t], e[n]);
          d > h && (u = l, h = d);
        }
        h > i && (u - t > 1 && this.simplifyDPStep(e, t, u, i, s), s.push(e[u]), n - u > 1 && this.simplifyDPStep(e, u, n, i, s));
      }, r.prototype.simplifyDouglasPeucker = function(e, t) {
        var n = e.length - 1, i = [e[0]];
        return this.simplifyDPStep(e, 0, n, t, i), i.push(e[n]), i;
      }, r.prototype.simplify = function(e, t, n) {
        if (e.length <= 2) return e;
        var i = t !== void 0 ? t * t : 1;
        return e = n ? e : this.simplifyRadialDist(e, i), e = this.simplifyDouglasPeucker(e, i);
      }, r.prototype.reduceEvents = function(e, t) {
        return this.simplify(e, t);
      }, r;
    }();
    a.RDPReduction = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r() {
      }
      return r.prototype.filterMoveEvents = function(e, t) {
        if (e.length <= 18) return e;
        for (var n = e.filter(function(d) {
          return d.type === t;
        }), i = a._POSignalsUtils.Util.keepFirstEventsWithDistance({
          events: n,
          threshold: 200,
          min: 18,
          max: 30
        }), s = -1, u = {}, h = 0; h < e.length; h++) {
          var l = e[h];
          l.type !== t && (l.type !== "mousedown" ? u[l.type] || (i.push(l), u[l.type] = !0) : s = h);
        }
        return s >= 0 && i.push(e[s]), a._POSignalsUtils.Util.sortEventsByTimestamp(i);
      }, r;
    }();
    a.EventsReduction = c;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r() {
        this.reduceFactor = new a.ReduceFactor(), this.reduceRDP = new a.ReduceRDP(new a.RDPEpsilonStrategy(new a.RDPReduction())), this.eventsReduction = new a.EventsReduction();
      }
      return Object.defineProperty(r.prototype, "reduceFactorMap", {
        set: function(e) {
          this.reduceFactor.reduceFactorMap = e;
        },
        enumerable: !1,
        configurable: !0
      }), r.prototype.reduceGesture = function(e) {
        var t = this.reduceRDP.reduceWithRPD(e.events);
        e.events = this.eventsReduction.filterMoveEvents(t.events, "touchmove"), e.reduction = t.reductionInfo;
      }, r.prototype.reduceKeyboardInteraction = function(e) {
        e.events = a._POSignalsUtils.Util.filterArrayByLength(e.events, 50);
      }, r.prototype.reduceMouseInteraction = function(e) {
        var t = this.reduceRDP.reduceWithRPD(e.events);
        e.events = this.eventsReduction.filterMoveEvents(t.events, "mousemove"), e.reduction = t.reductionInfo;
      }, r;
    }();
    a.ReductionManager = c;
  }(X || (X = {})), function(a) {
    var c = function(r) {
      function e(t, n) {
        var i = r.call(this, t) || this;
        return i.tagsWithValueIdentifications = new a.TagsIdentifications(), i.reductionManager = new a.ReductionManager(), i.lastGestureTimestamp = 0, i.currentBufferSize = 0, i.MAX_EVENT_COUNTERS = 20, i.bufferingStrategy = a.StrategyFactory.createBufferingStrategy(n, i), i.capturedKeyboardInteractions = new a.StorageArray(
          a._POSignalsUtils.Constants.CAPTURED_KEYBOARD_INTERACTIONS
        ), i.keyboardInteractionsCount = new a.StorageCounter(
          a._POSignalsUtils.Constants.KEYBOARD_INTERACTIONS_COUNT
        ), i.mouseInteractionsCount = new a.StorageCounter(
          a._POSignalsUtils.Constants.MOUSE_INTERACTIONS_COUNT
        ), i.gesturesCount = new a.StorageCounter(a._POSignalsUtils.Constants.GESTURES_COUNT), i.mouseEventCounters = new a.StorageArray(
          a._POSignalsUtils.Constants.MOUSE_EVENT_COUNTERS
        ), i.keyboardEventCounters = new a.StorageArray(
          a._POSignalsUtils.Constants.KEYBOARD_EVENT_COUNTERS
        ), i.touchEventCounters = new a.StorageArray(
          a._POSignalsUtils.Constants.TOUCH_EVENT_COUNTERS
        ), i.indirectEventCounters = new a.StorageArray(
          a._POSignalsUtils.Constants.INDIRECT_EVENT_COUNTERS
        ), i.capturedMouseInteractions = new a.StorageArray(
          a._POSignalsUtils.Constants.CAPTURED_MOUSE_INTERACTIONS
        ), i.capturedGestures = new a.StorageArray(
          a._POSignalsUtils.Constants.CAPTURED_GESTURES
        ), i.capturedIndirectEvents = new a.StorageArray(
          a._POSignalsUtils.Constants.CAPTURED_INDIRECT
        ), i.capturedMouseInteractionSummary = new a.StorageArray(
          a._POSignalsUtils.Constants.CAPTURED_MOUSE_INTERACTIONS_SUMMARY
        ), i.currentBufferSize = i.capturedGestures.length + i.capturedMouseInteractions.length + i.capturedKeyboardInteractions.length, i.uiControlManager = new a.UIControlManager(i), i.keyboard = new a.Keyboard(i, i.uiControlManager), i.keyboard.onInteraction.subscribe(i.handleKeyboardInteraction.bind(i)), i.keyboard.onEnterPress.subscribe(i.handleStTagOnEnter.bind(i)), i.keyboard.onObfuscatedValue.subscribe(i.handleTagValueOnBlur.bind(i)), i.mouse = new a.Mouse(i, i.uiControlManager), i.mouse.onInteraction.subscribe(i.handleMouseInteraction.bind(i)), i.mouse.onClickEvent.subscribe(i.handleStTagOnClick.bind(i)), i.sensors = new a.Sensors(i), i.gesture = new a.GestureEvents(i, i.sensors), i.gesture.onGesture.subscribe(i.handleGesture.bind(i)), i.indirect = new a.IndirectClient(i), i.indirect.onIndirect.subscribe(i.handleIndirect.bind(i)), i.onUrlChangeHandler = i.onUrlChange.bind(i), i;
      }
      return Qt(e, r), Object.defineProperty(e.prototype, "keyboardCounter", {
        get: function() {
          return this.keyboardInteractionsCount.get();
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "mouseCounter", {
        get: function() {
          return this.mouseInteractionsCount.get();
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "gesturesCounter", {
        get: function() {
          return this.gesturesCount.get();
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "additionalData", {
        get: function() {
          var t = a._POSignalsUtils.Util.getDeviceOrientation();
          return {
            locationHref: location.href,
            devTools: a._POSignalsUtils.Util.getDevToolsState(),
            innerWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            innerHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
            outerWidth: window.outerWidth,
            outerHeight: window.outerHeight,
            width: screen.width,
            height: screen.height,
            availWidth: screen.availWidth,
            availHeight: screen.availHeight,
            pixelRatio: window.devicePixelRatio,
            deviceOrientation: t.orientation,
            deviceAngle: t.angle
          };
        },
        enumerable: !1,
        configurable: !0
      }), e.prototype.getBehavioralData = function() {
        this.clearIndirectBuffer();
        var t = this.reduceEpochEventCounters();
        return {
          mouse: {
            count: this.mouseInteractionsCount.get(),
            interactions: this.capturedMouseInteractions.get()
          },
          keyboard: {
            count: this.keyboardInteractionsCount.get(),
            interactions: this.capturedKeyboardInteractions.get()
          },
          touch: { count: this.gesturesCount.get(), interactions: this.capturedGestures.get() },
          indirect: { events: this.capturedIndirectEvents.get() },
          mouseSummary: { events: this.capturedMouseInteractionSummary.get() },
          eventCounters: t
        };
      }, e.prototype.getBufferSize = function() {
        return this.currentBufferSize;
      }, e.prototype.getInteractionDuration = function(t) {
        return (t == null ? void 0 : t.length) > 0 ? t[t.length - 1].epochTs - t[0].epochTs : 0;
      }, e.prototype.dispose = function() {
        return Me(this, void 0, void 0, function() {
          return Re(this, function(t) {
            return this.stopListening(), this.keyboard.onInteraction.unsubscribe(
              this.handleKeyboardInteraction.bind(this)
            ), this.keyboard.onEnterPress.unsubscribe(this.handleStTagOnEnter.bind(this)), this.keyboard.onObfuscatedValue.unsubscribe(this.handleTagValueOnBlur.bind(this)), this.mouse.onInteraction.unsubscribe(this.handleMouseInteraction.bind(this)), this.mouse.onClickEvent.unsubscribe(this.handleStTagOnClick.bind(this)), this.gesture.onGesture.unsubscribe(this.handleGesture.bind(this)), this.indirect.unsubscribe(), this.indirect.onIndirect.unsubscribe(this.handleIndirect.bind(this)), [2];
          });
        });
      }, e.prototype.collectBehavioralData = function(t) {
        if (this.isBehavioralDataPaused) return !1;
        var n = a.PointerConfig.instance.pointerParams.behavioralBlacklist;
        return !(t && n && n[t]) || !window.location.href.match(n[t]);
      }, e.prototype.getElementsStID = function(t) {
        try {
          return a._POSignalsUtils.Util.getAttribute(t, "data-st-field") || this.keyboard.fieldsIdentifications.getIdentification(t, 0) || "";
        } catch (n) {
          return a._POSignalsUtils.Logger.warn("failed to get element stId", n), "";
        }
      }, e.prototype.addEventListener = function(t, n, i, s) {
        a.PointerConfig.instance.pointerParams.eventsBlackList.has(n) || (t.addEventListener(n, this.onEventHandler, s), t.addEventListener(n, i, s));
      }, e.prototype.addUiControlTags = function(t) {
        if ((t == null ? void 0 : t.length) > 0)
          for (var n = !1, i = 0, s = t; i < s.length; i++) {
            var u = s[i];
            try {
              if (u != null && u.name) {
                var h = this.uiControlManager.convertToTagValueConfig(u.value);
                n = this.addSingleTagWithValue(u.name, h) || n;
              }
            } catch (l) {
              a._POSignalsUtils.Logger.warn("failed to add tag config", l);
            }
          }
      }, e.prototype.refreshListening = function() {
        var t = a.PointerConfig.instance;
        this.tagsWithValueIdentifications.refreshConfig(t.pointerParams.remoteTags), this.reductionManager.reduceFactorMap = t.pointerParams.eventsReduceFactorMap, this.keyboard.refreshKeyboardCssSelectors(t.pointerParams.keyboardCssSelectors), this.sensors.maxSensorSamples = t.pointerParams.maxSensorSamples, this.sensors.sensorsTimestampDeltaInMillis = t.pointerParams.sensorsDeltaInMillis, this.mouse.start(), this.keyboard.start(), this.gesture.start(), this.indirect.start(), t.pointerParams.maxSensorSamples == 0 ? this.sensors.stop() : this.sensors.start(), this.addEventListener(window, "_onlocationchange", this.onUrlChangeHandler), this.addEventListener(window, "popstate", this.onUrlChangeHandler);
      }, e.prototype.addSingleTagWithValue = function(t, n) {
        try {
          if (n != null && n.context && !window.location.href.match(n.context))
            return !1;
          var i = "";
          if (n != null && n.operation && (n != null && n.valueSelector)) {
            var s = document.querySelector(n.valueSelector);
            if (s) {
              var u = a._POSignalsUtils.Util.getElementText(s);
              i = this.tagsWithValueIdentifications.getValue(n.operation, u);
            }
          }
          if (n != null && n.valueMandatory && !i)
            return a._POSignalsUtils.Logger.warn("tag '" + t + "' wasn't added. value is missing"), !1;
          this.addTag(t, i);
        } catch (h) {
          a._POSignalsUtils.Logger.warn("failed to add " + t + " tag", h);
        }
        return !1;
      }, e.prototype.addTagsWithValue = function(t) {
        var n = !1;
        for (var i in t) t.hasOwnProperty(i) && (n = this.addSingleTagWithValue(i, t[i]) || n);
      }, e.prototype.handleStTagOnEnter = function(t, n) {
        n instanceof HTMLInputElement && a._POSignalsUtils.Util.isTextInput(n) && this.handleStTagElement(n);
      }, e.prototype.handleTagValueOnBlur = function(t, n) {
        n && this.addTag(n.fieldKey, n.obfuscatedValue);
      }, e.prototype.handleStTagOnClick = function(t, n) {
        n instanceof HTMLInputElement && !a._POSignalsUtils.Util.isClickableInput(n) || this.handleStTagElement(n);
      }, e.prototype.handleMouseInteraction = function(t, n) {
        if (n) {
          this.incrementEventCounters(n.eventCounters, "mouse"), this.filterOldMouseEvents(), this.mouseInteractionsCount.increment(), this.reductionManager.reduceMouseInteraction(n);
          var i = this.bufferingStrategy.calculateStrategyResult(n, "mouse");
          n.quality = i.quality, this.handleMouseInteractionSummary(n), i.shouldCollect && (i.remove && this.removeInteraction(i.remove), this.capturedMouseInteractions.push(n), this.lastGestureTimestamp !== n.events[n.events.length - 1].eventTs && this.currentBufferSize++);
        }
      }, e.prototype.handleMouseInteractionSummary = function(t) {
        var n = {
          epochTs: t.epochTs,
          duration: this.getInteractionDuration(t.events),
          quality: t.quality
        };
        this.capturedMouseInteractionSummary.push(n), this.capturedMouseInteractionSummary.length > 10 && this.capturedMouseInteractionSummary.remove(0);
      }, e.prototype.handleIndirect = function(t, n) {
        this.filterOldIndirectEvents(), this.addIndirectEvents(n);
      }, e.prototype.handleKeyboardInteraction = function(t, n) {
        if (n) {
          this.incrementEventCounters(n.eventCounters, "keyboard"), this.filterOldKeyboardEvents(), this.keyboardInteractionsCount.increment(), this.reductionManager.reduceKeyboardInteraction(n);
          var i = this.bufferingStrategy.calculateStrategyResult(n, "keyboard");
          i.shouldCollect && (i.remove && this.removeInteraction(i.remove), n.quality = i.quality, this.capturedKeyboardInteractions.push(n), this.currentBufferSize++);
        }
      }, e.prototype.handleGesture = function(t, n) {
        var i;
        if (this.isValidGesture(n)) {
          this.incrementEventCounters(n.eventCounters, "touch"), this.filterOldGesturesEvents(), this.gesturesCount.increment(), this.reductionManager.reduceGesture(n);
          var s = this.bufferingStrategy.calculateStrategyResult(n, "touch");
          s.shouldCollect && (s.remove && this.removeInteraction(s.remove), n.quality = s.quality, this.sensors.onGesture(n), this.capturedGestures.push(n), this.currentBufferSize++, this.lastGestureTimestamp = (i = n.events[n.events.length - 1]) === null || i === void 0 ? void 0 : i.eventTs);
        }
      }, e.prototype.clearIndirectBuffer = function() {
        var t = this.indirect.clearBuffer();
        this.addIndirectEvents(t);
      }, e.prototype.removeInteraction = function(t) {
        switch (t.type) {
          case "mouse":
            this.capturedMouseInteractions.remove(t.index);
            break;
          case "keyboard":
            this.capturedKeyboardInteractions.remove(t.index);
            break;
          case "touch":
            this.capturedGestures.remove(t.index);
        }
      }, e.prototype.addIndirectEvents = function(t) {
        var n;
        if (((n = t == null ? void 0 : t.events) === null || n === void 0 ? void 0 : n.length) > 0) {
          for (var i = [], s = a._POSignalsUtils.Util.typesCounter(this.capturedIndirectEvents.get()), u = 0, h = t.events; u < h.length; u++) {
            var l = h[u];
            a.PointerConfig.instance.pointerParams.highPriorityIndirectEvents.has(l.type) && this.capturedIndirectEvents.length + i.length < a.PointerConfig.instance.pointerParams.maxIndirectEvents && i.push(l), s[l.type] > 0 || (i.push(l), s[l.type] = 1);
          }
          this.incrementEventCounters(s, "indirect"), this.capturedIndirectEvents.set(this.capturedIndirectEvents.concat(i));
        }
      }, e.prototype.onUrlChange = function() {
        this.addTag("location", window.location.href);
      }, e.prototype.handleStTagElement = function(t) {
        if (t) {
          var n = a.PointerConfig.instance.pointerParams.maxSelectorChildren, i = this.tagsWithValueIdentifications.getMatchingTags(t, n);
          this.addTagsWithValue(i);
          var s = a._POSignalsUtils.Util.isSelectorMatches(t, "[data-st-tag]", n);
          if (s instanceof Element) {
            var u = a._POSignalsUtils.Util.getAttribute(s, "data-st-tag"), h = a._POSignalsUtils.Util.getAttribute(s, "data-st-tag-value");
            u && this.addTag(u, h);
          }
        }
      }, e.prototype.stopListening = function() {
        this.keyboard.stop(), this.mouse.stop(), this.gesture.stop(), this.indirect.stop(), this.sensors.stop(), window.removeEventListener("_onlocationchange", this.onUrlChangeHandler), window.removeEventListener("popstate", this.onUrlChangeHandler);
      }, e.prototype.clearBehavioralData = function() {
        this.capturedKeyboardInteractions.clear(), this.capturedMouseInteractions.clear(), this.capturedGestures.clear(), this.capturedIndirectEvents.clear(), this.sensors.reset(), a.Tags.instance.reset(), this.currentBufferSize = 0, this.keyboardInteractionsCount.reset(), this.mouseInteractionsCount.reset(), this.gesturesCount.reset(), this.mouseEventCounters.clear(), this.mouseEventCounters.clear(), this.indirectEventCounters.clear(), this.keyboardEventCounters.clear(), this.touchEventCounters.clear(), this.eventCounters.clear();
      }, e.prototype.isValidGesture = function(t) {
        var n, i;
        return ((n = t == null ? void 0 : t.events) === null || n === void 0 ? void 0 : n.length) > 0 && ((i = t == null ? void 0 : t.events) === null || i === void 0 ? void 0 : i.length) < a.PointerConfig.instance.pointerParams.maxSnapshotsCount;
      }, e.prototype.filterOldIndirectEvents = function() {
        var t = (/* @__PURE__ */ new Date()).getTime();
        this.capturedIndirectEvents.set(
          this.capturedIndirectEvents.get().filter(function(n) {
            return t - n.epochTs <= 36e5;
          })
        );
      }, e.prototype.filterOldMouseEvents = function() {
        var t = (/* @__PURE__ */ new Date()).getTime();
        this.capturedMouseInteractions.set(
          this.capturedMouseInteractions.get().filter(function(n) {
            return t - n.epochTs <= 36e5;
          })
        );
      }, e.prototype.filterOldKeyboardEvents = function() {
        var t = (/* @__PURE__ */ new Date()).getTime();
        this.capturedKeyboardInteractions.set(
          this.capturedKeyboardInteractions.get().filter(function(n) {
            return t - n.epochTs <= 36e5;
          })
        );
      }, e.prototype.filterOldGesturesEvents = function() {
        var t = (/* @__PURE__ */ new Date()).getTime();
        this.capturedGestures.set(
          this.capturedGestures.get().filter(function(n) {
            return t - n.epochTs <= 36e5;
          })
        );
      }, e.prototype.incrementEventCounters = function(t, n) {
        var i, s = Date.now();
        switch (n) {
          case "mouse":
            i = this.mouseEventCounters;
            break;
          case "keyboard":
            i = this.keyboardEventCounters;
            break;
          case "touch":
            i = this.touchEventCounters;
            break;
          case "indirect":
            i = this.indirectEventCounters;
        }
        i.set(
          i.get().filter(function(u) {
            return s - u.epochTs <= 36e5;
          })
        ), i.length < this.MAX_EVENT_COUNTERS || i.remove(0), i.push(t);
      }, e.prototype.reduceEpochEventCounters = function() {
        var t = { epochTs: Date.now() };
        return fn(
          this.mouseEventCounters.get(),
          this.keyboardEventCounters.get(),
          this.touchEventCounters.get(),
          this.indirectEventCounters.get()
        ).forEach(function(n) {
          Object.keys(n).forEach(function(i) {
            i !== "epochTs" && (t[i] ? t[i] += n[i] : t[i] = n[i]);
          });
        }), delete t.epochTs, t;
      }, e;
    }(a.ClientBase);
    a.Client = c;
  }(X || (X = {}));
  var X, ko = function() {
    function a() {
    }
    return a.getData = function() {
      return X.ClientBase.instance().getData();
    }, a.init = function(c) {
      return X._POSignalsUtils.Util.ieFix(), X.ClientBase.instance().startSignals(c);
    }, a.initSilent = function(c) {
      return this.init(c);
    }, a.pauseBehavioralData = function() {
      X.ClientBase.instance().pauseBehavioralData();
    }, a.resumeBehavioralData = function() {
      X.ClientBase.instance().resumeBehavioralData();
    }, a;
  }(), xo = function(a) {
    document.readyState !== "loading" ? a() : document.addEventListener("DOMContentLoaded", a);
  };
  xo(function() {
    if (!window._pingOneSignalsReady) {
      var a = new CustomEvent("PingOneSignalsReadyEvent");
      document.dispatchEvent(a), window._pingOneSignalsReady = !0;
    }
  }), function(a) {
    var c;
    (function(e) {
      e[e.RICH = 3] = "RICH", e[e.CLICK = 2] = "CLICK", e[e.MOVE = 1] = "MOVE", e[e.POOR = 0] = "POOR";
    })(c || (c = {}));
    var r = function() {
      function e(t, n, i, s, u, h) {
        this.clientVersion = t, this.instanceUUID = n, this.initParams = i, this.metadata = s, this.behavioralDataHandler = u, this.sessionData = h, this.Max_Mouse_Touch_Interactions = 6;
      }
      return e.prototype.getData = function(t) {
        return Me(this, void 0, void 0, function() {
          var n, i;
          return Re(this, function(s) {
            switch (s.label) {
              case 0:
                return this.incrementGetData(), [4, this.getRiskData(t)];
              case 1:
                return n = s.sent(), (i = n.tags.findIndex(function(u) {
                  return u.name === "Get Data";
                })) !== -1 ? n.tags[i] = this._getDataCounter : n.tags.push(this._getDataCounter), [2, this.toString(n)];
            }
          });
        });
      }, e.prototype.getRiskData = function(t) {
        return Me(this, void 0, void 0, function() {
          var n, i, s, u, h, l, d;
          return Re(this, function(p) {
            switch (p.label) {
              case 0:
                return [
                  4,
                  Promise.all([
                    this.metadata.getDeviceAttributes(),
                    this.metadata.getLocalAgentJwt()
                  ])
                ];
              case 1:
                return n = p.sent(), i = n[0], s = n[1], u = this.behavioralDataHandler.getBehavioralData(), [4, this.modifyBehavioralData(u)];
              case 2:
                return u = p.sent(), h = {
                  behavioral: u,
                  tags: a.Tags.instance.tags,
                  sdkConfig: this.initParams,
                  epochTs: t,
                  instanceUUID: this.instanceUUID,
                  tabUUID: a._POSignalsStorage.SessionStorage.instance.tabUUID,
                  sdkVersion: this.clientVersion,
                  platform: "web",
                  clientToken: window._pingOneSignalsToken
                }, this.sessionData.universalTrustEnabled ? (d = {}, [4, this.getJWTSignedPayload(t, i.deviceId)]) : [3, 4];
              case 3:
                return l = Ct.apply(void 0, [(d.jwtDeviceAttributes = p.sent(), d), h]), [3, 5];
              case 4:
                l = Ct({ deviceAttributes: i }, h), p.label = 5;
              case 5:
                return this.sessionData.agentIdentificationEnabled && (l = Ct({ jwtAgentPayload: s }, l)), [2, l];
            }
          });
        });
      }, e.prototype.toString = function(t) {
        var n, i = this.metadata.getObfsInfo();
        try {
          n = a._POSignalsUtils.Util.string2buf(JSON.stringify(t));
        } catch (s) {
          throw new Error("Failed to create data, " + s.message);
        }
        try {
          n = a.pako.gzip(n);
        } catch (s) {
          throw new Error("Failed to compress data, " + s.message);
        }
        try {
          n = a._POSignalsUtils.Util.encryptionBytes(n, i.key);
        } catch (s) {
          throw new Error("failed to obfuscate data, " + s.message);
        }
        try {
          return a._POSignalsUtils.Util.base64Uint8Array(n) + "." + btoa(i.identifier);
        } catch (s) {
          throw new Error("failed to encode data, " + s.message);
        }
      }, e.prototype.getJWTSignedPayload = function(t, n) {
        return Me(this, void 0, void 0, function() {
          var i;
          return Re(this, function(s) {
            return i = this.metadata.getSerializedDeviceAttributes(), [2, this.sessionData.signJWTChallenge(i, t, n)];
          });
        });
      }, e.prototype.modifyBehavioralData = function(t) {
        return Me(this, void 0, void 0, function() {
          return Re(this, function(n) {
            return t.mouse.interactions = this.getBestMouseInteractions(t.mouse.interactions), t.touch.interactions = this.getBestTouchInteractions(
              t.touch.interactions,
              t.mouse.interactions
            ), t.keyboard.interactions = this.getBestKeyboardInteractions(
              t.keyboard.interactions
            ), [2, t];
          });
        });
      }, e.prototype.getBestInteractions = function(t) {
        var n = Date.now();
        a._POSignalsUtils.Logger.debug("total interactions:", t);
        var i = t.filter(function(l) {
          return n - l.epochTs <= 18e4;
        }), s = this.sortInteractions(i).slice(0, 2), u = t.filter(function(l) {
          return !s.some(function(d) {
            return d.epochTs === l.epochTs;
          });
        }), h = this.sortInteractions(u).slice(0, 5 - s.length);
        return a._POSignalsUtils.Logger.debug(
          "final interactions for getData:",
          fn(s, h)
        ), fn(s, h).sort(function(l, d) {
          return l.epochTs - d.epochTs;
        });
      }, e.prototype.getBestMouseInteractions = function(t) {
        return this.getBestInteractions(t);
      }, e.prototype.getBestKeyboardInteractions = function(t) {
        return this.getBestInteractions(t);
      }, e.prototype.getBestTouchInteractions = function(t, n) {
        var i = this.Max_Mouse_Touch_Interactions - n.length;
        return this.getTouchBestInteraction(t, i);
      }, e.prototype.incrementGetData = function() {
        this._getDataCounter ? (this._getDataCounter.value++, this._getDataCounter.timestamp = Date.now()) : this._getDataCounter = {
          value: 1,
          name: "Get Data",
          timestamp: Date.now(),
          epochTs: Date.now()
        };
      }, e.prototype.getTouchBestInteraction = function(t, n) {
        return (t = this.sortInteractions(t)).slice(0, n);
      }, e.prototype.sortInteractions = function(t) {
        return t.sort(function(n, i) {
          var s = c[n.quality], u = c[i.quality];
          return s === u ? i.epochTs - n.epochTs : u - s;
        });
      }, e;
    }();
    a.DataHandler = r;
  }(X || (X = {})), function(a) {
    var c = function() {
      function r() {
        this._configuration = {
          enabled: r.ENABLED_DEFAULT,
          bufferSize: r.BUFFER_SIZE_DEFAULT,
          maxSnapshotsCount: r.MAX_SNAPSHOTS_COUNT_DEFAULT,
          sensors: r.SENSORS_DEFAULT,
          metadataBlacklist: r.METADATA_BLACK_LIST_DEFAULT,
          tagsBlacklistRegex: r.TAGS_BLACK_LIST_REGEX_DEFAULT,
          behavioralBlacklist: r.BEHAVIORAL_BLACK_LIST_DEFAULT,
          webRtcUrl: r.WEB_RTC_URL_DEFAULT,
          eventsBlackList: r.EVENTS_BLACK_LIST_DEFAULT,
          eventsToIgnore: r.EVENTS_TO_IGNORE_DEFAULT,
          highPriorityIndirectEvents: r.HIGH_PRIORITY_INDIRECT_EVENTS_DEFAULT,
          indirectIntervalMillis: r.INDIRECT_INTERVAL_MILLIS_DEFAULT,
          mouseIntervalMillis: r.MOUSE_INTERVAL_MILLIS_DEFAULT,
          mouseIdleTimeoutMillis: r.MOUSE_IDLE_TIMEOUT_MILLIS_DEFAULT,
          maxMouseEvents: r.MAX_MOUSE_EVENTS_DEFAULT,
          maxIndirectEvents: r.MAX_INDIRECT_EVENTS_DEFAULT,
          keyboardFieldBlackList: r.KEYBOARD_FIELD_BLACK_LIST_DEFAULT,
          keyboardCssSelectors: r.KEYBOARD_CSS_SELECTORS_DEFAULT,
          keyboardCssSelectorsBlacklist: r.KEYBOARD_CSS_SELECTORS_BLACKLIST_DEFAULT,
          keyboardIdentifierAttributes: r.KEYBOARD_IDENTIFIER_ATTRIBUTES_DEFAULT,
          remoteTags: r.REMOTE_TAGS_DEFAULT,
          maxSelectorChildren: r.MAX_SELECTOR_CHILDREN_DEFAULT,
          eventsReduceFactorMap: r.EVENTS_REDUCE_FACTOR_MAP_DEFAULT,
          propertyDescriptors: r.PROPERTY_DESCRIPTORS_DEFAULT,
          additionalMediaCodecs: r.ADDITIONAL_MEDIA_CODECS_DEFAULT,
          fingerprintTimeoutMillis: r.FINGER_PRINT_TIMEOUT_MILLIS_DEFAULT,
          metadataDataPoints: r.METADATA_DATA_POINTS_DEFAULT,
          uiModeling: r.UI_MODELING_CONFIG_DEFAULT,
          uiControl: r.UI_CONTROL_LIST_DEFAULT
        };
      }
      return r.prototype.updateParams = function(e) {
        e && (this._configuration = e);
      }, Object.defineProperty(r.prototype, "enabled", {
        get: function() {
          return typeof this._configuration.enabled == "boolean" ? this._configuration.enabled : r.ENABLED_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "bufferSize", {
        get: function() {
          return typeof this._configuration.bufferSize == "number" && this._configuration.bufferSize > 0 ? this._configuration.bufferSize : r.BUFFER_SIZE_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "maxSnapshotsCount", {
        get: function() {
          return typeof this._configuration.maxSnapshotsCount == "number" && this._configuration.maxSnapshotsCount >= 0 ? this._configuration.maxSnapshotsCount : r.MAX_SNAPSHOTS_COUNT_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "maxSensorSamples", {
        get: function() {
          var e = this._configuration.sensors;
          return e && typeof e.maxSensorSamples == "number" && e.maxSensorSamples >= 0 ? e.maxSensorSamples : r.SENSORS_DEFAULT.maxSensorSamples;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "sensorsDeltaInMillis", {
        get: function() {
          var e = this._configuration.sensors;
          return e && typeof e.sensorsDeltaInMillis == "number" && e.sensorsDeltaInMillis >= 0 ? e.sensorsDeltaInMillis : r.SENSORS_DEFAULT.sensorsDeltaInMillis;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "metadataBlackList", {
        get: function() {
          var e;
          return a._POSignalsUtils.Util.isArray(this._configuration.metadataBlacklist) && ((e = this._configuration.metadataBlacklist) === null || e === void 0 ? void 0 : e.length) > 0 ? this._configuration.metadataBlacklist : r.METADATA_BLACK_LIST_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "behavioralBlacklist", {
        get: function() {
          return this._configuration.behavioralBlacklist ? this._configuration.behavioralBlacklist : r.BEHAVIORAL_BLACK_LIST_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "tagsBlacklistRegex", {
        get: function() {
          return typeof this._configuration.tagsBlacklistRegex == "string" ? this._configuration.tagsBlacklistRegex : r.TAGS_BLACK_LIST_REGEX_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "webRtcUrl", {
        get: function() {
          return typeof this._configuration.webRtcUrl == "string" ? this._configuration.webRtcUrl : r.WEB_RTC_URL_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "eventsBlackList", {
        get: function() {
          return a._POSignalsUtils.Util.isArray(this._configuration.eventsBlackList) && (this._configuration.eventsBlackList = new Set(
            this._configuration.eventsBlackList
          )), this._configuration.eventsBlackList instanceof Set ? this._configuration.eventsBlackList : r.EVENTS_BLACK_LIST_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "eventsToIgnore", {
        get: function() {
          return a._POSignalsUtils.Util.isArray(this._configuration.eventsToIgnore) && (this._configuration.eventsToIgnore = new Set(
            this._configuration.eventsToIgnore
          )), this._configuration.eventsToIgnore instanceof Set ? this._configuration.eventsToIgnore : r.EVENTS_TO_IGNORE_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "highPriorityIndirectEvents", {
        get: function() {
          return a._POSignalsUtils.Util.isArray(this._configuration.highPriorityIndirectEvents) && (this._configuration.highPriorityIndirectEvents = new Set(
            this._configuration.highPriorityIndirectEvents
          )), this._configuration.highPriorityIndirectEvents instanceof Set ? this._configuration.highPriorityIndirectEvents : r.HIGH_PRIORITY_INDIRECT_EVENTS_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "indirectIntervalMillis", {
        get: function() {
          return typeof this._configuration.indirectIntervalMillis == "number" && this._configuration.indirectIntervalMillis > 0 ? this._configuration.indirectIntervalMillis : r.INDIRECT_INTERVAL_MILLIS_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "mouseIntervalMillis", {
        get: function() {
          return typeof this._configuration.mouseIntervalMillis == "number" && this._configuration.mouseIntervalMillis > 0 ? this._configuration.mouseIntervalMillis : r.MOUSE_INTERVAL_MILLIS_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "mouseIdleTimeoutMillis", {
        get: function() {
          return typeof this._configuration.mouseIdleTimeoutMillis == "number" && this._configuration.mouseIdleTimeoutMillis > 0 ? this._configuration.mouseIdleTimeoutMillis : r.MOUSE_IDLE_TIMEOUT_MILLIS_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "maxMouseEvents", {
        get: function() {
          return typeof this._configuration.maxMouseEvents == "number" && this._configuration.maxMouseEvents >= 0 ? this._configuration.maxMouseEvents : r.MAX_MOUSE_EVENTS_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "maxIndirectEvents", {
        get: function() {
          return typeof this._configuration.maxIndirectEvents == "number" && this._configuration.maxIndirectEvents >= 0 ? this._configuration.maxIndirectEvents : r.MAX_INDIRECT_EVENTS_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "keyboardFieldBlackList", {
        get: function() {
          return a._POSignalsUtils.Util.isArray(this._configuration.keyboardFieldBlackList) && (this._configuration.keyboardFieldBlackList = new Set(
            this._configuration.keyboardFieldBlackList
          )), this._configuration.keyboardFieldBlackList instanceof Set ? this._configuration.keyboardFieldBlackList : r.KEYBOARD_FIELD_BLACK_LIST_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "keyboardCssSelectors", {
        get: function() {
          return this._configuration.keyboardCssSelectors ? this._configuration.keyboardCssSelectors : r.KEYBOARD_CSS_SELECTORS_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "keyboardCssSelectorsBlacklist", {
        get: function() {
          return a._POSignalsUtils.Util.isArray(
            this._configuration.keyboardCssSelectorsBlacklist
          ) ? this._configuration.keyboardCssSelectorsBlacklist : r.KEYBOARD_CSS_SELECTORS_BLACKLIST_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "keyboardIdentifierAttributes", {
        get: function() {
          return a._POSignalsUtils.Util.isArray(
            this._configuration.keyboardIdentifierAttributes
          ) ? this._configuration.keyboardIdentifierAttributes : r.KEYBOARD_IDENTIFIER_ATTRIBUTES_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "remoteTags", {
        get: function() {
          return this._configuration.remoteTags ? this._configuration.remoteTags : r.REMOTE_TAGS_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "maxSelectorChildren", {
        get: function() {
          return typeof this._configuration.maxSelectorChildren == "number" && this._configuration.maxSelectorChildren > 0 ? this._configuration.maxSelectorChildren : r.MAX_SELECTOR_CHILDREN_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "eventsReduceFactorMap", {
        get: function() {
          return this._configuration.eventsReduceFactorMap ? this._configuration.eventsReduceFactorMap : r.EVENTS_REDUCE_FACTOR_MAP_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "propertyDescriptors", {
        get: function() {
          return this._configuration.propertyDescriptors ? this._configuration.propertyDescriptors : r.PROPERTY_DESCRIPTORS_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "additionalMediaCodecs", {
        get: function() {
          return this._configuration.additionalMediaCodecs ? this._configuration.additionalMediaCodecs : r.ADDITIONAL_MEDIA_CODECS_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "fingerprintTimeoutMillis", {
        get: function() {
          return typeof this._configuration.fingerprintTimeoutMillis == "number" && this._configuration.fingerprintTimeoutMillis > 0 ? this._configuration.fingerprintTimeoutMillis : r.FINGER_PRINT_TIMEOUT_MILLIS_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "metadataDataPoints", {
        get: function() {
          return this._configuration.metadataDataPoints ? this._configuration.metadataDataPoints : r.METADATA_DATA_POINTS_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "uiModelingBlacklistRegex", {
        get: function() {
          var e;
          return typeof ((e = this._configuration.uiModeling) === null || e === void 0 ? void 0 : e.blacklistRegex) == "string" ? this._configuration.uiModeling.blacklistRegex : r.UI_MODELING_CONFIG_DEFAULT.blacklistRegex;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "uiModelingElementFilters", {
        get: function() {
          var e;
          return !((e = this._configuration.uiModeling) === null || e === void 0) && e.uiElementFilters ? this._configuration.uiModeling.uiElementFilters : r.UI_MODELING_CONFIG_DEFAULT.uiElementFilters;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "uiModelingMaxMatchingParents", {
        get: function() {
          var e;
          return typeof ((e = this._configuration.uiModeling) === null || e === void 0 ? void 0 : e.maxMatchingParents) == "number" ? this._configuration.uiModeling.maxMatchingParents : r.UI_MODELING_CONFIG_DEFAULT.maxMatchingParents;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(r.prototype, "uiControlsConfig", {
        get: function() {
          return a._POSignalsUtils.Util.isArray(this._configuration.uiControl) ? this._configuration.uiControl : r.UI_CONTROL_LIST_DEFAULT;
        },
        enumerable: !1,
        configurable: !0
      }), r.ENABLED_DEFAULT = !0, r.BUFFER_SIZE_DEFAULT = 10, r.MAX_SNAPSHOTS_COUNT_DEFAULT = 500, r.METADATA_BLACK_LIST_DEFAULT = [], r.TAGS_BLACK_LIST_REGEX_DEFAULT = "", r.BEHAVIORAL_BLACK_LIST_DEFAULT = {}, r.WEB_RTC_URL_DEFAULT = "", r.EVENTS_BLACK_LIST_DEFAULT = /* @__PURE__ */ new Set(), r.EVENTS_TO_IGNORE_DEFAULT = /* @__PURE__ */ new Set([
        "pointerover",
        "pointerenter",
        "pointerdown",
        "pointermove",
        "pointerup",
        "pointercancel",
        "pointerout",
        "pointerleave",
        "dragstart",
        "dragexit",
        "drop",
        "dragend"
      ]), r.MAX_INDIRECT_EVENTS_DEFAULT = 15, r.HIGH_PRIORITY_INDIRECT_EVENTS_DEFAULT = /* @__PURE__ */ new Set([
        "copy",
        "cut",
        "paste",
        "resize",
        "orientationchange",
        "languagechange",
        "submit",
        "select"
      ]), r.INDIRECT_INTERVAL_MILLIS_DEFAULT = 1e3, r.MOUSE_INTERVAL_MILLIS_DEFAULT = 1e3, r.MOUSE_IDLE_TIMEOUT_MILLIS_DEFAULT = 1e3, r.MAX_MOUSE_EVENTS_DEFAULT = 500, r.KEYBOARD_FIELD_BLACK_LIST_DEFAULT = /* @__PURE__ */ new Set(), r.KEYBOARD_CSS_SELECTORS_DEFAULT = {}, r.KEYBOARD_CSS_SELECTORS_BLACKLIST_DEFAULT = [], r.KEYBOARD_IDENTIFIER_ATTRIBUTES_DEFAULT = [
        "data-selenium",
        "data-selenium-id",
        "data-testid",
        "data-test-id",
        "data-qa-id",
        "data-id",
        "id"
      ], r.REMOTE_TAGS_DEFAULT = {
        dv_form_submit: { selector: '[data-skbuttontype="form-submit"]' },
        login_attempt_email_domain: {
          selector: '[data-st-tag="login.login_attempt"]',
          operation: "email_domain",
          valueSelector: '[data-st-field="username"]',
          valueMandatory: !0
        },
        login_attempt_hash: {
          selector: '[data-st-tag="login.login_attempt"]',
          operation: "obfuscate",
          valueSelector: '[data-st-field="username"]',
          valueMandatory: !0
        },
        login_attempt_length: {
          selector: '[data-st-tag="login.login_attempt"]',
          operation: "length",
          valueSelector: '[data-st-field="username"]',
          valueMandatory: !0
        },
        registration_attempt_email_domain: {
          selector: '[data-st-tag="registration.registration_attempt"]',
          operation: "email_domain",
          valueSelector: '[data-st-field="username"]',
          valueMandatory: !0
        },
        registration_attempt_hash: {
          selector: '[data-st-tag="registration.registration_attempt"]',
          operation: "obfuscate",
          valueSelector: '[data-st-field="username"]',
          valueMandatory: !0
        },
        registration_attempt_length: {
          selector: '[data-st-tag="registration.registration_attempt"]',
          operation: "length",
          valueSelector: '[data-st-field="username"]',
          valueMandatory: !0
        }
      }, r.MAX_SELECTOR_CHILDREN_DEFAULT = 2, r.EVENTS_REDUCE_FACTOR_MAP_DEFAULT = {}, r.PROPERTY_DESCRIPTORS_DEFAULT = {
        chrome: ["app", "csi", "loadtimes", "runtime"],
        navigator: ["webdriver"],
        Navigator: ["languages", "hardwareConcurrency"],
        window: ["outerWidth", "outerHeight"],
        Screen: ["width", "height"]
      }, r.ADDITIONAL_MEDIA_CODECS_DEFAULT = {}, r.FINGER_PRINT_TIMEOUT_MILLIS_DEFAULT = 3e3, r.METADATA_DATA_POINTS_DEFAULT = {}, r.UI_CONTROL_LIST_DEFAULT = [], r.UI_MODELING_CONFIG_DEFAULT = {
        blacklistRegex: "",
        uiElementFilters: { text: { maxLength: 25 }, placeholder: { maxLength: 25 } },
        maxMatchingParents: 2
      }, r.SENSORS_DEFAULT = { maxSensorSamples: 1, sensorsDeltaInMillis: 0 }, r;
    }();
    a.PointerParams = c;
  }(X || (X = {})), window._POSignalsEntities = X, window._pingOneSignals = ko;
}
